(function (xn, Gn) {
  typeof exports == 'object' && typeof module < 'u'
    ? (module.exports = Gn())
    : typeof define == 'function' && define.amd
      ? define(Gn)
      : ((xn = typeof globalThis < 'u' ? globalThis : xn || self), (xn.QLFQuizDrinkApp = Gn()));
})(this, function () {
  'use strict';
  window.process = { env: { NODE_ENV: 'production' } };
  function xn(e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }
  const { toString: Gn } = Object.prototype,
    { getPrototypeOf: js } = Object,
    Lr = ((e) => (t) => {
      const n = Gn.call(t);
      return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
    })(Object.create(null)),
    st = (e) => ((e = e.toLowerCase()), (t) => Lr(t) === e),
    Vr = (e) => (t) => typeof t === e,
    { isArray: Sn } = Array,
    Jn = Vr('undefined');
  function Lf(e) {
    return (
      e !== null &&
      !Jn(e) &&
      e.constructor !== null &&
      !Jn(e.constructor) &&
      Ge(e.constructor.isBuffer) &&
      e.constructor.isBuffer(e)
    );
  }
  const Ii = st('ArrayBuffer');
  function Vf(e) {
    let t;
    return (
      typeof ArrayBuffer < 'u' && ArrayBuffer.isView
        ? (t = ArrayBuffer.isView(e))
        : (t = e && e.buffer && Ii(e.buffer)),
      t
    );
  }
  const Mf = Vr('string'),
    Ge = Vr('function'),
    Ri = Vr('number'),
    Mr = (e) => e !== null && typeof e == 'object',
    Uf = (e) => e === !0 || e === !1,
    Ur = (e) => {
      if (Lr(e) !== 'object') return !1;
      const t = js(e);
      return (
        (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) &&
        !(Symbol.toStringTag in e) &&
        !(Symbol.iterator in e)
      );
    },
    Hf = st('Date'),
    jf = st('File'),
    zf = st('Blob'),
    Kf = st('FileList'),
    Wf = (e) => Mr(e) && Ge(e.pipe),
    Gf = (e) => {
      let t;
      return (
        e &&
        ((typeof FormData == 'function' && e instanceof FormData) ||
          (Ge(e.append) &&
            ((t = Lr(e)) === 'formdata' ||
              (t === 'object' && Ge(e.toString) && e.toString() === '[object FormData]'))))
      );
    },
    Jf = st('URLSearchParams'),
    [Yf, Qf, Zf, Xf] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(st),
    ed = (e) => (e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ''));
  function Yn(e, t, { allOwnKeys: n = !1 } = {}) {
    if (e === null || typeof e > 'u') return;
    let r, s;
    if ((typeof e != 'object' && (e = [e]), Sn(e)))
      for (r = 0, s = e.length; r < s; r++) t.call(null, e[r], r, e);
    else {
      const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e),
        i = o.length;
      let l;
      for (r = 0; r < i; r++) ((l = o[r]), t.call(null, e[l], l, e));
    }
  }
  function Di(e, t) {
    t = t.toLowerCase();
    const n = Object.keys(e);
    let r = n.length,
      s;
    for (; r-- > 0; ) if (((s = n[r]), t === s.toLowerCase())) return s;
    return null;
  }
  const Xt =
      typeof globalThis < 'u'
        ? globalThis
        : typeof self < 'u'
          ? self
          : typeof window < 'u'
            ? window
            : global,
    Pi = (e) => !Jn(e) && e !== Xt;
  function zs() {
    const { caseless: e } = (Pi(this) && this) || {},
      t = {},
      n = (r, s) => {
        const o = (e && Di(t, s)) || s;
        Ur(t[o]) && Ur(r)
          ? (t[o] = zs(t[o], r))
          : Ur(r)
            ? (t[o] = zs({}, r))
            : Sn(r)
              ? (t[o] = r.slice())
              : (t[o] = r);
      };
    for (let r = 0, s = arguments.length; r < s; r++) arguments[r] && Yn(arguments[r], n);
    return t;
  }
  const td = (e, t, n, { allOwnKeys: r } = {}) => (
      Yn(
        t,
        (s, o) => {
          n && Ge(s) ? (e[o] = xn(s, n)) : (e[o] = s);
        },
        { allOwnKeys: r }
      ),
      e
    ),
    nd = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e),
    rd = (e, t, n, r) => {
      ((e.prototype = Object.create(t.prototype, r)),
        (e.prototype.constructor = e),
        Object.defineProperty(e, 'super', { value: t.prototype }),
        n && Object.assign(e.prototype, n));
    },
    sd = (e, t, n, r) => {
      let s, o, i;
      const l = {};
      if (((t = t || {}), e == null)) return t;
      do {
        for (s = Object.getOwnPropertyNames(e), o = s.length; o-- > 0; )
          ((i = s[o]), (!r || r(i, e, t)) && !l[i] && ((t[i] = e[i]), (l[i] = !0)));
        e = n !== !1 && js(e);
      } while (e && (!n || n(e, t)) && e !== Object.prototype);
      return t;
    },
    od = (e, t, n) => {
      ((e = String(e)), (n === void 0 || n > e.length) && (n = e.length), (n -= t.length));
      const r = e.indexOf(t, n);
      return r !== -1 && r === n;
    },
    id = (e) => {
      if (!e) return null;
      if (Sn(e)) return e;
      let t = e.length;
      if (!Ri(t)) return null;
      const n = new Array(t);
      for (; t-- > 0; ) n[t] = e[t];
      return n;
    },
    ld = (
      (e) => (t) =>
        e && t instanceof e
    )(typeof Uint8Array < 'u' && js(Uint8Array)),
    ad = (e, t) => {
      const r = (e && e[Symbol.iterator]).call(e);
      let s;
      for (; (s = r.next()) && !s.done; ) {
        const o = s.value;
        t.call(e, o[0], o[1]);
      }
    },
    ud = (e, t) => {
      let n;
      const r = [];
      for (; (n = e.exec(t)) !== null; ) r.push(n);
      return r;
    },
    cd = st('HTMLFormElement'),
    fd = (e) =>
      e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function (n, r, s) {
        return r.toUpperCase() + s;
      }),
    Bi = (
      ({ hasOwnProperty: e }) =>
      (t, n) =>
        e.call(t, n)
    )(Object.prototype),
    dd = st('RegExp'),
    $i = (e, t) => {
      const n = Object.getOwnPropertyDescriptors(e),
        r = {};
      (Yn(n, (s, o) => {
        let i;
        (i = t(s, o, e)) !== !1 && (r[o] = i || s);
      }),
        Object.defineProperties(e, r));
    },
    pd = (e) => {
      $i(e, (t, n) => {
        if (Ge(e) && ['arguments', 'caller', 'callee'].indexOf(n) !== -1) return !1;
        const r = e[n];
        if (Ge(r)) {
          if (((t.enumerable = !1), 'writable' in t)) {
            t.writable = !1;
            return;
          }
          t.set ||
            (t.set = () => {
              throw Error("Can not rewrite read-only method '" + n + "'");
            });
        }
      });
    },
    hd = (e, t) => {
      const n = {},
        r = (s) => {
          s.forEach((o) => {
            n[o] = !0;
          });
        };
      return (Sn(e) ? r(e) : r(String(e).split(t)), n);
    },
    md = () => {},
    gd = (e, t) => (e != null && Number.isFinite((e = +e)) ? e : t);
  function _d(e) {
    return !!(e && Ge(e.append) && e[Symbol.toStringTag] === 'FormData' && e[Symbol.iterator]);
  }
  const yd = (e) => {
      const t = new Array(10),
        n = (r, s) => {
          if (Mr(r)) {
            if (t.indexOf(r) >= 0) return;
            if (!('toJSON' in r)) {
              t[s] = r;
              const o = Sn(r) ? [] : {};
              return (
                Yn(r, (i, l) => {
                  const a = n(i, s + 1);
                  !Jn(a) && (o[l] = a);
                }),
                (t[s] = void 0),
                o
              );
            }
          }
          return r;
        };
      return n(e, 0);
    },
    vd = st('AsyncFunction'),
    qd = (e) => e && (Mr(e) || Ge(e)) && Ge(e.then) && Ge(e.catch),
    Fi = ((e, t) =>
      e
        ? setImmediate
        : t
          ? ((n, r) => (
              Xt.addEventListener(
                'message',
                ({ source: s, data: o }) => {
                  s === Xt && o === n && r.length && r.shift()();
                },
                !1
              ),
              (s) => {
                (r.push(s), Xt.postMessage(n, '*'));
              }
            ))(`axios@${Math.random()}`, [])
          : (n) => setTimeout(n))(typeof setImmediate == 'function', Ge(Xt.postMessage)),
    bd =
      typeof queueMicrotask < 'u'
        ? queueMicrotask.bind(Xt)
        : (typeof process < 'u' && process.nextTick) || Fi,
    q = {
      isArray: Sn,
      isArrayBuffer: Ii,
      isBuffer: Lf,
      isFormData: Gf,
      isArrayBufferView: Vf,
      isString: Mf,
      isNumber: Ri,
      isBoolean: Uf,
      isObject: Mr,
      isPlainObject: Ur,
      isReadableStream: Yf,
      isRequest: Qf,
      isResponse: Zf,
      isHeaders: Xf,
      isUndefined: Jn,
      isDate: Hf,
      isFile: jf,
      isBlob: zf,
      isRegExp: dd,
      isFunction: Ge,
      isStream: Wf,
      isURLSearchParams: Jf,
      isTypedArray: ld,
      isFileList: Kf,
      forEach: Yn,
      merge: zs,
      extend: td,
      trim: ed,
      stripBOM: nd,
      inherits: rd,
      toFlatObject: sd,
      kindOf: Lr,
      kindOfTest: st,
      endsWith: od,
      toArray: id,
      forEachEntry: ad,
      matchAll: ud,
      isHTMLForm: cd,
      hasOwnProperty: Bi,
      hasOwnProp: Bi,
      reduceDescriptors: $i,
      freezeMethods: pd,
      toObjectSet: hd,
      toCamelCase: fd,
      noop: md,
      toFiniteNumber: gd,
      findKey: Di,
      global: Xt,
      isContextDefined: Pi,
      isSpecCompliantForm: _d,
      toJSONObject: yd,
      isAsyncFn: vd,
      isThenable: qd,
      setImmediate: Fi,
      asap: bd
    };
  function re(e, t, n, r, s) {
    (Error.call(this),
      Error.captureStackTrace
        ? Error.captureStackTrace(this, this.constructor)
        : (this.stack = new Error().stack),
      (this.message = e),
      (this.name = 'AxiosError'),
      t && (this.code = t),
      n && (this.config = n),
      r && (this.request = r),
      s && ((this.response = s), (this.status = s.status ? s.status : null)));
  }
  q.inherits(re, Error, {
    toJSON: function () {
      return {
        message: this.message,
        name: this.name,
        description: this.description,
        number: this.number,
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        config: q.toJSONObject(this.config),
        code: this.code,
        status: this.status
      };
    }
  });
  const Ni = re.prototype,
    Li = {};
  ([
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
  ].forEach((e) => {
    Li[e] = { value: e };
  }),
    Object.defineProperties(re, Li),
    Object.defineProperty(Ni, 'isAxiosError', { value: !0 }),
    (re.from = (e, t, n, r, s, o) => {
      const i = Object.create(Ni);
      return (
        q.toFlatObject(
          e,
          i,
          function (a) {
            return a !== Error.prototype;
          },
          (l) => l !== 'isAxiosError'
        ),
        re.call(i, e.message, t, n, r, s),
        (i.cause = e),
        (i.name = e.name),
        o && Object.assign(i, o),
        i
      );
    }));
  const Ed = null;
  function Ks(e) {
    return q.isPlainObject(e) || q.isArray(e);
  }
  function Vi(e) {
    return q.endsWith(e, '[]') ? e.slice(0, -2) : e;
  }
  function Mi(e, t, n) {
    return e
      ? e
          .concat(t)
          .map(function (s, o) {
            return ((s = Vi(s)), !n && o ? '[' + s + ']' : s);
          })
          .join(n ? '.' : '')
      : t;
  }
  function wd(e) {
    return q.isArray(e) && !e.some(Ks);
  }
  const xd = q.toFlatObject(q, {}, null, function (t) {
    return /^is[A-Z]/.test(t);
  });
  function Hr(e, t, n) {
    if (!q.isObject(e)) throw new TypeError('target must be an object');
    ((t = t || new FormData()),
      (n = q.toFlatObject(n, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function (v, y) {
        return !q.isUndefined(y[v]);
      })));
    const r = n.metaTokens,
      s = n.visitor || u,
      o = n.dots,
      i = n.indexes,
      a = (n.Blob || (typeof Blob < 'u' && Blob)) && q.isSpecCompliantForm(t);
    if (!q.isFunction(s)) throw new TypeError('visitor must be a function');
    function c(g) {
      if (g === null) return '';
      if (q.isDate(g)) return g.toISOString();
      if (!a && q.isBlob(g)) throw new re('Blob is not supported. Use a Buffer instead.');
      return q.isArrayBuffer(g) || q.isTypedArray(g)
        ? a && typeof Blob == 'function'
          ? new Blob([g])
          : Buffer.from(g)
        : g;
    }
    function u(g, v, y) {
      let E = g;
      if (g && !y && typeof g == 'object') {
        if (q.endsWith(v, '{}')) ((v = r ? v : v.slice(0, -2)), (g = JSON.stringify(g)));
        else if (
          (q.isArray(g) && wd(g)) ||
          ((q.isFileList(g) || q.endsWith(v, '[]')) && (E = q.toArray(g)))
        )
          return (
            (v = Vi(v)),
            E.forEach(function (P, te) {
              !(q.isUndefined(P) || P === null) &&
                t.append(i === !0 ? Mi([v], te, o) : i === null ? v : v + '[]', c(P));
            }),
            !1
          );
      }
      return Ks(g) ? !0 : (t.append(Mi(y, v, o), c(g)), !1);
    }
    const f = [],
      d = Object.assign(xd, { defaultVisitor: u, convertValue: c, isVisitable: Ks });
    function h(g, v) {
      if (!q.isUndefined(g)) {
        if (f.indexOf(g) !== -1) throw Error('Circular reference detected in ' + v.join('.'));
        (f.push(g),
          q.forEach(g, function (E, N) {
            (!(q.isUndefined(E) || E === null) &&
              s.call(t, E, q.isString(N) ? N.trim() : N, v, d)) === !0 &&
              h(E, v ? v.concat(N) : [N]);
          }),
          f.pop());
      }
    }
    if (!q.isObject(e)) throw new TypeError('data must be an object');
    return (h(e), t);
  }
  function Ui(e) {
    const t = {
      '!': '%21',
      "'": '%27',
      '(': '%28',
      ')': '%29',
      '~': '%7E',
      '%20': '+',
      '%00': '\0'
    };
    return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function (r) {
      return t[r];
    });
  }
  function Ws(e, t) {
    ((this._pairs = []), e && Hr(e, this, t));
  }
  const Hi = Ws.prototype;
  ((Hi.append = function (t, n) {
    this._pairs.push([t, n]);
  }),
    (Hi.toString = function (t) {
      const n = t
        ? function (r) {
            return t.call(this, r, Ui);
          }
        : Ui;
      return this._pairs
        .map(function (s) {
          return n(s[0]) + '=' + n(s[1]);
        }, '')
        .join('&');
    }));
  function Sd(e) {
    return encodeURIComponent(e)
      .replace(/%3A/gi, ':')
      .replace(/%24/g, '$')
      .replace(/%2C/gi, ',')
      .replace(/%20/g, '+')
      .replace(/%5B/gi, '[')
      .replace(/%5D/gi, ']');
  }
  function ji(e, t, n) {
    if (!t) return e;
    const r = (n && n.encode) || Sd;
    q.isFunction(n) && (n = { serialize: n });
    const s = n && n.serialize;
    let o;
    if (
      (s ? (o = s(t, n)) : (o = q.isURLSearchParams(t) ? t.toString() : new Ws(t, n).toString(r)),
      o)
    ) {
      const i = e.indexOf('#');
      (i !== -1 && (e = e.slice(0, i)), (e += (e.indexOf('?') === -1 ? '?' : '&') + o));
    }
    return e;
  }
  class zi {
    constructor() {
      this.handlers = [];
    }
    use(t, n, r) {
      return (
        this.handlers.push({
          fulfilled: t,
          rejected: n,
          synchronous: r ? r.synchronous : !1,
          runWhen: r ? r.runWhen : null
        }),
        this.handlers.length - 1
      );
    }
    eject(t) {
      this.handlers[t] && (this.handlers[t] = null);
    }
    clear() {
      this.handlers && (this.handlers = []);
    }
    forEach(t) {
      q.forEach(this.handlers, function (r) {
        r !== null && t(r);
      });
    }
  }
  const Ki = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 },
    Cd = {
      isBrowser: !0,
      classes: {
        URLSearchParams: typeof URLSearchParams < 'u' ? URLSearchParams : Ws,
        FormData: typeof FormData < 'u' ? FormData : null,
        Blob: typeof Blob < 'u' ? Blob : null
      },
      protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
    },
    Gs = typeof window < 'u' && typeof document < 'u',
    Js = (typeof navigator == 'object' && navigator) || void 0,
    Ad = Gs && (!Js || ['ReactNative', 'NativeScript', 'NS'].indexOf(Js.product) < 0),
    Td =
      typeof WorkerGlobalScope < 'u' &&
      self instanceof WorkerGlobalScope &&
      typeof self.importScripts == 'function',
    Od = (Gs && window.location.href) || 'http://localhost',
    Re = {
      ...Object.freeze(
        Object.defineProperty(
          {
            __proto__: null,
            hasBrowserEnv: Gs,
            hasStandardBrowserEnv: Ad,
            hasStandardBrowserWebWorkerEnv: Td,
            navigator: Js,
            origin: Od
          },
          Symbol.toStringTag,
          { value: 'Module' }
        )
      ),
      ...Cd
    };
  function kd(e, t) {
    return Hr(
      e,
      new Re.classes.URLSearchParams(),
      Object.assign(
        {
          visitor: function (n, r, s, o) {
            return Re.isNode && q.isBuffer(n)
              ? (this.append(r, n.toString('base64')), !1)
              : o.defaultVisitor.apply(this, arguments);
          }
        },
        t
      )
    );
  }
  function Id(e) {
    return q.matchAll(/\w+|\[(\w*)]/g, e).map((t) => (t[0] === '[]' ? '' : t[1] || t[0]));
  }
  function Rd(e) {
    const t = {},
      n = Object.keys(e);
    let r;
    const s = n.length;
    let o;
    for (r = 0; r < s; r++) ((o = n[r]), (t[o] = e[o]));
    return t;
  }
  function Wi(e) {
    function t(n, r, s, o) {
      let i = n[o++];
      if (i === '__proto__') return !0;
      const l = Number.isFinite(+i),
        a = o >= n.length;
      return (
        (i = !i && q.isArray(s) ? s.length : i),
        a
          ? (q.hasOwnProp(s, i) ? (s[i] = [s[i], r]) : (s[i] = r), !l)
          : ((!s[i] || !q.isObject(s[i])) && (s[i] = []),
            t(n, r, s[i], o) && q.isArray(s[i]) && (s[i] = Rd(s[i])),
            !l)
      );
    }
    if (q.isFormData(e) && q.isFunction(e.entries)) {
      const n = {};
      return (
        q.forEachEntry(e, (r, s) => {
          t(Id(r), s, n, 0);
        }),
        n
      );
    }
    return null;
  }
  function Dd(e, t, n) {
    if (q.isString(e))
      try {
        return ((t || JSON.parse)(e), q.trim(e));
      } catch (r) {
        if (r.name !== 'SyntaxError') throw r;
      }
    return (n || JSON.stringify)(e);
  }
  const Qn = {
    transitional: Ki,
    adapter: ['xhr', 'http', 'fetch'],
    transformRequest: [
      function (t, n) {
        const r = n.getContentType() || '',
          s = r.indexOf('application/json') > -1,
          o = q.isObject(t);
        if ((o && q.isHTMLForm(t) && (t = new FormData(t)), q.isFormData(t)))
          return s ? JSON.stringify(Wi(t)) : t;
        if (
          q.isArrayBuffer(t) ||
          q.isBuffer(t) ||
          q.isStream(t) ||
          q.isFile(t) ||
          q.isBlob(t) ||
          q.isReadableStream(t)
        )
          return t;
        if (q.isArrayBufferView(t)) return t.buffer;
        if (q.isURLSearchParams(t))
          return (
            n.setContentType('application/x-www-form-urlencoded;charset=utf-8', !1),
            t.toString()
          );
        let l;
        if (o) {
          if (r.indexOf('application/x-www-form-urlencoded') > -1)
            return kd(t, this.formSerializer).toString();
          if ((l = q.isFileList(t)) || r.indexOf('multipart/form-data') > -1) {
            const a = this.env && this.env.FormData;
            return Hr(l ? { 'files[]': t } : t, a && new a(), this.formSerializer);
          }
        }
        return o || s ? (n.setContentType('application/json', !1), Dd(t)) : t;
      }
    ],
    transformResponse: [
      function (t) {
        const n = this.transitional || Qn.transitional,
          r = n && n.forcedJSONParsing,
          s = this.responseType === 'json';
        if (q.isResponse(t) || q.isReadableStream(t)) return t;
        if (t && q.isString(t) && ((r && !this.responseType) || s)) {
          const i = !(n && n.silentJSONParsing) && s;
          try {
            return JSON.parse(t);
          } catch (l) {
            if (i)
              throw l.name === 'SyntaxError'
                ? re.from(l, re.ERR_BAD_RESPONSE, this, null, this.response)
                : l;
          }
        }
        return t;
      }
    ],
    timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: { FormData: Re.classes.FormData, Blob: Re.classes.Blob },
    validateStatus: function (t) {
      return t >= 200 && t < 300;
    },
    headers: { common: { Accept: 'application/json, text/plain, */*', 'Content-Type': void 0 } }
  };
  q.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (e) => {
    Qn.headers[e] = {};
  });
  const Pd = q.toObjectSet([
      'age',
      'authorization',
      'content-length',
      'content-type',
      'etag',
      'expires',
      'from',
      'host',
      'if-modified-since',
      'if-unmodified-since',
      'last-modified',
      'location',
      'max-forwards',
      'proxy-authorization',
      'referer',
      'retry-after',
      'user-agent'
    ]),
    Bd = (e) => {
      const t = {};
      let n, r, s;
      return (
        e &&
          e
            .split(
              `
`
            )
            .forEach(function (i) {
              ((s = i.indexOf(':')),
                (n = i.substring(0, s).trim().toLowerCase()),
                (r = i.substring(s + 1).trim()),
                !(!n || (t[n] && Pd[n])) &&
                  (n === 'set-cookie'
                    ? t[n]
                      ? t[n].push(r)
                      : (t[n] = [r])
                    : (t[n] = t[n] ? t[n] + ', ' + r : r)));
            }),
        t
      );
    },
    Gi = Symbol('internals');
  function Zn(e) {
    return e && String(e).trim().toLowerCase();
  }
  function jr(e) {
    return e === !1 || e == null ? e : q.isArray(e) ? e.map(jr) : String(e);
  }
  function $d(e) {
    const t = Object.create(null),
      n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let r;
    for (; (r = n.exec(e)); ) t[r[1]] = r[2];
    return t;
  }
  const Fd = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
  function Ys(e, t, n, r, s) {
    if (q.isFunction(r)) return r.call(this, t, n);
    if ((s && (t = n), !!q.isString(t))) {
      if (q.isString(r)) return t.indexOf(r) !== -1;
      if (q.isRegExp(r)) return r.test(t);
    }
  }
  function Nd(e) {
    return e
      .trim()
      .toLowerCase()
      .replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
  }
  function Ld(e, t) {
    const n = q.toCamelCase(' ' + t);
    ['get', 'set', 'has'].forEach((r) => {
      Object.defineProperty(e, r + n, {
        value: function (s, o, i) {
          return this[r].call(this, t, s, o, i);
        },
        configurable: !0
      });
    });
  }
  let je = class {
    constructor(t) {
      t && this.set(t);
    }
    set(t, n, r) {
      const s = this;
      function o(l, a, c) {
        const u = Zn(a);
        if (!u) throw new Error('header name must be a non-empty string');
        const f = q.findKey(s, u);
        (!f || s[f] === void 0 || c === !0 || (c === void 0 && s[f] !== !1)) && (s[f || a] = jr(l));
      }
      const i = (l, a) => q.forEach(l, (c, u) => o(c, u, a));
      if (q.isPlainObject(t) || t instanceof this.constructor) i(t, n);
      else if (q.isString(t) && (t = t.trim()) && !Fd(t)) i(Bd(t), n);
      else if (q.isHeaders(t)) for (const [l, a] of t.entries()) o(a, l, r);
      else t != null && o(n, t, r);
      return this;
    }
    get(t, n) {
      if (((t = Zn(t)), t)) {
        const r = q.findKey(this, t);
        if (r) {
          const s = this[r];
          if (!n) return s;
          if (n === !0) return $d(s);
          if (q.isFunction(n)) return n.call(this, s, r);
          if (q.isRegExp(n)) return n.exec(s);
          throw new TypeError('parser must be boolean|regexp|function');
        }
      }
    }
    has(t, n) {
      if (((t = Zn(t)), t)) {
        const r = q.findKey(this, t);
        return !!(r && this[r] !== void 0 && (!n || Ys(this, this[r], r, n)));
      }
      return !1;
    }
    delete(t, n) {
      const r = this;
      let s = !1;
      function o(i) {
        if (((i = Zn(i)), i)) {
          const l = q.findKey(r, i);
          l && (!n || Ys(r, r[l], l, n)) && (delete r[l], (s = !0));
        }
      }
      return (q.isArray(t) ? t.forEach(o) : o(t), s);
    }
    clear(t) {
      const n = Object.keys(this);
      let r = n.length,
        s = !1;
      for (; r--; ) {
        const o = n[r];
        (!t || Ys(this, this[o], o, t, !0)) && (delete this[o], (s = !0));
      }
      return s;
    }
    normalize(t) {
      const n = this,
        r = {};
      return (
        q.forEach(this, (s, o) => {
          const i = q.findKey(r, o);
          if (i) {
            ((n[i] = jr(s)), delete n[o]);
            return;
          }
          const l = t ? Nd(o) : String(o).trim();
          (l !== o && delete n[o], (n[l] = jr(s)), (r[l] = !0));
        }),
        this
      );
    }
    concat(...t) {
      return this.constructor.concat(this, ...t);
    }
    toJSON(t) {
      const n = Object.create(null);
      return (
        q.forEach(this, (r, s) => {
          r != null && r !== !1 && (n[s] = t && q.isArray(r) ? r.join(', ') : r);
        }),
        n
      );
    }
    [Symbol.iterator]() {
      return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
      return Object.entries(this.toJSON()).map(([t, n]) => t + ': ' + n).join(`
`);
    }
    get [Symbol.toStringTag]() {
      return 'AxiosHeaders';
    }
    static from(t) {
      return t instanceof this ? t : new this(t);
    }
    static concat(t, ...n) {
      const r = new this(t);
      return (n.forEach((s) => r.set(s)), r);
    }
    static accessor(t) {
      const r = (this[Gi] = this[Gi] = { accessors: {} }).accessors,
        s = this.prototype;
      function o(i) {
        const l = Zn(i);
        r[l] || (Ld(s, i), (r[l] = !0));
      }
      return (q.isArray(t) ? t.forEach(o) : o(t), this);
    }
  };
  (je.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
  ]),
    q.reduceDescriptors(je.prototype, ({ value: e }, t) => {
      let n = t[0].toUpperCase() + t.slice(1);
      return {
        get: () => e,
        set(r) {
          this[n] = r;
        }
      };
    }),
    q.freezeMethods(je));
  function Qs(e, t) {
    const n = this || Qn,
      r = t || n,
      s = je.from(r.headers);
    let o = r.data;
    return (
      q.forEach(e, function (l) {
        o = l.call(n, o, s.normalize(), t ? t.status : void 0);
      }),
      s.normalize(),
      o
    );
  }
  function Ji(e) {
    return !!(e && e.__CANCEL__);
  }
  function Cn(e, t, n) {
    (re.call(this, e ?? 'canceled', re.ERR_CANCELED, t, n), (this.name = 'CanceledError'));
  }
  q.inherits(Cn, re, { __CANCEL__: !0 });
  function Yi(e, t, n) {
    const r = n.config.validateStatus;
    !n.status || !r || r(n.status)
      ? e(n)
      : t(
          new re(
            'Request failed with status code ' + n.status,
            [re.ERR_BAD_REQUEST, re.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
            n.config,
            n.request,
            n
          )
        );
  }
  function Vd(e) {
    const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
    return (t && t[1]) || '';
  }
  function Md(e, t) {
    e = e || 10;
    const n = new Array(e),
      r = new Array(e);
    let s = 0,
      o = 0,
      i;
    return (
      (t = t !== void 0 ? t : 1e3),
      function (a) {
        const c = Date.now(),
          u = r[o];
        (i || (i = c), (n[s] = a), (r[s] = c));
        let f = o,
          d = 0;
        for (; f !== s; ) ((d += n[f++]), (f = f % e));
        if (((s = (s + 1) % e), s === o && (o = (o + 1) % e), c - i < t)) return;
        const h = u && c - u;
        return h ? Math.round((d * 1e3) / h) : void 0;
      }
    );
  }
  function Ud(e, t) {
    let n = 0,
      r = 1e3 / t,
      s,
      o;
    const i = (c, u = Date.now()) => {
      ((n = u), (s = null), o && (clearTimeout(o), (o = null)), e.apply(null, c));
    };
    return [
      (...c) => {
        const u = Date.now(),
          f = u - n;
        f >= r
          ? i(c, u)
          : ((s = c),
            o ||
              (o = setTimeout(() => {
                ((o = null), i(s));
              }, r - f)));
      },
      () => s && i(s)
    ];
  }
  const zr = (e, t, n = 3) => {
      let r = 0;
      const s = Md(50, 250);
      return Ud((o) => {
        const i = o.loaded,
          l = o.lengthComputable ? o.total : void 0,
          a = i - r,
          c = s(a),
          u = i <= l;
        r = i;
        const f = {
          loaded: i,
          total: l,
          progress: l ? i / l : void 0,
          bytes: a,
          rate: c || void 0,
          estimated: c && l && u ? (l - i) / c : void 0,
          event: o,
          lengthComputable: l != null,
          [t ? 'download' : 'upload']: !0
        };
        e(f);
      }, n);
    },
    Qi = (e, t) => {
      const n = e != null;
      return [(r) => t[0]({ lengthComputable: n, total: e, loaded: r }), t[1]];
    },
    Zi =
      (e) =>
      (...t) =>
        q.asap(() => e(...t)),
    Hd = Re.hasStandardBrowserEnv
      ? ((e, t) => (n) => (
          (n = new URL(n, Re.origin)),
          e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)
        ))(new URL(Re.origin), Re.navigator && /(msie|trident)/i.test(Re.navigator.userAgent))
      : () => !0,
    jd = Re.hasStandardBrowserEnv
      ? {
          write(e, t, n, r, s, o) {
            const i = [e + '=' + encodeURIComponent(t)];
            (q.isNumber(n) && i.push('expires=' + new Date(n).toGMTString()),
              q.isString(r) && i.push('path=' + r),
              q.isString(s) && i.push('domain=' + s),
              o === !0 && i.push('secure'),
              (document.cookie = i.join('; ')));
          },
          read(e) {
            const t = document.cookie.match(new RegExp('(^|;\\s*)(' + e + ')=([^;]*)'));
            return t ? decodeURIComponent(t[3]) : null;
          },
          remove(e) {
            this.write(e, '', Date.now() - 864e5);
          }
        }
      : {
          write() {},
          read() {
            return null;
          },
          remove() {}
        };
  function zd(e) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
  }
  function Kd(e, t) {
    return t ? e.replace(/\/?\/$/, '') + '/' + t.replace(/^\/+/, '') : e;
  }
  function Xi(e, t, n) {
    let r = !zd(t);
    return e && (r || n == !1) ? Kd(e, t) : t;
  }
  const el = (e) => (e instanceof je ? { ...e } : e);
  function en(e, t) {
    t = t || {};
    const n = {};
    function r(c, u, f, d) {
      return q.isPlainObject(c) && q.isPlainObject(u)
        ? q.merge.call({ caseless: d }, c, u)
        : q.isPlainObject(u)
          ? q.merge({}, u)
          : q.isArray(u)
            ? u.slice()
            : u;
    }
    function s(c, u, f, d) {
      if (q.isUndefined(u)) {
        if (!q.isUndefined(c)) return r(void 0, c, f, d);
      } else return r(c, u, f, d);
    }
    function o(c, u) {
      if (!q.isUndefined(u)) return r(void 0, u);
    }
    function i(c, u) {
      if (q.isUndefined(u)) {
        if (!q.isUndefined(c)) return r(void 0, c);
      } else return r(void 0, u);
    }
    function l(c, u, f) {
      if (f in t) return r(c, u);
      if (f in e) return r(void 0, c);
    }
    const a = {
      url: o,
      method: o,
      data: o,
      baseURL: i,
      transformRequest: i,
      transformResponse: i,
      paramsSerializer: i,
      timeout: i,
      timeoutMessage: i,
      withCredentials: i,
      withXSRFToken: i,
      adapter: i,
      responseType: i,
      xsrfCookieName: i,
      xsrfHeaderName: i,
      onUploadProgress: i,
      onDownloadProgress: i,
      decompress: i,
      maxContentLength: i,
      maxBodyLength: i,
      beforeRedirect: i,
      transport: i,
      httpAgent: i,
      httpsAgent: i,
      cancelToken: i,
      socketPath: i,
      responseEncoding: i,
      validateStatus: l,
      headers: (c, u, f) => s(el(c), el(u), f, !0)
    };
    return (
      q.forEach(Object.keys(Object.assign({}, e, t)), function (u) {
        const f = a[u] || s,
          d = f(e[u], t[u], u);
        (q.isUndefined(d) && f !== l) || (n[u] = d);
      }),
      n
    );
  }
  const tl = (e) => {
      const t = en({}, e);
      let {
        data: n,
        withXSRFToken: r,
        xsrfHeaderName: s,
        xsrfCookieName: o,
        headers: i,
        auth: l
      } = t;
      ((t.headers = i = je.from(i)),
        (t.url = ji(Xi(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer)),
        l &&
          i.set(
            'Authorization',
            'Basic ' +
              btoa(
                (l.username || '') +
                  ':' +
                  (l.password ? unescape(encodeURIComponent(l.password)) : '')
              )
          ));
      let a;
      if (q.isFormData(n)) {
        if (Re.hasStandardBrowserEnv || Re.hasStandardBrowserWebWorkerEnv) i.setContentType(void 0);
        else if ((a = i.getContentType()) !== !1) {
          const [c, ...u] = a
            ? a
                .split(';')
                .map((f) => f.trim())
                .filter(Boolean)
            : [];
          i.setContentType([c || 'multipart/form-data', ...u].join('; '));
        }
      }
      if (
        Re.hasStandardBrowserEnv &&
        (r && q.isFunction(r) && (r = r(t)), r || (r !== !1 && Hd(t.url)))
      ) {
        const c = s && o && jd.read(o);
        c && i.set(s, c);
      }
      return t;
    },
    Wd =
      typeof XMLHttpRequest < 'u' &&
      function (e) {
        return new Promise(function (n, r) {
          const s = tl(e);
          let o = s.data;
          const i = je.from(s.headers).normalize();
          let { responseType: l, onUploadProgress: a, onDownloadProgress: c } = s,
            u,
            f,
            d,
            h,
            g;
          function v() {
            (h && h(),
              g && g(),
              s.cancelToken && s.cancelToken.unsubscribe(u),
              s.signal && s.signal.removeEventListener('abort', u));
          }
          let y = new XMLHttpRequest();
          (y.open(s.method.toUpperCase(), s.url, !0), (y.timeout = s.timeout));
          function E() {
            if (!y) return;
            const P = je.from('getAllResponseHeaders' in y && y.getAllResponseHeaders()),
              B = {
                data: !l || l === 'text' || l === 'json' ? y.responseText : y.response,
                status: y.status,
                statusText: y.statusText,
                headers: P,
                config: e,
                request: y
              };
            (Yi(
              function (V) {
                (n(V), v());
              },
              function (V) {
                (r(V), v());
              },
              B
            ),
              (y = null));
          }
          ('onloadend' in y
            ? (y.onloadend = E)
            : (y.onreadystatechange = function () {
                !y ||
                  y.readyState !== 4 ||
                  (y.status === 0 && !(y.responseURL && y.responseURL.indexOf('file:') === 0)) ||
                  setTimeout(E);
              }),
            (y.onabort = function () {
              y && (r(new re('Request aborted', re.ECONNABORTED, e, y)), (y = null));
            }),
            (y.onerror = function () {
              (r(new re('Network Error', re.ERR_NETWORK, e, y)), (y = null));
            }),
            (y.ontimeout = function () {
              let te = s.timeout ? 'timeout of ' + s.timeout + 'ms exceeded' : 'timeout exceeded';
              const B = s.transitional || Ki;
              (s.timeoutErrorMessage && (te = s.timeoutErrorMessage),
                r(new re(te, B.clarifyTimeoutError ? re.ETIMEDOUT : re.ECONNABORTED, e, y)),
                (y = null));
            }),
            o === void 0 && i.setContentType(null),
            'setRequestHeader' in y &&
              q.forEach(i.toJSON(), function (te, B) {
                y.setRequestHeader(B, te);
              }),
            q.isUndefined(s.withCredentials) || (y.withCredentials = !!s.withCredentials),
            l && l !== 'json' && (y.responseType = s.responseType),
            c && (([d, g] = zr(c, !0)), y.addEventListener('progress', d)),
            a &&
              y.upload &&
              (([f, h] = zr(a)),
              y.upload.addEventListener('progress', f),
              y.upload.addEventListener('loadend', h)),
            (s.cancelToken || s.signal) &&
              ((u = (P) => {
                y && (r(!P || P.type ? new Cn(null, e, y) : P), y.abort(), (y = null));
              }),
              s.cancelToken && s.cancelToken.subscribe(u),
              s.signal && (s.signal.aborted ? u() : s.signal.addEventListener('abort', u))));
          const N = Vd(s.url);
          if (N && Re.protocols.indexOf(N) === -1) {
            r(new re('Unsupported protocol ' + N + ':', re.ERR_BAD_REQUEST, e));
            return;
          }
          y.send(o || null);
        });
      },
    Gd = (e, t) => {
      const { length: n } = (e = e ? e.filter(Boolean) : []);
      if (t || n) {
        let r = new AbortController(),
          s;
        const o = function (c) {
          if (!s) {
            ((s = !0), l());
            const u = c instanceof Error ? c : this.reason;
            r.abort(u instanceof re ? u : new Cn(u instanceof Error ? u.message : u));
          }
        };
        let i =
          t &&
          setTimeout(() => {
            ((i = null), o(new re(`timeout ${t} of ms exceeded`, re.ETIMEDOUT)));
          }, t);
        const l = () => {
          e &&
            (i && clearTimeout(i),
            (i = null),
            e.forEach((c) => {
              c.unsubscribe ? c.unsubscribe(o) : c.removeEventListener('abort', o);
            }),
            (e = null));
        };
        e.forEach((c) => c.addEventListener('abort', o));
        const { signal: a } = r;
        return ((a.unsubscribe = () => q.asap(l)), a);
      }
    },
    Jd = function* (e, t) {
      let n = e.byteLength;
      if (n < t) {
        yield e;
        return;
      }
      let r = 0,
        s;
      for (; r < n; ) ((s = r + t), yield e.slice(r, s), (r = s));
    },
    Yd = async function* (e, t) {
      for await (const n of Qd(e)) yield* Jd(n, t);
    },
    Qd = async function* (e) {
      if (e[Symbol.asyncIterator]) {
        yield* e;
        return;
      }
      const t = e.getReader();
      try {
        for (;;) {
          const { done: n, value: r } = await t.read();
          if (n) break;
          yield r;
        }
      } finally {
        await t.cancel();
      }
    },
    nl = (e, t, n, r) => {
      const s = Yd(e, t);
      let o = 0,
        i,
        l = (a) => {
          i || ((i = !0), r && r(a));
        };
      return new ReadableStream(
        {
          async pull(a) {
            try {
              const { done: c, value: u } = await s.next();
              if (c) {
                (l(), a.close());
                return;
              }
              let f = u.byteLength;
              if (n) {
                let d = (o += f);
                n(d);
              }
              a.enqueue(new Uint8Array(u));
            } catch (c) {
              throw (l(c), c);
            }
          },
          cancel(a) {
            return (l(a), s.return());
          }
        },
        { highWaterMark: 2 }
      );
    },
    Kr =
      typeof fetch == 'function' && typeof Request == 'function' && typeof Response == 'function',
    rl = Kr && typeof ReadableStream == 'function',
    Zd =
      Kr &&
      (typeof TextEncoder == 'function'
        ? (
            (e) => (t) =>
              e.encode(t)
          )(new TextEncoder())
        : async (e) => new Uint8Array(await new Response(e).arrayBuffer())),
    sl = (e, ...t) => {
      try {
        return !!e(...t);
      } catch {
        return !1;
      }
    },
    Xd =
      rl &&
      sl(() => {
        let e = !1;
        const t = new Request(Re.origin, {
          body: new ReadableStream(),
          method: 'POST',
          get duplex() {
            return ((e = !0), 'half');
          }
        }).headers.has('Content-Type');
        return e && !t;
      }),
    ol = 64 * 1024,
    Zs = rl && sl(() => q.isReadableStream(new Response('').body)),
    Wr = { stream: Zs && ((e) => e.body) };
  Kr &&
    ((e) => {
      ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach((t) => {
        !Wr[t] &&
          (Wr[t] = q.isFunction(e[t])
            ? (n) => n[t]()
            : (n, r) => {
                throw new re(`Response type '${t}' is not supported`, re.ERR_NOT_SUPPORT, r);
              });
      });
    })(new Response());
  const ep = async (e) => {
      if (e == null) return 0;
      if (q.isBlob(e)) return e.size;
      if (q.isSpecCompliantForm(e))
        return (await new Request(Re.origin, { method: 'POST', body: e }).arrayBuffer()).byteLength;
      if (q.isArrayBufferView(e) || q.isArrayBuffer(e)) return e.byteLength;
      if ((q.isURLSearchParams(e) && (e = e + ''), q.isString(e))) return (await Zd(e)).byteLength;
    },
    tp = async (e, t) => {
      const n = q.toFiniteNumber(e.getContentLength());
      return n ?? ep(t);
    },
    Xs = {
      http: Ed,
      xhr: Wd,
      fetch:
        Kr &&
        (async (e) => {
          let {
            url: t,
            method: n,
            data: r,
            signal: s,
            cancelToken: o,
            timeout: i,
            onDownloadProgress: l,
            onUploadProgress: a,
            responseType: c,
            headers: u,
            withCredentials: f = 'same-origin',
            fetchOptions: d
          } = tl(e);
          c = c ? (c + '').toLowerCase() : 'text';
          let h = Gd([s, o && o.toAbortSignal()], i),
            g;
          const v =
            h &&
            h.unsubscribe &&
            (() => {
              h.unsubscribe();
            });
          let y;
          try {
            if (a && Xd && n !== 'get' && n !== 'head' && (y = await tp(u, r)) !== 0) {
              let B = new Request(t, { method: 'POST', body: r, duplex: 'half' }),
                J;
              if (
                (q.isFormData(r) && (J = B.headers.get('content-type')) && u.setContentType(J),
                B.body)
              ) {
                const [V, ae] = Qi(y, zr(Zi(a)));
                r = nl(B.body, ol, V, ae);
              }
            }
            q.isString(f) || (f = f ? 'include' : 'omit');
            const E = 'credentials' in Request.prototype;
            g = new Request(t, {
              ...d,
              signal: h,
              method: n.toUpperCase(),
              headers: u.normalize().toJSON(),
              body: r,
              duplex: 'half',
              credentials: E ? f : void 0
            });
            let N = await fetch(g);
            const P = Zs && (c === 'stream' || c === 'response');
            if (Zs && (l || (P && v))) {
              const B = {};
              ['status', 'statusText', 'headers'].forEach((U) => {
                B[U] = N[U];
              });
              const J = q.toFiniteNumber(N.headers.get('content-length')),
                [V, ae] = (l && Qi(J, zr(Zi(l), !0))) || [];
              N = new Response(
                nl(N.body, ol, V, () => {
                  (ae && ae(), v && v());
                }),
                B
              );
            }
            c = c || 'text';
            let te = await Wr[q.findKey(Wr, c) || 'text'](N, e);
            return (
              !P && v && v(),
              await new Promise((B, J) => {
                Yi(B, J, {
                  data: te,
                  headers: je.from(N.headers),
                  status: N.status,
                  statusText: N.statusText,
                  config: e,
                  request: g
                });
              })
            );
          } catch (E) {
            throw (
              v && v(),
              E && E.name === 'TypeError' && /fetch/i.test(E.message)
                ? Object.assign(new re('Network Error', re.ERR_NETWORK, e, g), {
                    cause: E.cause || E
                  })
                : re.from(E, E && E.code, e, g)
            );
          }
        })
    };
  q.forEach(Xs, (e, t) => {
    if (e) {
      try {
        Object.defineProperty(e, 'name', { value: t });
      } catch {}
      Object.defineProperty(e, 'adapterName', { value: t });
    }
  });
  const il = (e) => `- ${e}`,
    np = (e) => q.isFunction(e) || e === null || e === !1,
    ll = {
      getAdapter: (e) => {
        e = q.isArray(e) ? e : [e];
        const { length: t } = e;
        let n, r;
        const s = {};
        for (let o = 0; o < t; o++) {
          n = e[o];
          let i;
          if (((r = n), !np(n) && ((r = Xs[(i = String(n)).toLowerCase()]), r === void 0)))
            throw new re(`Unknown adapter '${i}'`);
          if (r) break;
          s[i || '#' + o] = r;
        }
        if (!r) {
          const o = Object.entries(s).map(
            ([l, a]) =>
              `adapter ${l} ` +
              (a === !1 ? 'is not supported by the environment' : 'is not available in the build')
          );
          let i = t
            ? o.length > 1
              ? `since :
` +
                o.map(il).join(`
`)
              : ' ' + il(o[0])
            : 'as no adapter specified';
          throw new re(
            'There is no suitable adapter to dispatch the request ' + i,
            'ERR_NOT_SUPPORT'
          );
        }
        return r;
      },
      adapters: Xs
    };
  function eo(e) {
    if ((e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted))
      throw new Cn(null, e);
  }
  function al(e) {
    return (
      eo(e),
      (e.headers = je.from(e.headers)),
      (e.data = Qs.call(e, e.transformRequest)),
      ['post', 'put', 'patch'].indexOf(e.method) !== -1 &&
        e.headers.setContentType('application/x-www-form-urlencoded', !1),
      ll
        .getAdapter(e.adapter || Qn.adapter)(e)
        .then(
          function (r) {
            return (
              eo(e),
              (r.data = Qs.call(e, e.transformResponse, r)),
              (r.headers = je.from(r.headers)),
              r
            );
          },
          function (r) {
            return (
              Ji(r) ||
                (eo(e),
                r &&
                  r.response &&
                  ((r.response.data = Qs.call(e, e.transformResponse, r.response)),
                  (r.response.headers = je.from(r.response.headers)))),
              Promise.reject(r)
            );
          }
        )
    );
  }
  const ul = '1.8.4',
    Gr = {};
  ['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((e, t) => {
    Gr[e] = function (r) {
      return typeof r === e || 'a' + (t < 1 ? 'n ' : ' ') + e;
    };
  });
  const cl = {};
  ((Gr.transitional = function (t, n, r) {
    function s(o, i) {
      return '[Axios v' + ul + "] Transitional option '" + o + "'" + i + (r ? '. ' + r : '');
    }
    return (o, i, l) => {
      if (t === !1)
        throw new re(s(i, ' has been removed' + (n ? ' in ' + n : '')), re.ERR_DEPRECATED);
      return (
        n &&
          !cl[i] &&
          ((cl[i] = !0),
          console.warn(
            s(i, ' has been deprecated since v' + n + ' and will be removed in the near future')
          )),
        t ? t(o, i, l) : !0
      );
    };
  }),
    (Gr.spelling = function (t) {
      return (n, r) => (console.warn(`${r} is likely a misspelling of ${t}`), !0);
    }));
  function rp(e, t, n) {
    if (typeof e != 'object') throw new re('options must be an object', re.ERR_BAD_OPTION_VALUE);
    const r = Object.keys(e);
    let s = r.length;
    for (; s-- > 0; ) {
      const o = r[s],
        i = t[o];
      if (i) {
        const l = e[o],
          a = l === void 0 || i(l, o, e);
        if (a !== !0) throw new re('option ' + o + ' must be ' + a, re.ERR_BAD_OPTION_VALUE);
        continue;
      }
      if (n !== !0) throw new re('Unknown option ' + o, re.ERR_BAD_OPTION);
    }
  }
  const Jr = { assertOptions: rp, validators: Gr },
    dt = Jr.validators;
  let tn = class {
    constructor(t) {
      ((this.defaults = t), (this.interceptors = { request: new zi(), response: new zi() }));
    }
    async request(t, n) {
      try {
        return await this._request(t, n);
      } catch (r) {
        if (r instanceof Error) {
          let s = {};
          Error.captureStackTrace ? Error.captureStackTrace(s) : (s = new Error());
          const o = s.stack ? s.stack.replace(/^.+\n/, '') : '';
          try {
            r.stack
              ? o &&
                !String(r.stack).endsWith(o.replace(/^.+\n.+\n/, '')) &&
                (r.stack +=
                  `
` + o)
              : (r.stack = o);
          } catch {}
        }
        throw r;
      }
    }
    _request(t, n) {
      (typeof t == 'string' ? ((n = n || {}), (n.url = t)) : (n = t || {}),
        (n = en(this.defaults, n)));
      const { transitional: r, paramsSerializer: s, headers: o } = n;
      (r !== void 0 &&
        Jr.assertOptions(
          r,
          {
            silentJSONParsing: dt.transitional(dt.boolean),
            forcedJSONParsing: dt.transitional(dt.boolean),
            clarifyTimeoutError: dt.transitional(dt.boolean)
          },
          !1
        ),
        s != null &&
          (q.isFunction(s)
            ? (n.paramsSerializer = { serialize: s })
            : Jr.assertOptions(s, { encode: dt.function, serialize: dt.function }, !0)),
        n.allowAbsoluteUrls !== void 0 ||
          (this.defaults.allowAbsoluteUrls !== void 0
            ? (n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls)
            : (n.allowAbsoluteUrls = !0)),
        Jr.assertOptions(
          n,
          { baseUrl: dt.spelling('baseURL'), withXsrfToken: dt.spelling('withXSRFToken') },
          !0
        ),
        (n.method = (n.method || this.defaults.method || 'get').toLowerCase()));
      let i = o && q.merge(o.common, o[n.method]);
      (o &&
        q.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], (g) => {
          delete o[g];
        }),
        (n.headers = je.concat(i, o)));
      const l = [];
      let a = !0;
      this.interceptors.request.forEach(function (v) {
        (typeof v.runWhen == 'function' && v.runWhen(n) === !1) ||
          ((a = a && v.synchronous), l.unshift(v.fulfilled, v.rejected));
      });
      const c = [];
      this.interceptors.response.forEach(function (v) {
        c.push(v.fulfilled, v.rejected);
      });
      let u,
        f = 0,
        d;
      if (!a) {
        const g = [al.bind(this), void 0];
        for (
          g.unshift.apply(g, l), g.push.apply(g, c), d = g.length, u = Promise.resolve(n);
          f < d;

        )
          u = u.then(g[f++], g[f++]);
        return u;
      }
      d = l.length;
      let h = n;
      for (f = 0; f < d; ) {
        const g = l[f++],
          v = l[f++];
        try {
          h = g(h);
        } catch (y) {
          v.call(this, y);
          break;
        }
      }
      try {
        u = al.call(this, h);
      } catch (g) {
        return Promise.reject(g);
      }
      for (f = 0, d = c.length; f < d; ) u = u.then(c[f++], c[f++]);
      return u;
    }
    getUri(t) {
      t = en(this.defaults, t);
      const n = Xi(t.baseURL, t.url, t.allowAbsoluteUrls);
      return ji(n, t.params, t.paramsSerializer);
    }
  };
  (q.forEach(['delete', 'get', 'head', 'options'], function (t) {
    tn.prototype[t] = function (n, r) {
      return this.request(en(r || {}, { method: t, url: n, data: (r || {}).data }));
    };
  }),
    q.forEach(['post', 'put', 'patch'], function (t) {
      function n(r) {
        return function (o, i, l) {
          return this.request(
            en(l || {}, {
              method: t,
              headers: r ? { 'Content-Type': 'multipart/form-data' } : {},
              url: o,
              data: i
            })
          );
        };
      }
      ((tn.prototype[t] = n()), (tn.prototype[t + 'Form'] = n(!0)));
    }));
  let sp = class Nf {
    constructor(t) {
      if (typeof t != 'function') throw new TypeError('executor must be a function.');
      let n;
      this.promise = new Promise(function (o) {
        n = o;
      });
      const r = this;
      (this.promise.then((s) => {
        if (!r._listeners) return;
        let o = r._listeners.length;
        for (; o-- > 0; ) r._listeners[o](s);
        r._listeners = null;
      }),
        (this.promise.then = (s) => {
          let o;
          const i = new Promise((l) => {
            (r.subscribe(l), (o = l));
          }).then(s);
          return (
            (i.cancel = function () {
              r.unsubscribe(o);
            }),
            i
          );
        }),
        t(function (o, i, l) {
          r.reason || ((r.reason = new Cn(o, i, l)), n(r.reason));
        }));
    }
    throwIfRequested() {
      if (this.reason) throw this.reason;
    }
    subscribe(t) {
      if (this.reason) {
        t(this.reason);
        return;
      }
      this._listeners ? this._listeners.push(t) : (this._listeners = [t]);
    }
    unsubscribe(t) {
      if (!this._listeners) return;
      const n = this._listeners.indexOf(t);
      n !== -1 && this._listeners.splice(n, 1);
    }
    toAbortSignal() {
      const t = new AbortController(),
        n = (r) => {
          t.abort(r);
        };
      return (this.subscribe(n), (t.signal.unsubscribe = () => this.unsubscribe(n)), t.signal);
    }
    static source() {
      let t;
      return {
        token: new Nf(function (s) {
          t = s;
        }),
        cancel: t
      };
    }
  };
  function op(e) {
    return function (n) {
      return e.apply(null, n);
    };
  }
  function ip(e) {
    return q.isObject(e) && e.isAxiosError === !0;
  }
  const to = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
  };
  Object.entries(to).forEach(([e, t]) => {
    to[t] = e;
  });
  function fl(e) {
    const t = new tn(e),
      n = xn(tn.prototype.request, t);
    return (
      q.extend(n, tn.prototype, t, { allOwnKeys: !0 }),
      q.extend(n, t, null, { allOwnKeys: !0 }),
      (n.create = function (s) {
        return fl(en(e, s));
      }),
      n
    );
  }
  const Ee = fl(Qn);
  ((Ee.Axios = tn),
    (Ee.CanceledError = Cn),
    (Ee.CancelToken = sp),
    (Ee.isCancel = Ji),
    (Ee.VERSION = ul),
    (Ee.toFormData = Hr),
    (Ee.AxiosError = re),
    (Ee.Cancel = Ee.CanceledError),
    (Ee.all = function (t) {
      return Promise.all(t);
    }),
    (Ee.spread = op),
    (Ee.isAxiosError = ip),
    (Ee.mergeConfig = en),
    (Ee.AxiosHeaders = je),
    (Ee.formToJSON = (e) => Wi(q.isHTMLForm(e) ? new FormData(e) : e)),
    (Ee.getAdapter = ll.getAdapter),
    (Ee.HttpStatusCode = to),
    (Ee.default = Ee));
  const {
    Axios: Bv,
    AxiosError: $v,
    CanceledError: Fv,
    isCancel: Nv,
    CancelToken: Lv,
    VERSION: Vv,
    all: Mv,
    Cancel: Uv,
    isAxiosError: Hv,
    spread: jv,
    toFormData: zv,
    AxiosHeaders: Kv,
    HttpStatusCode: Wv,
    formToJSON: Gv,
    getAdapter: Jv,
    mergeConfig: Yv
  } = Ee;
  ((window.axios = Ee),
    (window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'));
  /**
   * @vue/shared v3.5.13
   * (c) 2018-present Yuxi (Evan) You and Vue contributors
   * @license MIT
   **/ /*! #__NO_SIDE_EFFECTS__ */ function kt(e) {
    const t = Object.create(null);
    for (const n of e.split(',')) t[n] = 1;
    return (n) => n in t;
  }
  const ce = Object.freeze({}),
    An = Object.freeze([]),
    Ie = () => {},
    lp = () => !1,
    Xn = (e) =>
      e.charCodeAt(0) === 111 &&
      e.charCodeAt(1) === 110 &&
      (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97),
    Yr = (e) => e.startsWith('onUpdate:'),
    ve = Object.assign,
    no = (e, t) => {
      const n = e.indexOf(t);
      n > -1 && e.splice(n, 1);
    },
    ap = Object.prototype.hasOwnProperty,
    le = (e, t) => ap.call(e, t),
    z = Array.isArray,
    nn = (e) => Qr(e) === '[object Map]',
    dl = (e) => Qr(e) === '[object Set]',
    G = (e) => typeof e == 'function',
    ye = (e) => typeof e == 'string',
    It = (e) => typeof e == 'symbol',
    ue = (e) => e !== null && typeof e == 'object',
    ro = (e) => (ue(e) || G(e)) && G(e.then) && G(e.catch),
    pl = Object.prototype.toString,
    Qr = (e) => pl.call(e),
    so = (e) => Qr(e).slice(8, -1),
    hl = (e) => Qr(e) === '[object Object]',
    oo = (e) => ye(e) && e !== 'NaN' && e[0] !== '-' && '' + parseInt(e, 10) === e,
    er = kt(
      ',key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted'
    ),
    up = kt('bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo'),
    Zr = (e) => {
      const t = Object.create(null);
      return (n) => t[n] || (t[n] = e(n));
    },
    cp = /-(\w)/g,
    $e = Zr((e) => e.replace(cp, (t, n) => (n ? n.toUpperCase() : ''))),
    fp = /\B([A-Z])/g,
    Rt = Zr((e) => e.replace(fp, '-$1').toLowerCase()),
    rn = Zr((e) => e.charAt(0).toUpperCase() + e.slice(1)),
    sn = Zr((e) => (e ? `on${rn(e)}` : '')),
    Ut = (e, t) => !Object.is(e, t),
    Tn = (e, ...t) => {
      for (let n = 0; n < e.length; n++) e[n](...t);
    },
    Xr = (e, t, n, r = !1) => {
      Object.defineProperty(e, t, { configurable: !0, enumerable: !1, writable: r, value: n });
    },
    io = (e) => {
      const t = parseFloat(e);
      return isNaN(t) ? e : t;
    },
    dp = (e) => {
      const t = ye(e) ? Number(e) : NaN;
      return isNaN(t) ? e : t;
    };
  let ml;
  const tr = () =>
    ml ||
    (ml =
      typeof globalThis < 'u'
        ? globalThis
        : typeof self < 'u'
          ? self
          : typeof window < 'u'
            ? window
            : typeof global < 'u'
              ? global
              : {});
  function On(e) {
    if (z(e)) {
      const t = {};
      for (let n = 0; n < e.length; n++) {
        const r = e[n],
          s = ye(r) ? gp(r) : On(r);
        if (s) for (const o in s) t[o] = s[o];
      }
      return t;
    } else if (ye(e) || ue(e)) return e;
  }
  const pp = /;(?![^(]*\))/g,
    hp = /:([^]+)/,
    mp = /\/\*[^]*?\*\//g;
  function gp(e) {
    const t = {};
    return (
      e
        .replace(mp, '')
        .split(pp)
        .forEach((n) => {
          if (n) {
            const r = n.split(hp);
            r.length > 1 && (t[r[0].trim()] = r[1].trim());
          }
        }),
      t
    );
  }
  function Xe(e) {
    let t = '';
    if (ye(e)) t = e;
    else if (z(e))
      for (let n = 0; n < e.length; n++) {
        const r = Xe(e[n]);
        r && (t += r + ' ');
      }
    else if (ue(e)) for (const n in e) e[n] && (t += n + ' ');
    return t.trim();
  }
  const _p =
      'html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot',
    yp =
      'svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view',
    vp =
      'annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics',
    qp = kt(_p),
    bp = kt(yp),
    Ep = kt(vp),
    wp = kt('itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly');
  function gl(e) {
    return !!e || e === '';
  }
  const _l = (e) => !!(e && e.__v_isRef === !0),
    ot = (e) =>
      ye(e)
        ? e
        : e == null
          ? ''
          : z(e) || (ue(e) && (e.toString === pl || !G(e.toString)))
            ? _l(e)
              ? ot(e.value)
              : JSON.stringify(e, yl, 2)
            : String(e),
    yl = (e, t) =>
      _l(t)
        ? yl(e, t.value)
        : nn(t)
          ? {
              [`Map(${t.size})`]: [...t.entries()].reduce(
                (n, [r, s], o) => ((n[lo(r, o) + ' =>'] = s), n),
                {}
              )
            }
          : dl(t)
            ? { [`Set(${t.size})`]: [...t.values()].map((n) => lo(n)) }
            : It(t)
              ? lo(t)
              : ue(t) && !z(t) && !hl(t)
                ? String(t)
                : t,
    lo = (e, t = '') => {
      var n;
      return It(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e;
    };
  var xp = { NODE_ENV: '"production"' };
  function et(e, ...t) {
    console.warn(`[Vue warn] ${e}`, ...t);
  }
  let Fe;
  class vl {
    constructor(t = !1) {
      ((this.detached = t),
        (this._active = !0),
        (this.effects = []),
        (this.cleanups = []),
        (this._isPaused = !1),
        (this.parent = Fe),
        !t && Fe && (this.index = (Fe.scopes || (Fe.scopes = [])).push(this) - 1));
    }
    get active() {
      return this._active;
    }
    pause() {
      if (this._active) {
        this._isPaused = !0;
        let t, n;
        if (this.scopes) for (t = 0, n = this.scopes.length; t < n; t++) this.scopes[t].pause();
        for (t = 0, n = this.effects.length; t < n; t++) this.effects[t].pause();
      }
    }
    resume() {
      if (this._active && this._isPaused) {
        this._isPaused = !1;
        let t, n;
        if (this.scopes) for (t = 0, n = this.scopes.length; t < n; t++) this.scopes[t].resume();
        for (t = 0, n = this.effects.length; t < n; t++) this.effects[t].resume();
      }
    }
    run(t) {
      if (this._active) {
        const n = Fe;
        try {
          return ((Fe = this), t());
        } finally {
          Fe = n;
        }
      } else et('cannot run an inactive effect scope.');
    }
    on() {
      Fe = this;
    }
    off() {
      Fe = this.parent;
    }
    stop(t) {
      if (this._active) {
        this._active = !1;
        let n, r;
        for (n = 0, r = this.effects.length; n < r; n++) this.effects[n].stop();
        for (this.effects.length = 0, n = 0, r = this.cleanups.length; n < r; n++)
          this.cleanups[n]();
        if (((this.cleanups.length = 0), this.scopes)) {
          for (n = 0, r = this.scopes.length; n < r; n++) this.scopes[n].stop(!0);
          this.scopes.length = 0;
        }
        if (!this.detached && this.parent && !t) {
          const s = this.parent.scopes.pop();
          s && s !== this && ((this.parent.scopes[this.index] = s), (s.index = this.index));
        }
        this.parent = void 0;
      }
    }
  }
  function ql(e) {
    return new vl(e);
  }
  function bl() {
    return Fe;
  }
  function Sp(e, t = !1) {
    Fe
      ? Fe.cleanups.push(e)
      : t ||
        et(
          'onScopeDispose() is called when there is no active effect scope to be associated with.'
        );
  }
  let fe;
  const ao = new WeakSet();
  class El {
    constructor(t) {
      ((this.fn = t),
        (this.deps = void 0),
        (this.depsTail = void 0),
        (this.flags = 5),
        (this.next = void 0),
        (this.cleanup = void 0),
        (this.scheduler = void 0),
        Fe && Fe.active && Fe.effects.push(this));
    }
    pause() {
      this.flags |= 64;
    }
    resume() {
      this.flags & 64 && ((this.flags &= -65), ao.has(this) && (ao.delete(this), this.trigger()));
    }
    notify() {
      (this.flags & 2 && !(this.flags & 32)) || this.flags & 8 || xl(this);
    }
    run() {
      if (!(this.flags & 1)) return this.fn();
      ((this.flags |= 2), Ol(this), Sl(this));
      const t = fe,
        n = it;
      ((fe = this), (it = !0));
      try {
        return this.fn();
      } finally {
        (fe !== this &&
          et('Active effect was not restored correctly - this is likely a Vue internal bug.'),
          Cl(this),
          (fe = t),
          (it = n),
          (this.flags &= -3));
      }
    }
    stop() {
      if (this.flags & 1) {
        for (let t = this.deps; t; t = t.nextDep) po(t);
        ((this.deps = this.depsTail = void 0),
          Ol(this),
          this.onStop && this.onStop(),
          (this.flags &= -2));
      }
    }
    trigger() {
      this.flags & 64 ? ao.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
    }
    runIfDirty() {
      fo(this) && this.run();
    }
    get dirty() {
      return fo(this);
    }
  }
  let wl = 0,
    nr,
    rr;
  function xl(e, t = !1) {
    if (((e.flags |= 8), t)) {
      ((e.next = rr), (rr = e));
      return;
    }
    ((e.next = nr), (nr = e));
  }
  function uo() {
    wl++;
  }
  function co() {
    if (--wl > 0) return;
    if (rr) {
      let t = rr;
      for (rr = void 0; t; ) {
        const n = t.next;
        ((t.next = void 0), (t.flags &= -9), (t = n));
      }
    }
    let e;
    for (; nr; ) {
      let t = nr;
      for (nr = void 0; t; ) {
        const n = t.next;
        if (((t.next = void 0), (t.flags &= -9), t.flags & 1))
          try {
            t.trigger();
          } catch (r) {
            e || (e = r);
          }
        t = n;
      }
    }
    if (e) throw e;
  }
  function Sl(e) {
    for (let t = e.deps; t; t = t.nextDep)
      ((t.version = -1), (t.prevActiveLink = t.dep.activeLink), (t.dep.activeLink = t));
  }
  function Cl(e) {
    let t,
      n = e.depsTail,
      r = n;
    for (; r; ) {
      const s = r.prevDep;
      (r.version === -1 ? (r === n && (n = s), po(r), Cp(r)) : (t = r),
        (r.dep.activeLink = r.prevActiveLink),
        (r.prevActiveLink = void 0),
        (r = s));
    }
    ((e.deps = t), (e.depsTail = n));
  }
  function fo(e) {
    for (let t = e.deps; t; t = t.nextDep)
      if (
        t.dep.version !== t.version ||
        (t.dep.computed && (Al(t.dep.computed) || t.dep.version !== t.version))
      )
        return !0;
    return !!e._dirty;
  }
  function Al(e) {
    if ((e.flags & 4 && !(e.flags & 16)) || ((e.flags &= -17), e.globalVersion === sr)) return;
    e.globalVersion = sr;
    const t = e.dep;
    if (((e.flags |= 2), t.version > 0 && !e.isSSR && e.deps && !fo(e))) {
      e.flags &= -3;
      return;
    }
    const n = fe,
      r = it;
    ((fe = e), (it = !0));
    try {
      Sl(e);
      const s = e.fn(e._value);
      (t.version === 0 || Ut(s, e._value)) && ((e._value = s), t.version++);
    } catch (s) {
      throw (t.version++, s);
    } finally {
      ((fe = n), (it = r), Cl(e), (e.flags &= -3));
    }
  }
  function po(e, t = !1) {
    const { dep: n, prevSub: r, nextSub: s } = e;
    if (
      (r && ((r.nextSub = s), (e.prevSub = void 0)),
      s && ((s.prevSub = r), (e.nextSub = void 0)),
      n.subsHead === e && (n.subsHead = s),
      n.subs === e && ((n.subs = r), !r && n.computed))
    ) {
      n.computed.flags &= -5;
      for (let o = n.computed.deps; o; o = o.nextDep) po(o, !0);
    }
    !t && !--n.sc && n.map && n.map.delete(n.key);
  }
  function Cp(e) {
    const { prevDep: t, nextDep: n } = e;
    (t && ((t.nextDep = n), (e.prevDep = void 0)), n && ((n.prevDep = t), (e.nextDep = void 0)));
  }
  let it = !0;
  const Tl = [];
  function Dt() {
    (Tl.push(it), (it = !1));
  }
  function Pt() {
    const e = Tl.pop();
    it = e === void 0 ? !0 : e;
  }
  function Ol(e) {
    const { cleanup: t } = e;
    if (((e.cleanup = void 0), t)) {
      const n = fe;
      fe = void 0;
      try {
        t();
      } finally {
        fe = n;
      }
    }
  }
  let sr = 0;
  class Ap {
    constructor(t, n) {
      ((this.sub = t),
        (this.dep = n),
        (this.version = n.version),
        (this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0));
    }
  }
  class ho {
    constructor(t) {
      ((this.computed = t),
        (this.version = 0),
        (this.activeLink = void 0),
        (this.subs = void 0),
        (this.map = void 0),
        (this.key = void 0),
        (this.sc = 0),
        (this.subsHead = void 0));
    }
    track(t) {
      if (!fe || !it || fe === this.computed) return;
      let n = this.activeLink;
      if (n === void 0 || n.sub !== fe)
        ((n = this.activeLink = new Ap(fe, this)),
          fe.deps
            ? ((n.prevDep = fe.depsTail), (fe.depsTail.nextDep = n), (fe.depsTail = n))
            : (fe.deps = fe.depsTail = n),
          kl(n));
      else if (n.version === -1 && ((n.version = this.version), n.nextDep)) {
        const r = n.nextDep;
        ((r.prevDep = n.prevDep),
          n.prevDep && (n.prevDep.nextDep = r),
          (n.prevDep = fe.depsTail),
          (n.nextDep = void 0),
          (fe.depsTail.nextDep = n),
          (fe.depsTail = n),
          fe.deps === n && (fe.deps = r));
      }
      return (fe.onTrack && fe.onTrack(ve({ effect: fe }, t)), n);
    }
    trigger(t) {
      (this.version++, sr++, this.notify(t));
    }
    notify(t) {
      uo();
      try {
        if (xp.NODE_ENV !== 'production')
          for (let n = this.subsHead; n; n = n.nextSub)
            n.sub.onTrigger && !(n.sub.flags & 8) && n.sub.onTrigger(ve({ effect: n.sub }, t));
        for (let n = this.subs; n; n = n.prevSub) n.sub.notify() && n.sub.dep.notify();
      } finally {
        co();
      }
    }
  }
  function kl(e) {
    if ((e.dep.sc++, e.sub.flags & 4)) {
      const t = e.dep.computed;
      if (t && !e.dep.subs) {
        t.flags |= 20;
        for (let r = t.deps; r; r = r.nextDep) kl(r);
      }
      const n = e.dep.subs;
      (n !== e && ((e.prevSub = n), n && (n.nextSub = e)),
        e.dep.subsHead === void 0 && (e.dep.subsHead = e),
        (e.dep.subs = e));
    }
  }
  const es = new WeakMap(),
    on = Symbol('Object iterate'),
    mo = Symbol('Map keys iterate'),
    or = Symbol('Array iterate');
  function Te(e, t, n) {
    if (it && fe) {
      let r = es.get(e);
      r || es.set(e, (r = new Map()));
      let s = r.get(n);
      (s || (r.set(n, (s = new ho())), (s.map = r), (s.key = n)),
        s.track({ target: e, type: t, key: n }));
    }
  }
  function pt(e, t, n, r, s, o) {
    const i = es.get(e);
    if (!i) {
      sr++;
      return;
    }
    const l = (a) => {
      a && a.trigger({ target: e, type: t, key: n, newValue: r, oldValue: s, oldTarget: o });
    };
    if ((uo(), t === 'clear')) i.forEach(l);
    else {
      const a = z(e),
        c = a && oo(n);
      if (a && n === 'length') {
        const u = Number(r);
        i.forEach((f, d) => {
          (d === 'length' || d === or || (!It(d) && d >= u)) && l(f);
        });
      } else
        switch (((n !== void 0 || i.has(void 0)) && l(i.get(n)), c && l(i.get(or)), t)) {
          case 'add':
            a ? c && l(i.get('length')) : (l(i.get(on)), nn(e) && l(i.get(mo)));
            break;
          case 'delete':
            a || (l(i.get(on)), nn(e) && l(i.get(mo)));
            break;
          case 'set':
            nn(e) && l(i.get(on));
            break;
        }
    }
    co();
  }
  function Tp(e, t) {
    const n = es.get(e);
    return n && n.get(t);
  }
  function kn(e) {
    const t = Q(e);
    return t === e ? t : (Te(t, 'iterate', or), Ne(e) ? t : t.map(De));
  }
  function ts(e) {
    return (Te((e = Q(e)), 'iterate', or), e);
  }
  const Op = {
    __proto__: null,
    [Symbol.iterator]() {
      return go(this, Symbol.iterator, De);
    },
    concat(...e) {
      return kn(this).concat(...e.map((t) => (z(t) ? kn(t) : t)));
    },
    entries() {
      return go(this, 'entries', (e) => ((e[1] = De(e[1])), e));
    },
    every(e, t) {
      return Bt(this, 'every', e, t, void 0, arguments);
    },
    filter(e, t) {
      return Bt(this, 'filter', e, t, (n) => n.map(De), arguments);
    },
    find(e, t) {
      return Bt(this, 'find', e, t, De, arguments);
    },
    findIndex(e, t) {
      return Bt(this, 'findIndex', e, t, void 0, arguments);
    },
    findLast(e, t) {
      return Bt(this, 'findLast', e, t, De, arguments);
    },
    findLastIndex(e, t) {
      return Bt(this, 'findLastIndex', e, t, void 0, arguments);
    },
    forEach(e, t) {
      return Bt(this, 'forEach', e, t, void 0, arguments);
    },
    includes(...e) {
      return _o(this, 'includes', e);
    },
    indexOf(...e) {
      return _o(this, 'indexOf', e);
    },
    join(e) {
      return kn(this).join(e);
    },
    lastIndexOf(...e) {
      return _o(this, 'lastIndexOf', e);
    },
    map(e, t) {
      return Bt(this, 'map', e, t, void 0, arguments);
    },
    pop() {
      return ir(this, 'pop');
    },
    push(...e) {
      return ir(this, 'push', e);
    },
    reduce(e, ...t) {
      return Il(this, 'reduce', e, t);
    },
    reduceRight(e, ...t) {
      return Il(this, 'reduceRight', e, t);
    },
    shift() {
      return ir(this, 'shift');
    },
    some(e, t) {
      return Bt(this, 'some', e, t, void 0, arguments);
    },
    splice(...e) {
      return ir(this, 'splice', e);
    },
    toReversed() {
      return kn(this).toReversed();
    },
    toSorted(e) {
      return kn(this).toSorted(e);
    },
    toSpliced(...e) {
      return kn(this).toSpliced(...e);
    },
    unshift(...e) {
      return ir(this, 'unshift', e);
    },
    values() {
      return go(this, 'values', De);
    }
  };
  function go(e, t, n) {
    const r = ts(e),
      s = r[t]();
    return (
      r !== e &&
        !Ne(e) &&
        ((s._next = s.next),
        (s.next = () => {
          const o = s._next();
          return (o.value && (o.value = n(o.value)), o);
        })),
      s
    );
  }
  const kp = Array.prototype;
  function Bt(e, t, n, r, s, o) {
    const i = ts(e),
      l = i !== e && !Ne(e),
      a = i[t];
    if (a !== kp[t]) {
      const f = a.apply(e, o);
      return l ? De(f) : f;
    }
    let c = n;
    i !== e &&
      (l
        ? (c = function (f, d) {
            return n.call(this, De(f), d, e);
          })
        : n.length > 2 &&
          (c = function (f, d) {
            return n.call(this, f, d, e);
          }));
    const u = a.call(i, c, r);
    return l && s ? s(u) : u;
  }
  function Il(e, t, n, r) {
    const s = ts(e);
    let o = n;
    return (
      s !== e &&
        (Ne(e)
          ? n.length > 3 &&
            (o = function (i, l, a) {
              return n.call(this, i, l, a, e);
            })
          : (o = function (i, l, a) {
              return n.call(this, i, De(l), a, e);
            })),
      s[t](o, ...r)
    );
  }
  function _o(e, t, n) {
    const r = Q(e);
    Te(r, 'iterate', or);
    const s = r[t](...n);
    return (s === -1 || s === !1) && lr(n[0]) ? ((n[0] = Q(n[0])), r[t](...n)) : s;
  }
  function ir(e, t, n = []) {
    (Dt(), uo());
    const r = Q(e)[t].apply(e, n);
    return (co(), Pt(), r);
  }
  const Ip = kt('__proto__,__v_isRef,__isVue'),
    Rl = new Set(
      Object.getOwnPropertyNames(Symbol)
        .filter((e) => e !== 'arguments' && e !== 'caller')
        .map((e) => Symbol[e])
        .filter(It)
    );
  function Rp(e) {
    It(e) || (e = String(e));
    const t = Q(this);
    return (Te(t, 'has', e), t.hasOwnProperty(e));
  }
  class Dl {
    constructor(t = !1, n = !1) {
      ((this._isReadonly = t), (this._isShallow = n));
    }
    get(t, n, r) {
      if (n === '__v_skip') return t.__v_skip;
      const s = this._isReadonly,
        o = this._isShallow;
      if (n === '__v_isReactive') return !s;
      if (n === '__v_isReadonly') return s;
      if (n === '__v_isShallow') return o;
      if (n === '__v_raw')
        return r === (s ? (o ? Vl : Ll) : o ? Nl : Fl).get(t) ||
          Object.getPrototypeOf(t) === Object.getPrototypeOf(r)
          ? t
          : void 0;
      const i = z(t);
      if (!s) {
        let a;
        if (i && (a = Op[n])) return a;
        if (n === 'hasOwnProperty') return Rp;
      }
      const l = Reflect.get(t, n, me(t) ? t : r);
      return (It(n) ? Rl.has(n) : Ip(n)) || (s || Te(t, 'get', n), o)
        ? l
        : me(l)
          ? i && oo(n)
            ? l
            : l.value
          : ue(l)
            ? s
              ? Ml(l)
              : os(l)
            : l;
    }
  }
  class Pl extends Dl {
    constructor(t = !1) {
      super(!1, t);
    }
    set(t, n, r, s) {
      let o = t[n];
      if (!this._isShallow) {
        const a = $t(o);
        if ((!Ne(r) && !$t(r) && ((o = Q(o)), (r = Q(r))), !z(t) && me(o) && !me(r)))
          return a ? !1 : ((o.value = r), !0);
      }
      const i = z(t) && oo(n) ? Number(n) < t.length : le(t, n),
        l = Reflect.set(t, n, r, me(t) ? t : s);
      return (t === Q(s) && (i ? Ut(r, o) && pt(t, 'set', n, r, o) : pt(t, 'add', n, r)), l);
    }
    deleteProperty(t, n) {
      const r = le(t, n),
        s = t[n],
        o = Reflect.deleteProperty(t, n);
      return (o && r && pt(t, 'delete', n, void 0, s), o);
    }
    has(t, n) {
      const r = Reflect.has(t, n);
      return ((!It(n) || !Rl.has(n)) && Te(t, 'has', n), r);
    }
    ownKeys(t) {
      return (Te(t, 'iterate', z(t) ? 'length' : on), Reflect.ownKeys(t));
    }
  }
  class Bl extends Dl {
    constructor(t = !1) {
      super(!0, t);
    }
    set(t, n) {
      return (et(`Set operation on key "${String(n)}" failed: target is readonly.`, t), !0);
    }
    deleteProperty(t, n) {
      return (et(`Delete operation on key "${String(n)}" failed: target is readonly.`, t), !0);
    }
  }
  const Dp = new Pl(),
    Pp = new Bl(),
    Bp = new Pl(!0),
    $p = new Bl(!0),
    yo = (e) => e,
    ns = (e) => Reflect.getPrototypeOf(e);
  function Fp(e, t, n) {
    return function (...r) {
      const s = this.__v_raw,
        o = Q(s),
        i = nn(o),
        l = e === 'entries' || (e === Symbol.iterator && i),
        a = e === 'keys' && i,
        c = s[e](...r),
        u = n ? yo : t ? vo : De;
      return (
        !t && Te(o, 'iterate', a ? mo : on),
        {
          next() {
            const { value: f, done: d } = c.next();
            return d ? { value: f, done: d } : { value: l ? [u(f[0]), u(f[1])] : u(f), done: d };
          },
          [Symbol.iterator]() {
            return this;
          }
        }
      );
    };
  }
  function rs(e) {
    return function (...t) {
      {
        const n = t[0] ? `on key "${t[0]}" ` : '';
        et(`${rn(e)} operation ${n}failed: target is readonly.`, Q(this));
      }
      return e === 'delete' ? !1 : e === 'clear' ? void 0 : this;
    };
  }
  function Np(e, t) {
    const n = {
      get(s) {
        const o = this.__v_raw,
          i = Q(o),
          l = Q(s);
        e || (Ut(s, l) && Te(i, 'get', s), Te(i, 'get', l));
        const { has: a } = ns(i),
          c = t ? yo : e ? vo : De;
        if (a.call(i, s)) return c(o.get(s));
        if (a.call(i, l)) return c(o.get(l));
        o !== i && o.get(s);
      },
      get size() {
        const s = this.__v_raw;
        return (!e && Te(Q(s), 'iterate', on), Reflect.get(s, 'size', s));
      },
      has(s) {
        const o = this.__v_raw,
          i = Q(o),
          l = Q(s);
        return (
          e || (Ut(s, l) && Te(i, 'has', s), Te(i, 'has', l)),
          s === l ? o.has(s) : o.has(s) || o.has(l)
        );
      },
      forEach(s, o) {
        const i = this,
          l = i.__v_raw,
          a = Q(l),
          c = t ? yo : e ? vo : De;
        return (!e && Te(a, 'iterate', on), l.forEach((u, f) => s.call(o, c(u), c(f), i)));
      }
    };
    return (
      ve(
        n,
        e
          ? { add: rs('add'), set: rs('set'), delete: rs('delete'), clear: rs('clear') }
          : {
              add(s) {
                !t && !Ne(s) && !$t(s) && (s = Q(s));
                const o = Q(this);
                return (ns(o).has.call(o, s) || (o.add(s), pt(o, 'add', s, s)), this);
              },
              set(s, o) {
                !t && !Ne(o) && !$t(o) && (o = Q(o));
                const i = Q(this),
                  { has: l, get: a } = ns(i);
                let c = l.call(i, s);
                c ? $l(i, l, s) : ((s = Q(s)), (c = l.call(i, s)));
                const u = a.call(i, s);
                return (
                  i.set(s, o),
                  c ? Ut(o, u) && pt(i, 'set', s, o, u) : pt(i, 'add', s, o),
                  this
                );
              },
              delete(s) {
                const o = Q(this),
                  { has: i, get: l } = ns(o);
                let a = i.call(o, s);
                a ? $l(o, i, s) : ((s = Q(s)), (a = i.call(o, s)));
                const c = l ? l.call(o, s) : void 0,
                  u = o.delete(s);
                return (a && pt(o, 'delete', s, void 0, c), u);
              },
              clear() {
                const s = Q(this),
                  o = s.size !== 0,
                  i = nn(s) ? new Map(s) : new Set(s),
                  l = s.clear();
                return (o && pt(s, 'clear', void 0, void 0, i), l);
              }
            }
      ),
      ['keys', 'values', 'entries', Symbol.iterator].forEach((s) => {
        n[s] = Fp(s, e, t);
      }),
      n
    );
  }
  function ss(e, t) {
    const n = Np(e, t);
    return (r, s, o) =>
      s === '__v_isReactive'
        ? !e
        : s === '__v_isReadonly'
          ? e
          : s === '__v_raw'
            ? r
            : Reflect.get(le(n, s) && s in r ? n : r, s, o);
  }
  const Lp = { get: ss(!1, !1) },
    Vp = { get: ss(!1, !0) },
    Mp = { get: ss(!0, !1) },
    Up = { get: ss(!0, !0) };
  function $l(e, t, n) {
    const r = Q(n);
    if (r !== n && t.call(e, r)) {
      const s = so(e);
      et(
        `Reactive ${s} contains both the raw and reactive versions of the same object${s === 'Map' ? ' as keys' : ''}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
      );
    }
  }
  const Fl = new WeakMap(),
    Nl = new WeakMap(),
    Ll = new WeakMap(),
    Vl = new WeakMap();
  function Hp(e) {
    switch (e) {
      case 'Object':
      case 'Array':
        return 1;
      case 'Map':
      case 'Set':
      case 'WeakMap':
      case 'WeakSet':
        return 2;
      default:
        return 0;
    }
  }
  function jp(e) {
    return e.__v_skip || !Object.isExtensible(e) ? 0 : Hp(so(e));
  }
  function os(e) {
    return $t(e) ? e : is(e, !1, Dp, Lp, Fl);
  }
  function zp(e) {
    return is(e, !1, Bp, Vp, Nl);
  }
  function Ml(e) {
    return is(e, !0, Pp, Mp, Ll);
  }
  function ht(e) {
    return is(e, !0, $p, Up, Vl);
  }
  function is(e, t, n, r, s) {
    if (!ue(e)) return (et(`value cannot be made ${t ? 'readonly' : 'reactive'}: ${String(e)}`), e);
    if (e.__v_raw && !(t && e.__v_isReactive)) return e;
    const o = s.get(e);
    if (o) return o;
    const i = jp(e);
    if (i === 0) return e;
    const l = new Proxy(e, i === 2 ? r : n);
    return (s.set(e, l), l);
  }
  function mt(e) {
    return $t(e) ? mt(e.__v_raw) : !!(e && e.__v_isReactive);
  }
  function $t(e) {
    return !!(e && e.__v_isReadonly);
  }
  function Ne(e) {
    return !!(e && e.__v_isShallow);
  }
  function lr(e) {
    return e ? !!e.__v_raw : !1;
  }
  function Q(e) {
    const t = e && e.__v_raw;
    return t ? Q(t) : e;
  }
  function Ht(e) {
    return (!le(e, '__v_skip') && Object.isExtensible(e) && Xr(e, '__v_skip', !0), e);
  }
  const De = (e) => (ue(e) ? os(e) : e),
    vo = (e) => (ue(e) ? Ml(e) : e);
  function me(e) {
    return e ? e.__v_isRef === !0 : !1;
  }
  function se(e) {
    return Kp(e, !1);
  }
  function Kp(e, t) {
    return me(e) ? e : new Wp(e, t);
  }
  class Wp {
    constructor(t, n) {
      ((this.dep = new ho()),
        (this.__v_isRef = !0),
        (this.__v_isShallow = !1),
        (this._rawValue = n ? t : Q(t)),
        (this._value = n ? t : De(t)),
        (this.__v_isShallow = n));
    }
    get value() {
      return (this.dep.track({ target: this, type: 'get', key: 'value' }), this._value);
    }
    set value(t) {
      const n = this._rawValue,
        r = this.__v_isShallow || Ne(t) || $t(t);
      ((t = r ? t : Q(t)),
        Ut(t, n) &&
          ((this._rawValue = t),
          (this._value = r ? t : De(t)),
          this.dep.trigger({ target: this, type: 'set', key: 'value', newValue: t, oldValue: n })));
    }
  }
  function jt(e) {
    return me(e) ? e.value : e;
  }
  const Gp = {
    get: (e, t, n) => (t === '__v_raw' ? e : jt(Reflect.get(e, t, n))),
    set: (e, t, n, r) => {
      const s = e[t];
      return me(s) && !me(n) ? ((s.value = n), !0) : Reflect.set(e, t, n, r);
    }
  };
  function Ul(e) {
    return mt(e) ? e : new Proxy(e, Gp);
  }
  function Hl(e) {
    lr(e) || et('toRefs() expects a reactive object but received a plain one.');
    const t = z(e) ? new Array(e.length) : {};
    for (const n in e) t[n] = jl(e, n);
    return t;
  }
  class Jp {
    constructor(t, n, r) {
      ((this._object = t),
        (this._key = n),
        (this._defaultValue = r),
        (this.__v_isRef = !0),
        (this._value = void 0));
    }
    get value() {
      const t = this._object[this._key];
      return (this._value = t === void 0 ? this._defaultValue : t);
    }
    set value(t) {
      this._object[this._key] = t;
    }
    get dep() {
      return Tp(Q(this._object), this._key);
    }
  }
  class Yp {
    constructor(t) {
      ((this._getter = t),
        (this.__v_isRef = !0),
        (this.__v_isReadonly = !0),
        (this._value = void 0));
    }
    get value() {
      return (this._value = this._getter());
    }
  }
  function qo(e, t, n) {
    return me(e) ? e : G(e) ? new Yp(e) : ue(e) && arguments.length > 1 ? jl(e, t, n) : se(e);
  }
  function jl(e, t, n) {
    const r = e[t];
    return me(r) ? r : new Jp(e, t, n);
  }
  class Qp {
    constructor(t, n, r) {
      ((this.fn = t),
        (this.setter = n),
        (this._value = void 0),
        (this.dep = new ho(this)),
        (this.__v_isRef = !0),
        (this.deps = void 0),
        (this.depsTail = void 0),
        (this.flags = 16),
        (this.globalVersion = sr - 1),
        (this.next = void 0),
        (this.effect = this),
        (this.__v_isReadonly = !n),
        (this.isSSR = r));
    }
    notify() {
      if (((this.flags |= 16), !(this.flags & 8) && fe !== this)) return (xl(this, !0), !0);
    }
    get value() {
      const t = this.dep.track({ target: this, type: 'get', key: 'value' });
      return (Al(this), t && (t.version = this.dep.version), this._value);
    }
    set value(t) {
      this.setter ? this.setter(t) : et('Write operation failed: computed value is readonly');
    }
  }
  function Zp(e, t, n = !1) {
    let r, s;
    return (G(e) ? (r = e) : ((r = e.get), (s = e.set)), new Qp(r, s, n));
  }
  const ls = {},
    as = new WeakMap();
  let ln;
  function Xp(e, t = !1, n = ln) {
    if (n) {
      let r = as.get(n);
      (r || as.set(n, (r = [])), r.push(e));
    } else
      t || et('onWatcherCleanup() was called when there was no active watcher to associate with.');
  }
  function eh(e, t, n = ce) {
    const { immediate: r, deep: s, once: o, scheduler: i, augmentJob: l, call: a } = n,
      c = (B) => {
        (n.onWarn || et)(
          'Invalid watch source: ',
          B,
          'A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.'
        );
      },
      u = (B) => (s ? B : Ne(B) || s === !1 || s === 0 ? Ft(B, 1) : Ft(B));
    let f,
      d,
      h,
      g,
      v = !1,
      y = !1;
    if (
      (me(e)
        ? ((d = () => e.value), (v = Ne(e)))
        : mt(e)
          ? ((d = () => u(e)), (v = !0))
          : z(e)
            ? ((y = !0),
              (v = e.some((B) => mt(B) || Ne(B))),
              (d = () =>
                e.map((B) => {
                  if (me(B)) return B.value;
                  if (mt(B)) return u(B);
                  if (G(B)) return a ? a(B, 2) : B();
                  c(B);
                })))
            : G(e)
              ? t
                ? (d = a ? () => a(e, 2) : e)
                : (d = () => {
                    if (h) {
                      Dt();
                      try {
                        h();
                      } finally {
                        Pt();
                      }
                    }
                    const B = ln;
                    ln = f;
                    try {
                      return a ? a(e, 3, [g]) : e(g);
                    } finally {
                      ln = B;
                    }
                  })
              : ((d = Ie), c(e)),
      t && s)
    ) {
      const B = d,
        J = s === !0 ? 1 / 0 : s;
      d = () => Ft(B(), J);
    }
    const E = bl(),
      N = () => {
        (f.stop(), E && E.active && no(E.effects, f));
      };
    if (o && t) {
      const B = t;
      t = (...J) => {
        (B(...J), N());
      };
    }
    let P = y ? new Array(e.length).fill(ls) : ls;
    const te = (B) => {
      if (!(!(f.flags & 1) || (!f.dirty && !B)))
        if (t) {
          const J = f.run();
          if (s || v || (y ? J.some((V, ae) => Ut(V, P[ae])) : Ut(J, P))) {
            h && h();
            const V = ln;
            ln = f;
            try {
              const ae = [J, P === ls ? void 0 : y && P[0] === ls ? [] : P, g];
              (a ? a(t, 3, ae) : t(...ae), (P = J));
            } finally {
              ln = V;
            }
          }
        } else f.run();
    };
    return (
      l && l(te),
      (f = new El(d)),
      (f.scheduler = i ? () => i(te, !1) : te),
      (g = (B) => Xp(B, !1, f)),
      (h = f.onStop =
        () => {
          const B = as.get(f);
          if (B) {
            if (a) a(B, 4);
            else for (const J of B) J();
            as.delete(f);
          }
        }),
      (f.onTrack = n.onTrack),
      (f.onTrigger = n.onTrigger),
      t ? (r ? te(!0) : (P = f.run())) : i ? i(te.bind(null, !0), !0) : f.run(),
      (N.pause = f.pause.bind(f)),
      (N.resume = f.resume.bind(f)),
      (N.stop = N),
      N
    );
  }
  function Ft(e, t = 1 / 0, n) {
    if (t <= 0 || !ue(e) || e.__v_skip || ((n = n || new Set()), n.has(e))) return e;
    if ((n.add(e), t--, me(e))) Ft(e.value, t, n);
    else if (z(e)) for (let r = 0; r < e.length; r++) Ft(e[r], t, n);
    else if (dl(e) || nn(e))
      e.forEach((r) => {
        Ft(r, t, n);
      });
    else if (hl(e)) {
      for (const r in e) Ft(e[r], t, n);
      for (const r of Object.getOwnPropertySymbols(e))
        Object.prototype.propertyIsEnumerable.call(e, r) && Ft(e[r], t, n);
    }
    return e;
  }
  var zt = { NODE_ENV: '"production"' };
  const an = [];
  function us(e) {
    an.push(e);
  }
  function cs() {
    an.pop();
  }
  let bo = !1;
  function k(e, ...t) {
    if (bo) return;
    ((bo = !0), Dt());
    const n = an.length ? an[an.length - 1].component : null,
      r = n && n.appContext.config.warnHandler,
      s = th();
    if (r)
      In(r, n, 11, [
        e +
          t
            .map((o) => {
              var i, l;
              return (l = (i = o.toString) == null ? void 0 : i.call(o)) != null
                ? l
                : JSON.stringify(o);
            })
            .join(''),
        n && n.proxy,
        s.map(({ vnode: o }) => `at <${Ts(n, o.type)}>`).join(`
`),
        s
      ]);
    else {
      const o = [`[Vue warn]: ${e}`, ...t];
      (s.length &&
        o.push(
          `
`,
          ...nh(s)
        ),
        console.warn(...o));
    }
    (Pt(), (bo = !1));
  }
  function th() {
    let e = an[an.length - 1];
    if (!e) return [];
    const t = [];
    for (; e; ) {
      const n = t[0];
      n && n.vnode === e ? n.recurseCount++ : t.push({ vnode: e, recurseCount: 0 });
      const r = e.component && e.component.parent;
      e = r && r.vnode;
    }
    return t;
  }
  function nh(e) {
    const t = [];
    return (
      e.forEach((n, r) => {
        t.push(
          ...(r === 0
            ? []
            : [
                `
`
              ]),
          ...rh(n)
        );
      }),
      t
    );
  }
  function rh({ vnode: e, recurseCount: t }) {
    const n = t > 0 ? `... (${t} recursive calls)` : '',
      r = e.component ? e.component.parent == null : !1,
      s = ` at <${Ts(e.component, e.type, r)}`,
      o = '>' + n;
    return e.props ? [s, ...sh(e.props), o] : [s + o];
  }
  function sh(e) {
    const t = [],
      n = Object.keys(e);
    return (
      n.slice(0, 3).forEach((r) => {
        t.push(...zl(r, e[r]));
      }),
      n.length > 3 && t.push(' ...'),
      t
    );
  }
  function zl(e, t, n) {
    return ye(t)
      ? ((t = JSON.stringify(t)), n ? t : [`${e}=${t}`])
      : typeof t == 'number' || typeof t == 'boolean' || t == null
        ? n
          ? t
          : [`${e}=${t}`]
        : me(t)
          ? ((t = zl(e, Q(t.value), !0)), n ? t : [`${e}=Ref<`, t, '>'])
          : G(t)
            ? [`${e}=fn${t.name ? `<${t.name}>` : ''}`]
            : ((t = Q(t)), n ? t : [`${e}=`, t]);
  }
  function oh(e, t) {
    e !== void 0 &&
      (typeof e != 'number'
        ? k(`${t} is not a valid number - got ${JSON.stringify(e)}.`)
        : isNaN(e) && k(`${t} is NaN - the duration expression might be incorrect.`));
  }
  const Eo = {
    sp: 'serverPrefetch hook',
    bc: 'beforeCreate hook',
    c: 'created hook',
    bm: 'beforeMount hook',
    m: 'mounted hook',
    bu: 'beforeUpdate hook',
    u: 'updated',
    bum: 'beforeUnmount hook',
    um: 'unmounted hook',
    a: 'activated hook',
    da: 'deactivated hook',
    ec: 'errorCaptured hook',
    rtc: 'renderTracked hook',
    rtg: 'renderTriggered hook',
    0: 'setup function',
    1: 'render function',
    2: 'watcher getter',
    3: 'watcher callback',
    4: 'watcher cleanup function',
    5: 'native event handler',
    6: 'component event handler',
    7: 'vnode hook',
    8: 'directive hook',
    9: 'transition hook',
    10: 'app errorHandler',
    11: 'app warnHandler',
    12: 'ref function',
    13: 'async component loader',
    14: 'scheduler flush',
    15: 'component update',
    16: 'app unmount cleanup function'
  };
  function In(e, t, n, r) {
    try {
      return r ? e(...r) : e();
    } catch (s) {
      ar(s, t, n);
    }
  }
  function lt(e, t, n, r) {
    if (G(e)) {
      const s = In(e, t, n, r);
      return (
        s &&
          ro(s) &&
          s.catch((o) => {
            ar(o, t, n);
          }),
        s
      );
    }
    if (z(e)) {
      const s = [];
      for (let o = 0; o < e.length; o++) s.push(lt(e[o], t, n, r));
      return s;
    } else k(`Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`);
  }
  function ar(e, t, n, r = !0) {
    const s = t ? t.vnode : null,
      { errorHandler: o, throwUnhandledErrorInProduction: i } = (t && t.appContext.config) || ce;
    if (t) {
      let l = t.parent;
      const a = t.proxy,
        c = Eo[n];
      for (; l; ) {
        const u = l.ec;
        if (u) {
          for (let f = 0; f < u.length; f++) if (u[f](e, a, c) === !1) return;
        }
        l = l.parent;
      }
      if (o) {
        (Dt(), In(o, null, 10, [e, a, c]), Pt());
        return;
      }
    }
    ih(e, n, s, r, i);
  }
  function ih(e, t, n, r = !0, s = !1) {
    {
      const o = Eo[t];
      if ((n && us(n), k(`Unhandled error${o ? ` during execution of ${o}` : ''}`), n && cs(), r))
        throw e;
      console.error(e);
    }
  }
  const Le = [];
  let gt = -1;
  const Rn = [];
  let Kt = null,
    Dn = 0;
  const Kl = Promise.resolve();
  let fs = null;
  const lh = 100;
  function wo(e) {
    const t = fs || Kl;
    return e ? t.then(this ? e.bind(this) : e) : t;
  }
  function ah(e) {
    let t = gt + 1,
      n = Le.length;
    for (; t < n; ) {
      const r = (t + n) >>> 1,
        s = Le[r],
        o = ur(s);
      o < e || (o === e && s.flags & 2) ? (t = r + 1) : (n = r);
    }
    return t;
  }
  function ds(e) {
    if (!(e.flags & 1)) {
      const t = ur(e),
        n = Le[Le.length - 1];
      (!n || (!(e.flags & 2) && t >= ur(n)) ? Le.push(e) : Le.splice(ah(t), 0, e),
        (e.flags |= 1),
        Wl());
    }
  }
  function Wl() {
    fs || (fs = Kl.then(Yl));
  }
  function xo(e) {
    (z(e)
      ? Rn.push(...e)
      : Kt && e.id === -1
        ? Kt.splice(Dn + 1, 0, e)
        : e.flags & 1 || (Rn.push(e), (e.flags |= 1)),
      Wl());
  }
  function Gl(e, t, n = gt + 1) {
    for (t = t || new Map(); n < Le.length; n++) {
      const r = Le[n];
      if (r && r.flags & 2) {
        if ((e && r.id !== e.uid) || So(t, r)) continue;
        (Le.splice(n, 1), n--, r.flags & 4 && (r.flags &= -2), r(), r.flags & 4 || (r.flags &= -2));
      }
    }
  }
  function Jl(e) {
    if (Rn.length) {
      const t = [...new Set(Rn)].sort((n, r) => ur(n) - ur(r));
      if (((Rn.length = 0), Kt)) {
        Kt.push(...t);
        return;
      }
      for (Kt = t, e = e || new Map(), Dn = 0; Dn < Kt.length; Dn++) {
        const n = Kt[Dn];
        So(e, n) || (n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), (n.flags &= -2));
      }
      ((Kt = null), (Dn = 0));
    }
  }
  const ur = (e) => (e.id == null ? (e.flags & 2 ? -1 : 1 / 0) : e.id);
  function Yl(e) {
    e = e || new Map();
    const t = (n) => So(e, n);
    try {
      for (gt = 0; gt < Le.length; gt++) {
        const n = Le[gt];
        if (n && !(n.flags & 8)) {
          if (zt.NODE_ENV !== 'production' && t(n)) continue;
          (n.flags & 4 && (n.flags &= -2),
            In(n, n.i, n.i ? 15 : 14),
            n.flags & 4 || (n.flags &= -2));
        }
      }
    } finally {
      for (; gt < Le.length; gt++) {
        const n = Le[gt];
        n && (n.flags &= -2);
      }
      ((gt = -1), (Le.length = 0), Jl(e), (fs = null), (Le.length || Rn.length) && Yl(e));
    }
  }
  function So(e, t) {
    const n = e.get(t) || 0;
    if (n > lh) {
      const r = t.i,
        s = r && Go(r.type);
      return (
        ar(
          `Maximum recursive updates exceeded${s ? ` in component <${s}>` : ''}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
          null,
          10
        ),
        !0
      );
    }
    return (e.set(t, n + 1), !1);
  }
  let _t = !1;
  const ps = new Map();
  tr().__VUE_HMR_RUNTIME__ = { createRecord: Co(Ql), rerender: Co(fh), reload: Co(dh) };
  const un = new Map();
  function uh(e) {
    const t = e.type.__hmrId;
    let n = un.get(t);
    (n || (Ql(t, e.type), (n = un.get(t))), n.instances.add(e));
  }
  function ch(e) {
    un.get(e.type.__hmrId).instances.delete(e);
  }
  function Ql(e, t) {
    return un.has(e) ? !1 : (un.set(e, { initialDef: hs(t), instances: new Set() }), !0);
  }
  function hs(e) {
    return ru(e) ? e.__vccOpts : e;
  }
  function fh(e, t) {
    const n = un.get(e);
    n &&
      ((n.initialDef.render = t),
      [...n.instances].forEach((r) => {
        (t && ((r.render = t), (hs(r.type).render = t)),
          (r.renderCache = []),
          (_t = !0),
          r.update(),
          (_t = !1));
      }));
  }
  function dh(e, t) {
    const n = un.get(e);
    if (!n) return;
    ((t = hs(t)), Zl(n.initialDef, t));
    const r = [...n.instances];
    for (let s = 0; s < r.length; s++) {
      const o = r[s],
        i = hs(o.type);
      let l = ps.get(i);
      (l || (i !== n.initialDef && Zl(i, t), ps.set(i, (l = new Set()))),
        l.add(o),
        o.appContext.propsCache.delete(o.type),
        o.appContext.emitsCache.delete(o.type),
        o.appContext.optionsCache.delete(o.type),
        o.ceReload
          ? (l.add(o), o.ceReload(t.styles), l.delete(o))
          : o.parent
            ? ds(() => {
                ((_t = !0), o.parent.update(), (_t = !1), l.delete(o));
              })
            : o.appContext.reload
              ? o.appContext.reload()
              : typeof window < 'u'
                ? window.location.reload()
                : console.warn(
                    '[HMR] Root or manually mounted instance modified. Full reload required.'
                  ),
        o.root.ce && o !== o.root && o.root.ce._removeChildStyle(i));
    }
    xo(() => {
      ps.clear();
    });
  }
  function Zl(e, t) {
    ve(e, t);
    for (const n in e) n !== '__file' && !(n in t) && delete e[n];
  }
  function Co(e) {
    return (t, n) => {
      try {
        return e(t, n);
      } catch (r) {
        (console.error(r),
          console.warn(
            '[HMR] Something went wrong during Vue component hot-reload. Full reload required.'
          ));
      }
    };
  }
  let yt,
    cr = [],
    Ao = !1;
  function fr(e, ...t) {
    yt ? yt.emit(e, ...t) : Ao || cr.push({ event: e, args: t });
  }
  function Xl(e, t) {
    var n, r;
    ((yt = e),
      yt
        ? ((yt.enabled = !0), cr.forEach(({ event: s, args: o }) => yt.emit(s, ...o)), (cr = []))
        : typeof window < 'u' &&
            window.HTMLElement &&
            !(
              (r = (n = window.navigator) == null ? void 0 : n.userAgent) != null &&
              r.includes('jsdom')
            )
          ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((o) => {
              Xl(o, t);
            }),
            setTimeout(() => {
              yt || ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null), (Ao = !0), (cr = []));
            }, 3e3))
          : ((Ao = !0), (cr = [])));
  }
  function ph(e, t) {
    fr('app:init', e, t, { Fragment: Se, Text: qr, Comment: xe, Static: Fn });
  }
  function hh(e) {
    fr('app:unmount', e);
  }
  const mh = To('component:added'),
    ea = To('component:updated'),
    gh = To('component:removed'),
    _h = (e) => {
      yt && typeof yt.cleanupBuffer == 'function' && !yt.cleanupBuffer(e) && gh(e);
    };
  /*! #__NO_SIDE_EFFECTS__ */ function To(e) {
    return (t) => {
      fr(e, t.appContext.app, t.uid, t.parent ? t.parent.uid : void 0, t);
    };
  }
  const yh = ta('perf:start'),
    vh = ta('perf:end');
  function ta(e) {
    return (t, n, r) => {
      fr(e, t.appContext.app, t.uid, t, n, r);
    };
  }
  function qh(e, t, n) {
    fr('component:emit', e.appContext.app, e, t, n);
  }
  let we = null,
    na = null;
  function ms(e) {
    const t = we;
    return ((we = e), (na = (e && e.type.__scopeId) || null), t);
  }
  function dr(e, t = we, n) {
    if (!t || e._n) return e;
    const r = (...s) => {
      r._d && Ga(-1);
      const o = ms(t);
      let i;
      try {
        i = e(...s);
      } finally {
        (ms(o), r._d && Ga(1));
      }
      return (ea(t), i);
    };
    return ((r._n = !0), (r._c = !0), (r._d = !0), r);
  }
  function ra(e) {
    up(e) && k('Do not use built-in directive ids as custom directive id: ' + e);
  }
  function sa(e, t) {
    if (we === null) return (k('withDirectives can only be used inside render functions.'), e);
    const n = As(we),
      r = e.dirs || (e.dirs = []);
    for (let s = 0; s < t.length; s++) {
      let [o, i, l, a = ce] = t[s];
      o &&
        (G(o) && (o = { mounted: o, updated: o }),
        o.deep && Ft(i),
        r.push({ dir: o, instance: n, value: i, oldValue: void 0, arg: l, modifiers: a }));
    }
    return e;
  }
  function cn(e, t, n, r) {
    const s = e.dirs,
      o = t && t.dirs;
    for (let i = 0; i < s.length; i++) {
      const l = s[i];
      o && (l.oldValue = o[i].value);
      let a = l.dir[r];
      a && (Dt(), lt(a, n, 8, [e.el, l, e, t]), Pt());
    }
  }
  const bh = Symbol('_vte'),
    oa = (e) => e.__isTeleport,
    Wt = Symbol('_leaveCb'),
    gs = Symbol('_enterCb');
  function Eh() {
    const e = { isMounted: !1, isLeaving: !1, isUnmounting: !1, leavingVNodes: new Map() };
    return (
      mr(() => {
        e.isMounted = !0;
      }),
      Io(() => {
        e.isUnmounting = !0;
      }),
      e
    );
  }
  const tt = [Function, Array],
    ia = {
      mode: String,
      appear: Boolean,
      persisted: Boolean,
      onBeforeEnter: tt,
      onEnter: tt,
      onAfterEnter: tt,
      onEnterCancelled: tt,
      onBeforeLeave: tt,
      onLeave: tt,
      onAfterLeave: tt,
      onLeaveCancelled: tt,
      onBeforeAppear: tt,
      onAppear: tt,
      onAfterAppear: tt,
      onAppearCancelled: tt
    },
    la = (e) => {
      const t = e.subTree;
      return t.component ? la(t.component) : t;
    },
    wh = {
      name: 'BaseTransition',
      props: ia,
      setup(e, { slots: t }) {
        const n = Ss(),
          r = Eh();
        return () => {
          const s = t.default && fa(t.default(), !0);
          if (!s || !s.length) return;
          const o = aa(s),
            i = Q(e),
            { mode: l } = i;
          if (
            (l &&
              l !== 'in-out' &&
              l !== 'out-in' &&
              l !== 'default' &&
              k(`invalid <transition> mode: ${l}`),
            r.isLeaving)
          )
            return ko(o);
          const a = ca(o);
          if (!a) return ko(o);
          let c = Oo(a, i, r, n, (f) => (c = f));
          a.type !== xe && pr(a, c);
          let u = n.subTree && ca(n.subTree);
          if (u && u.type !== xe && !gn(a, u) && la(n).type !== xe) {
            let f = Oo(u, i, r, n);
            if ((pr(u, f), l === 'out-in' && a.type !== xe))
              return (
                (r.isLeaving = !0),
                (f.afterLeave = () => {
                  ((r.isLeaving = !1),
                    n.job.flags & 8 || n.update(),
                    delete f.afterLeave,
                    (u = void 0));
                }),
                ko(o)
              );
            l === 'in-out' && a.type !== xe
              ? (f.delayLeave = (d, h, g) => {
                  const v = ua(r, u);
                  ((v[String(u.key)] = u),
                    (d[Wt] = () => {
                      (h(), (d[Wt] = void 0), delete c.delayedLeave, (u = void 0));
                    }),
                    (c.delayedLeave = () => {
                      (g(), delete c.delayedLeave, (u = void 0));
                    }));
                })
              : (u = void 0);
          } else u && (u = void 0);
          return o;
        };
      }
    };
  function aa(e) {
    let t = e[0];
    if (e.length > 1) {
      let n = !1;
      for (const r of e)
        if (r.type !== xe) {
          if (n) {
            k(
              '<transition> can only be used on a single element or component. Use <transition-group> for lists.'
            );
            break;
          }
          ((t = r), (n = !0));
        }
    }
    return t;
  }
  const xh = wh;
  function ua(e, t) {
    const { leavingVNodes: n } = e;
    let r = n.get(t.type);
    return (r || ((r = Object.create(null)), n.set(t.type, r)), r);
  }
  function Oo(e, t, n, r, s) {
    const {
        appear: o,
        mode: i,
        persisted: l = !1,
        onBeforeEnter: a,
        onEnter: c,
        onAfterEnter: u,
        onEnterCancelled: f,
        onBeforeLeave: d,
        onLeave: h,
        onAfterLeave: g,
        onLeaveCancelled: v,
        onBeforeAppear: y,
        onAppear: E,
        onAfterAppear: N,
        onAppearCancelled: P
      } = t,
      te = String(e.key),
      B = ua(n, e),
      J = (U, I) => {
        U && lt(U, r, 9, I);
      },
      V = (U, I) => {
        const O = I[1];
        (J(U, I), z(U) ? U.every((T) => T.length <= 1) && O() : U.length <= 1 && O());
      },
      ae = {
        mode: i,
        persisted: l,
        beforeEnter(U) {
          let I = a;
          if (!n.isMounted)
            if (o) I = y || a;
            else return;
          U[Wt] && U[Wt](!0);
          const O = B[te];
          (O && gn(e, O) && O.el[Wt] && O.el[Wt](), J(I, [U]));
        },
        enter(U) {
          let I = c,
            O = u,
            T = f;
          if (!n.isMounted)
            if (o) ((I = E || c), (O = N || u), (T = P || f));
            else return;
          let ne = !1;
          const he = (U[gs] = (be) => {
            ne ||
              ((ne = !0),
              be ? J(T, [U]) : J(O, [U]),
              ae.delayedLeave && ae.delayedLeave(),
              (U[gs] = void 0));
          });
          I ? V(I, [U, he]) : he();
        },
        leave(U, I) {
          const O = String(e.key);
          if ((U[gs] && U[gs](!0), n.isUnmounting)) return I();
          J(d, [U]);
          let T = !1;
          const ne = (U[Wt] = (he) => {
            T ||
              ((T = !0),
              I(),
              he ? J(v, [U]) : J(g, [U]),
              (U[Wt] = void 0),
              B[O] === e && delete B[O]);
          });
          ((B[O] = e), h ? V(h, [U, ne]) : ne());
        },
        clone(U) {
          const I = Oo(U, t, n, r, s);
          return (s && s(I), I);
        }
      };
    return ae;
  }
  function ko(e) {
    if (hr(e)) return ((e = vt(e)), (e.children = null), e);
  }
  function ca(e) {
    if (!hr(e)) return oa(e.type) && e.children ? aa(e.children) : e;
    if (e.component) return e.component.subTree;
    const { shapeFlag: t, children: n } = e;
    if (n) {
      if (t & 16) return n[0];
      if (t & 32 && G(n.default)) return n.default();
    }
  }
  function pr(e, t) {
    e.shapeFlag & 6 && e.component
      ? ((e.transition = t), pr(e.component.subTree, t))
      : e.shapeFlag & 128
        ? ((e.ssContent.transition = t.clone(e.ssContent)),
          (e.ssFallback.transition = t.clone(e.ssFallback)))
        : (e.transition = t);
  }
  function fa(e, t = !1, n) {
    let r = [],
      s = 0;
    for (let o = 0; o < e.length; o++) {
      let i = e[o];
      const l = n == null ? i.key : String(n) + String(i.key != null ? i.key : o);
      i.type === Se
        ? (i.patchFlag & 128 && s++, (r = r.concat(fa(i.children, t, l))))
        : (t || i.type !== xe) && r.push(l != null ? vt(i, { key: l }) : i);
    }
    if (s > 1) for (let o = 0; o < r.length; o++) r[o].patchFlag = -2;
    return r;
  }
  /*! #__NO_SIDE_EFFECTS__ */ function nt(e, t) {
    return G(e) ? ve({ name: e.name }, t, { setup: e }) : e;
  }
  function da(e) {
    e.ids = [e.ids[0] + e.ids[2]++ + '-', 0, 0];
  }
  const Sh = new WeakSet();
  function _s(e, t, n, r, s = !1) {
    if (z(e)) {
      e.forEach((g, v) => _s(g, t && (z(t) ? t[v] : t), n, r, s));
      return;
    }
    if (Pn(r) && !s) {
      r.shapeFlag & 512 &&
        r.type.__asyncResolved &&
        r.component.subTree.component &&
        _s(e, t, n, r.component.subTree);
      return;
    }
    const o = r.shapeFlag & 4 ? As(r.component) : r.el,
      i = s ? null : o,
      { i: l, r: a } = e;
    if (!l) {
      k(
        'Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function.'
      );
      return;
    }
    const c = t && t.r,
      u = l.refs === ce ? (l.refs = {}) : l.refs,
      f = l.setupState,
      d = Q(f),
      h =
        f === ce
          ? () => !1
          : (g) => (
              le(d, g) &&
                !me(d[g]) &&
                k(
                  `Template ref "${g}" used on a non-ref value. It will not work in the production build.`
                ),
              Sh.has(d[g]) ? !1 : le(d, g)
            );
    if (
      (c != null &&
        c !== a &&
        (ye(c) ? ((u[c] = null), h(c) && (f[c] = null)) : me(c) && (c.value = null)),
      G(a))
    )
      In(a, l, 12, [i, u]);
    else {
      const g = ye(a),
        v = me(a);
      if (g || v) {
        const y = () => {
          if (e.f) {
            const E = g ? (h(a) ? f[a] : u[a]) : a.value;
            s
              ? z(E) && no(E, o)
              : z(E)
                ? E.includes(o) || E.push(o)
                : g
                  ? ((u[a] = [o]), h(a) && (f[a] = u[a]))
                  : ((a.value = [o]), e.k && (u[e.k] = a.value));
          } else
            g
              ? ((u[a] = i), h(a) && (f[a] = i))
              : v
                ? ((a.value = i), e.k && (u[e.k] = i))
                : k('Invalid template ref type:', a, `(${typeof a})`);
        };
        i ? ((y.id = -1), Je(y, n)) : y();
      } else k('Invalid template ref type:', a, `(${typeof a})`);
    }
  }
  (tr().requestIdleCallback, tr().cancelIdleCallback);
  const Pn = (e) => !!e.type.__asyncLoader,
    hr = (e) => e.type.__isKeepAlive;
  function Ch(e, t) {
    pa(e, 'a', t);
  }
  function Ah(e, t) {
    pa(e, 'da', t);
  }
  function pa(e, t, n = Ce) {
    const r =
      e.__wdc ||
      (e.__wdc = () => {
        let s = n;
        for (; s; ) {
          if (s.isDeactivated) return;
          s = s.parent;
        }
        return e();
      });
    if ((ys(t, r, n), n)) {
      let s = n.parent;
      for (; s && s.parent; ) (hr(s.parent.vnode) && Th(r, t, n, s), (s = s.parent));
    }
  }
  function Th(e, t, n, r) {
    const s = ys(t, e, r, !0);
    vs(() => {
      no(r[t], s);
    }, n);
  }
  function ys(e, t, n = Ce, r = !1) {
    if (n) {
      const s = n[e] || (n[e] = []),
        o =
          t.__weh ||
          (t.__weh = (...i) => {
            Dt();
            const l = wr(n),
              a = lt(t, n, e, i);
            return (l(), Pt(), a);
          });
      return (r ? s.unshift(o) : s.push(o), o);
    } else {
      const s = sn(Eo[e].replace(/ hook$/, ''));
      k(
        `${s} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
      );
    }
  }
  const Nt =
      (e) =>
      (t, n = Ce) => {
        (!xr || e === 'sp') && ys(e, (...r) => t(...r), n);
      },
    Oh = Nt('bm'),
    mr = Nt('m'),
    ha = Nt('bu'),
    kh = Nt('u'),
    Io = Nt('bum'),
    vs = Nt('um'),
    Ih = Nt('sp'),
    Rh = Nt('rtg'),
    Dh = Nt('rtc');
  function Ph(e, t = Ce) {
    ys('ec', e, t);
  }
  const Bh = 'components',
    ma = Symbol.for('v-ndc');
  function $h(e) {
    return ye(e) ? Fh(Bh, e, !1) || e : e || ma;
  }
  function Fh(e, t, n = !0, r = !1) {
    const s = we || Ce;
    if (s) {
      const o = s.type;
      {
        const l = Go(o, !1);
        if (l && (l === t || l === $e(t) || l === rn($e(t)))) return o;
      }
      const i = ga(s[e] || o[e], t) || ga(s.appContext[e], t);
      return !i && r
        ? o
        : (n &&
            !i &&
            k(`Failed to resolve ${e.slice(0, -1)}: ${t}
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.`),
          i);
    } else k(`resolve${rn(e.slice(0, -1))} can only be used in render() or setup().`);
  }
  function ga(e, t) {
    return e && (e[t] || e[$e(t)] || e[rn($e(t))]);
  }
  function gr(e, t, n, r) {
    let s;
    const o = n,
      i = z(e);
    if (i || ye(e)) {
      const l = i && mt(e);
      let a = !1;
      (l && ((a = !Ne(e)), (e = ts(e))), (s = new Array(e.length)));
      for (let c = 0, u = e.length; c < u; c++) s[c] = t(a ? De(e[c]) : e[c], c, void 0, o);
    } else if (typeof e == 'number') {
      (Number.isInteger(e) || k(`The v-for range expect an integer value but got ${e}.`),
        (s = new Array(e)));
      for (let l = 0; l < e; l++) s[l] = t(l + 1, l, void 0, o);
    } else if (ue(e))
      if (e[Symbol.iterator]) s = Array.from(e, (l, a) => t(l, a, void 0, o));
      else {
        const l = Object.keys(e);
        s = new Array(l.length);
        for (let a = 0, c = l.length; a < c; a++) {
          const u = l[a];
          s[a] = t(e[u], u, a, o);
        }
      }
    else s = [];
    return s;
  }
  function Ro(e, t, n = {}, r, s) {
    if (we.ce || (we.parent && Pn(we.parent) && we.parent.ce))
      return (H(), hn(Se, null, [j('slot', n, r && r())], 64));
    let o = e[t];
    (o &&
      o.length > 1 &&
      (k(
        'SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template.'
      ),
      (o = () => [])),
      o && o._c && (o._d = !1),
      H());
    const i = o && _a(o(n)),
      l = n.key || (i && i.key),
      a = hn(
        Se,
        { key: (l && !It(l) ? l : `_${t}`) + (!i && r ? '_fb' : '') },
        i || (r ? r() : []),
        i && e._ === 1 ? 64 : -2
      );
    return (a.scopeId && (a.slotScopeIds = [a.scopeId + '-s']), o && o._c && (o._d = !0), a);
  }
  function _a(e) {
    return e.some((t) => (mn(t) ? !(t.type === xe || (t.type === Se && !_a(t.children))) : !0))
      ? e
      : null;
  }
  const Do = (e) => (e ? (eu(e) ? As(e) : Do(e.parent)) : null),
    fn = ve(Object.create(null), {
      $: (e) => e,
      $el: (e) => e.vnode.el,
      $data: (e) => e.data,
      $props: (e) => ht(e.props),
      $attrs: (e) => ht(e.attrs),
      $slots: (e) => ht(e.slots),
      $refs: (e) => ht(e.refs),
      $parent: (e) => Do(e.parent),
      $root: (e) => Do(e.root),
      $host: (e) => e.ce,
      $emit: (e) => e.emit,
      $options: (e) => Ea(e),
      $forceUpdate: (e) =>
        e.f ||
        (e.f = () => {
          ds(e.update);
        }),
      $nextTick: (e) => e.n || (e.n = wo.bind(e.proxy)),
      $watch: (e) => _m.bind(e)
    }),
    Po = (e) => e === '_' || e === '$',
    Bo = (e, t) => e !== ce && !e.__isScriptSetup && le(e, t),
    ya = {
      get({ _: e }, t) {
        if (t === '__v_skip') return !0;
        const {
          ctx: n,
          setupState: r,
          data: s,
          props: o,
          accessCache: i,
          type: l,
          appContext: a
        } = e;
        if (t === '__isVue') return !0;
        let c;
        if (t[0] !== '$') {
          const h = i[t];
          if (h !== void 0)
            switch (h) {
              case 1:
                return r[t];
              case 2:
                return s[t];
              case 4:
                return n[t];
              case 3:
                return o[t];
            }
          else {
            if (Bo(r, t)) return ((i[t] = 1), r[t]);
            if (s !== ce && le(s, t)) return ((i[t] = 2), s[t]);
            if ((c = e.propsOptions[0]) && le(c, t)) return ((i[t] = 3), o[t]);
            if (n !== ce && le(n, t)) return ((i[t] = 4), n[t]);
            $o && (i[t] = 0);
          }
        }
        const u = fn[t];
        let f, d;
        if (u)
          return (
            t === '$attrs' ? (Te(e.attrs, 'get', ''), ws()) : t === '$slots' && Te(e, 'get', t),
            u(e)
          );
        if ((f = l.__cssModules) && (f = f[t])) return f;
        if (n !== ce && le(n, t)) return ((i[t] = 4), n[t]);
        if (((d = a.config.globalProperties), le(d, t))) return d[t];
        we &&
          (!ye(t) || t.indexOf('__v') !== 0) &&
          (s !== ce && Po(t[0]) && le(s, t)
            ? k(
                `Property ${JSON.stringify(t)} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
              )
            : e === we &&
              k(
                `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
              ));
      },
      set({ _: e }, t, n) {
        const { data: r, setupState: s, ctx: o } = e;
        return Bo(s, t)
          ? ((s[t] = n), !0)
          : s.__isScriptSetup && le(s, t)
            ? (k(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1)
            : r !== ce && le(r, t)
              ? ((r[t] = n), !0)
              : le(e.props, t)
                ? (k(`Attempting to mutate prop "${t}". Props are readonly.`), !1)
                : t[0] === '$' && t.slice(1) in e
                  ? (k(
                      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
                    ),
                    !1)
                  : (t in e.appContext.config.globalProperties
                      ? Object.defineProperty(o, t, { enumerable: !0, configurable: !0, value: n })
                      : (o[t] = n),
                    !0);
      },
      has(
        { _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: s, propsOptions: o } },
        i
      ) {
        let l;
        return (
          !!n[i] ||
          (e !== ce && le(e, i)) ||
          Bo(t, i) ||
          ((l = o[0]) && le(l, i)) ||
          le(r, i) ||
          le(fn, i) ||
          le(s.config.globalProperties, i)
        );
      },
      defineProperty(e, t, n) {
        return (
          n.get != null
            ? (e._.accessCache[t] = 0)
            : le(n, 'value') && this.set(e, t, n.value, null),
          Reflect.defineProperty(e, t, n)
        );
      }
    };
  ya.ownKeys = (e) => (
    k(
      'Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead.'
    ),
    Reflect.ownKeys(e)
  );
  function Nh(e) {
    const t = {};
    return (
      Object.defineProperty(t, '_', { configurable: !0, enumerable: !1, get: () => e }),
      Object.keys(fn).forEach((n) => {
        Object.defineProperty(t, n, {
          configurable: !0,
          enumerable: !1,
          get: () => fn[n](e),
          set: Ie
        });
      }),
      t
    );
  }
  function Lh(e) {
    const {
      ctx: t,
      propsOptions: [n]
    } = e;
    n &&
      Object.keys(n).forEach((r) => {
        Object.defineProperty(t, r, {
          enumerable: !0,
          configurable: !0,
          get: () => e.props[r],
          set: Ie
        });
      });
  }
  function Vh(e) {
    const { ctx: t, setupState: n } = e;
    Object.keys(Q(n)).forEach((r) => {
      if (!n.__isScriptSetup) {
        if (Po(r[0])) {
          k(
            `setup() return property ${JSON.stringify(r)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
          );
          return;
        }
        Object.defineProperty(t, r, { enumerable: !0, configurable: !0, get: () => n[r], set: Ie });
      }
    });
  }
  function va(e) {
    return z(e) ? e.reduce((t, n) => ((t[n] = null), t), {}) : e;
  }
  function Mh() {
    const e = Object.create(null);
    return (t, n) => {
      e[n] ? k(`${t} property "${n}" is already defined in ${e[n]}.`) : (e[n] = t);
    };
  }
  let $o = !0;
  function Uh(e) {
    const t = Ea(e),
      n = e.proxy,
      r = e.ctx;
    (($o = !1), t.beforeCreate && qa(t.beforeCreate, e, 'bc'));
    const {
        data: s,
        computed: o,
        methods: i,
        watch: l,
        provide: a,
        inject: c,
        created: u,
        beforeMount: f,
        mounted: d,
        beforeUpdate: h,
        updated: g,
        activated: v,
        deactivated: y,
        beforeDestroy: E,
        beforeUnmount: N,
        destroyed: P,
        unmounted: te,
        render: B,
        renderTracked: J,
        renderTriggered: V,
        errorCaptured: ae,
        serverPrefetch: U,
        expose: I,
        inheritAttrs: O,
        components: T,
        directives: ne,
        filters: he
      } = t,
      be = Mh();
    {
      const [L] = e.propsOptions;
      if (L) for (const Z in L) be('Props', Z);
    }
    if ((c && Hh(c, r, be), i))
      for (const L in i) {
        const Z = i[L];
        G(Z)
          ? (Object.defineProperty(r, L, {
              value: Z.bind(n),
              configurable: !0,
              enumerable: !0,
              writable: !0
            }),
            be('Methods', L))
          : k(
              `Method "${L}" has type "${typeof Z}" in the component definition. Did you reference the function correctly?`
            );
      }
    if (s) {
      G(s) || k('The data option must be a function. Plain object usage is no longer supported.');
      const L = s.call(n, n);
      if (
        (ro(L) &&
          k(
            'data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>.'
          ),
        !ue(L))
      )
        k('data() should return an object.');
      else {
        e.data = os(L);
        for (const Z in L)
          (be('Data', Z),
            Po(Z[0]) ||
              Object.defineProperty(r, Z, {
                configurable: !0,
                enumerable: !0,
                get: () => L[Z],
                set: Ie
              }));
      }
    }
    if ((($o = !0), o))
      for (const L in o) {
        const Z = o[L],
          oe = G(Z) ? Z.bind(n, n) : G(Z.get) ? Z.get.bind(n, n) : Ie;
        oe === Ie && k(`Computed property "${L}" has no getter.`);
        const Ct =
            !G(Z) && G(Z.set)
              ? Z.set.bind(n)
              : () => {
                  k(`Write operation failed: computed property "${L}" is readonly.`);
                },
          ze = ee({ get: oe, set: Ct });
        (Object.defineProperty(r, L, {
          enumerable: !0,
          configurable: !0,
          get: () => ze.value,
          set: (ke) => (ze.value = ke)
        }),
          be('Computed', L));
      }
    if (l) for (const L in l) ba(l[L], r, n, L);
    if (a) {
      const L = G(a) ? a.call(n) : a;
      Reflect.ownKeys(L).forEach((Z) => {
        Jh(Z, L[Z]);
      });
    }
    u && qa(u, e, 'c');
    function de(L, Z) {
      z(Z) ? Z.forEach((oe) => L(oe.bind(n))) : Z && L(Z.bind(n));
    }
    if (
      (de(Oh, f),
      de(mr, d),
      de(ha, h),
      de(kh, g),
      de(Ch, v),
      de(Ah, y),
      de(Ph, ae),
      de(Dh, J),
      de(Rh, V),
      de(Io, N),
      de(vs, te),
      de(Ih, U),
      z(I))
    )
      if (I.length) {
        const L = e.exposed || (e.exposed = {});
        I.forEach((Z) => {
          Object.defineProperty(L, Z, { get: () => n[Z], set: (oe) => (n[Z] = oe) });
        });
      } else e.exposed || (e.exposed = {});
    (B && e.render === Ie && (e.render = B),
      O != null && (e.inheritAttrs = O),
      T && (e.components = T),
      ne && (e.directives = ne),
      U && da(e));
  }
  function Hh(e, t, n = Ie) {
    z(e) && (e = Fo(e));
    for (const r in e) {
      const s = e[r];
      let o;
      (ue(s)
        ? 'default' in s
          ? (o = yr(s.from || r, s.default, !0))
          : (o = yr(s.from || r))
        : (o = yr(s)),
        me(o)
          ? Object.defineProperty(t, r, {
              enumerable: !0,
              configurable: !0,
              get: () => o.value,
              set: (i) => (o.value = i)
            })
          : (t[r] = o),
        n('Inject', r));
    }
  }
  function qa(e, t, n) {
    lt(z(e) ? e.map((r) => r.bind(t.proxy)) : e.bind(t.proxy), t, n);
  }
  function ba(e, t, n, r) {
    let s = r.includes('.') ? Ma(n, r) : () => n[r];
    if (ye(e)) {
      const o = t[e];
      G(o) ? at(s, o) : k(`Invalid watch handler specified by key "${e}"`, o);
    } else if (G(e)) at(s, e.bind(n));
    else if (ue(e))
      if (z(e)) e.forEach((o) => ba(o, t, n, r));
      else {
        const o = G(e.handler) ? e.handler.bind(n) : t[e.handler];
        G(o) ? at(s, o, e) : k(`Invalid watch handler specified by key "${e.handler}"`, o);
      }
    else k(`Invalid watch option: "${r}"`, e);
  }
  function Ea(e) {
    const t = e.type,
      { mixins: n, extends: r } = t,
      {
        mixins: s,
        optionsCache: o,
        config: { optionMergeStrategies: i }
      } = e.appContext,
      l = o.get(t);
    let a;
    return (
      l
        ? (a = l)
        : !s.length && !n && !r
          ? (a = t)
          : ((a = {}), s.length && s.forEach((c) => qs(a, c, i, !0)), qs(a, t, i)),
      ue(t) && o.set(t, a),
      a
    );
  }
  function qs(e, t, n, r = !1) {
    const { mixins: s, extends: o } = t;
    (o && qs(e, o, n, !0), s && s.forEach((i) => qs(e, i, n, !0)));
    for (const i in t)
      if (r && i === 'expose')
        k(
          '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
        );
      else {
        const l = jh[i] || (n && n[i]);
        e[i] = l ? l(e[i], t[i]) : t[i];
      }
    return e;
  }
  const jh = {
    data: wa,
    props: xa,
    emits: xa,
    methods: _r,
    computed: _r,
    beforeCreate: Ve,
    created: Ve,
    beforeMount: Ve,
    mounted: Ve,
    beforeUpdate: Ve,
    updated: Ve,
    beforeDestroy: Ve,
    beforeUnmount: Ve,
    destroyed: Ve,
    unmounted: Ve,
    activated: Ve,
    deactivated: Ve,
    errorCaptured: Ve,
    serverPrefetch: Ve,
    components: _r,
    directives: _r,
    watch: Kh,
    provide: wa,
    inject: zh
  };
  function wa(e, t) {
    return t
      ? e
        ? function () {
            return ve(G(e) ? e.call(this, this) : e, G(t) ? t.call(this, this) : t);
          }
        : t
      : e;
  }
  function zh(e, t) {
    return _r(Fo(e), Fo(t));
  }
  function Fo(e) {
    if (z(e)) {
      const t = {};
      for (let n = 0; n < e.length; n++) t[e[n]] = e[n];
      return t;
    }
    return e;
  }
  function Ve(e, t) {
    return e ? [...new Set([].concat(e, t))] : t;
  }
  function _r(e, t) {
    return e ? ve(Object.create(null), e, t) : t;
  }
  function xa(e, t) {
    return e
      ? z(e) && z(t)
        ? [...new Set([...e, ...t])]
        : ve(Object.create(null), va(e), va(t ?? {}))
      : t;
  }
  function Kh(e, t) {
    if (!e) return t;
    if (!t) return e;
    const n = ve(Object.create(null), e);
    for (const r in t) n[r] = Ve(e[r], t[r]);
    return n;
  }
  function Sa() {
    return {
      app: null,
      config: {
        isNativeTag: lp,
        performance: !1,
        globalProperties: {},
        optionMergeStrategies: {},
        errorHandler: void 0,
        warnHandler: void 0,
        compilerOptions: {}
      },
      mixins: [],
      components: {},
      directives: {},
      provides: Object.create(null),
      optionsCache: new WeakMap(),
      propsCache: new WeakMap(),
      emitsCache: new WeakMap()
    };
  }
  let Wh = 0;
  function Gh(e, t) {
    return function (r, s = null) {
      (G(r) || (r = ve({}, r)),
        s != null &&
          !ue(s) &&
          (k('root props passed to app.mount() must be an object.'), (s = null)));
      const o = Sa(),
        i = new WeakSet(),
        l = [];
      let a = !1;
      const c = (o.app = {
        _uid: Wh++,
        _component: r,
        _props: s,
        _container: null,
        _context: o,
        _instance: null,
        version: su,
        get config() {
          return o.config;
        },
        set config(u) {
          k('app.config cannot be replaced. Modify individual options instead.');
        },
        use(u, ...f) {
          return (
            i.has(u)
              ? k('Plugin has already been applied to target app.')
              : u && G(u.install)
                ? (i.add(u), u.install(c, ...f))
                : G(u)
                  ? (i.add(u), u(c, ...f))
                  : k(
                      'A plugin must either be a function or an object with an "install" function.'
                    ),
            c
          );
        },
        mixin(u) {
          return (
            o.mixins.includes(u)
              ? k('Mixin has already been applied to target app' + (u.name ? `: ${u.name}` : ''))
              : o.mixins.push(u),
            c
          );
        },
        component(u, f) {
          return (
            Wo(u, o.config),
            f
              ? (o.components[u] &&
                  k(`Component "${u}" has already been registered in target app.`),
                (o.components[u] = f),
                c)
              : o.components[u]
          );
        },
        directive(u, f) {
          return (
            ra(u),
            f
              ? (o.directives[u] &&
                  k(`Directive "${u}" has already been registered in target app.`),
                (o.directives[u] = f),
                c)
              : o.directives[u]
          );
        },
        mount(u, f, d) {
          if (a)
            k(
              'App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`'
            );
          else {
            u.__vue_app__ &&
              k(
                'There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first.'
              );
            const h = c._ceVNode || j(r, s);
            return (
              (h.appContext = o),
              d === !0 ? (d = 'svg') : d === !1 && (d = void 0),
              (o.reload = () => {
                e(vt(h), u, d);
              }),
              e(h, u, d),
              (a = !0),
              (c._container = u),
              (u.__vue_app__ = c),
              (c._instance = h.component),
              ph(c, su),
              As(h.component)
            );
          }
        },
        onUnmount(u) {
          (typeof u != 'function' &&
            k(`Expected function as first argument to app.onUnmount(), but got ${typeof u}`),
            l.push(u));
        },
        unmount() {
          a
            ? (lt(l, c._instance, 16),
              e(null, c._container),
              (c._instance = null),
              hh(c),
              delete c._container.__vue_app__)
            : k('Cannot unmount an app that is not mounted.');
        },
        provide(u, f) {
          return (
            u in o.provides &&
              k(
                `App already provides property with key "${String(u)}". It will be overwritten with the new value.`
              ),
            (o.provides[u] = f),
            c
          );
        },
        runWithContext(u) {
          const f = dn;
          dn = c;
          try {
            return u();
          } finally {
            dn = f;
          }
        }
      });
      return c;
    };
  }
  let dn = null;
  function Jh(e, t) {
    if (!Ce) k('provide() can only be used inside setup().');
    else {
      let n = Ce.provides;
      const r = Ce.parent && Ce.parent.provides;
      (r === n && (n = Ce.provides = Object.create(r)), (n[e] = t));
    }
  }
  function yr(e, t, n = !1) {
    const r = Ce || we;
    if (r || dn) {
      const s = dn
        ? dn._context.provides
        : r
          ? r.parent == null
            ? r.vnode.appContext && r.vnode.appContext.provides
            : r.parent.provides
          : void 0;
      if (s && e in s) return s[e];
      if (arguments.length > 1) return n && G(t) ? t.call(r && r.proxy) : t;
      k(`injection "${String(e)}" not found.`);
    } else k('inject() can only be used inside setup() or functional components.');
  }
  function Yh() {
    return !!(Ce || we || dn);
  }
  const Ca = {},
    Aa = () => Object.create(Ca),
    Ta = (e) => Object.getPrototypeOf(e) === Ca;
  function Qh(e, t, n, r = !1) {
    const s = {},
      o = Aa();
    ((e.propsDefaults = Object.create(null)), Oa(e, t, s, o));
    for (const i in e.propsOptions[0]) i in s || (s[i] = void 0);
    (Ra(t || {}, s, e),
      n ? (e.props = r ? s : zp(s)) : e.type.props ? (e.props = s) : (e.props = o),
      (e.attrs = o));
  }
  function Zh(e) {
    for (; e; ) {
      if (e.type.__hmrId) return !0;
      e = e.parent;
    }
  }
  function Xh(e, t, n, r) {
    const {
        props: s,
        attrs: o,
        vnode: { patchFlag: i }
      } = e,
      l = Q(s),
      [a] = e.propsOptions;
    let c = !1;
    if (!Zh(e) && (r || i > 0) && !(i & 16)) {
      if (i & 8) {
        const u = e.vnode.dynamicProps;
        for (let f = 0; f < u.length; f++) {
          let d = u[f];
          if (Es(e.emitsOptions, d)) continue;
          const h = t[d];
          if (a)
            if (le(o, d)) h !== o[d] && ((o[d] = h), (c = !0));
            else {
              const g = $e(d);
              s[g] = No(a, l, g, h, e, !1);
            }
          else h !== o[d] && ((o[d] = h), (c = !0));
        }
      }
    } else {
      Oa(e, t, s, o) && (c = !0);
      let u;
      for (const f in l)
        (!t || (!le(t, f) && ((u = Rt(f)) === f || !le(t, u)))) &&
          (a
            ? n && (n[f] !== void 0 || n[u] !== void 0) && (s[f] = No(a, l, f, void 0, e, !0))
            : delete s[f]);
      if (o !== l) for (const f in o) (!t || !le(t, f)) && (delete o[f], (c = !0));
    }
    (c && pt(e.attrs, 'set', ''), Ra(t || {}, s, e));
  }
  function Oa(e, t, n, r) {
    const [s, o] = e.propsOptions;
    let i = !1,
      l;
    if (t)
      for (let a in t) {
        if (er(a)) continue;
        const c = t[a];
        let u;
        s && le(s, (u = $e(a)))
          ? !o || !o.includes(u)
            ? (n[u] = c)
            : ((l || (l = {}))[u] = c)
          : Es(e.emitsOptions, a) || ((!(a in r) || c !== r[a]) && ((r[a] = c), (i = !0)));
      }
    if (o) {
      const a = Q(n),
        c = l || ce;
      for (let u = 0; u < o.length; u++) {
        const f = o[u];
        n[f] = No(s, a, f, c[f], e, !le(c, f));
      }
    }
    return i;
  }
  function No(e, t, n, r, s, o) {
    const i = e[n];
    if (i != null) {
      const l = le(i, 'default');
      if (l && r === void 0) {
        const a = i.default;
        if (i.type !== Function && !i.skipFactory && G(a)) {
          const { propsDefaults: c } = s;
          if (n in c) r = c[n];
          else {
            const u = wr(s);
            ((r = c[n] = a.call(null, t)), u());
          }
        } else r = a;
        s.ce && s.ce._setProp(n, r);
      }
      i[0] && (o && !l ? (r = !1) : i[1] && (r === '' || r === Rt(n)) && (r = !0));
    }
    return r;
  }
  const em = new WeakMap();
  function ka(e, t, n = !1) {
    const r = n ? em : t.propsCache,
      s = r.get(e);
    if (s) return s;
    const o = e.props,
      i = {},
      l = [];
    let a = !1;
    if (!G(e)) {
      const u = (f) => {
        a = !0;
        const [d, h] = ka(f, t, !0);
        (ve(i, d), h && l.push(...h));
      };
      (!n && t.mixins.length && t.mixins.forEach(u),
        e.extends && u(e.extends),
        e.mixins && e.mixins.forEach(u));
    }
    if (!o && !a) return (ue(e) && r.set(e, An), An);
    if (z(o))
      for (let u = 0; u < o.length; u++) {
        ye(o[u]) || k('props must be strings when using array syntax.', o[u]);
        const f = $e(o[u]);
        Ia(f) && (i[f] = ce);
      }
    else if (o) {
      ue(o) || k('invalid props options', o);
      for (const u in o) {
        const f = $e(u);
        if (Ia(f)) {
          const d = o[u],
            h = (i[f] = z(d) || G(d) ? { type: d } : ve({}, d)),
            g = h.type;
          let v = !1,
            y = !0;
          if (z(g))
            for (let E = 0; E < g.length; ++E) {
              const N = g[E],
                P = G(N) && N.name;
              if (P === 'Boolean') {
                v = !0;
                break;
              } else P === 'String' && (y = !1);
            }
          else v = G(g) && g.name === 'Boolean';
          ((h[0] = v), (h[1] = y), (v || le(h, 'default')) && l.push(f));
        }
      }
    }
    const c = [i, l];
    return (ue(e) && r.set(e, c), c);
  }
  function Ia(e) {
    return e[0] !== '$' && !er(e)
      ? !0
      : (k(`Invalid prop name: "${e}" is a reserved property.`), !1);
  }
  function tm(e) {
    return e === null
      ? 'null'
      : typeof e == 'function'
        ? e.name || ''
        : (typeof e == 'object' && e.constructor && e.constructor.name) || '';
  }
  function Ra(e, t, n) {
    const r = Q(t),
      s = n.propsOptions[0],
      o = Object.keys(e).map((i) => $e(i));
    for (const i in s) {
      let l = s[i];
      l != null && nm(i, r[i], l, ht(r), !o.includes(i));
    }
  }
  function nm(e, t, n, r, s) {
    const { type: o, required: i, validator: l, skipCheck: a } = n;
    if (i && s) {
      k('Missing required prop: "' + e + '"');
      return;
    }
    if (!(t == null && !i)) {
      if (o != null && o !== !0 && !a) {
        let c = !1;
        const u = z(o) ? o : [o],
          f = [];
        for (let d = 0; d < u.length && !c; d++) {
          const { valid: h, expectedType: g } = sm(t, u[d]);
          (f.push(g || ''), (c = h));
        }
        if (!c) {
          k(om(e, t, f));
          return;
        }
      }
      l && !l(t, r) && k('Invalid prop: custom validator check failed for prop "' + e + '".');
    }
  }
  const rm = kt('String,Number,Boolean,Function,Symbol,BigInt');
  function sm(e, t) {
    let n;
    const r = tm(t);
    if (r === 'null') n = e === null;
    else if (rm(r)) {
      const s = typeof e;
      ((n = s === r.toLowerCase()), !n && s === 'object' && (n = e instanceof t));
    } else r === 'Object' ? (n = ue(e)) : r === 'Array' ? (n = z(e)) : (n = e instanceof t);
    return { valid: n, expectedType: r };
  }
  function om(e, t, n) {
    if (n.length === 0)
      return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
    let r = `Invalid prop: type check failed for prop "${e}". Expected ${n.map(rn).join(' | ')}`;
    const s = n[0],
      o = so(t),
      i = Da(t, s),
      l = Da(t, o);
    return (
      n.length === 1 && Pa(s) && !im(s, o) && (r += ` with value ${i}`),
      (r += `, got ${o} `),
      Pa(o) && (r += `with value ${l}.`),
      r
    );
  }
  function Da(e, t) {
    return t === 'String' ? `"${e}"` : t === 'Number' ? `${Number(e)}` : `${e}`;
  }
  function Pa(e) {
    return ['string', 'number', 'boolean'].some((n) => e.toLowerCase() === n);
  }
  function im(...e) {
    return e.some((t) => t.toLowerCase() === 'boolean');
  }
  const Ba = (e) => e[0] === '_' || e === '$stable',
    Lo = (e) => (z(e) ? e.map(ct) : [ct(e)]),
    lm = (e, t, n) => {
      if (t._n) return t;
      const r = dr(
        (...s) => (
          zt.NODE_ENV !== 'production' &&
            Ce &&
            (!n || n.root === Ce.root) &&
            k(
              `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
            ),
          Lo(t(...s))
        ),
        n
      );
      return ((r._c = !1), r);
    },
    $a = (e, t, n) => {
      const r = e._ctx;
      for (const s in e) {
        if (Ba(s)) continue;
        const o = e[s];
        if (G(o)) t[s] = lm(s, o, r);
        else if (o != null) {
          k(
            `Non-function value encountered for slot "${s}". Prefer function slots for better performance.`
          );
          const i = Lo(o);
          t[s] = () => i;
        }
      }
    },
    Fa = (e, t) => {
      hr(e.vnode) ||
        k(
          'Non-function value encountered for default slot. Prefer function slots for better performance.'
        );
      const n = Lo(t);
      e.slots.default = () => n;
    },
    Vo = (e, t, n) => {
      for (const r in t) (n || r !== '_') && (e[r] = t[r]);
    },
    am = (e, t, n) => {
      const r = (e.slots = Aa());
      if (e.vnode.shapeFlag & 32) {
        const s = t._;
        s ? (Vo(r, t, n), n && Xr(r, '_', s, !0)) : $a(t, r);
      } else t && Fa(e, t);
    },
    um = (e, t, n) => {
      const { vnode: r, slots: s } = e;
      let o = !0,
        i = ce;
      if (r.shapeFlag & 32) {
        const l = t._;
        (l
          ? _t
            ? (Vo(s, t, n), pt(e, 'set', '$slots'))
            : n && l === 1
              ? (o = !1)
              : Vo(s, t, n)
          : ((o = !t.$stable), $a(t, s)),
          (i = t));
      } else t && (Fa(e, t), (i = { default: 1 }));
      if (o) for (const l in s) !Ba(l) && i[l] == null && delete s[l];
    };
  let vr, Gt;
  function Bn(e, t) {
    (e.appContext.config.performance && bs() && Gt.mark(`vue-${t}-${e.uid}`),
      yh(e, t, bs() ? Gt.now() : Date.now()));
  }
  function $n(e, t) {
    if (e.appContext.config.performance && bs()) {
      const n = `vue-${t}-${e.uid}`,
        r = n + ':end';
      (Gt.mark(r), Gt.measure(`<${Ts(e, e.type)}> ${t}`, n, r), Gt.clearMarks(n), Gt.clearMarks(r));
    }
    vh(e, t, bs() ? Gt.now() : Date.now());
  }
  function bs() {
    return (
      vr !== void 0 ||
        (typeof window < 'u' && window.performance
          ? ((vr = !0), (Gt = window.performance))
          : (vr = !1)),
      vr
    );
  }
  function cm() {
    const e = [];
    if (e.length) {
      const t = e.length > 1;
      console.warn(`Feature flag${t ? 's' : ''} ${e.join(', ')} ${t ? 'are' : 'is'} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`);
    }
  }
  const Je = xm;
  function fm(e) {
    return dm(e);
  }
  function dm(e, t) {
    cm();
    const n = tr();
    ((n.__VUE__ = !0), Xl(n.__VUE_DEVTOOLS_GLOBAL_HOOK__, n));
    const {
        insert: r,
        remove: s,
        patchProp: o,
        createElement: i,
        createText: l,
        createComment: a,
        setText: c,
        setElementText: u,
        parentNode: f,
        nextSibling: d,
        setScopeId: h = Ie,
        insertStaticContent: g
      } = e,
      v = (
        p,
        m,
        b,
        C = null,
        x = null,
        S = null,
        $ = void 0,
        D = null,
        R = _t ? !1 : !!m.dynamicChildren
      ) => {
        if (p === m) return;
        (p && !gn(p, m) && ((C = Hs(p)), Ke(p, x, S, !0), (p = null)),
          m.patchFlag === -2 && ((R = !1), (m.dynamicChildren = null)));
        const { type: A, ref: Y, shapeFlag: F } = m;
        switch (A) {
          case qr:
            y(p, m, b, C);
            break;
          case xe:
            E(p, m, b, C);
            break;
          case Fn:
            p == null ? N(m, b, C, $) : P(p, m, b, $);
            break;
          case Se:
            ne(p, m, b, C, x, S, $, D, R);
            break;
          default:
            F & 1
              ? J(p, m, b, C, x, S, $, D, R)
              : F & 6
                ? he(p, m, b, C, x, S, $, D, R)
                : F & 64 || F & 128
                  ? A.process(p, m, b, C, x, S, $, D, R, Fr)
                  : k('Invalid VNode type:', A, `(${typeof A})`);
        }
        Y != null && x && _s(Y, p && p.ref, S, m || p, !m);
      },
      y = (p, m, b, C) => {
        if (p == null) r((m.el = l(m.children)), b, C);
        else {
          const x = (m.el = p.el);
          m.children !== p.children && c(x, m.children);
        }
      },
      E = (p, m, b, C) => {
        p == null ? r((m.el = a(m.children || '')), b, C) : (m.el = p.el);
      },
      N = (p, m, b, C) => {
        [p.el, p.anchor] = g(p.children, m, b, C, p.el, p.anchor);
      },
      P = (p, m, b, C) => {
        if (m.children !== p.children) {
          const x = d(p.anchor);
          (B(p), ([m.el, m.anchor] = g(m.children, b, x, C)));
        } else ((m.el = p.el), (m.anchor = p.anchor));
      },
      te = ({ el: p, anchor: m }, b, C) => {
        let x;
        for (; p && p !== m; ) ((x = d(p)), r(p, b, C), (p = x));
        r(m, b, C);
      },
      B = ({ el: p, anchor: m }) => {
        let b;
        for (; p && p !== m; ) ((b = d(p)), s(p), (p = b));
        s(m);
      },
      J = (p, m, b, C, x, S, $, D, R) => {
        (m.type === 'svg' ? ($ = 'svg') : m.type === 'math' && ($ = 'mathml'),
          p == null ? V(m, b, C, x, S, $, D, R) : I(p, m, x, S, $, D, R));
      },
      V = (p, m, b, C, x, S, $, D) => {
        let R, A;
        const { props: Y, shapeFlag: F, transition: W, dirs: X } = p;
        if (
          ((R = p.el = i(p.type, S, Y && Y.is, Y)),
          F & 8 ? u(R, p.children) : F & 16 && U(p.children, R, null, C, x, Mo(p, S), $, D),
          X && cn(p, null, C, 'created'),
          ae(R, p, p.scopeId, $, C),
          Y)
        ) {
          for (const ge in Y) ge !== 'value' && !er(ge) && o(R, ge, null, Y[ge], S, C);
          ('value' in Y && o(R, 'value', null, Y.value, S),
            (A = Y.onVnodeBeforeMount) && qt(A, C, p));
        }
        (Xr(R, '__vnode', p, !0),
          Xr(R, '__vueParentComponent', C, !0),
          X && cn(p, null, C, 'beforeMount'));
        const ie = pm(x, W);
        (ie && W.beforeEnter(R),
          r(R, m, b),
          ((A = Y && Y.onVnodeMounted) || ie || X) &&
            Je(() => {
              (A && qt(A, C, p), ie && W.enter(R), X && cn(p, null, C, 'mounted'));
            }, x));
      },
      ae = (p, m, b, C, x) => {
        if ((b && h(p, b), C)) for (let S = 0; S < C.length; S++) h(p, C[S]);
        if (x) {
          let S = x.subTree;
          if (
            (S.patchFlag > 0 && S.patchFlag & 2048 && (S = jo(S.children) || S),
            m === S || (Wa(S.type) && (S.ssContent === m || S.ssFallback === m)))
          ) {
            const $ = x.vnode;
            ae(p, $, $.scopeId, $.slotScopeIds, x.parent);
          }
        }
      },
      U = (p, m, b, C, x, S, $, D, R = 0) => {
        for (let A = R; A < p.length; A++) {
          const Y = (p[A] = D ? Jt(p[A]) : ct(p[A]));
          v(null, Y, m, b, C, x, S, $, D);
        }
      },
      I = (p, m, b, C, x, S, $) => {
        const D = (m.el = p.el);
        D.__vnode = m;
        let { patchFlag: R, dynamicChildren: A, dirs: Y } = m;
        R |= p.patchFlag & 16;
        const F = p.props || ce,
          W = m.props || ce;
        let X;
        if (
          (b && pn(b, !1),
          (X = W.onVnodeBeforeUpdate) && qt(X, b, m, p),
          Y && cn(m, p, b, 'beforeUpdate'),
          b && pn(b, !0),
          _t && ((R = 0), ($ = !1), (A = null)),
          ((F.innerHTML && W.innerHTML == null) || (F.textContent && W.textContent == null)) &&
            u(D, ''),
          A
            ? (O(p.dynamicChildren, A, D, b, C, Mo(m, x), S), Uo(p, m))
            : $ || oe(p, m, D, null, b, C, Mo(m, x), S, !1),
          R > 0)
        ) {
          if (R & 16) T(D, F, W, b, x);
          else if (
            (R & 2 && F.class !== W.class && o(D, 'class', null, W.class, x),
            R & 4 && o(D, 'style', F.style, W.style, x),
            R & 8)
          ) {
            const ie = m.dynamicProps;
            for (let ge = 0; ge < ie.length; ge++) {
              const pe = ie[ge],
                Ze = F[pe],
                We = W[pe];
              (We !== Ze || pe === 'value') && o(D, pe, Ze, We, x, b);
            }
          }
          R & 1 && p.children !== m.children && u(D, m.children);
        } else !$ && A == null && T(D, F, W, b, x);
        ((X = W.onVnodeUpdated) || Y) &&
          Je(() => {
            (X && qt(X, b, m, p), Y && cn(m, p, b, 'updated'));
          }, C);
      },
      O = (p, m, b, C, x, S, $) => {
        for (let D = 0; D < m.length; D++) {
          const R = p[D],
            A = m[D],
            Y = R.el && (R.type === Se || !gn(R, A) || R.shapeFlag & 70) ? f(R.el) : b;
          v(R, A, Y, null, C, x, S, $, !0);
        }
      },
      T = (p, m, b, C, x) => {
        if (m !== b) {
          if (m !== ce) for (const S in m) !er(S) && !(S in b) && o(p, S, m[S], null, x, C);
          for (const S in b) {
            if (er(S)) continue;
            const $ = b[S],
              D = m[S];
            $ !== D && S !== 'value' && o(p, S, D, $, x, C);
          }
          'value' in b && o(p, 'value', m.value, b.value, x);
        }
      },
      ne = (p, m, b, C, x, S, $, D, R) => {
        const A = (m.el = p ? p.el : l('')),
          Y = (m.anchor = p ? p.anchor : l(''));
        let { patchFlag: F, dynamicChildren: W, slotScopeIds: X } = m;
        ((_t || F & 2048) && ((F = 0), (R = !1), (W = null)),
          X && (D = D ? D.concat(X) : X),
          p == null
            ? (r(A, b, C), r(Y, b, C), U(m.children || [], b, Y, x, S, $, D, R))
            : F > 0 && F & 64 && W && p.dynamicChildren
              ? (O(p.dynamicChildren, W, b, x, S, $, D), Uo(p, m))
              : oe(p, m, b, Y, x, S, $, D, R));
      },
      he = (p, m, b, C, x, S, $, D, R) => {
        ((m.slotScopeIds = D),
          p == null
            ? m.shapeFlag & 512
              ? x.ctx.activate(m, b, C, $, R)
              : be(m, b, C, x, S, $, R)
            : de(p, m, R));
      },
      be = (p, m, b, C, x, S, $) => {
        const D = (p.component = Rm(p, C, x));
        if (
          (D.type.__hmrId && uh(D),
          us(p),
          Bn(D, 'mount'),
          hr(p) && (D.ctx.renderer = Fr),
          Bn(D, 'init'),
          Pm(D, !1, $),
          $n(D, 'init'),
          D.asyncDep)
        ) {
          if ((_t && (p.el = null), x && x.registerDep(D, L, $), !p.el)) {
            const R = (D.subTree = j(xe));
            E(null, R, m, b);
          }
        } else L(D, p, m, b, x, S, $);
        (cs(), $n(D, 'mount'));
      },
      de = (p, m, b) => {
        const C = (m.component = p.component);
        if (Em(p, m, b))
          if (C.asyncDep && !C.asyncResolved) {
            (us(m), Z(C, m, b), cs());
            return;
          } else ((C.next = m), C.update());
        else ((m.el = p.el), (C.vnode = m));
      },
      L = (p, m, b, C, x, S, $) => {
        const D = () => {
          if (p.isMounted) {
            let { next: F, bu: W, u: X, parent: ie, vnode: ge } = p;
            {
              const Tt = Na(p);
              if (Tt) {
                (F && ((F.el = ge.el), Z(p, F, $)),
                  Tt.asyncDep.then(() => {
                    p.isUnmounted || D();
                  }));
                return;
              }
            }
            let pe = F,
              Ze;
            (us(F || p.vnode),
              pn(p, !1),
              F ? ((F.el = ge.el), Z(p, F, $)) : (F = ge),
              W && Tn(W),
              (Ze = F.props && F.props.onVnodeBeforeUpdate) && qt(Ze, ie, F, ge),
              pn(p, !0),
              Bn(p, 'render'));
            const We = Ha(p);
            $n(p, 'render');
            const At = p.subTree;
            ((p.subTree = We),
              Bn(p, 'patch'),
              v(At, We, f(At.el), Hs(At), p, x, S),
              $n(p, 'patch'),
              (F.el = We.el),
              pe === null && wm(p, We.el),
              X && Je(X, x),
              (Ze = F.props && F.props.onVnodeUpdated) && Je(() => qt(Ze, ie, F, ge), x),
              ea(p),
              cs());
          } else {
            let F;
            const { el: W, props: X } = m,
              { bm: ie, m: ge, parent: pe, root: Ze, type: We } = p,
              At = Pn(m);
            (pn(p, !1),
              ie && Tn(ie),
              !At && (F = X && X.onVnodeBeforeMount) && qt(F, pe, m),
              pn(p, !0));
            {
              (Ze.ce && Ze.ce._injectChildStyle(We), Bn(p, 'render'));
              const Tt = (p.subTree = Ha(p));
              ($n(p, 'render'),
                Bn(p, 'patch'),
                v(null, Tt, b, C, p, x, S),
                $n(p, 'patch'),
                (m.el = Tt.el));
            }
            if ((ge && Je(ge, x), !At && (F = X && X.onVnodeMounted))) {
              const Tt = m;
              Je(() => qt(F, pe, Tt), x);
            }
            ((m.shapeFlag & 256 || (pe && Pn(pe.vnode) && pe.vnode.shapeFlag & 256)) &&
              p.a &&
              Je(p.a, x),
              (p.isMounted = !0),
              mh(p),
              (m = b = C = null));
          }
        };
        p.scope.on();
        const R = (p.effect = new El(D));
        p.scope.off();
        const A = (p.update = R.run.bind(R)),
          Y = (p.job = R.runIfDirty.bind(R));
        ((Y.i = p),
          (Y.id = p.uid),
          (R.scheduler = () => ds(Y)),
          pn(p, !0),
          (R.onTrack = p.rtc ? (F) => Tn(p.rtc, F) : void 0),
          (R.onTrigger = p.rtg ? (F) => Tn(p.rtg, F) : void 0),
          A());
      },
      Z = (p, m, b) => {
        m.component = p;
        const C = p.vnode.props;
        ((p.vnode = m),
          (p.next = null),
          Xh(p, m.props, C, b),
          um(p, m.children, b),
          Dt(),
          Gl(p),
          Pt());
      },
      oe = (p, m, b, C, x, S, $, D, R = !1) => {
        const A = p && p.children,
          Y = p ? p.shapeFlag : 0,
          F = m.children,
          { patchFlag: W, shapeFlag: X } = m;
        if (W > 0) {
          if (W & 128) {
            ze(A, F, b, C, x, S, $, D, R);
            return;
          } else if (W & 256) {
            Ct(A, F, b, C, x, S, $, D, R);
            return;
          }
        }
        X & 8
          ? (Y & 16 && $r(A, x, S), F !== A && u(b, F))
          : Y & 16
            ? X & 16
              ? ze(A, F, b, C, x, S, $, D, R)
              : $r(A, x, S, !0)
            : (Y & 8 && u(b, ''), X & 16 && U(F, b, C, x, S, $, D, R));
      },
      Ct = (p, m, b, C, x, S, $, D, R) => {
        ((p = p || An), (m = m || An));
        const A = p.length,
          Y = m.length,
          F = Math.min(A, Y);
        let W;
        for (W = 0; W < F; W++) {
          const X = (m[W] = R ? Jt(m[W]) : ct(m[W]));
          v(p[W], X, b, null, x, S, $, D, R);
        }
        A > Y ? $r(p, x, S, !0, !1, F) : U(m, b, C, x, S, $, D, R, F);
      },
      ze = (p, m, b, C, x, S, $, D, R) => {
        let A = 0;
        const Y = m.length;
        let F = p.length - 1,
          W = Y - 1;
        for (; A <= F && A <= W; ) {
          const X = p[A],
            ie = (m[A] = R ? Jt(m[A]) : ct(m[A]));
          if (gn(X, ie)) v(X, ie, b, null, x, S, $, D, R);
          else break;
          A++;
        }
        for (; A <= F && A <= W; ) {
          const X = p[F],
            ie = (m[W] = R ? Jt(m[W]) : ct(m[W]));
          if (gn(X, ie)) v(X, ie, b, null, x, S, $, D, R);
          else break;
          (F--, W--);
        }
        if (A > F) {
          if (A <= W) {
            const X = W + 1,
              ie = X < Y ? m[X].el : C;
            for (; A <= W; ) (v(null, (m[A] = R ? Jt(m[A]) : ct(m[A])), b, ie, x, S, $, D, R), A++);
          }
        } else if (A > W) for (; A <= F; ) (Ke(p[A], x, S, !0), A++);
        else {
          const X = A,
            ie = A,
            ge = new Map();
          for (A = ie; A <= W; A++) {
            const He = (m[A] = R ? Jt(m[A]) : ct(m[A]));
            He.key != null &&
              (ge.has(He.key) &&
                k(
                  'Duplicate keys found during update:',
                  JSON.stringify(He.key),
                  'Make sure keys are unique.'
                ),
              ge.set(He.key, A));
          }
          let pe,
            Ze = 0;
          const We = W - ie + 1;
          let At = !1,
            Tt = 0;
          const Nr = new Array(We);
          for (A = 0; A < We; A++) Nr[A] = 0;
          for (A = X; A <= F; A++) {
            const He = p[A];
            if (Ze >= We) {
              Ke(He, x, S, !0);
              continue;
            }
            let Ot;
            if (He.key != null) Ot = ge.get(He.key);
            else
              for (pe = ie; pe <= W; pe++)
                if (Nr[pe - ie] === 0 && gn(He, m[pe])) {
                  Ot = pe;
                  break;
                }
            Ot === void 0
              ? Ke(He, x, S, !0)
              : ((Nr[Ot - ie] = A + 1),
                Ot >= Tt ? (Tt = Ot) : (At = !0),
                v(He, m[Ot], b, null, x, S, $, D, R),
                Ze++);
          }
          const $f = At ? hm(Nr) : An;
          for (pe = $f.length - 1, A = We - 1; A >= 0; A--) {
            const He = ie + A,
              Ot = m[He],
              Ff = He + 1 < Y ? m[He + 1].el : C;
            Nr[A] === 0
              ? v(null, Ot, b, Ff, x, S, $, D, R)
              : At && (pe < 0 || A !== $f[pe] ? ke(Ot, b, Ff, 2) : pe--);
          }
        }
      },
      ke = (p, m, b, C, x = null) => {
        const { el: S, type: $, transition: D, children: R, shapeFlag: A } = p;
        if (A & 6) {
          ke(p.component.subTree, m, b, C);
          return;
        }
        if (A & 128) {
          p.suspense.move(m, b, C);
          return;
        }
        if (A & 64) {
          $.move(p, m, b, Fr);
          return;
        }
        if ($ === Se) {
          r(S, m, b);
          for (let F = 0; F < R.length; F++) ke(R[F], m, b, C);
          r(p.anchor, m, b);
          return;
        }
        if ($ === Fn) {
          te(p, m, b);
          return;
        }
        if (C !== 2 && A & 1 && D)
          if (C === 0) (D.beforeEnter(S), r(S, m, b), Je(() => D.enter(S), x));
          else {
            const { leave: F, delayLeave: W, afterLeave: X } = D,
              ie = () => r(S, m, b),
              ge = () => {
                F(S, () => {
                  (ie(), X && X());
                });
              };
            W ? W(S, ie, ge) : ge();
          }
        else r(S, m, b);
      },
      Ke = (p, m, b, C = !1, x = !1) => {
        const {
          type: S,
          props: $,
          ref: D,
          children: R,
          dynamicChildren: A,
          shapeFlag: Y,
          patchFlag: F,
          dirs: W,
          cacheIndex: X
        } = p;
        if (
          (F === -2 && (x = !1),
          D != null && _s(D, null, b, p, !0),
          X != null && (m.renderCache[X] = void 0),
          Y & 256)
        ) {
          m.ctx.deactivate(p);
          return;
        }
        const ie = Y & 1 && W,
          ge = !Pn(p);
        let pe;
        if ((ge && (pe = $ && $.onVnodeBeforeUnmount) && qt(pe, m, p), Y & 6))
          Tv(p.component, b, C);
        else {
          if (Y & 128) {
            p.suspense.unmount(b, C);
            return;
          }
          (ie && cn(p, null, m, 'beforeUnmount'),
            Y & 64
              ? p.type.remove(p, m, b, Fr, C)
              : A && !A.hasOnce && (S !== Se || (F > 0 && F & 64))
                ? $r(A, m, b, !1, !0)
                : ((S === Se && F & 384) || (!x && Y & 16)) && $r(R, m, b),
            C && Wn(p));
        }
        ((ge && (pe = $ && $.onVnodeUnmounted)) || ie) &&
          Je(() => {
            (pe && qt(pe, m, p), ie && cn(p, null, m, 'unmounted'));
          }, b);
      },
      Wn = (p) => {
        const { type: m, el: b, anchor: C, transition: x } = p;
        if (m === Se) {
          p.patchFlag > 0 && p.patchFlag & 2048 && x && !x.persisted
            ? p.children.forEach(($) => {
                $.type === xe ? s($.el) : Wn($);
              })
            : Br(b, C);
          return;
        }
        if (m === Fn) {
          B(p);
          return;
        }
        const S = () => {
          (s(b), x && !x.persisted && x.afterLeave && x.afterLeave());
        };
        if (p.shapeFlag & 1 && x && !x.persisted) {
          const { leave: $, delayLeave: D } = x,
            R = () => $(b, S);
          D ? D(p.el, S, R) : R();
        } else S();
      },
      Br = (p, m) => {
        let b;
        for (; p !== m; ) ((b = d(p)), s(p), (p = b));
        s(m);
      },
      Tv = (p, m, b) => {
        p.type.__hmrId && ch(p);
        const { bum: C, scope: x, job: S, subTree: $, um: D, m: R, a: A } = p;
        (La(R),
          La(A),
          C && Tn(C),
          x.stop(),
          S && ((S.flags |= 8), Ke($, p, m, b)),
          D && Je(D, m),
          Je(() => {
            p.isUnmounted = !0;
          }, m),
          m &&
            m.pendingBranch &&
            !m.isUnmounted &&
            p.asyncDep &&
            !p.asyncResolved &&
            p.suspenseId === m.pendingId &&
            (m.deps--, m.deps === 0 && m.resolve()),
          _h(p));
      },
      $r = (p, m, b, C = !1, x = !1, S = 0) => {
        for (let $ = S; $ < p.length; $++) Ke(p[$], m, b, C, x);
      },
      Hs = (p) => {
        if (p.shapeFlag & 6) return Hs(p.component.subTree);
        if (p.shapeFlag & 128) return p.suspense.next();
        const m = d(p.anchor || p.el),
          b = m && m[bh];
        return b ? d(b) : m;
      };
    let ki = !1;
    const Bf = (p, m, b) => {
        (p == null
          ? m._vnode && Ke(m._vnode, null, null, !0)
          : v(m._vnode || null, p, m, null, null, null, b),
          (m._vnode = p),
          ki || ((ki = !0), Gl(), Jl(), (ki = !1)));
      },
      Fr = { p: v, um: Ke, m: ke, r: Wn, mt: be, mc: U, pc: oe, pbc: O, n: Hs, o: e };
    return { render: Bf, hydrate: void 0, createApp: Gh(Bf) };
  }
  function Mo({ type: e, props: t }, n) {
    return (n === 'svg' && e === 'foreignObject') ||
      (n === 'mathml' && e === 'annotation-xml' && t && t.encoding && t.encoding.includes('html'))
      ? void 0
      : n;
  }
  function pn({ effect: e, job: t }, n) {
    n ? ((e.flags |= 32), (t.flags |= 4)) : ((e.flags &= -33), (t.flags &= -5));
  }
  function pm(e, t) {
    return (!e || (e && !e.pendingBranch)) && t && !t.persisted;
  }
  function Uo(e, t, n = !1) {
    const r = e.children,
      s = t.children;
    if (z(r) && z(s))
      for (let o = 0; o < r.length; o++) {
        const i = r[o];
        let l = s[o];
        (l.shapeFlag & 1 &&
          !l.dynamicChildren &&
          ((l.patchFlag <= 0 || l.patchFlag === 32) && ((l = s[o] = Jt(s[o])), (l.el = i.el)),
          !n && l.patchFlag !== -2 && Uo(i, l)),
          l.type === qr && (l.el = i.el),
          l.type === xe && !l.el && (l.el = i.el));
      }
  }
  function hm(e) {
    const t = e.slice(),
      n = [0];
    let r, s, o, i, l;
    const a = e.length;
    for (r = 0; r < a; r++) {
      const c = e[r];
      if (c !== 0) {
        if (((s = n[n.length - 1]), e[s] < c)) {
          ((t[r] = s), n.push(r));
          continue;
        }
        for (o = 0, i = n.length - 1; o < i; )
          ((l = (o + i) >> 1), e[n[l]] < c ? (o = l + 1) : (i = l));
        c < e[n[o]] && (o > 0 && (t[r] = n[o - 1]), (n[o] = r));
      }
    }
    for (o = n.length, i = n[o - 1]; o-- > 0; ) ((n[o] = i), (i = t[i]));
    return n;
  }
  function Na(e) {
    const t = e.subTree.component;
    if (t) return t.asyncDep && !t.asyncResolved ? t : Na(t);
  }
  function La(e) {
    if (e) for (let t = 0; t < e.length; t++) e[t].flags |= 8;
  }
  const mm = Symbol.for('v-scx'),
    gm = () => {
      {
        const e = yr(mm);
        return (
          e ||
            k(
              'Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build.'
            ),
          e
        );
      }
    };
  function at(e, t, n) {
    return (
      G(t) ||
        k(
          '`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature.'
        ),
      Va(e, t, n)
    );
  }
  function Va(e, t, n = ce) {
    const { immediate: r, deep: s, flush: o, once: i } = n;
    t ||
      (r !== void 0 &&
        k(
          'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
        ),
      s !== void 0 &&
        k(
          'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
        ),
      i !== void 0 &&
        k(
          'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
        ));
    const l = ve({}, n);
    l.onWarn = k;
    const a = (t && r) || (!t && o !== 'post');
    let c;
    if (xr) {
      if (o === 'sync') {
        const h = gm();
        c = h.__watcherHandles || (h.__watcherHandles = []);
      } else if (!a) {
        const h = () => {};
        return ((h.stop = Ie), (h.resume = Ie), (h.pause = Ie), h);
      }
    }
    const u = Ce;
    l.call = (h, g, v) => lt(h, u, g, v);
    let f = !1;
    (o === 'post'
      ? (l.scheduler = (h) => {
          Je(h, u && u.suspense);
        })
      : o !== 'sync' &&
        ((f = !0),
        (l.scheduler = (h, g) => {
          g ? h() : ds(h);
        })),
      (l.augmentJob = (h) => {
        (t && (h.flags |= 4), f && ((h.flags |= 2), u && ((h.id = u.uid), (h.i = u))));
      }));
    const d = eh(e, t, l);
    return (xr && (c ? c.push(d) : a && d()), d);
  }
  function _m(e, t, n) {
    const r = this.proxy,
      s = ye(e) ? (e.includes('.') ? Ma(r, e) : () => r[e]) : e.bind(r, r);
    let o;
    G(t) ? (o = t) : ((o = t.handler), (n = t));
    const i = wr(this),
      l = Va(s, o.bind(r), n);
    return (i(), l);
  }
  function Ma(e, t) {
    const n = t.split('.');
    return () => {
      let r = e;
      for (let s = 0; s < n.length && r; s++) r = r[n[s]];
      return r;
    };
  }
  const ym = (e, t) =>
    t === 'modelValue' || t === 'model-value'
      ? e.modelModifiers
      : e[`${t}Modifiers`] || e[`${$e(t)}Modifiers`] || e[`${Rt(t)}Modifiers`];
  function vm(e, t, ...n) {
    if (e.isUnmounted) return;
    const r = e.vnode.props || ce;
    {
      const {
        emitsOptions: u,
        propsOptions: [f]
      } = e;
      if (u)
        if (!(t in u))
          (!f || !(sn($e(t)) in f)) &&
            k(
              `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${sn($e(t))}" prop.`
            );
        else {
          const d = u[t];
          G(d) &&
            (d(...n) || k(`Invalid event arguments: event validation failed for event "${t}".`));
        }
    }
    let s = n;
    const o = t.startsWith('update:'),
      i = o && ym(r, t.slice(7));
    (i && (i.trim && (s = n.map((u) => (ye(u) ? u.trim() : u))), i.number && (s = n.map(io))),
      qh(e, t, s));
    {
      const u = t.toLowerCase();
      u !== t &&
        r[sn(u)] &&
        k(
          `Event "${u}" is emitted in component ${Ts(e, e.type)} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${Rt(t)}" instead of "${t}".`
        );
    }
    let l,
      a = r[(l = sn(t))] || r[(l = sn($e(t)))];
    (!a && o && (a = r[(l = sn(Rt(t)))]), a && lt(a, e, 6, s));
    const c = r[l + 'Once'];
    if (c) {
      if (!e.emitted) e.emitted = {};
      else if (e.emitted[l]) return;
      ((e.emitted[l] = !0), lt(c, e, 6, s));
    }
  }
  function Ua(e, t, n = !1) {
    const r = t.emitsCache,
      s = r.get(e);
    if (s !== void 0) return s;
    const o = e.emits;
    let i = {},
      l = !1;
    if (!G(e)) {
      const a = (c) => {
        const u = Ua(c, t, !0);
        u && ((l = !0), ve(i, u));
      };
      (!n && t.mixins.length && t.mixins.forEach(a),
        e.extends && a(e.extends),
        e.mixins && e.mixins.forEach(a));
    }
    return !o && !l
      ? (ue(e) && r.set(e, null), null)
      : (z(o) ? o.forEach((a) => (i[a] = null)) : ve(i, o), ue(e) && r.set(e, i), i);
  }
  function Es(e, t) {
    return !e || !Xn(t)
      ? !1
      : ((t = t.slice(2).replace(/Once$/, '')),
        le(e, t[0].toLowerCase() + t.slice(1)) || le(e, Rt(t)) || le(e, t));
  }
  let Ho = !1;
  function ws() {
    Ho = !0;
  }
  function Ha(e) {
    const {
        type: t,
        vnode: n,
        proxy: r,
        withProxy: s,
        propsOptions: [o],
        slots: i,
        attrs: l,
        emit: a,
        render: c,
        renderCache: u,
        props: f,
        data: d,
        setupState: h,
        ctx: g,
        inheritAttrs: v
      } = e,
      y = ms(e);
    let E, N;
    Ho = !1;
    try {
      if (n.shapeFlag & 4) {
        const B = s || r,
          J =
            zt.NODE_ENV !== 'production' && h.__isScriptSetup
              ? new Proxy(B, {
                  get(V, ae, U) {
                    return (
                      k(
                        `Property '${String(ae)}' was accessed via 'this'. Avoid using 'this' in templates.`
                      ),
                      Reflect.get(V, ae, U)
                    );
                  }
                })
              : B;
        ((E = ct(c.call(J, B, u, zt.NODE_ENV !== 'production' ? ht(f) : f, h, d, g))), (N = l));
      } else {
        const B = t;
        (zt.NODE_ENV !== 'production' && l === f && ws(),
          (E = ct(
            B.length > 1
              ? B(
                  zt.NODE_ENV !== 'production' ? ht(f) : f,
                  zt.NODE_ENV !== 'production'
                    ? {
                        get attrs() {
                          return (ws(), ht(l));
                        },
                        slots: i,
                        emit: a
                      }
                    : { attrs: l, slots: i, emit: a }
                )
              : B(zt.NODE_ENV !== 'production' ? ht(f) : f, null)
          )),
          (N = t.props ? l : qm(l)));
      }
    } catch (B) {
      ((br.length = 0), ar(B, e, 1), (E = j(xe)));
    }
    let P = E,
      te;
    if ((E.patchFlag > 0 && E.patchFlag & 2048 && ([P, te] = ja(E)), N && v !== !1)) {
      const B = Object.keys(N),
        { shapeFlag: J } = P;
      if (B.length) {
        if (J & 7) (o && B.some(Yr) && (N = bm(N, o)), (P = vt(P, N, !1, !0)));
        else if (!Ho && P.type !== xe) {
          const V = Object.keys(l),
            ae = [],
            U = [];
          for (let I = 0, O = V.length; I < O; I++) {
            const T = V[I];
            Xn(T) ? Yr(T) || ae.push(T[2].toLowerCase() + T.slice(3)) : U.push(T);
          }
          (U.length &&
            k(
              `Extraneous non-props attributes (${U.join(', ')}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`
            ),
            ae.length &&
              k(
                `Extraneous non-emits event listeners (${ae.join(', ')}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
              ));
        }
      }
    }
    return (
      n.dirs &&
        (za(P) ||
          k(
            'Runtime directive used on component with non-element root node. The directives will not function as intended.'
          ),
        (P = vt(P, null, !1, !0)),
        (P.dirs = P.dirs ? P.dirs.concat(n.dirs) : n.dirs)),
      n.transition &&
        (za(P) ||
          k('Component inside <Transition> renders non-element root node that cannot be animated.'),
        pr(P, n.transition)),
      te ? te(P) : (E = P),
      ms(y),
      E
    );
  }
  const ja = (e) => {
    const t = e.children,
      n = e.dynamicChildren,
      r = jo(t, !1);
    if (r) {
      if (r.patchFlag > 0 && r.patchFlag & 2048) return ja(r);
    } else return [e, void 0];
    const s = t.indexOf(r),
      o = n ? n.indexOf(r) : -1,
      i = (l) => {
        ((t[s] = l),
          n && (o > -1 ? (n[o] = l) : l.patchFlag > 0 && (e.dynamicChildren = [...n, l])));
      };
    return [ct(r), i];
  };
  function jo(e, t = !0) {
    let n;
    for (let r = 0; r < e.length; r++) {
      const s = e[r];
      if (mn(s)) {
        if (s.type !== xe || s.children === 'v-if') {
          if (n) return;
          if (((n = s), t && n.patchFlag > 0 && n.patchFlag & 2048)) return jo(n.children);
        }
      } else return;
    }
    return n;
  }
  const qm = (e) => {
      let t;
      for (const n in e) (n === 'class' || n === 'style' || Xn(n)) && ((t || (t = {}))[n] = e[n]);
      return t;
    },
    bm = (e, t) => {
      const n = {};
      for (const r in e) (!Yr(r) || !(r.slice(9) in t)) && (n[r] = e[r]);
      return n;
    },
    za = (e) => e.shapeFlag & 7 || e.type === xe;
  function Em(e, t, n) {
    const { props: r, children: s, component: o } = e,
      { props: i, children: l, patchFlag: a } = t,
      c = o.emitsOptions;
    if (((s || l) && _t) || t.dirs || t.transition) return !0;
    if (n && a >= 0) {
      if (a & 1024) return !0;
      if (a & 16) return r ? Ka(r, i, c) : !!i;
      if (a & 8) {
        const u = t.dynamicProps;
        for (let f = 0; f < u.length; f++) {
          const d = u[f];
          if (i[d] !== r[d] && !Es(c, d)) return !0;
        }
      }
    } else
      return (s || l) && (!l || !l.$stable) ? !0 : r === i ? !1 : r ? (i ? Ka(r, i, c) : !0) : !!i;
    return !1;
  }
  function Ka(e, t, n) {
    const r = Object.keys(t);
    if (r.length !== Object.keys(e).length) return !0;
    for (let s = 0; s < r.length; s++) {
      const o = r[s];
      if (t[o] !== e[o] && !Es(n, o)) return !0;
    }
    return !1;
  }
  function wm({ vnode: e, parent: t }, n) {
    for (; t; ) {
      const r = t.subTree;
      if ((r.suspense && r.suspense.activeBranch === e && (r.el = e.el), r === e))
        (((e = t.vnode).el = n), (t = t.parent));
      else break;
    }
  }
  const Wa = (e) => e.__isSuspense;
  function xm(e, t) {
    t && t.pendingBranch ? (z(e) ? t.effects.push(...e) : t.effects.push(e)) : xo(e);
  }
  const Se = Symbol.for('v-fgt'),
    qr = Symbol.for('v-txt'),
    xe = Symbol.for('v-cmt'),
    Fn = Symbol.for('v-stc'),
    br = [];
  let Ye = null;
  function H(e = !1) {
    br.push((Ye = e ? null : []));
  }
  function Sm() {
    (br.pop(), (Ye = br[br.length - 1] || null));
  }
  let Er = 1;
  function Ga(e, t = !1) {
    ((Er += e), e < 0 && Ye && t && (Ye.hasOnce = !0));
  }
  function Ja(e) {
    return ((e.dynamicChildren = Er > 0 ? Ye || An : null), Sm(), Er > 0 && Ye && Ye.push(e), e);
  }
  function K(e, t, n, r, s, o) {
    return Ja(_(e, t, n, r, s, o, !0));
  }
  function hn(e, t, n, r, s) {
    return Ja(j(e, t, n, r, s, !0));
  }
  function mn(e) {
    return e ? e.__v_isVNode === !0 : !1;
  }
  function gn(e, t) {
    if (t.shapeFlag & 6 && e.component) {
      const n = ps.get(t.type);
      if (n && n.has(e.component)) return ((e.shapeFlag &= -257), (t.shapeFlag &= -513), !1);
    }
    return e.type === t.type && e.key === t.key;
  }
  const Cm = (...e) => Am(...e),
    Ya = ({ key: e }) => e ?? null,
    xs = ({ ref: e, ref_key: t, ref_for: n }) => (
      typeof e == 'number' && (e = '' + e),
      e != null ? (ye(e) || me(e) || G(e) ? { i: we, r: e, k: t, f: !!n } : e) : null
    );
  function _(e, t = null, n = null, r = 0, s = null, o = e === Se ? 0 : 1, i = !1, l = !1) {
    const a = {
      __v_isVNode: !0,
      __v_skip: !0,
      type: e,
      props: t,
      key: t && Ya(t),
      ref: t && xs(t),
      scopeId: na,
      slotScopeIds: null,
      children: n,
      component: null,
      suspense: null,
      ssContent: null,
      ssFallback: null,
      dirs: null,
      transition: null,
      el: null,
      anchor: null,
      target: null,
      targetStart: null,
      targetAnchor: null,
      staticCount: 0,
      shapeFlag: o,
      patchFlag: r,
      dynamicProps: s,
      dynamicChildren: null,
      appContext: null,
      ctx: we
    };
    return (
      l ? (zo(a, n), o & 128 && e.normalize(a)) : n && (a.shapeFlag |= ye(n) ? 8 : 16),
      a.key !== a.key && k('VNode created with invalid key (NaN). VNode type:', a.type),
      Er > 0 && !i && Ye && (a.patchFlag > 0 || o & 6) && a.patchFlag !== 32 && Ye.push(a),
      a
    );
  }
  const j = Cm;
  function Am(e, t = null, n = null, r = 0, s = null, o = !1) {
    if (
      ((!e || e === ma) && (e || k(`Invalid vnode type when creating vnode: ${e}.`), (e = xe)),
      mn(e))
    ) {
      const l = vt(e, t, !0);
      return (
        n && zo(l, n),
        Er > 0 && !o && Ye && (l.shapeFlag & 6 ? (Ye[Ye.indexOf(e)] = l) : Ye.push(l)),
        (l.patchFlag = -2),
        l
      );
    }
    if ((ru(e) && (e = e.__vccOpts), t)) {
      t = Tm(t);
      let { class: l, style: a } = t;
      (l && !ye(l) && (t.class = Xe(l)),
        ue(a) && (lr(a) && !z(a) && (a = ve({}, a)), (t.style = On(a))));
    }
    const i = ye(e) ? 1 : Wa(e) ? 128 : oa(e) ? 64 : ue(e) ? 4 : G(e) ? 2 : 0;
    return (
      i & 4 &&
        lr(e) &&
        ((e = Q(e)),
        k(
          'Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.',
          `
Component that was made reactive: `,
          e
        )),
      _(e, t, n, r, s, i, o, !0)
    );
  }
  function Tm(e) {
    return e ? (lr(e) || Ta(e) ? ve({}, e) : e) : null;
  }
  function vt(e, t, n = !1, r = !1) {
    const { props: s, ref: o, patchFlag: i, children: l, transition: a } = e,
      c = t ? Om(s || {}, t) : s,
      u = {
        __v_isVNode: !0,
        __v_skip: !0,
        type: e.type,
        props: c,
        key: c && Ya(c),
        ref: t && t.ref ? (n && o ? (z(o) ? o.concat(xs(t)) : [o, xs(t)]) : xs(t)) : o,
        scopeId: e.scopeId,
        slotScopeIds: e.slotScopeIds,
        children: i === -1 && z(l) ? l.map(Qa) : l,
        target: e.target,
        targetStart: e.targetStart,
        targetAnchor: e.targetAnchor,
        staticCount: e.staticCount,
        shapeFlag: e.shapeFlag,
        patchFlag: t && e.type !== Se ? (i === -1 ? 16 : i | 16) : i,
        dynamicProps: e.dynamicProps,
        dynamicChildren: e.dynamicChildren,
        appContext: e.appContext,
        dirs: e.dirs,
        transition: a,
        component: e.component,
        suspense: e.suspense,
        ssContent: e.ssContent && vt(e.ssContent),
        ssFallback: e.ssFallback && vt(e.ssFallback),
        el: e.el,
        anchor: e.anchor,
        ctx: e.ctx,
        ce: e.ce
      };
    return (a && r && pr(u, a.clone(u)), u);
  }
  function Qa(e) {
    const t = vt(e);
    return (z(e.children) && (t.children = e.children.map(Qa)), t);
  }
  function ut(e = ' ', t = 0) {
    return j(qr, null, e, t);
  }
  function Za(e, t) {
    const n = j(Fn, null, e);
    return ((n.staticCount = t), n);
  }
  function Pe(e = '', t = !1) {
    return t ? (H(), hn(xe, null, e)) : j(xe, null, e);
  }
  function ct(e) {
    return e == null || typeof e == 'boolean'
      ? j(xe)
      : z(e)
        ? j(Se, null, e.slice())
        : mn(e)
          ? Jt(e)
          : j(qr, null, String(e));
  }
  function Jt(e) {
    return (e.el === null && e.patchFlag !== -1) || e.memo ? e : vt(e);
  }
  function zo(e, t) {
    let n = 0;
    const { shapeFlag: r } = e;
    if (t == null) t = null;
    else if (z(t)) n = 16;
    else if (typeof t == 'object')
      if (r & 65) {
        const s = t.default;
        s && (s._c && (s._d = !1), zo(e, s()), s._c && (s._d = !0));
        return;
      } else {
        n = 32;
        const s = t._;
        !s && !Ta(t)
          ? (t._ctx = we)
          : s === 3 && we && (we.slots._ === 1 ? (t._ = 1) : ((t._ = 2), (e.patchFlag |= 1024)));
      }
    else
      G(t)
        ? ((t = { default: t, _ctx: we }), (n = 32))
        : ((t = String(t)), r & 64 ? ((n = 16), (t = [ut(t)])) : (n = 8));
    ((e.children = t), (e.shapeFlag |= n));
  }
  function Om(...e) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const r = e[n];
      for (const s in r)
        if (s === 'class') t.class !== r.class && (t.class = Xe([t.class, r.class]));
        else if (s === 'style') t.style = On([t.style, r.style]);
        else if (Xn(s)) {
          const o = t[s],
            i = r[s];
          i && o !== i && !(z(o) && o.includes(i)) && (t[s] = o ? [].concat(o, i) : i);
        } else s !== '' && (t[s] = r[s]);
    }
    return t;
  }
  function qt(e, t, n, r = null) {
    lt(e, t, 7, [n, r]);
  }
  const km = Sa();
  let Im = 0;
  function Rm(e, t, n) {
    const r = e.type,
      s = (t ? t.appContext : e.appContext) || km,
      o = {
        uid: Im++,
        vnode: e,
        type: r,
        parent: t,
        appContext: s,
        root: null,
        next: null,
        subTree: null,
        effect: null,
        update: null,
        job: null,
        scope: new vl(!0),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: t ? t.provides : Object.create(s.provides),
        ids: t ? t.ids : ['', 0, 0],
        accessCache: null,
        renderCache: [],
        components: null,
        directives: null,
        propsOptions: ka(r, s),
        emitsOptions: Ua(r, s),
        emit: null,
        emitted: null,
        propsDefaults: ce,
        inheritAttrs: r.inheritAttrs,
        ctx: ce,
        data: ce,
        props: ce,
        attrs: ce,
        slots: ce,
        refs: ce,
        setupState: ce,
        setupContext: null,
        suspense: n,
        suspenseId: n ? n.pendingId : 0,
        asyncDep: null,
        asyncResolved: !1,
        isMounted: !1,
        isUnmounted: !1,
        isDeactivated: !1,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
      };
    return (
      (o.ctx = Nh(o)),
      (o.root = t ? t.root : o),
      (o.emit = vm.bind(null, o)),
      e.ce && e.ce(o),
      o
    );
  }
  let Ce = null;
  const Ss = () => Ce || we;
  let Cs, Ko;
  {
    const e = tr(),
      t = (n, r) => {
        let s;
        return (
          (s = e[n]) || (s = e[n] = []),
          s.push(r),
          (o) => {
            s.length > 1 ? s.forEach((i) => i(o)) : s[0](o);
          }
        );
      };
    ((Cs = t('__VUE_INSTANCE_SETTERS__', (n) => (Ce = n))),
      (Ko = t('__VUE_SSR_SETTERS__', (n) => (xr = n))));
  }
  const wr = (e) => {
      const t = Ce;
      return (
        Cs(e),
        e.scope.on(),
        () => {
          (e.scope.off(), Cs(t));
        }
      );
    },
    Xa = () => {
      (Ce && Ce.scope.off(), Cs(null));
    },
    Dm = kt('slot,component');
  function Wo(e, { isNativeTag: t }) {
    (Dm(e) || t(e)) && k('Do not use built-in or reserved HTML elements as component id: ' + e);
  }
  function eu(e) {
    return e.vnode.shapeFlag & 4;
  }
  let xr = !1;
  function Pm(e, t = !1, n = !1) {
    t && Ko(t);
    const { props: r, children: s } = e.vnode,
      o = eu(e);
    (Qh(e, r, o, t), am(e, s, n));
    const i = o ? Bm(e, t) : void 0;
    return (t && Ko(!1), i);
  }
  function Bm(e, t) {
    var n;
    const r = e.type;
    {
      if ((r.name && Wo(r.name, e.appContext.config), r.components)) {
        const o = Object.keys(r.components);
        for (let i = 0; i < o.length; i++) Wo(o[i], e.appContext.config);
      }
      if (r.directives) {
        const o = Object.keys(r.directives);
        for (let i = 0; i < o.length; i++) ra(o[i]);
      }
      r.compilerOptions &&
        $m() &&
        k(
          '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
        );
    }
    ((e.accessCache = Object.create(null)), (e.proxy = new Proxy(e.ctx, ya)), Lh(e));
    const { setup: s } = r;
    if (s) {
      Dt();
      const o = (e.setupContext = s.length > 1 ? Lm(e) : null),
        i = wr(e),
        l = In(s, e, 0, [ht(e.props), o]),
        a = ro(l);
      if ((Pt(), i(), (a || e.sp) && !Pn(e) && da(e), a)) {
        if ((l.then(Xa, Xa), t))
          return l
            .then((c) => {
              tu(e, c, t);
            })
            .catch((c) => {
              ar(c, e, 0);
            });
        if (((e.asyncDep = l), !e.suspense)) {
          const c = (n = r.name) != null ? n : 'Anonymous';
          k(
            `Component <${c}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
          );
        }
      } else tu(e, l, t);
    } else nu(e, t);
  }
  function tu(e, t, n) {
    (G(t)
      ? e.type.__ssrInlineRender
        ? (e.ssrRender = t)
        : (e.render = t)
      : ue(t)
        ? (mn(t) &&
            k('setup() should not return VNodes directly - return a render function instead.'),
          (e.devtoolsRawSetupState = t),
          (e.setupState = Ul(t)),
          Vh(e))
        : t !== void 0 &&
          k(`setup() should return an object. Received: ${t === null ? 'null' : typeof t}`),
      nu(e, n));
  }
  const $m = () => !0;
  function nu(e, t, n) {
    const r = e.type;
    e.render || (e.render = r.render || Ie);
    {
      const s = wr(e);
      Dt();
      try {
        Uh(e);
      } finally {
        (Pt(), s());
      }
    }
    !r.render &&
      e.render === Ie &&
      !t &&
      (r.template
        ? k(
            'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
          )
        : k('Component is missing template or render function: ', r));
  }
  const Fm = {
    get(e, t) {
      return (ws(), Te(e, 'get', ''), e[t]);
    },
    set() {
      return (k('setupContext.attrs is readonly.'), !1);
    },
    deleteProperty() {
      return (k('setupContext.attrs is readonly.'), !1);
    }
  };
  function Nm(e) {
    return new Proxy(e.slots, {
      get(t, n) {
        return (Te(e, 'get', '$slots'), t[n]);
      }
    });
  }
  function Lm(e) {
    const t = (n) => {
      if ((e.exposed && k('expose() should be called only once per setup().'), n != null)) {
        let r = typeof n;
        (r === 'object' && (z(n) ? (r = 'array') : me(n) && (r = 'ref')),
          r !== 'object' && k(`expose() should be passed a plain object, received ${r}.`));
      }
      e.exposed = n || {};
    };
    {
      let n, r;
      return Object.freeze({
        get attrs() {
          return n || (n = new Proxy(e.attrs, Fm));
        },
        get slots() {
          return r || (r = Nm(e));
        },
        get emit() {
          return (s, ...o) => e.emit(s, ...o);
        },
        expose: t
      });
    }
  }
  function As(e) {
    return e.exposed
      ? e.exposeProxy ||
          (e.exposeProxy = new Proxy(Ul(Ht(e.exposed)), {
            get(t, n) {
              if (n in t) return t[n];
              if (n in fn) return fn[n](e);
            },
            has(t, n) {
              return n in t || n in fn;
            }
          }))
      : e.proxy;
  }
  const Vm = /(?:^|[-_])(\w)/g,
    Mm = (e) => e.replace(Vm, (t) => t.toUpperCase()).replace(/[-_]/g, '');
  function Go(e, t = !0) {
    return G(e) ? e.displayName || e.name : e.name || (t && e.__name);
  }
  function Ts(e, t, n = !1) {
    let r = Go(t);
    if (!r && t.__file) {
      const s = t.__file.match(/([^/\\]+)\.\w+$/);
      s && (r = s[1]);
    }
    if (!r && e && e.parent) {
      const s = (o) => {
        for (const i in o) if (o[i] === t) return i;
      };
      r = s(e.components || e.parent.type.components) || s(e.appContext.components);
    }
    return r ? Mm(r) : n ? 'App' : 'Anonymous';
  }
  function ru(e) {
    return G(e) && '__vccOpts' in e;
  }
  const ee = (e, t) => {
    const n = Zp(e, t, xr);
    {
      const r = Ss();
      r && r.appContext.config.warnRecursiveComputed && (n._warnRecursive = !0);
    }
    return n;
  };
  function Um(e, t, n) {
    const r = arguments.length;
    return r === 2
      ? ue(t) && !z(t)
        ? mn(t)
          ? j(e, null, [t])
          : j(e, t)
        : j(e, null, t)
      : (r > 3 ? (n = Array.prototype.slice.call(arguments, 2)) : r === 3 && mn(n) && (n = [n]),
        j(e, t, n));
  }
  function Hm() {
    if (typeof window > 'u') return;
    const e = { style: 'color:#3ba776' },
      t = { style: 'color:#1677ff' },
      n = { style: 'color:#f5222d' },
      r = { style: 'color:#eb2f96' },
      s = {
        __vue_custom_formatter: !0,
        header(f) {
          return ue(f)
            ? f.__isVue
              ? ['div', e, 'VueInstance']
              : me(f)
                ? ['div', {}, ['span', e, u(f)], '<', l('_value' in f ? f._value : f), '>']
                : mt(f)
                  ? [
                      'div',
                      {},
                      ['span', e, Ne(f) ? 'ShallowReactive' : 'Reactive'],
                      '<',
                      l(f),
                      `>${$t(f) ? ' (readonly)' : ''}`
                    ]
                  : $t(f)
                    ? [
                        'div',
                        {},
                        ['span', e, Ne(f) ? 'ShallowReadonly' : 'Readonly'],
                        '<',
                        l(f),
                        '>'
                      ]
                    : null
            : null;
        },
        hasBody(f) {
          return f && f.__isVue;
        },
        body(f) {
          if (f && f.__isVue) return ['div', {}, ...o(f.$)];
        }
      };
    function o(f) {
      const d = [];
      (f.type.props && f.props && d.push(i('props', Q(f.props))),
        f.setupState !== ce && d.push(i('setup', f.setupState)),
        f.data !== ce && d.push(i('data', Q(f.data))));
      const h = a(f, 'computed');
      h && d.push(i('computed', h));
      const g = a(f, 'inject');
      return (
        g && d.push(i('injected', g)),
        d.push([
          'div',
          {},
          ['span', { style: r.style + ';opacity:0.66' }, '$ (internal): '],
          ['object', { object: f }]
        ]),
        d
      );
    }
    function i(f, d) {
      return (
        (d = ve({}, d)),
        Object.keys(d).length
          ? [
              'div',
              { style: 'line-height:1.25em;margin-bottom:0.6em' },
              ['div', { style: 'color:#476582' }, f],
              [
                'div',
                { style: 'padding-left:1.25em' },
                ...Object.keys(d).map((h) => ['div', {}, ['span', r, h + ': '], l(d[h], !1)])
              ]
            ]
          : ['span', {}]
      );
    }
    function l(f, d = !0) {
      return typeof f == 'number'
        ? ['span', t, f]
        : typeof f == 'string'
          ? ['span', n, JSON.stringify(f)]
          : typeof f == 'boolean'
            ? ['span', r, f]
            : ue(f)
              ? ['object', { object: d ? Q(f) : f }]
              : ['span', n, String(f)];
    }
    function a(f, d) {
      const h = f.type;
      if (G(h)) return;
      const g = {};
      for (const v in f.ctx) c(h, v, d) && (g[v] = f.ctx[v]);
      return g;
    }
    function c(f, d, h) {
      const g = f[h];
      if (
        (z(g) && g.includes(d)) ||
        (ue(g) && d in g) ||
        (f.extends && c(f.extends, d, h)) ||
        (f.mixins && f.mixins.some((v) => c(v, d, h)))
      )
        return !0;
    }
    function u(f) {
      return Ne(f) ? 'ShallowRef' : f.effect ? 'ComputedRef' : 'Ref';
    }
    window.devtoolsFormatters
      ? window.devtoolsFormatters.push(s)
      : (window.devtoolsFormatters = [s]);
  }
  const su = '3.5.13',
    bt = k;
  let Jo;
  const ou = typeof window < 'u' && window.trustedTypes;
  if (ou)
    try {
      Jo = ou.createPolicy('vue', { createHTML: (e) => e });
    } catch (e) {
      bt(`Error creating trusted types policy: ${e}`);
    }
  const iu = Jo ? (e) => Jo.createHTML(e) : (e) => e,
    jm = 'http://www.w3.org/2000/svg',
    zm = 'http://www.w3.org/1998/Math/MathML',
    Lt = typeof document < 'u' ? document : null,
    lu = Lt && Lt.createElement('template'),
    Km = {
      insert: (e, t, n) => {
        t.insertBefore(e, n || null);
      },
      remove: (e) => {
        const t = e.parentNode;
        t && t.removeChild(e);
      },
      createElement: (e, t, n, r) => {
        const s =
          t === 'svg'
            ? Lt.createElementNS(jm, e)
            : t === 'mathml'
              ? Lt.createElementNS(zm, e)
              : n
                ? Lt.createElement(e, { is: n })
                : Lt.createElement(e);
        return (
          e === 'select' && r && r.multiple != null && s.setAttribute('multiple', r.multiple),
          s
        );
      },
      createText: (e) => Lt.createTextNode(e),
      createComment: (e) => Lt.createComment(e),
      setText: (e, t) => {
        e.nodeValue = t;
      },
      setElementText: (e, t) => {
        e.textContent = t;
      },
      parentNode: (e) => e.parentNode,
      nextSibling: (e) => e.nextSibling,
      querySelector: (e) => Lt.querySelector(e),
      setScopeId(e, t) {
        e.setAttribute(t, '');
      },
      insertStaticContent(e, t, n, r, s, o) {
        const i = n ? n.previousSibling : t.lastChild;
        if (s && (s === o || s.nextSibling))
          for (; t.insertBefore(s.cloneNode(!0), n), !(s === o || !(s = s.nextSibling)); );
        else {
          lu.innerHTML = iu(
            r === 'svg' ? `<svg>${e}</svg>` : r === 'mathml' ? `<math>${e}</math>` : e
          );
          const l = lu.content;
          if (r === 'svg' || r === 'mathml') {
            const a = l.firstChild;
            for (; a.firstChild; ) l.appendChild(a.firstChild);
            l.removeChild(a);
          }
          t.insertBefore(l, n);
        }
        return [i ? i.nextSibling : t.firstChild, n ? n.previousSibling : t.lastChild];
      }
    },
    Yt = 'transition',
    Sr = 'animation',
    Cr = Symbol('_vtc'),
    au = {
      name: String,
      type: String,
      css: { type: Boolean, default: !0 },
      duration: [String, Number, Object],
      enterFromClass: String,
      enterActiveClass: String,
      enterToClass: String,
      appearFromClass: String,
      appearActiveClass: String,
      appearToClass: String,
      leaveFromClass: String,
      leaveActiveClass: String,
      leaveToClass: String
    },
    Wm = ve({}, ia, au),
    Gm = ((e) => ((e.displayName = 'Transition'), (e.props = Wm), e))((e, { slots: t }) =>
      Um(xh, Jm(e), t)
    ),
    _n = (e, t = []) => {
      z(e) ? e.forEach((n) => n(...t)) : e && e(...t);
    },
    uu = (e) => (e ? (z(e) ? e.some((t) => t.length > 1) : e.length > 1) : !1);
  function Jm(e) {
    const t = {};
    for (const T in e) T in au || (t[T] = e[T]);
    if (e.css === !1) return t;
    const {
        name: n = 'v',
        type: r,
        duration: s,
        enterFromClass: o = `${n}-enter-from`,
        enterActiveClass: i = `${n}-enter-active`,
        enterToClass: l = `${n}-enter-to`,
        appearFromClass: a = o,
        appearActiveClass: c = i,
        appearToClass: u = l,
        leaveFromClass: f = `${n}-leave-from`,
        leaveActiveClass: d = `${n}-leave-active`,
        leaveToClass: h = `${n}-leave-to`
      } = e,
      g = Ym(s),
      v = g && g[0],
      y = g && g[1],
      {
        onBeforeEnter: E,
        onEnter: N,
        onEnterCancelled: P,
        onLeave: te,
        onLeaveCancelled: B,
        onBeforeAppear: J = E,
        onAppear: V = N,
        onAppearCancelled: ae = P
      } = t,
      U = (T, ne, he, be) => {
        ((T._enterCancelled = be), yn(T, ne ? u : l), yn(T, ne ? c : i), he && he());
      },
      I = (T, ne) => {
        ((T._isLeaving = !1), yn(T, f), yn(T, h), yn(T, d), ne && ne());
      },
      O = (T) => (ne, he) => {
        const be = T ? V : N,
          de = () => U(ne, T, he);
        (_n(be, [ne, de]),
          cu(() => {
            (yn(ne, T ? a : o), Vt(ne, T ? u : l), uu(be) || fu(ne, r, v, de));
          }));
      };
    return ve(t, {
      onBeforeEnter(T) {
        (_n(E, [T]), Vt(T, o), Vt(T, i));
      },
      onBeforeAppear(T) {
        (_n(J, [T]), Vt(T, a), Vt(T, c));
      },
      onEnter: O(!1),
      onAppear: O(!0),
      onLeave(T, ne) {
        T._isLeaving = !0;
        const he = () => I(T, ne);
        (Vt(T, f),
          T._enterCancelled ? (Vt(T, d), hu()) : (hu(), Vt(T, d)),
          cu(() => {
            T._isLeaving && (yn(T, f), Vt(T, h), uu(te) || fu(T, r, y, he));
          }),
          _n(te, [T, he]));
      },
      onEnterCancelled(T) {
        (U(T, !1, void 0, !0), _n(P, [T]));
      },
      onAppearCancelled(T) {
        (U(T, !0, void 0, !0), _n(ae, [T]));
      },
      onLeaveCancelled(T) {
        (I(T), _n(B, [T]));
      }
    });
  }
  function Ym(e) {
    if (e == null) return null;
    if (ue(e)) return [Yo(e.enter), Yo(e.leave)];
    {
      const t = Yo(e);
      return [t, t];
    }
  }
  function Yo(e) {
    const t = dp(e);
    return (oh(t, '<transition> explicit duration'), t);
  }
  function Vt(e, t) {
    (t.split(/\s+/).forEach((n) => n && e.classList.add(n)), (e[Cr] || (e[Cr] = new Set())).add(t));
  }
  function yn(e, t) {
    t.split(/\s+/).forEach((r) => r && e.classList.remove(r));
    const n = e[Cr];
    n && (n.delete(t), n.size || (e[Cr] = void 0));
  }
  function cu(e) {
    requestAnimationFrame(() => {
      requestAnimationFrame(e);
    });
  }
  let Qm = 0;
  function fu(e, t, n, r) {
    const s = (e._endId = ++Qm),
      o = () => {
        s === e._endId && r();
      };
    if (n != null) return setTimeout(o, n);
    const { type: i, timeout: l, propCount: a } = Zm(e, t);
    if (!i) return r();
    const c = i + 'end';
    let u = 0;
    const f = () => {
        (e.removeEventListener(c, d), o());
      },
      d = (h) => {
        h.target === e && ++u >= a && f();
      };
    (setTimeout(() => {
      u < a && f();
    }, l + 1),
      e.addEventListener(c, d));
  }
  function Zm(e, t) {
    const n = window.getComputedStyle(e),
      r = (g) => (n[g] || '').split(', '),
      s = r(`${Yt}Delay`),
      o = r(`${Yt}Duration`),
      i = du(s, o),
      l = r(`${Sr}Delay`),
      a = r(`${Sr}Duration`),
      c = du(l, a);
    let u = null,
      f = 0,
      d = 0;
    t === Yt
      ? i > 0 && ((u = Yt), (f = i), (d = o.length))
      : t === Sr
        ? c > 0 && ((u = Sr), (f = c), (d = a.length))
        : ((f = Math.max(i, c)),
          (u = f > 0 ? (i > c ? Yt : Sr) : null),
          (d = u ? (u === Yt ? o.length : a.length) : 0));
    const h = u === Yt && /\b(transform|all)(,|$)/.test(r(`${Yt}Property`).toString());
    return { type: u, timeout: f, propCount: d, hasTransform: h };
  }
  function du(e, t) {
    for (; e.length < t.length; ) e = e.concat(e);
    return Math.max(...t.map((n, r) => pu(n) + pu(e[r])));
  }
  function pu(e) {
    return e === 'auto' ? 0 : Number(e.slice(0, -1).replace(',', '.')) * 1e3;
  }
  function hu() {
    return document.body.offsetHeight;
  }
  function Xm(e, t, n) {
    const r = e[Cr];
    (r && (t = (t ? [t, ...r] : [...r]).join(' ')),
      t == null ? e.removeAttribute('class') : n ? e.setAttribute('class', t) : (e.className = t));
  }
  const mu = Symbol('_vod'),
    e0 = Symbol('_vsh'),
    gu = Symbol('CSS_VAR_TEXT');
  function t0(e) {
    const t = Ss();
    if (!t) {
      bt('useCssVars is called without current active component instance.');
      return;
    }
    const n = (t.ut = (s = e(t.proxy)) => {
      Array.from(document.querySelectorAll(`[data-v-owner="${t.uid}"]`)).forEach((o) => Os(o, s));
    });
    t.getCssVars = () => e(t.proxy);
    const r = () => {
      const s = e(t.proxy);
      (t.ce ? Os(t.ce, s) : Qo(t.subTree, s), n(s));
    };
    (ha(() => {
      xo(r);
    }),
      mr(() => {
        at(r, Ie, { flush: 'post' });
        const s = new MutationObserver(r);
        (s.observe(t.subTree.el.parentNode, { childList: !0 }), vs(() => s.disconnect()));
      }));
  }
  function Qo(e, t) {
    if (e.shapeFlag & 128) {
      const n = e.suspense;
      ((e = n.activeBranch),
        n.pendingBranch &&
          !n.isHydrating &&
          n.effects.push(() => {
            Qo(n.activeBranch, t);
          }));
    }
    for (; e.component; ) e = e.component.subTree;
    if (e.shapeFlag & 1 && e.el) Os(e.el, t);
    else if (e.type === Se) e.children.forEach((n) => Qo(n, t));
    else if (e.type === Fn) {
      let { el: n, anchor: r } = e;
      for (; n && (Os(n, t), n !== r); ) n = n.nextSibling;
    }
  }
  function Os(e, t) {
    if (e.nodeType === 1) {
      const n = e.style;
      let r = '';
      for (const s in t) (n.setProperty(`--${s}`, t[s]), (r += `--${s}: ${t[s]};`));
      n[gu] = r;
    }
  }
  const n0 = /(^|;)\s*display\s*:/;
  function r0(e, t, n) {
    const r = e.style,
      s = ye(n);
    let o = !1;
    if (n && !s) {
      if (t)
        if (ye(t))
          for (const i of t.split(';')) {
            const l = i.slice(0, i.indexOf(':')).trim();
            n[l] == null && ks(r, l, '');
          }
        else for (const i in t) n[i] == null && ks(r, i, '');
      for (const i in n) (i === 'display' && (o = !0), ks(r, i, n[i]));
    } else if (s) {
      if (t !== n) {
        const i = r[gu];
        (i && (n += ';' + i), (r.cssText = n), (o = n0.test(n)));
      }
    } else t && e.removeAttribute('style');
    mu in e && ((e[mu] = o ? r.display : ''), e[e0] && (r.display = 'none'));
  }
  const s0 = /[^\\];\s*$/,
    _u = /\s*!important$/;
  function ks(e, t, n) {
    if (z(n)) n.forEach((r) => ks(e, t, r));
    else if (
      (n == null && (n = ''),
      s0.test(n) && bt(`Unexpected semicolon at the end of '${t}' style value: '${n}'`),
      t.startsWith('--'))
    )
      e.setProperty(t, n);
    else {
      const r = o0(e, t);
      _u.test(n) ? e.setProperty(Rt(r), n.replace(_u, ''), 'important') : (e[r] = n);
    }
  }
  const yu = ['Webkit', 'Moz', 'ms'],
    Zo = {};
  function o0(e, t) {
    const n = Zo[t];
    if (n) return n;
    let r = $e(t);
    if (r !== 'filter' && r in e) return (Zo[t] = r);
    r = rn(r);
    for (let s = 0; s < yu.length; s++) {
      const o = yu[s] + r;
      if (o in e) return (Zo[t] = o);
    }
    return t;
  }
  const vu = 'http://www.w3.org/1999/xlink';
  function qu(e, t, n, r, s, o = wp(t)) {
    r && t.startsWith('xlink:')
      ? n == null
        ? e.removeAttributeNS(vu, t.slice(6, t.length))
        : e.setAttributeNS(vu, t, n)
      : n == null || (o && !gl(n))
        ? e.removeAttribute(t)
        : e.setAttribute(t, o ? '' : It(n) ? String(n) : n);
  }
  function bu(e, t, n, r, s) {
    if (t === 'innerHTML' || t === 'textContent') {
      n != null && (e[t] = t === 'innerHTML' ? iu(n) : n);
      return;
    }
    const o = e.tagName;
    if (t === 'value' && o !== 'PROGRESS' && !o.includes('-')) {
      const l = o === 'OPTION' ? e.getAttribute('value') || '' : e.value,
        a = n == null ? (e.type === 'checkbox' ? 'on' : '') : String(n);
      ((l !== a || !('_value' in e)) && (e.value = a),
        n == null && e.removeAttribute(t),
        (e._value = n));
      return;
    }
    let i = !1;
    if (n === '' || n == null) {
      const l = typeof e[t];
      l === 'boolean'
        ? (n = gl(n))
        : n == null && l === 'string'
          ? ((n = ''), (i = !0))
          : l === 'number' && ((n = 0), (i = !0));
    }
    try {
      e[t] = n;
    } catch (l) {
      i || bt(`Failed setting prop "${t}" on <${o.toLowerCase()}>: value ${n} is invalid.`, l);
    }
    i && e.removeAttribute(s || t);
  }
  function Nn(e, t, n, r) {
    e.addEventListener(t, n, r);
  }
  function i0(e, t, n, r) {
    e.removeEventListener(t, n, r);
  }
  const Eu = Symbol('_vei');
  function l0(e, t, n, r, s = null) {
    const o = e[Eu] || (e[Eu] = {}),
      i = o[t];
    if (r && i) i.value = xu(r, t);
    else {
      const [l, a] = a0(t);
      if (r) {
        const c = (o[t] = f0(xu(r, t), s));
        Nn(e, l, c, a);
      } else i && (i0(e, l, i, a), (o[t] = void 0));
    }
  }
  const wu = /(?:Once|Passive|Capture)$/;
  function a0(e) {
    let t;
    if (wu.test(e)) {
      t = {};
      let r;
      for (; (r = e.match(wu)); )
        ((e = e.slice(0, e.length - r[0].length)), (t[r[0].toLowerCase()] = !0));
    }
    return [e[2] === ':' ? e.slice(3) : Rt(e.slice(2)), t];
  }
  let Xo = 0;
  const u0 = Promise.resolve(),
    c0 = () => Xo || (u0.then(() => (Xo = 0)), (Xo = Date.now()));
  function f0(e, t) {
    const n = (r) => {
      if (!r._vts) r._vts = Date.now();
      else if (r._vts <= n.attached) return;
      lt(d0(r, n.value), t, 5, [r]);
    };
    return ((n.value = e), (n.attached = c0()), n);
  }
  function xu(e, t) {
    return G(e) || z(e)
      ? e
      : (bt(`Wrong type passed as event handler to ${t} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof e}.`),
        Ie);
  }
  function d0(e, t) {
    if (z(t)) {
      const n = e.stopImmediatePropagation;
      return (
        (e.stopImmediatePropagation = () => {
          (n.call(e), (e._stopped = !0));
        }),
        t.map((r) => (s) => !s._stopped && r && r(s))
      );
    } else return t;
  }
  const Su = (e) =>
      e.charCodeAt(0) === 111 &&
      e.charCodeAt(1) === 110 &&
      e.charCodeAt(2) > 96 &&
      e.charCodeAt(2) < 123,
    p0 = (e, t, n, r, s, o) => {
      const i = s === 'svg';
      t === 'class'
        ? Xm(e, r, i)
        : t === 'style'
          ? r0(e, n, r)
          : Xn(t)
            ? Yr(t) || l0(e, t, n, r, o)
            : (
                  t[0] === '.'
                    ? ((t = t.slice(1)), !0)
                    : t[0] === '^'
                      ? ((t = t.slice(1)), !1)
                      : h0(e, t, r, i)
                )
              ? (bu(e, t, r),
                !e.tagName.includes('-') &&
                  (t === 'value' || t === 'checked' || t === 'selected') &&
                  qu(e, t, r, i, o, t !== 'value'))
              : e._isVueCE && (/[A-Z]/.test(t) || !ye(r))
                ? bu(e, $e(t), r, o, t)
                : (t === 'true-value'
                    ? (e._trueValue = r)
                    : t === 'false-value' && (e._falseValue = r),
                  qu(e, t, r, i));
    };
  function h0(e, t, n, r) {
    if (r) return !!(t === 'innerHTML' || t === 'textContent' || (t in e && Su(t) && G(n)));
    if (
      t === 'spellcheck' ||
      t === 'draggable' ||
      t === 'translate' ||
      t === 'form' ||
      (t === 'list' && e.tagName === 'INPUT') ||
      (t === 'type' && e.tagName === 'TEXTAREA')
    )
      return !1;
    if (t === 'width' || t === 'height') {
      const s = e.tagName;
      if (s === 'IMG' || s === 'VIDEO' || s === 'CANVAS' || s === 'SOURCE') return !1;
    }
    return Su(t) && ye(n) ? !1 : t in e;
  }
  const Cu = (e) => {
    const t = e.props['onUpdate:modelValue'] || !1;
    return z(t) ? (n) => Tn(t, n) : t;
  };
  function m0(e) {
    e.target.composing = !0;
  }
  function Au(e) {
    const t = e.target;
    t.composing && ((t.composing = !1), t.dispatchEvent(new Event('input')));
  }
  const ei = Symbol('_assign'),
    Tu = {
      created(e, { modifiers: { lazy: t, trim: n, number: r } }, s) {
        e[ei] = Cu(s);
        const o = r || (s.props && s.props.type === 'number');
        (Nn(e, t ? 'change' : 'input', (i) => {
          if (i.target.composing) return;
          let l = e.value;
          (n && (l = l.trim()), o && (l = io(l)), e[ei](l));
        }),
          n &&
            Nn(e, 'change', () => {
              e.value = e.value.trim();
            }),
          t || (Nn(e, 'compositionstart', m0), Nn(e, 'compositionend', Au), Nn(e, 'change', Au)));
      },
      mounted(e, { value: t }) {
        e.value = t ?? '';
      },
      beforeUpdate(e, { value: t, oldValue: n, modifiers: { lazy: r, trim: s, number: o } }, i) {
        if (((e[ei] = Cu(i)), e.composing)) return;
        const l = (o || e.type === 'number') && !/^0\d/.test(e.value) ? io(e.value) : e.value,
          a = t ?? '';
        l !== a &&
          ((document.activeElement === e &&
            e.type !== 'range' &&
            ((r && t === n) || (s && e.value.trim() === a))) ||
            (e.value = a));
      }
    },
    g0 = ['ctrl', 'shift', 'alt', 'meta'],
    _0 = {
      stop: (e) => e.stopPropagation(),
      prevent: (e) => e.preventDefault(),
      self: (e) => e.target !== e.currentTarget,
      ctrl: (e) => !e.ctrlKey,
      shift: (e) => !e.shiftKey,
      alt: (e) => !e.altKey,
      meta: (e) => !e.metaKey,
      left: (e) => 'button' in e && e.button !== 0,
      middle: (e) => 'button' in e && e.button !== 1,
      right: (e) => 'button' in e && e.button !== 2,
      exact: (e, t) => g0.some((n) => e[`${n}Key`] && !t.includes(n))
    },
    Ou = (e, t) => {
      const n = e._withMods || (e._withMods = {}),
        r = t.join('.');
      return (
        n[r] ||
        (n[r] = (s, ...o) => {
          for (let i = 0; i < t.length; i++) {
            const l = _0[t[i]];
            if (l && l(s, t)) return;
          }
          return e(s, ...o);
        })
      );
    },
    y0 = {
      esc: 'escape',
      space: ' ',
      up: 'arrow-up',
      left: 'arrow-left',
      right: 'arrow-right',
      down: 'arrow-down',
      delete: 'backspace'
    },
    ku = (e, t) => {
      const n = e._withKeys || (e._withKeys = {}),
        r = t.join('.');
      return (
        n[r] ||
        (n[r] = (s) => {
          if (!('key' in s)) return;
          const o = Rt(s.key);
          if (t.some((i) => i === o || y0[i] === o)) return e(s);
        })
      );
    },
    v0 = ve({ patchProp: p0 }, Km);
  let Iu;
  function q0() {
    return Iu || (Iu = fm(v0));
  }
  const b0 = (...e) => {
    const t = q0().createApp(...e);
    (w0(t), x0(t));
    const { mount: n } = t;
    return (
      (t.mount = (r) => {
        const s = S0(r);
        if (!s) return;
        const o = t._component;
        (!G(o) && !o.render && !o.template && (o.template = s.innerHTML),
          s.nodeType === 1 && (s.textContent = ''));
        const i = n(s, !1, E0(s));
        return (
          s instanceof Element && (s.removeAttribute('v-cloak'), s.setAttribute('data-v-app', '')),
          i
        );
      }),
      t
    );
  };
  function E0(e) {
    if (e instanceof SVGElement) return 'svg';
    if (typeof MathMLElement == 'function' && e instanceof MathMLElement) return 'mathml';
  }
  function w0(e) {
    Object.defineProperty(e.config, 'isNativeTag', {
      value: (t) => qp(t) || bp(t) || Ep(t),
      writable: !1
    });
  }
  function x0(e) {
    {
      const t = e.config.isCustomElement;
      Object.defineProperty(e.config, 'isCustomElement', {
        get() {
          return t;
        },
        set() {
          bt(
            'The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead.'
          );
        }
      });
      const n = e.config.compilerOptions,
        r =
          'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
      Object.defineProperty(e.config, 'compilerOptions', {
        get() {
          return (bt(r), n);
        },
        set() {
          bt(r);
        }
      });
    }
  }
  function S0(e) {
    if (ye(e)) {
      const t = document.querySelector(e);
      return (t || bt(`Failed to mount app: mount target selector "${e}" returned null.`), t);
    }
    return (
      window.ShadowRoot &&
        e instanceof window.ShadowRoot &&
        e.mode === 'closed' &&
        bt('mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'),
      e
    );
  }
  function C0() {
    Hm();
  }
  C0();
  var A0 = Object.create,
    Ru = Object.defineProperty,
    T0 = Object.getOwnPropertyDescriptor,
    ti = Object.getOwnPropertyNames,
    O0 = Object.getPrototypeOf,
    k0 = Object.prototype.hasOwnProperty,
    I0 = (e, t) =>
      function () {
        return (e && (t = (0, e[ti(e)[0]])((e = 0))), t);
      },
    R0 = (e, t) =>
      function () {
        return (t || (0, e[ti(e)[0]])((t = { exports: {} }).exports, t), t.exports);
      },
    D0 = (e, t, n, r) => {
      if ((t && typeof t == 'object') || typeof t == 'function')
        for (let s of ti(t))
          !k0.call(e, s) &&
            s !== n &&
            Ru(e, s, { get: () => t[s], enumerable: !(r = T0(t, s)) || r.enumerable });
      return e;
    },
    P0 = (e, t, n) => (
      (n = e != null ? A0(O0(e)) : {}),
      D0(Ru(n, 'default', { value: e, enumerable: !0 }), e)
    ),
    Ar = I0({
      '../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js'() {}
    }),
    B0 = R0({
      '../../node_modules/.pnpm/rfdc@1.4.1/node_modules/rfdc/index.js'(e, t) {
        (Ar(), (t.exports = r));
        function n(o) {
          return o instanceof Buffer
            ? Buffer.from(o)
            : new o.constructor(o.buffer.slice(), o.byteOffset, o.length);
        }
        function r(o) {
          if (((o = o || {}), o.circles)) return s(o);
          const i = new Map();
          if (
            (i.set(Date, (f) => new Date(f)),
            i.set(Map, (f, d) => new Map(a(Array.from(f), d))),
            i.set(Set, (f, d) => new Set(a(Array.from(f), d))),
            o.constructorHandlers)
          )
            for (const f of o.constructorHandlers) i.set(f[0], f[1]);
          let l = null;
          return o.proto ? u : c;
          function a(f, d) {
            const h = Object.keys(f),
              g = new Array(h.length);
            for (let v = 0; v < h.length; v++) {
              const y = h[v],
                E = f[y];
              typeof E != 'object' || E === null
                ? (g[y] = E)
                : E.constructor !== Object && (l = i.get(E.constructor))
                  ? (g[y] = l(E, d))
                  : ArrayBuffer.isView(E)
                    ? (g[y] = n(E))
                    : (g[y] = d(E));
            }
            return g;
          }
          function c(f) {
            if (typeof f != 'object' || f === null) return f;
            if (Array.isArray(f)) return a(f, c);
            if (f.constructor !== Object && (l = i.get(f.constructor))) return l(f, c);
            const d = {};
            for (const h in f) {
              if (Object.hasOwnProperty.call(f, h) === !1) continue;
              const g = f[h];
              typeof g != 'object' || g === null
                ? (d[h] = g)
                : g.constructor !== Object && (l = i.get(g.constructor))
                  ? (d[h] = l(g, c))
                  : ArrayBuffer.isView(g)
                    ? (d[h] = n(g))
                    : (d[h] = c(g));
            }
            return d;
          }
          function u(f) {
            if (typeof f != 'object' || f === null) return f;
            if (Array.isArray(f)) return a(f, u);
            if (f.constructor !== Object && (l = i.get(f.constructor))) return l(f, u);
            const d = {};
            for (const h in f) {
              const g = f[h];
              typeof g != 'object' || g === null
                ? (d[h] = g)
                : g.constructor !== Object && (l = i.get(g.constructor))
                  ? (d[h] = l(g, u))
                  : ArrayBuffer.isView(g)
                    ? (d[h] = n(g))
                    : (d[h] = u(g));
            }
            return d;
          }
        }
        function s(o) {
          const i = [],
            l = [],
            a = new Map();
          if (
            (a.set(Date, (h) => new Date(h)),
            a.set(Map, (h, g) => new Map(u(Array.from(h), g))),
            a.set(Set, (h, g) => new Set(u(Array.from(h), g))),
            o.constructorHandlers)
          )
            for (const h of o.constructorHandlers) a.set(h[0], h[1]);
          let c = null;
          return o.proto ? d : f;
          function u(h, g) {
            const v = Object.keys(h),
              y = new Array(v.length);
            for (let E = 0; E < v.length; E++) {
              const N = v[E],
                P = h[N];
              if (typeof P != 'object' || P === null) y[N] = P;
              else if (P.constructor !== Object && (c = a.get(P.constructor))) y[N] = c(P, g);
              else if (ArrayBuffer.isView(P)) y[N] = n(P);
              else {
                const te = i.indexOf(P);
                te !== -1 ? (y[N] = l[te]) : (y[N] = g(P));
              }
            }
            return y;
          }
          function f(h) {
            if (typeof h != 'object' || h === null) return h;
            if (Array.isArray(h)) return u(h, f);
            if (h.constructor !== Object && (c = a.get(h.constructor))) return c(h, f);
            const g = {};
            (i.push(h), l.push(g));
            for (const v in h) {
              if (Object.hasOwnProperty.call(h, v) === !1) continue;
              const y = h[v];
              if (typeof y != 'object' || y === null) g[v] = y;
              else if (y.constructor !== Object && (c = a.get(y.constructor))) g[v] = c(y, f);
              else if (ArrayBuffer.isView(y)) g[v] = n(y);
              else {
                const E = i.indexOf(y);
                E !== -1 ? (g[v] = l[E]) : (g[v] = f(y));
              }
            }
            return (i.pop(), l.pop(), g);
          }
          function d(h) {
            if (typeof h != 'object' || h === null) return h;
            if (Array.isArray(h)) return u(h, d);
            if (h.constructor !== Object && (c = a.get(h.constructor))) return c(h, d);
            const g = {};
            (i.push(h), l.push(g));
            for (const v in h) {
              const y = h[v];
              if (typeof y != 'object' || y === null) g[v] = y;
              else if (y.constructor !== Object && (c = a.get(y.constructor))) g[v] = c(y, d);
              else if (ArrayBuffer.isView(y)) g[v] = n(y);
              else {
                const E = i.indexOf(y);
                E !== -1 ? (g[v] = l[E]) : (g[v] = d(y));
              }
            }
            return (i.pop(), l.pop(), g);
          }
        }
      }
    });
  (Ar(), Ar(), Ar());
  var Du = typeof navigator < 'u',
    M =
      typeof window < 'u'
        ? window
        : typeof globalThis < 'u'
          ? globalThis
          : typeof global < 'u'
            ? global
            : {};
  (typeof M.chrome < 'u' && M.chrome.devtools, Du && (M.self, M.top));
  var Pu;
  (typeof navigator < 'u' &&
    ((Pu = navigator.userAgent) == null || Pu.toLowerCase().includes('electron')),
    Ar());
  var $0 = P0(B0()),
    F0 = /(?:^|[-_/])(\w)/g;
  function N0(e, t) {
    return t ? t.toUpperCase() : '';
  }
  function L0(e) {
    return e && `${e}`.replace(F0, N0);
  }
  function V0(e, t) {
    let n = e.replace(/^[a-z]:/i, '').replace(/\\/g, '/');
    n.endsWith(`index${t}`) && (n = n.replace(`/index${t}`, t));
    const r = n.lastIndexOf('/'),
      s = n.substring(r + 1);
    {
      const o = s.lastIndexOf(t);
      return s.substring(0, o);
    }
  }
  var Bu = (0, $0.default)({ circles: !0 });
  const M0 = { trailing: !0 };
  function Ln(e, t = 25, n = {}) {
    if (((n = { ...M0, ...n }), !Number.isFinite(t)))
      throw new TypeError('Expected `wait` to be a finite number');
    let r,
      s,
      o = [],
      i,
      l;
    const a = (c, u) => (
      (i = U0(e, c, u)),
      i.finally(() => {
        if (((i = null), n.trailing && l && !s)) {
          const f = a(c, l);
          return ((l = null), f);
        }
      }),
      i
    );
    return function (...c) {
      return i
        ? (n.trailing && (l = c), i)
        : new Promise((u) => {
            const f = !s && n.leading;
            (clearTimeout(s),
              (s = setTimeout(() => {
                s = null;
                const d = n.leading ? r : a(this, c);
                for (const h of o) h(d);
                o = [];
              }, t)),
              f ? ((r = a(this, c)), u(r)) : o.push(u));
          });
    };
  }
  async function U0(e, t, n) {
    return await e.apply(t, n);
  }
  function ni(e, t = {}, n) {
    for (const r in e) {
      const s = e[r],
        o = n ? `${n}:${r}` : r;
      typeof s == 'object' && s !== null ? ni(s, t, o) : typeof s == 'function' && (t[o] = s);
    }
    return t;
  }
  const H0 = { run: (e) => e() },
    j0 = () => H0,
    $u = typeof console.createTask < 'u' ? console.createTask : j0;
  function z0(e, t) {
    const n = t.shift(),
      r = $u(n);
    return e.reduce((s, o) => s.then(() => r.run(() => o(...t))), Promise.resolve());
  }
  function K0(e, t) {
    const n = t.shift(),
      r = $u(n);
    return Promise.all(e.map((s) => r.run(() => s(...t))));
  }
  function ri(e, t) {
    for (const n of [...e]) n(t);
  }
  class W0 {
    constructor() {
      ((this._hooks = {}),
        (this._before = void 0),
        (this._after = void 0),
        (this._deprecatedMessages = void 0),
        (this._deprecatedHooks = {}),
        (this.hook = this.hook.bind(this)),
        (this.callHook = this.callHook.bind(this)),
        (this.callHookWith = this.callHookWith.bind(this)));
    }
    hook(t, n, r = {}) {
      if (!t || typeof n != 'function') return () => {};
      const s = t;
      let o;
      for (; this._deprecatedHooks[t]; ) ((o = this._deprecatedHooks[t]), (t = o.to));
      if (o && !r.allowDeprecated) {
        let i = o.message;
        (i || (i = `${s} hook has been deprecated` + (o.to ? `, please use ${o.to}` : '')),
          this._deprecatedMessages || (this._deprecatedMessages = new Set()),
          this._deprecatedMessages.has(i) || (console.warn(i), this._deprecatedMessages.add(i)));
      }
      if (!n.name)
        try {
          Object.defineProperty(n, 'name', {
            get: () => '_' + t.replace(/\W+/g, '_') + '_hook_cb',
            configurable: !0
          });
        } catch {}
      return (
        (this._hooks[t] = this._hooks[t] || []),
        this._hooks[t].push(n),
        () => {
          n && (this.removeHook(t, n), (n = void 0));
        }
      );
    }
    hookOnce(t, n) {
      let r,
        s = (...o) => (typeof r == 'function' && r(), (r = void 0), (s = void 0), n(...o));
      return ((r = this.hook(t, s)), r);
    }
    removeHook(t, n) {
      if (this._hooks[t]) {
        const r = this._hooks[t].indexOf(n);
        (r !== -1 && this._hooks[t].splice(r, 1),
          this._hooks[t].length === 0 && delete this._hooks[t]);
      }
    }
    deprecateHook(t, n) {
      this._deprecatedHooks[t] = typeof n == 'string' ? { to: n } : n;
      const r = this._hooks[t] || [];
      delete this._hooks[t];
      for (const s of r) this.hook(t, s);
    }
    deprecateHooks(t) {
      Object.assign(this._deprecatedHooks, t);
      for (const n in t) this.deprecateHook(n, t[n]);
    }
    addHooks(t) {
      const n = ni(t),
        r = Object.keys(n).map((s) => this.hook(s, n[s]));
      return () => {
        for (const s of r.splice(0, r.length)) s();
      };
    }
    removeHooks(t) {
      const n = ni(t);
      for (const r in n) this.removeHook(r, n[r]);
    }
    removeAllHooks() {
      for (const t in this._hooks) delete this._hooks[t];
    }
    callHook(t, ...n) {
      return (n.unshift(t), this.callHookWith(z0, t, ...n));
    }
    callHookParallel(t, ...n) {
      return (n.unshift(t), this.callHookWith(K0, t, ...n));
    }
    callHookWith(t, n, ...r) {
      const s = this._before || this._after ? { name: n, args: r, context: {} } : void 0;
      this._before && ri(this._before, s);
      const o = t(n in this._hooks ? [...this._hooks[n]] : [], r);
      return o instanceof Promise
        ? o.finally(() => {
            this._after && s && ri(this._after, s);
          })
        : (this._after && s && ri(this._after, s), o);
    }
    beforeEach(t) {
      return (
        (this._before = this._before || []),
        this._before.push(t),
        () => {
          if (this._before !== void 0) {
            const n = this._before.indexOf(t);
            n !== -1 && this._before.splice(n, 1);
          }
        }
      );
    }
    afterEach(t) {
      return (
        (this._after = this._after || []),
        this._after.push(t),
        () => {
          if (this._after !== void 0) {
            const n = this._after.indexOf(t);
            n !== -1 && this._after.splice(n, 1);
          }
        }
      );
    }
  }
  function Fu() {
    return new W0();
  }
  var G0 = Object.create,
    Nu = Object.defineProperty,
    J0 = Object.getOwnPropertyDescriptor,
    si = Object.getOwnPropertyNames,
    Y0 = Object.getPrototypeOf,
    Q0 = Object.prototype.hasOwnProperty,
    Z0 = (e, t) =>
      function () {
        return (e && (t = (0, e[si(e)[0]])((e = 0))), t);
      },
    Lu = (e, t) =>
      function () {
        return (t || (0, e[si(e)[0]])((t = { exports: {} }).exports, t), t.exports);
      },
    X0 = (e, t, n, r) => {
      if ((t && typeof t == 'object') || typeof t == 'function')
        for (let s of si(t))
          !Q0.call(e, s) &&
            s !== n &&
            Nu(e, s, { get: () => t[s], enumerable: !(r = J0(t, s)) || r.enumerable });
      return e;
    },
    eg = (e, t, n) => (
      (n = e != null ? G0(Y0(e)) : {}),
      X0(Nu(n, 'default', { value: e, enumerable: !0 }), e)
    ),
    w = Z0({
      '../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js'() {}
    }),
    tg = Lu({
      '../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/lib/speakingurl.js'(
        e,
        t
      ) {
        (w(),
          (function (n) {
            var r = {
                À: 'A',
                Á: 'A',
                Â: 'A',
                Ã: 'A',
                Ä: 'Ae',
                Å: 'A',
                Æ: 'AE',
                Ç: 'C',
                È: 'E',
                É: 'E',
                Ê: 'E',
                Ë: 'E',
                Ì: 'I',
                Í: 'I',
                Î: 'I',
                Ï: 'I',
                Ð: 'D',
                Ñ: 'N',
                Ò: 'O',
                Ó: 'O',
                Ô: 'O',
                Õ: 'O',
                Ö: 'Oe',
                Ő: 'O',
                Ø: 'O',
                Ù: 'U',
                Ú: 'U',
                Û: 'U',
                Ü: 'Ue',
                Ű: 'U',
                Ý: 'Y',
                Þ: 'TH',
                ß: 'ss',
                à: 'a',
                á: 'a',
                â: 'a',
                ã: 'a',
                ä: 'ae',
                å: 'a',
                æ: 'ae',
                ç: 'c',
                è: 'e',
                é: 'e',
                ê: 'e',
                ë: 'e',
                ì: 'i',
                í: 'i',
                î: 'i',
                ï: 'i',
                ð: 'd',
                ñ: 'n',
                ò: 'o',
                ó: 'o',
                ô: 'o',
                õ: 'o',
                ö: 'oe',
                ő: 'o',
                ø: 'o',
                ù: 'u',
                ú: 'u',
                û: 'u',
                ü: 'ue',
                ű: 'u',
                ý: 'y',
                þ: 'th',
                ÿ: 'y',
                ẞ: 'SS',
                ا: 'a',
                أ: 'a',
                إ: 'i',
                آ: 'aa',
                ؤ: 'u',
                ئ: 'e',
                ء: 'a',
                ب: 'b',
                ت: 't',
                ث: 'th',
                ج: 'j',
                ح: 'h',
                خ: 'kh',
                د: 'd',
                ذ: 'th',
                ر: 'r',
                ز: 'z',
                س: 's',
                ش: 'sh',
                ص: 's',
                ض: 'dh',
                ط: 't',
                ظ: 'z',
                ع: 'a',
                غ: 'gh',
                ف: 'f',
                ق: 'q',
                ك: 'k',
                ل: 'l',
                م: 'm',
                ن: 'n',
                ه: 'h',
                و: 'w',
                ي: 'y',
                ى: 'a',
                ة: 'h',
                ﻻ: 'la',
                ﻷ: 'laa',
                ﻹ: 'lai',
                ﻵ: 'laa',
                گ: 'g',
                چ: 'ch',
                پ: 'p',
                ژ: 'zh',
                ک: 'k',
                ی: 'y',
                'َ': 'a',
                'ً': 'an',
                'ِ': 'e',
                'ٍ': 'en',
                'ُ': 'u',
                'ٌ': 'on',
                'ْ': '',
                '٠': '0',
                '١': '1',
                '٢': '2',
                '٣': '3',
                '٤': '4',
                '٥': '5',
                '٦': '6',
                '٧': '7',
                '٨': '8',
                '٩': '9',
                '۰': '0',
                '۱': '1',
                '۲': '2',
                '۳': '3',
                '۴': '4',
                '۵': '5',
                '۶': '6',
                '۷': '7',
                '۸': '8',
                '۹': '9',
                က: 'k',
                ခ: 'kh',
                ဂ: 'g',
                ဃ: 'ga',
                င: 'ng',
                စ: 's',
                ဆ: 'sa',
                ဇ: 'z',
                စျ: 'za',
                ည: 'ny',
                ဋ: 't',
                ဌ: 'ta',
                ဍ: 'd',
                ဎ: 'da',
                ဏ: 'na',
                တ: 't',
                ထ: 'ta',
                ဒ: 'd',
                ဓ: 'da',
                န: 'n',
                ပ: 'p',
                ဖ: 'pa',
                ဗ: 'b',
                ဘ: 'ba',
                မ: 'm',
                ယ: 'y',
                ရ: 'ya',
                လ: 'l',
                ဝ: 'w',
                သ: 'th',
                ဟ: 'h',
                ဠ: 'la',
                အ: 'a',
                'ြ': 'y',
                'ျ': 'ya',
                'ွ': 'w',
                'ြွ': 'yw',
                'ျွ': 'ywa',
                'ှ': 'h',
                ဧ: 'e',
                '၏': '-e',
                ဣ: 'i',
                ဤ: '-i',
                ဉ: 'u',
                ဦ: '-u',
                ဩ: 'aw',
                သြော: 'aw',
                ဪ: 'aw',
                '၀': '0',
                '၁': '1',
                '၂': '2',
                '၃': '3',
                '၄': '4',
                '၅': '5',
                '၆': '6',
                '၇': '7',
                '၈': '8',
                '၉': '9',
                '္': '',
                '့': '',
                'း': '',
                č: 'c',
                ď: 'd',
                ě: 'e',
                ň: 'n',
                ř: 'r',
                š: 's',
                ť: 't',
                ů: 'u',
                ž: 'z',
                Č: 'C',
                Ď: 'D',
                Ě: 'E',
                Ň: 'N',
                Ř: 'R',
                Š: 'S',
                Ť: 'T',
                Ů: 'U',
                Ž: 'Z',
                ހ: 'h',
                ށ: 'sh',
                ނ: 'n',
                ރ: 'r',
                ބ: 'b',
                ޅ: 'lh',
                ކ: 'k',
                އ: 'a',
                ވ: 'v',
                މ: 'm',
                ފ: 'f',
                ދ: 'dh',
                ތ: 'th',
                ލ: 'l',
                ގ: 'g',
                ޏ: 'gn',
                ސ: 's',
                ޑ: 'd',
                ޒ: 'z',
                ޓ: 't',
                ޔ: 'y',
                ޕ: 'p',
                ޖ: 'j',
                ޗ: 'ch',
                ޘ: 'tt',
                ޙ: 'hh',
                ޚ: 'kh',
                ޛ: 'th',
                ޜ: 'z',
                ޝ: 'sh',
                ޞ: 's',
                ޟ: 'd',
                ޠ: 't',
                ޡ: 'z',
                ޢ: 'a',
                ޣ: 'gh',
                ޤ: 'q',
                ޥ: 'w',
                'ަ': 'a',
                'ާ': 'aa',
                'ި': 'i',
                'ީ': 'ee',
                'ު': 'u',
                'ޫ': 'oo',
                'ެ': 'e',
                'ޭ': 'ey',
                'ޮ': 'o',
                'ޯ': 'oa',
                'ް': '',
                ა: 'a',
                ბ: 'b',
                გ: 'g',
                დ: 'd',
                ე: 'e',
                ვ: 'v',
                ზ: 'z',
                თ: 't',
                ი: 'i',
                კ: 'k',
                ლ: 'l',
                მ: 'm',
                ნ: 'n',
                ო: 'o',
                პ: 'p',
                ჟ: 'zh',
                რ: 'r',
                ს: 's',
                ტ: 't',
                უ: 'u',
                ფ: 'p',
                ქ: 'k',
                ღ: 'gh',
                ყ: 'q',
                შ: 'sh',
                ჩ: 'ch',
                ც: 'ts',
                ძ: 'dz',
                წ: 'ts',
                ჭ: 'ch',
                ხ: 'kh',
                ჯ: 'j',
                ჰ: 'h',
                α: 'a',
                β: 'v',
                γ: 'g',
                δ: 'd',
                ε: 'e',
                ζ: 'z',
                η: 'i',
                θ: 'th',
                ι: 'i',
                κ: 'k',
                λ: 'l',
                μ: 'm',
                ν: 'n',
                ξ: 'ks',
                ο: 'o',
                π: 'p',
                ρ: 'r',
                σ: 's',
                τ: 't',
                υ: 'y',
                φ: 'f',
                χ: 'x',
                ψ: 'ps',
                ω: 'o',
                ά: 'a',
                έ: 'e',
                ί: 'i',
                ό: 'o',
                ύ: 'y',
                ή: 'i',
                ώ: 'o',
                ς: 's',
                ϊ: 'i',
                ΰ: 'y',
                ϋ: 'y',
                ΐ: 'i',
                Α: 'A',
                Β: 'B',
                Γ: 'G',
                Δ: 'D',
                Ε: 'E',
                Ζ: 'Z',
                Η: 'I',
                Θ: 'TH',
                Ι: 'I',
                Κ: 'K',
                Λ: 'L',
                Μ: 'M',
                Ν: 'N',
                Ξ: 'KS',
                Ο: 'O',
                Π: 'P',
                Ρ: 'R',
                Σ: 'S',
                Τ: 'T',
                Υ: 'Y',
                Φ: 'F',
                Χ: 'X',
                Ψ: 'PS',
                Ω: 'O',
                Ά: 'A',
                Έ: 'E',
                Ί: 'I',
                Ό: 'O',
                Ύ: 'Y',
                Ή: 'I',
                Ώ: 'O',
                Ϊ: 'I',
                Ϋ: 'Y',
                ā: 'a',
                ē: 'e',
                ģ: 'g',
                ī: 'i',
                ķ: 'k',
                ļ: 'l',
                ņ: 'n',
                ū: 'u',
                Ā: 'A',
                Ē: 'E',
                Ģ: 'G',
                Ī: 'I',
                Ķ: 'k',
                Ļ: 'L',
                Ņ: 'N',
                Ū: 'U',
                Ќ: 'Kj',
                ќ: 'kj',
                Љ: 'Lj',
                љ: 'lj',
                Њ: 'Nj',
                њ: 'nj',
                Тс: 'Ts',
                тс: 'ts',
                ą: 'a',
                ć: 'c',
                ę: 'e',
                ł: 'l',
                ń: 'n',
                ś: 's',
                ź: 'z',
                ż: 'z',
                Ą: 'A',
                Ć: 'C',
                Ę: 'E',
                Ł: 'L',
                Ń: 'N',
                Ś: 'S',
                Ź: 'Z',
                Ż: 'Z',
                Є: 'Ye',
                І: 'I',
                Ї: 'Yi',
                Ґ: 'G',
                є: 'ye',
                і: 'i',
                ї: 'yi',
                ґ: 'g',
                ă: 'a',
                Ă: 'A',
                ș: 's',
                Ș: 'S',
                ț: 't',
                Ț: 'T',
                ţ: 't',
                Ţ: 'T',
                а: 'a',
                б: 'b',
                в: 'v',
                г: 'g',
                д: 'd',
                е: 'e',
                ё: 'yo',
                ж: 'zh',
                з: 'z',
                и: 'i',
                й: 'i',
                к: 'k',
                л: 'l',
                м: 'm',
                н: 'n',
                о: 'o',
                п: 'p',
                р: 'r',
                с: 's',
                т: 't',
                у: 'u',
                ф: 'f',
                х: 'kh',
                ц: 'c',
                ч: 'ch',
                ш: 'sh',
                щ: 'sh',
                ъ: '',
                ы: 'y',
                ь: '',
                э: 'e',
                ю: 'yu',
                я: 'ya',
                А: 'A',
                Б: 'B',
                В: 'V',
                Г: 'G',
                Д: 'D',
                Е: 'E',
                Ё: 'Yo',
                Ж: 'Zh',
                З: 'Z',
                И: 'I',
                Й: 'I',
                К: 'K',
                Л: 'L',
                М: 'M',
                Н: 'N',
                О: 'O',
                П: 'P',
                Р: 'R',
                С: 'S',
                Т: 'T',
                У: 'U',
                Ф: 'F',
                Х: 'Kh',
                Ц: 'C',
                Ч: 'Ch',
                Ш: 'Sh',
                Щ: 'Sh',
                Ъ: '',
                Ы: 'Y',
                Ь: '',
                Э: 'E',
                Ю: 'Yu',
                Я: 'Ya',
                ђ: 'dj',
                ј: 'j',
                ћ: 'c',
                џ: 'dz',
                Ђ: 'Dj',
                Ј: 'j',
                Ћ: 'C',
                Џ: 'Dz',
                ľ: 'l',
                ĺ: 'l',
                ŕ: 'r',
                Ľ: 'L',
                Ĺ: 'L',
                Ŕ: 'R',
                ş: 's',
                Ş: 'S',
                ı: 'i',
                İ: 'I',
                ğ: 'g',
                Ğ: 'G',
                ả: 'a',
                Ả: 'A',
                ẳ: 'a',
                Ẳ: 'A',
                ẩ: 'a',
                Ẩ: 'A',
                đ: 'd',
                Đ: 'D',
                ẹ: 'e',
                Ẹ: 'E',
                ẽ: 'e',
                Ẽ: 'E',
                ẻ: 'e',
                Ẻ: 'E',
                ế: 'e',
                Ế: 'E',
                ề: 'e',
                Ề: 'E',
                ệ: 'e',
                Ệ: 'E',
                ễ: 'e',
                Ễ: 'E',
                ể: 'e',
                Ể: 'E',
                ỏ: 'o',
                ọ: 'o',
                Ọ: 'o',
                ố: 'o',
                Ố: 'O',
                ồ: 'o',
                Ồ: 'O',
                ổ: 'o',
                Ổ: 'O',
                ộ: 'o',
                Ộ: 'O',
                ỗ: 'o',
                Ỗ: 'O',
                ơ: 'o',
                Ơ: 'O',
                ớ: 'o',
                Ớ: 'O',
                ờ: 'o',
                Ờ: 'O',
                ợ: 'o',
                Ợ: 'O',
                ỡ: 'o',
                Ỡ: 'O',
                Ở: 'o',
                ở: 'o',
                ị: 'i',
                Ị: 'I',
                ĩ: 'i',
                Ĩ: 'I',
                ỉ: 'i',
                Ỉ: 'i',
                ủ: 'u',
                Ủ: 'U',
                ụ: 'u',
                Ụ: 'U',
                ũ: 'u',
                Ũ: 'U',
                ư: 'u',
                Ư: 'U',
                ứ: 'u',
                Ứ: 'U',
                ừ: 'u',
                Ừ: 'U',
                ự: 'u',
                Ự: 'U',
                ữ: 'u',
                Ữ: 'U',
                ử: 'u',
                Ử: 'ư',
                ỷ: 'y',
                Ỷ: 'y',
                ỳ: 'y',
                Ỳ: 'Y',
                ỵ: 'y',
                Ỵ: 'Y',
                ỹ: 'y',
                Ỹ: 'Y',
                ạ: 'a',
                Ạ: 'A',
                ấ: 'a',
                Ấ: 'A',
                ầ: 'a',
                Ầ: 'A',
                ậ: 'a',
                Ậ: 'A',
                ẫ: 'a',
                Ẫ: 'A',
                ắ: 'a',
                Ắ: 'A',
                ằ: 'a',
                Ằ: 'A',
                ặ: 'a',
                Ặ: 'A',
                ẵ: 'a',
                Ẵ: 'A',
                '⓪': '0',
                '①': '1',
                '②': '2',
                '③': '3',
                '④': '4',
                '⑤': '5',
                '⑥': '6',
                '⑦': '7',
                '⑧': '8',
                '⑨': '9',
                '⑩': '10',
                '⑪': '11',
                '⑫': '12',
                '⑬': '13',
                '⑭': '14',
                '⑮': '15',
                '⑯': '16',
                '⑰': '17',
                '⑱': '18',
                '⑲': '18',
                '⑳': '18',
                '⓵': '1',
                '⓶': '2',
                '⓷': '3',
                '⓸': '4',
                '⓹': '5',
                '⓺': '6',
                '⓻': '7',
                '⓼': '8',
                '⓽': '9',
                '⓾': '10',
                '⓿': '0',
                '⓫': '11',
                '⓬': '12',
                '⓭': '13',
                '⓮': '14',
                '⓯': '15',
                '⓰': '16',
                '⓱': '17',
                '⓲': '18',
                '⓳': '19',
                '⓴': '20',
                'Ⓐ': 'A',
                'Ⓑ': 'B',
                'Ⓒ': 'C',
                'Ⓓ': 'D',
                'Ⓔ': 'E',
                'Ⓕ': 'F',
                'Ⓖ': 'G',
                'Ⓗ': 'H',
                'Ⓘ': 'I',
                'Ⓙ': 'J',
                'Ⓚ': 'K',
                'Ⓛ': 'L',
                'Ⓜ': 'M',
                'Ⓝ': 'N',
                'Ⓞ': 'O',
                'Ⓟ': 'P',
                'Ⓠ': 'Q',
                'Ⓡ': 'R',
                'Ⓢ': 'S',
                'Ⓣ': 'T',
                'Ⓤ': 'U',
                'Ⓥ': 'V',
                'Ⓦ': 'W',
                'Ⓧ': 'X',
                'Ⓨ': 'Y',
                'Ⓩ': 'Z',
                'ⓐ': 'a',
                'ⓑ': 'b',
                'ⓒ': 'c',
                'ⓓ': 'd',
                'ⓔ': 'e',
                'ⓕ': 'f',
                'ⓖ': 'g',
                'ⓗ': 'h',
                'ⓘ': 'i',
                'ⓙ': 'j',
                'ⓚ': 'k',
                'ⓛ': 'l',
                'ⓜ': 'm',
                'ⓝ': 'n',
                'ⓞ': 'o',
                'ⓟ': 'p',
                'ⓠ': 'q',
                'ⓡ': 'r',
                'ⓢ': 's',
                'ⓣ': 't',
                'ⓤ': 'u',
                'ⓦ': 'v',
                'ⓥ': 'w',
                'ⓧ': 'x',
                'ⓨ': 'y',
                'ⓩ': 'z',
                '“': '"',
                '”': '"',
                '‘': "'",
                '’': "'",
                '∂': 'd',
                ƒ: 'f',
                '™': '(TM)',
                '©': '(C)',
                œ: 'oe',
                Œ: 'OE',
                '®': '(R)',
                '†': '+',
                '℠': '(SM)',
                '…': '...',
                '˚': 'o',
                º: 'o',
                ª: 'a',
                '•': '*',
                '၊': ',',
                '။': '.',
                $: 'USD',
                '€': 'EUR',
                '₢': 'BRN',
                '₣': 'FRF',
                '£': 'GBP',
                '₤': 'ITL',
                '₦': 'NGN',
                '₧': 'ESP',
                '₩': 'KRW',
                '₪': 'ILS',
                '₫': 'VND',
                '₭': 'LAK',
                '₮': 'MNT',
                '₯': 'GRD',
                '₱': 'ARS',
                '₲': 'PYG',
                '₳': 'ARA',
                '₴': 'UAH',
                '₵': 'GHS',
                '¢': 'cent',
                '¥': 'CNY',
                元: 'CNY',
                円: 'YEN',
                '﷼': 'IRR',
                '₠': 'EWE',
                '฿': 'THB',
                '₨': 'INR',
                '₹': 'INR',
                '₰': 'PF',
                '₺': 'TRY',
                '؋': 'AFN',
                '₼': 'AZN',
                лв: 'BGN',
                '៛': 'KHR',
                '₡': 'CRC',
                '₸': 'KZT',
                ден: 'MKD',
                zł: 'PLN',
                '₽': 'RUB',
                '₾': 'GEL'
              },
              s = ['်', 'ް'],
              o = {
                'ာ': 'a',
                'ါ': 'a',
                'ေ': 'e',
                'ဲ': 'e',
                'ိ': 'i',
                'ီ': 'i',
                'ို': 'o',
                'ု': 'u',
                'ူ': 'u',
                'ေါင်': 'aung',
                'ော': 'aw',
                'ော်': 'aw',
                'ေါ': 'aw',
                'ေါ်': 'aw',
                '်': '်',
                က်: 'et',
                'ိုက်': 'aik',
                'ောက်': 'auk',
                င်: 'in',
                'ိုင်': 'aing',
                'ောင်': 'aung',
                စ်: 'it',
                ည်: 'i',
                တ်: 'at',
                'ိတ်': 'eik',
                'ုတ်': 'ok',
                'ွတ်': 'ut',
                'ေတ်': 'it',
                ဒ်: 'd',
                'ိုဒ်': 'ok',
                'ုဒ်': 'ait',
                န်: 'an',
                'ာန်': 'an',
                'ိန်': 'ein',
                'ုန်': 'on',
                'ွန်': 'un',
                ပ်: 'at',
                'ိပ်': 'eik',
                'ုပ်': 'ok',
                'ွပ်': 'ut',
                န်ုပ်: 'nub',
                မ်: 'an',
                'ိမ်': 'ein',
                'ုမ်': 'on',
                'ွမ်': 'un',
                ယ်: 'e',
                'ိုလ်': 'ol',
                ဉ်: 'in',
                'ံ': 'an',
                'ိံ': 'ein',
                'ုံ': 'on',
                'ައް': 'ah',
                'ަށް': 'ah'
              },
              i = {
                en: {},
                az: {
                  ç: 'c',
                  ə: 'e',
                  ğ: 'g',
                  ı: 'i',
                  ö: 'o',
                  ş: 's',
                  ü: 'u',
                  Ç: 'C',
                  Ə: 'E',
                  Ğ: 'G',
                  İ: 'I',
                  Ö: 'O',
                  Ş: 'S',
                  Ü: 'U'
                },
                cs: {
                  č: 'c',
                  ď: 'd',
                  ě: 'e',
                  ň: 'n',
                  ř: 'r',
                  š: 's',
                  ť: 't',
                  ů: 'u',
                  ž: 'z',
                  Č: 'C',
                  Ď: 'D',
                  Ě: 'E',
                  Ň: 'N',
                  Ř: 'R',
                  Š: 'S',
                  Ť: 'T',
                  Ů: 'U',
                  Ž: 'Z'
                },
                fi: { ä: 'a', Ä: 'A', ö: 'o', Ö: 'O' },
                hu: { ä: 'a', Ä: 'A', ö: 'o', Ö: 'O', ü: 'u', Ü: 'U', ű: 'u', Ű: 'U' },
                lt: {
                  ą: 'a',
                  č: 'c',
                  ę: 'e',
                  ė: 'e',
                  į: 'i',
                  š: 's',
                  ų: 'u',
                  ū: 'u',
                  ž: 'z',
                  Ą: 'A',
                  Č: 'C',
                  Ę: 'E',
                  Ė: 'E',
                  Į: 'I',
                  Š: 'S',
                  Ų: 'U',
                  Ū: 'U'
                },
                lv: {
                  ā: 'a',
                  č: 'c',
                  ē: 'e',
                  ģ: 'g',
                  ī: 'i',
                  ķ: 'k',
                  ļ: 'l',
                  ņ: 'n',
                  š: 's',
                  ū: 'u',
                  ž: 'z',
                  Ā: 'A',
                  Č: 'C',
                  Ē: 'E',
                  Ģ: 'G',
                  Ī: 'i',
                  Ķ: 'k',
                  Ļ: 'L',
                  Ņ: 'N',
                  Š: 'S',
                  Ū: 'u',
                  Ž: 'Z'
                },
                pl: {
                  ą: 'a',
                  ć: 'c',
                  ę: 'e',
                  ł: 'l',
                  ń: 'n',
                  ó: 'o',
                  ś: 's',
                  ź: 'z',
                  ż: 'z',
                  Ą: 'A',
                  Ć: 'C',
                  Ę: 'e',
                  Ł: 'L',
                  Ń: 'N',
                  Ó: 'O',
                  Ś: 'S',
                  Ź: 'Z',
                  Ż: 'Z'
                },
                sv: { ä: 'a', Ä: 'A', ö: 'o', Ö: 'O' },
                sk: { ä: 'a', Ä: 'A' },
                sr: { љ: 'lj', њ: 'nj', Љ: 'Lj', Њ: 'Nj', đ: 'dj', Đ: 'Dj' },
                tr: { Ü: 'U', Ö: 'O', ü: 'u', ö: 'o' }
              },
              l = {
                ar: {
                  '∆': 'delta',
                  '∞': 'la-nihaya',
                  '♥': 'hob',
                  '&': 'wa',
                  '|': 'aw',
                  '<': 'aqal-men',
                  '>': 'akbar-men',
                  '∑': 'majmou',
                  '¤': 'omla'
                },
                az: {},
                ca: {
                  '∆': 'delta',
                  '∞': 'infinit',
                  '♥': 'amor',
                  '&': 'i',
                  '|': 'o',
                  '<': 'menys que',
                  '>': 'mes que',
                  '∑': 'suma dels',
                  '¤': 'moneda'
                },
                cs: {
                  '∆': 'delta',
                  '∞': 'nekonecno',
                  '♥': 'laska',
                  '&': 'a',
                  '|': 'nebo',
                  '<': 'mensi nez',
                  '>': 'vetsi nez',
                  '∑': 'soucet',
                  '¤': 'mena'
                },
                de: {
                  '∆': 'delta',
                  '∞': 'unendlich',
                  '♥': 'Liebe',
                  '&': 'und',
                  '|': 'oder',
                  '<': 'kleiner als',
                  '>': 'groesser als',
                  '∑': 'Summe von',
                  '¤': 'Waehrung'
                },
                dv: {
                  '∆': 'delta',
                  '∞': 'kolunulaa',
                  '♥': 'loabi',
                  '&': 'aai',
                  '|': 'noonee',
                  '<': 'ah vure kuda',
                  '>': 'ah vure bodu',
                  '∑': 'jumula',
                  '¤': 'faisaa'
                },
                en: {
                  '∆': 'delta',
                  '∞': 'infinity',
                  '♥': 'love',
                  '&': 'and',
                  '|': 'or',
                  '<': 'less than',
                  '>': 'greater than',
                  '∑': 'sum',
                  '¤': 'currency'
                },
                es: {
                  '∆': 'delta',
                  '∞': 'infinito',
                  '♥': 'amor',
                  '&': 'y',
                  '|': 'u',
                  '<': 'menos que',
                  '>': 'mas que',
                  '∑': 'suma de los',
                  '¤': 'moneda'
                },
                fa: {
                  '∆': 'delta',
                  '∞': 'bi-nahayat',
                  '♥': 'eshgh',
                  '&': 'va',
                  '|': 'ya',
                  '<': 'kamtar-az',
                  '>': 'bishtar-az',
                  '∑': 'majmooe',
                  '¤': 'vahed'
                },
                fi: {
                  '∆': 'delta',
                  '∞': 'aarettomyys',
                  '♥': 'rakkaus',
                  '&': 'ja',
                  '|': 'tai',
                  '<': 'pienempi kuin',
                  '>': 'suurempi kuin',
                  '∑': 'summa',
                  '¤': 'valuutta'
                },
                fr: {
                  '∆': 'delta',
                  '∞': 'infiniment',
                  '♥': 'Amour',
                  '&': 'et',
                  '|': 'ou',
                  '<': 'moins que',
                  '>': 'superieure a',
                  '∑': 'somme des',
                  '¤': 'monnaie'
                },
                ge: {
                  '∆': 'delta',
                  '∞': 'usasruloba',
                  '♥': 'siqvaruli',
                  '&': 'da',
                  '|': 'an',
                  '<': 'naklebi',
                  '>': 'meti',
                  '∑': 'jami',
                  '¤': 'valuta'
                },
                gr: {},
                hu: {
                  '∆': 'delta',
                  '∞': 'vegtelen',
                  '♥': 'szerelem',
                  '&': 'es',
                  '|': 'vagy',
                  '<': 'kisebb mint',
                  '>': 'nagyobb mint',
                  '∑': 'szumma',
                  '¤': 'penznem'
                },
                it: {
                  '∆': 'delta',
                  '∞': 'infinito',
                  '♥': 'amore',
                  '&': 'e',
                  '|': 'o',
                  '<': 'minore di',
                  '>': 'maggiore di',
                  '∑': 'somma',
                  '¤': 'moneta'
                },
                lt: {
                  '∆': 'delta',
                  '∞': 'begalybe',
                  '♥': 'meile',
                  '&': 'ir',
                  '|': 'ar',
                  '<': 'maziau nei',
                  '>': 'daugiau nei',
                  '∑': 'suma',
                  '¤': 'valiuta'
                },
                lv: {
                  '∆': 'delta',
                  '∞': 'bezgaliba',
                  '♥': 'milestiba',
                  '&': 'un',
                  '|': 'vai',
                  '<': 'mazak neka',
                  '>': 'lielaks neka',
                  '∑': 'summa',
                  '¤': 'valuta'
                },
                my: {
                  '∆': 'kwahkhyaet',
                  '∞': 'asaonasme',
                  '♥': 'akhyait',
                  '&': 'nhin',
                  '|': 'tho',
                  '<': 'ngethaw',
                  '>': 'kyithaw',
                  '∑': 'paungld',
                  '¤': 'ngwekye'
                },
                mk: {},
                nl: {
                  '∆': 'delta',
                  '∞': 'oneindig',
                  '♥': 'liefde',
                  '&': 'en',
                  '|': 'of',
                  '<': 'kleiner dan',
                  '>': 'groter dan',
                  '∑': 'som',
                  '¤': 'valuta'
                },
                pl: {
                  '∆': 'delta',
                  '∞': 'nieskonczonosc',
                  '♥': 'milosc',
                  '&': 'i',
                  '|': 'lub',
                  '<': 'mniejsze niz',
                  '>': 'wieksze niz',
                  '∑': 'suma',
                  '¤': 'waluta'
                },
                pt: {
                  '∆': 'delta',
                  '∞': 'infinito',
                  '♥': 'amor',
                  '&': 'e',
                  '|': 'ou',
                  '<': 'menor que',
                  '>': 'maior que',
                  '∑': 'soma',
                  '¤': 'moeda'
                },
                ro: {
                  '∆': 'delta',
                  '∞': 'infinit',
                  '♥': 'dragoste',
                  '&': 'si',
                  '|': 'sau',
                  '<': 'mai mic ca',
                  '>': 'mai mare ca',
                  '∑': 'suma',
                  '¤': 'valuta'
                },
                ru: {
                  '∆': 'delta',
                  '∞': 'beskonechno',
                  '♥': 'lubov',
                  '&': 'i',
                  '|': 'ili',
                  '<': 'menshe',
                  '>': 'bolshe',
                  '∑': 'summa',
                  '¤': 'valjuta'
                },
                sk: {
                  '∆': 'delta',
                  '∞': 'nekonecno',
                  '♥': 'laska',
                  '&': 'a',
                  '|': 'alebo',
                  '<': 'menej ako',
                  '>': 'viac ako',
                  '∑': 'sucet',
                  '¤': 'mena'
                },
                sr: {},
                tr: {
                  '∆': 'delta',
                  '∞': 'sonsuzluk',
                  '♥': 'ask',
                  '&': 've',
                  '|': 'veya',
                  '<': 'kucuktur',
                  '>': 'buyuktur',
                  '∑': 'toplam',
                  '¤': 'para birimi'
                },
                uk: {
                  '∆': 'delta',
                  '∞': 'bezkinechnist',
                  '♥': 'lubov',
                  '&': 'i',
                  '|': 'abo',
                  '<': 'menshe',
                  '>': 'bilshe',
                  '∑': 'suma',
                  '¤': 'valjuta'
                },
                vn: {
                  '∆': 'delta',
                  '∞': 'vo cuc',
                  '♥': 'yeu',
                  '&': 'va',
                  '|': 'hoac',
                  '<': 'nho hon',
                  '>': 'lon hon',
                  '∑': 'tong',
                  '¤': 'tien te'
                }
              },
              a = [';', '?', ':', '@', '&', '=', '+', '$', ',', '/'].join(''),
              c = [';', '?', ':', '@', '&', '=', '+', '$', ','].join(''),
              u = ['.', '!', '~', '*', "'", '(', ')'].join(''),
              f = function (y, E) {
                var N = '-',
                  P = '',
                  te = '',
                  B = !0,
                  J = {},
                  V,
                  ae,
                  U,
                  I,
                  O,
                  T,
                  ne,
                  he,
                  be,
                  de,
                  L,
                  Z,
                  oe,
                  Ct,
                  ze = '';
                if (typeof y != 'string') return '';
                if (
                  (typeof E == 'string' && (N = E), (ne = l.en), (he = i.en), typeof E == 'object')
                ) {
                  ((V = E.maintainCase || !1),
                    (J = E.custom && typeof E.custom == 'object' ? E.custom : J),
                    (U = (+E.truncate > 1 && E.truncate) || !1),
                    (I = E.uric || !1),
                    (O = E.uricNoSlash || !1),
                    (T = E.mark || !1),
                    (B = !(E.symbols === !1 || E.lang === !1)),
                    (N = E.separator || N),
                    I && (ze += a),
                    O && (ze += c),
                    T && (ze += u),
                    (ne = E.lang && l[E.lang] && B ? l[E.lang] : B ? l.en : {}),
                    (he =
                      E.lang && i[E.lang] ? i[E.lang] : E.lang === !1 || E.lang === !0 ? {} : i.en),
                    E.titleCase &&
                    typeof E.titleCase.length == 'number' &&
                    Array.prototype.toString.call(E.titleCase)
                      ? (E.titleCase.forEach(function (ke) {
                          J[ke + ''] = ke + '';
                        }),
                        (ae = !0))
                      : (ae = !!E.titleCase),
                    E.custom &&
                      typeof E.custom.length == 'number' &&
                      Array.prototype.toString.call(E.custom) &&
                      E.custom.forEach(function (ke) {
                        J[ke + ''] = ke + '';
                      }),
                    Object.keys(J).forEach(function (ke) {
                      var Ke;
                      (ke.length > 1
                        ? (Ke = new RegExp('\\b' + h(ke) + '\\b', 'gi'))
                        : (Ke = new RegExp(h(ke), 'gi')),
                        (y = y.replace(Ke, J[ke])));
                    }));
                  for (L in J) ze += L;
                }
                for (
                  ze += N,
                    ze = h(ze),
                    y = y.replace(/(^\s+|\s+$)/g, ''),
                    oe = !1,
                    Ct = !1,
                    de = 0,
                    Z = y.length;
                  de < Z;
                  de++
                )
                  ((L = y[de]),
                    g(L, J)
                      ? (oe = !1)
                      : he[L]
                        ? ((L = oe && he[L].match(/[A-Za-z0-9]/) ? ' ' + he[L] : he[L]), (oe = !1))
                        : L in r
                          ? (de + 1 < Z && s.indexOf(y[de + 1]) >= 0
                              ? ((te += L), (L = ''))
                              : Ct === !0
                                ? ((L = o[te] + r[L]), (te = ''))
                                : (L = oe && r[L].match(/[A-Za-z0-9]/) ? ' ' + r[L] : r[L]),
                            (oe = !1),
                            (Ct = !1))
                          : L in o
                            ? ((te += L), (L = ''), de === Z - 1 && (L = o[te]), (Ct = !0))
                            : ne[L] && !(I && a.indexOf(L) !== -1) && !(O && c.indexOf(L) !== -1)
                              ? ((L = oe || P.substr(-1).match(/[A-Za-z0-9]/) ? N + ne[L] : ne[L]),
                                (L +=
                                  y[de + 1] !== void 0 && y[de + 1].match(/[A-Za-z0-9]/) ? N : ''),
                                (oe = !0))
                              : (Ct === !0
                                  ? ((L = o[te] + L), (te = ''), (Ct = !1))
                                  : oe &&
                                    (/[A-Za-z0-9]/.test(L) || P.substr(-1).match(/A-Za-z0-9]/)) &&
                                    (L = ' ' + L),
                                (oe = !1)),
                    (P += L.replace(new RegExp('[^\\w\\s' + ze + '_-]', 'g'), N)));
                return (
                  ae &&
                    (P = P.replace(/(\w)(\S*)/g, function (ke, Ke, Wn) {
                      var Br = Ke.toUpperCase() + (Wn !== null ? Wn : '');
                      return Object.keys(J).indexOf(Br.toLowerCase()) < 0 ? Br : Br.toLowerCase();
                    })),
                  (P = P.replace(/\s+/g, N)
                    .replace(new RegExp('\\' + N + '+', 'g'), N)
                    .replace(new RegExp('(^\\' + N + '+|\\' + N + '+$)', 'g'), '')),
                  U &&
                    P.length > U &&
                    ((be = P.charAt(U) === N),
                    (P = P.slice(0, U)),
                    be || (P = P.slice(0, P.lastIndexOf(N)))),
                  !V && !ae && (P = P.toLowerCase()),
                  P
                );
              },
              d = function (y) {
                return function (N) {
                  return f(N, y);
                };
              },
              h = function (y) {
                return y.replace(/[-\\^$*+?.()|[\]{}\/]/g, '\\$&');
              },
              g = function (v, y) {
                for (var E in y) if (y[E] === v) return !0;
              };
            if (typeof t < 'u' && t.exports) ((t.exports = f), (t.exports.createSlug = d));
            else if (typeof define < 'u' && define.amd)
              define([], function () {
                return f;
              });
            else
              try {
                if (n.getSlug || n.createSlug)
                  throw 'speakingurl: globals exists /(getSlug|createSlug)/';
                ((n.getSlug = f), (n.createSlug = d));
              } catch {}
          })(e));
      }
    }),
    ng = Lu({
      '../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/index.js'(e, t) {
        (w(), (t.exports = tg()));
      }
    });
  (w(), w(), w(), w(), w(), w(), w(), w());
  function rg(e) {
    var t;
    const n = e.name || e._componentTag || e.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ || e.__name;
    return n === 'index' && (t = e.__file) != null && t.endsWith('index.vue') ? '' : n;
  }
  function sg(e) {
    const t = e.__file;
    if (t) return L0(V0(t, '.vue'));
  }
  function Vu(e, t) {
    return ((e.type.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ = t), t);
  }
  function oi(e) {
    if (e.__VUE_DEVTOOLS_NEXT_APP_RECORD__) return e.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
    if (e.root) return e.appContext.app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
  }
  function Mu(e) {
    var t, n;
    const r = (t = e.subTree) == null ? void 0 : t.type,
      s = oi(e);
    return s ? ((n = s == null ? void 0 : s.types) == null ? void 0 : n.Fragment) === r : !1;
  }
  function Is(e) {
    var t, n, r;
    const s = rg((e == null ? void 0 : e.type) || {});
    if (s) return s;
    if ((e == null ? void 0 : e.root) === e) return 'Root';
    for (const i in (n = (t = e.parent) == null ? void 0 : t.type) == null ? void 0 : n.components)
      if (e.parent.type.components[i] === (e == null ? void 0 : e.type)) return Vu(e, i);
    for (const i in (r = e.appContext) == null ? void 0 : r.components)
      if (e.appContext.components[i] === (e == null ? void 0 : e.type)) return Vu(e, i);
    const o = sg((e == null ? void 0 : e.type) || {});
    return o || 'Anonymous Component';
  }
  function og(e) {
    var t, n, r;
    const s =
        (r =
          (n = (t = e == null ? void 0 : e.appContext) == null ? void 0 : t.app) == null
            ? void 0
            : n.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__) != null
          ? r
          : 0,
      o = e === (e == null ? void 0 : e.root) ? 'root' : e.uid;
    return `${s}:${o}`;
  }
  function ii(e, t) {
    return ((t = t || `${e.id}:root`), e.instanceMap.get(t) || e.instanceMap.get(':root'));
  }
  function ig() {
    const e = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      get width() {
        return e.right - e.left;
      },
      get height() {
        return e.bottom - e.top;
      }
    };
    return e;
  }
  var Rs;
  function lg(e) {
    return (Rs || (Rs = document.createRange()), Rs.selectNode(e), Rs.getBoundingClientRect());
  }
  function ag(e) {
    const t = ig();
    if (!e.children) return t;
    for (let n = 0, r = e.children.length; n < r; n++) {
      const s = e.children[n];
      let o;
      if (s.component) o = vn(s.component);
      else if (s.el) {
        const i = s.el;
        i.nodeType === 1 || i.getBoundingClientRect
          ? (o = i.getBoundingClientRect())
          : i.nodeType === 3 && i.data.trim() && (o = lg(i));
      }
      o && ug(t, o);
    }
    return t;
  }
  function ug(e, t) {
    return (
      (!e.top || t.top < e.top) && (e.top = t.top),
      (!e.bottom || t.bottom > e.bottom) && (e.bottom = t.bottom),
      (!e.left || t.left < e.left) && (e.left = t.left),
      (!e.right || t.right > e.right) && (e.right = t.right),
      e
    );
  }
  var Uu = { top: 0, left: 0, right: 0, bottom: 0, width: 0, height: 0 };
  function vn(e) {
    const t = e.subTree.el;
    return typeof window > 'u'
      ? Uu
      : Mu(e)
        ? ag(e.subTree)
        : (t == null ? void 0 : t.nodeType) === 1
          ? t == null
            ? void 0
            : t.getBoundingClientRect()
          : e.subTree.component
            ? vn(e.subTree.component)
            : Uu;
  }
  w();
  function li(e) {
    return Mu(e) ? cg(e.subTree) : e.subTree ? [e.subTree.el] : [];
  }
  function cg(e) {
    if (!e.children) return [];
    const t = [];
    return (
      e.children.forEach((n) => {
        n.component ? t.push(...li(n.component)) : n != null && n.el && t.push(n.el);
      }),
      t
    );
  }
  var Hu = '__vue-devtools-component-inspector__',
    ju = '__vue-devtools-component-inspector__card__',
    zu = '__vue-devtools-component-inspector__name__',
    Ku = '__vue-devtools-component-inspector__indicator__',
    Wu = {
      display: 'block',
      zIndex: 2147483640,
      position: 'fixed',
      backgroundColor: '#42b88325',
      border: '1px solid #42b88350',
      borderRadius: '5px',
      transition: 'all 0.1s ease-in',
      pointerEvents: 'none'
    },
    fg = {
      fontFamily: 'Arial, Helvetica, sans-serif',
      padding: '5px 8px',
      borderRadius: '4px',
      textAlign: 'left',
      position: 'absolute',
      left: 0,
      color: '#e9e9e9',
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '24px',
      backgroundColor: '#42b883',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)'
    },
    dg = {
      display: 'inline-block',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '12px',
      opacity: 0.7
    };
  function Vn() {
    return document.getElementById(Hu);
  }
  function pg() {
    return document.getElementById(ju);
  }
  function hg() {
    return document.getElementById(Ku);
  }
  function mg() {
    return document.getElementById(zu);
  }
  function ai(e) {
    return {
      left: `${Math.round(e.left * 100) / 100}px`,
      top: `${Math.round(e.top * 100) / 100}px`,
      width: `${Math.round(e.width * 100) / 100}px`,
      height: `${Math.round(e.height * 100) / 100}px`
    };
  }
  function ui(e) {
    var t;
    const n = document.createElement('div');
    ((n.id = (t = e.elementId) != null ? t : Hu),
      Object.assign(n.style, { ...Wu, ...ai(e.bounds), ...e.style }));
    const r = document.createElement('span');
    ((r.id = ju), Object.assign(r.style, { ...fg, top: e.bounds.top < 35 ? 0 : '-35px' }));
    const s = document.createElement('span');
    ((s.id = zu), (s.innerHTML = `&lt;${e.name}&gt;&nbsp;&nbsp;`));
    const o = document.createElement('i');
    return (
      (o.id = Ku),
      (o.innerHTML = `${Math.round(e.bounds.width * 100) / 100} x ${Math.round(e.bounds.height * 100) / 100}`),
      Object.assign(o.style, dg),
      r.appendChild(s),
      r.appendChild(o),
      n.appendChild(r),
      document.body.appendChild(n),
      n
    );
  }
  function ci(e) {
    const t = Vn(),
      n = pg(),
      r = mg(),
      s = hg();
    t &&
      (Object.assign(t.style, { ...Wu, ...ai(e.bounds) }),
      Object.assign(n.style, { top: e.bounds.top < 35 ? 0 : '-35px' }),
      (r.innerHTML = `&lt;${e.name}&gt;&nbsp;&nbsp;`),
      (s.innerHTML = `${Math.round(e.bounds.width * 100) / 100} x ${Math.round(e.bounds.height * 100) / 100}`));
  }
  function gg(e) {
    const t = vn(e);
    if (!t.width && !t.height) return;
    const n = Is(e);
    Vn() ? ci({ bounds: t, name: n }) : ui({ bounds: t, name: n });
  }
  function Gu() {
    const e = Vn();
    e && (e.style.display = 'none');
  }
  var fi = null;
  function di(e) {
    const t = e.target;
    if (t) {
      const n = t.__vueParentComponent;
      if (n && ((fi = n), n.vnode.el)) {
        const s = vn(n),
          o = Is(n);
        Vn() ? ci({ bounds: s, name: o }) : ui({ bounds: s, name: o });
      }
    }
  }
  function _g(e, t) {
    if ((e.preventDefault(), e.stopPropagation(), fi)) {
      const n = og(fi);
      t(n);
    }
  }
  var Ds = null;
  function yg() {
    (Gu(),
      window.removeEventListener('mouseover', di),
      window.removeEventListener('click', Ds, !0),
      (Ds = null));
  }
  function vg() {
    return (
      window.addEventListener('mouseover', di),
      new Promise((e) => {
        function t(n) {
          (n.preventDefault(),
            n.stopPropagation(),
            _g(n, (r) => {
              (window.removeEventListener('click', t, !0),
                (Ds = null),
                window.removeEventListener('mouseover', di));
              const s = Vn();
              (s && (s.style.display = 'none'), e(JSON.stringify({ id: r })));
            }));
        }
        ((Ds = t), window.addEventListener('click', t, !0));
      })
    );
  }
  function qg(e) {
    const t = ii(Me.value, e.id);
    if (t) {
      const [n] = li(t);
      if (typeof n.scrollIntoView == 'function') n.scrollIntoView({ behavior: 'smooth' });
      else {
        const r = vn(t),
          s = document.createElement('div'),
          o = { ...ai(r), position: 'absolute' };
        (Object.assign(s.style, o),
          document.body.appendChild(s),
          s.scrollIntoView({ behavior: 'smooth' }),
          setTimeout(() => {
            document.body.removeChild(s);
          }, 2e3));
      }
      setTimeout(() => {
        const r = vn(t);
        if (r.width || r.height) {
          const s = Is(t),
            o = Vn();
          (o ? ci({ ...e, name: s, bounds: r }) : ui({ ...e, name: s, bounds: r }),
            setTimeout(() => {
              o && (o.style.display = 'none');
            }, 1500));
        }
      }, 1200);
    }
  }
  w();
  var Ju, Yu;
  (Yu = (Ju = M).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__) != null ||
    (Ju.__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = !0);
  function bg(e) {
    let t = 0;
    const n = setInterval(() => {
      (M.__VUE_INSPECTOR__ && (clearInterval(n), (t += 30), e()), t >= 5e3 && clearInterval(n));
    }, 30);
  }
  function Eg() {
    const e = M.__VUE_INSPECTOR__,
      t = e.openInEditor;
    e.openInEditor = async (...n) => {
      (e.disable(), t(...n));
    };
  }
  function wg() {
    return new Promise((e) => {
      function t() {
        (Eg(), e(M.__VUE_INSPECTOR__));
      }
      M.__VUE_INSPECTOR__
        ? t()
        : bg(() => {
            t();
          });
    });
  }
  (w(), w());
  function xg(e) {
    return !!(e && e.__v_isReadonly);
  }
  function Qu(e) {
    return xg(e) ? Qu(e.__v_raw) : !!(e && e.__v_isReactive);
  }
  function pi(e) {
    return !!(e && e.__v_isRef === !0);
  }
  function Tr(e) {
    const t = e && e.__v_raw;
    return t ? Tr(t) : e;
  }
  var Sg = class {
      constructor() {
        this.refEditor = new Cg();
      }
      set(e, t, n, r) {
        const s = Array.isArray(t) ? t : t.split('.');
        for (; s.length > 1; ) {
          const l = s.shift();
          (e instanceof Map
            ? (e = e.get(l))
            : e instanceof Set
              ? (e = Array.from(e.values())[l])
              : (e = e[l]),
            this.refEditor.isRef(e) && (e = this.refEditor.get(e)));
        }
        const o = s[0],
          i = this.refEditor.get(e)[o];
        r ? r(e, o, n) : this.refEditor.isRef(i) ? this.refEditor.set(i, n) : (e[o] = n);
      }
      get(e, t) {
        const n = Array.isArray(t) ? t : t.split('.');
        for (let r = 0; r < n.length; r++)
          if (
            (e instanceof Map ? (e = e.get(n[r])) : (e = e[n[r]]),
            this.refEditor.isRef(e) && (e = this.refEditor.get(e)),
            !e)
          )
            return;
        return e;
      }
      has(e, t, n = !1) {
        if (typeof e > 'u') return !1;
        const r = Array.isArray(t) ? t.slice() : t.split('.'),
          s = n ? 2 : 1;
        for (; e && r.length > s; ) {
          const o = r.shift();
          ((e = e[o]), this.refEditor.isRef(e) && (e = this.refEditor.get(e)));
        }
        return e != null && Object.prototype.hasOwnProperty.call(e, r[0]);
      }
      createDefaultSetCallback(e) {
        return (t, n, r) => {
          if (
            ((e.remove || e.newKey) &&
              (Array.isArray(t)
                ? t.splice(n, 1)
                : Tr(t) instanceof Map
                  ? t.delete(n)
                  : Tr(t) instanceof Set
                    ? t.delete(Array.from(t.values())[n])
                    : Reflect.deleteProperty(t, n)),
            !e.remove)
          ) {
            const s = t[e.newKey || n];
            this.refEditor.isRef(s)
              ? this.refEditor.set(s, r)
              : Tr(t) instanceof Map
                ? t.set(e.newKey || n, r)
                : Tr(t) instanceof Set
                  ? t.add(r)
                  : (t[e.newKey || n] = r);
          }
        };
      }
    },
    Cg = class {
      set(e, t) {
        if (pi(e)) e.value = t;
        else {
          if (e instanceof Set && Array.isArray(t)) {
            (e.clear(), t.forEach((s) => e.add(s)));
            return;
          }
          const n = Object.keys(t);
          if (e instanceof Map) {
            const s = new Set(e.keys());
            (n.forEach((o) => {
              (e.set(o, Reflect.get(t, o)), s.delete(o));
            }),
              s.forEach((o) => e.delete(o)));
            return;
          }
          const r = new Set(Object.keys(e));
          (n.forEach((s) => {
            (Reflect.set(e, s, Reflect.get(t, s)), r.delete(s));
          }),
            r.forEach((s) => Reflect.deleteProperty(e, s)));
        }
      }
      get(e) {
        return pi(e) ? e.value : e;
      }
      isRef(e) {
        return pi(e) || Qu(e);
      }
    };
  (w(), w(), w());
  var Ag = '__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS_STATE__';
  function Tg() {
    if (!Du || typeof localStorage > 'u' || localStorage === null)
      return {
        recordingState: !1,
        mouseEventEnabled: !1,
        keyboardEventEnabled: !1,
        componentEventEnabled: !1,
        performanceEventEnabled: !1,
        selected: ''
      };
    const e = localStorage.getItem(Ag);
    return e
      ? JSON.parse(e)
      : {
          recordingState: !1,
          mouseEventEnabled: !1,
          keyboardEventEnabled: !1,
          componentEventEnabled: !1,
          performanceEventEnabled: !1,
          selected: ''
        };
  }
  (w(), w(), w());
  var Zu, Xu;
  (Xu = (Zu = M).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS) != null ||
    (Zu.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS = []);
  var Og = new Proxy(M.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS, {
    get(e, t, n) {
      return Reflect.get(e, t, n);
    }
  });
  function kg(e, t) {
    ((Ae.timelineLayersState[t.id] = !1),
      Og.push({ ...e, descriptorId: t.id, appRecord: oi(t.app) }));
  }
  var ec, tc;
  (tc = (ec = M).__VUE_DEVTOOLS_KIT_INSPECTOR__) != null ||
    (ec.__VUE_DEVTOOLS_KIT_INSPECTOR__ = []);
  var hi = new Proxy(M.__VUE_DEVTOOLS_KIT_INSPECTOR__, {
      get(e, t, n) {
        return Reflect.get(e, t, n);
      }
    }),
    nc = Ln(() => {
      Un.hooks.callHook('sendInspectorToClient', rc());
    });
  function Ig(e, t) {
    var n, r;
    (hi.push({
      options: e,
      descriptor: t,
      treeFilterPlaceholder: (n = e.treeFilterPlaceholder) != null ? n : 'Search tree...',
      stateFilterPlaceholder: (r = e.stateFilterPlaceholder) != null ? r : 'Search state...',
      treeFilter: '',
      selectedNodeId: '',
      appRecord: oi(t.app)
    }),
      nc());
  }
  function rc() {
    return hi
      .filter((e) => e.descriptor.app === Me.value.app)
      .filter((e) => e.descriptor.id !== 'components')
      .map((e) => {
        var t;
        const n = e.descriptor,
          r = e.options;
        return {
          id: r.id,
          label: r.label,
          logo: n.logo,
          icon: `custom-ic-baseline-${(t = r == null ? void 0 : r.icon) == null ? void 0 : t.replace(/_/g, '-')}`,
          packageName: n.packageName,
          homepage: n.homepage,
          pluginId: n.id
        };
      });
  }
  function Ps(e, t) {
    return hi.find((n) => n.options.id === e && (t ? n.descriptor.app === t : !0));
  }
  function Rg() {
    const e = Fu();
    e.hook('addInspector', ({ inspector: r, plugin: s }) => {
      Ig(r, s.descriptor);
    });
    const t = Ln(async ({ inspectorId: r, plugin: s }) => {
      var o;
      if (
        !r ||
        !((o = s == null ? void 0 : s.descriptor) != null && o.app) ||
        Ae.highPerfModeEnabled
      )
        return;
      const i = Ps(r, s.descriptor.app),
        l = {
          app: s.descriptor.app,
          inspectorId: r,
          filter: (i == null ? void 0 : i.treeFilter) || '',
          rootNodes: []
        };
      (await new Promise((a) => {
        e.callHookWith(async (c) => {
          (await Promise.all(c.map((u) => u(l))), a());
        }, 'getInspectorTree');
      }),
        e.callHookWith(async (a) => {
          await Promise.all(a.map((c) => c({ inspectorId: r, rootNodes: l.rootNodes })));
        }, 'sendInspectorTreeToClient'));
    }, 120);
    e.hook('sendInspectorTree', t);
    const n = Ln(async ({ inspectorId: r, plugin: s }) => {
      var o;
      if (
        !r ||
        !((o = s == null ? void 0 : s.descriptor) != null && o.app) ||
        Ae.highPerfModeEnabled
      )
        return;
      const i = Ps(r, s.descriptor.app),
        l = {
          app: s.descriptor.app,
          inspectorId: r,
          nodeId: (i == null ? void 0 : i.selectedNodeId) || '',
          state: null
        },
        a = { currentTab: `custom-inspector:${r}` };
      (l.nodeId &&
        (await new Promise((c) => {
          e.callHookWith(async (u) => {
            (await Promise.all(u.map((f) => f(l, a))), c());
          }, 'getInspectorState');
        })),
        e.callHookWith(async (c) => {
          await Promise.all(c.map((u) => u({ inspectorId: r, nodeId: l.nodeId, state: l.state })));
        }, 'sendInspectorStateToClient'));
    }, 120);
    return (
      e.hook('sendInspectorState', n),
      e.hook('customInspectorSelectNode', ({ inspectorId: r, nodeId: s, plugin: o }) => {
        const i = Ps(r, o.descriptor.app);
        i && (i.selectedNodeId = s);
      }),
      e.hook('timelineLayerAdded', ({ options: r, plugin: s }) => {
        kg(r, s.descriptor);
      }),
      e.hook('timelineEventAdded', ({ options: r, plugin: s }) => {
        var o;
        const i = ['performance', 'component-event', 'keyboard', 'mouse'];
        Ae.highPerfModeEnabled ||
          (!((o = Ae.timelineLayersState) != null && o[s.descriptor.id]) &&
            !i.includes(r.layerId)) ||
          e.callHookWith(async (l) => {
            await Promise.all(l.map((a) => a(r)));
          }, 'sendTimelineEventToClient');
      }),
      e.hook('getComponentInstances', async ({ app: r }) => {
        const s = r.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
        if (!s) return null;
        const o = s.id.toString();
        return [...s.instanceMap].filter(([l]) => l.split(':')[0] === o).map(([, l]) => l);
      }),
      e.hook('getComponentBounds', async ({ instance: r }) => vn(r)),
      e.hook('getComponentName', ({ instance: r }) => Is(r)),
      e.hook('componentHighlight', ({ uid: r }) => {
        const s = Me.value.instanceMap.get(r);
        s && gg(s);
      }),
      e.hook('componentUnhighlight', () => {
        Gu();
      }),
      e
    );
  }
  var sc, oc;
  (oc = (sc = M).__VUE_DEVTOOLS_KIT_APP_RECORDS__) != null ||
    (sc.__VUE_DEVTOOLS_KIT_APP_RECORDS__ = []);
  var ic, lc;
  (lc = (ic = M).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__) != null ||
    (ic.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = {});
  var ac, uc;
  (uc = (ac = M).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__) != null ||
    (ac.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = '');
  var cc, fc;
  (fc = (cc = M).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__) != null ||
    (cc.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__ = []);
  var dc, pc;
  (pc = (dc = M).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__) != null ||
    (dc.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ = []);
  var qn = '__VUE_DEVTOOLS_KIT_GLOBAL_STATE__';
  function Dg() {
    return {
      connected: !1,
      clientConnected: !1,
      vitePluginDetected: !0,
      appRecords: [],
      activeAppRecordId: '',
      tabs: [],
      commands: [],
      highPerfModeEnabled: !0,
      devtoolsClientDetected: {},
      perfUniqueGroupId: 0,
      timelineLayersState: Tg()
    };
  }
  var hc, mc;
  (mc = (hc = M)[qn]) != null || (hc[qn] = Dg());
  var Pg = Ln((e) => {
    Un.hooks.callHook('devtoolsStateUpdated', { state: e });
  });
  Ln((e, t) => {
    Un.hooks.callHook('devtoolsConnectedUpdated', { state: e, oldState: t });
  });
  var Bs = new Proxy(M.__VUE_DEVTOOLS_KIT_APP_RECORDS__, {
      get(e, t, n) {
        return t === 'value'
          ? M.__VUE_DEVTOOLS_KIT_APP_RECORDS__
          : M.__VUE_DEVTOOLS_KIT_APP_RECORDS__[t];
      }
    }),
    Me = new Proxy(M.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__, {
      get(e, t, n) {
        return t === 'value'
          ? M.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__
          : t === 'id'
            ? M.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__
            : M.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__[t];
      }
    });
  function gc() {
    Pg({
      ...M[qn],
      appRecords: Bs.value,
      activeAppRecordId: Me.id,
      tabs: M.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__,
      commands: M.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__
    });
  }
  function Bg(e) {
    ((M.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = e), gc());
  }
  function $g(e) {
    ((M.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = e), gc());
  }
  var Ae = new Proxy(M[qn], {
    get(e, t) {
      return t === 'appRecords'
        ? Bs
        : t === 'activeAppRecordId'
          ? Me.id
          : t === 'tabs'
            ? M.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__
            : t === 'commands'
              ? M.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__
              : M[qn][t];
    },
    deleteProperty(e, t) {
      return (delete e[t], !0);
    },
    set(e, t, n) {
      return ({ ...M[qn] }, (e[t] = n), (M[qn][t] = n), !0);
    }
  });
  function Fg(e = {}) {
    var t, n, r;
    const { file: s, host: o, baseUrl: i = window.location.origin, line: l = 0, column: a = 0 } = e;
    if (s) {
      if (o === 'chrome-extension') {
        const c = s.replace(/\\/g, '\\\\'),
          u =
            (n = (t = window.VUE_DEVTOOLS_CONFIG) == null ? void 0 : t.openInEditorHost) != null
              ? n
              : '/';
        fetch(`${u}__open-in-editor?file=${encodeURI(s)}`).then((f) => {
          if (!f.ok) {
            const d = `Opening component ${c} failed`;
            console.log(`%c${d}`, 'color:red');
          }
        });
      } else if (Ae.vitePluginDetected) {
        const c = (r = M.__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__) != null ? r : i;
        M.__VUE_INSPECTOR__.openInEditor(c, s, l, a);
      }
    }
  }
  (w(), w(), w(), w(), w());
  var _c, yc;
  (yc = (_c = M).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__) != null ||
    (_c.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__ = []);
  var mi = new Proxy(M.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__, {
    get(e, t, n) {
      return Reflect.get(e, t, n);
    }
  });
  function gi(e) {
    const t = {};
    return (
      Object.keys(e).forEach((n) => {
        t[n] = e[n].defaultValue;
      }),
      t
    );
  }
  function _i(e) {
    return `__VUE_DEVTOOLS_NEXT_PLUGIN_SETTINGS__${e}__`;
  }
  function Ng(e) {
    var t, n, r;
    const s =
      (n =
        (t = mi.find((o) => {
          var i;
          return o[0].id === e && !!((i = o[0]) != null && i.settings);
        })) == null
          ? void 0
          : t[0]) != null
        ? n
        : null;
    return (r = s == null ? void 0 : s.settings) != null ? r : null;
  }
  function vc(e, t) {
    var n, r, s;
    const o = _i(e);
    if (o) {
      const i = localStorage.getItem(o);
      if (i) return JSON.parse(i);
    }
    if (e) {
      const i =
        (r = (n = mi.find((l) => l[0].id === e)) == null ? void 0 : n[0]) != null ? r : null;
      return gi((s = i == null ? void 0 : i.settings) != null ? s : {});
    }
    return gi(t);
  }
  function Lg(e, t) {
    const n = _i(e);
    localStorage.getItem(n) || localStorage.setItem(n, JSON.stringify(gi(t)));
  }
  function Vg(e, t, n) {
    const r = _i(e),
      s = localStorage.getItem(r),
      o = JSON.parse(s || '{}'),
      i = { ...o, [t]: n };
    (localStorage.setItem(r, JSON.stringify(i)),
      Un.hooks.callHookWith((l) => {
        l.forEach((a) => a({ pluginId: e, key: t, oldValue: o[t], newValue: n, settings: i }));
      }, 'setPluginSettings'));
  }
  (w(), w(), w(), w(), w(), w(), w(), w(), w(), w(), w());
  var qc,
    bc,
    Qe = (bc = (qc = M).__VUE_DEVTOOLS_HOOK) != null ? bc : (qc.__VUE_DEVTOOLS_HOOK = Fu()),
    Mg = {
      vueAppInit(e) {
        Qe.hook('app:init', e);
      },
      vueAppUnmount(e) {
        Qe.hook('app:unmount', e);
      },
      vueAppConnected(e) {
        Qe.hook('app:connected', e);
      },
      componentAdded(e) {
        return Qe.hook('component:added', e);
      },
      componentEmit(e) {
        return Qe.hook('component:emit', e);
      },
      componentUpdated(e) {
        return Qe.hook('component:updated', e);
      },
      componentRemoved(e) {
        return Qe.hook('component:removed', e);
      },
      setupDevtoolsPlugin(e) {
        Qe.hook('devtools-plugin:setup', e);
      },
      perfStart(e) {
        return Qe.hook('perf:start', e);
      },
      perfEnd(e) {
        return Qe.hook('perf:end', e);
      }
    },
    Ec = {
      on: Mg,
      setupDevToolsPlugin(e, t) {
        return Qe.callHook('devtools-plugin:setup', e, t);
      }
    },
    Ug = class {
      constructor({ plugin: e, ctx: t }) {
        ((this.hooks = t.hooks), (this.plugin = e));
      }
      get on() {
        return {
          visitComponentTree: (e) => {
            this.hooks.hook('visitComponentTree', e);
          },
          inspectComponent: (e) => {
            this.hooks.hook('inspectComponent', e);
          },
          editComponentState: (e) => {
            this.hooks.hook('editComponentState', e);
          },
          getInspectorTree: (e) => {
            this.hooks.hook('getInspectorTree', e);
          },
          getInspectorState: (e) => {
            this.hooks.hook('getInspectorState', e);
          },
          editInspectorState: (e) => {
            this.hooks.hook('editInspectorState', e);
          },
          inspectTimelineEvent: (e) => {
            this.hooks.hook('inspectTimelineEvent', e);
          },
          timelineCleared: (e) => {
            this.hooks.hook('timelineCleared', e);
          },
          setPluginSettings: (e) => {
            this.hooks.hook('setPluginSettings', e);
          }
        };
      }
      notifyComponentUpdate(e) {
        var t;
        if (Ae.highPerfModeEnabled) return;
        const n = rc().find((r) => r.packageName === this.plugin.descriptor.packageName);
        if (n != null && n.id) {
          if (e) {
            const r = [e.appContext.app, e.uid, (t = e.parent) == null ? void 0 : t.uid, e];
            Qe.callHook('component:updated', ...r);
          } else Qe.callHook('component:updated');
          this.hooks.callHook('sendInspectorState', { inspectorId: n.id, plugin: this.plugin });
        }
      }
      addInspector(e) {
        (this.hooks.callHook('addInspector', { inspector: e, plugin: this.plugin }),
          this.plugin.descriptor.settings && Lg(e.id, this.plugin.descriptor.settings));
      }
      sendInspectorTree(e) {
        Ae.highPerfModeEnabled ||
          this.hooks.callHook('sendInspectorTree', { inspectorId: e, plugin: this.plugin });
      }
      sendInspectorState(e) {
        Ae.highPerfModeEnabled ||
          this.hooks.callHook('sendInspectorState', { inspectorId: e, plugin: this.plugin });
      }
      selectInspectorNode(e, t) {
        this.hooks.callHook('customInspectorSelectNode', {
          inspectorId: e,
          nodeId: t,
          plugin: this.plugin
        });
      }
      visitComponentTree(e) {
        return this.hooks.callHook('visitComponentTree', e);
      }
      now() {
        return Ae.highPerfModeEnabled ? 0 : Date.now();
      }
      addTimelineLayer(e) {
        this.hooks.callHook('timelineLayerAdded', { options: e, plugin: this.plugin });
      }
      addTimelineEvent(e) {
        Ae.highPerfModeEnabled ||
          this.hooks.callHook('timelineEventAdded', { options: e, plugin: this.plugin });
      }
      getSettings(e) {
        return vc(e ?? this.plugin.descriptor.id, this.plugin.descriptor.settings);
      }
      getComponentInstances(e) {
        return this.hooks.callHook('getComponentInstances', { app: e });
      }
      getComponentBounds(e) {
        return this.hooks.callHook('getComponentBounds', { instance: e });
      }
      getComponentName(e) {
        return this.hooks.callHook('getComponentName', { instance: e });
      }
      highlightElement(e) {
        const t = e.__VUE_DEVTOOLS_NEXT_UID__;
        return this.hooks.callHook('componentHighlight', { uid: t });
      }
      unhighlightElement() {
        return this.hooks.callHook('componentUnhighlight');
      }
    },
    Hg = Ug;
  (w(), w(), w(), w());
  var jg = '__vue_devtool_undefined__',
    zg = '__vue_devtool_infinity__',
    Kg = '__vue_devtool_negative_infinity__',
    Wg = '__vue_devtool_nan__';
  (w(), w());
  var Gg = { [jg]: 'undefined', [Wg]: 'NaN', [zg]: 'Infinity', [Kg]: '-Infinity' };
  (Object.entries(Gg).reduce((e, [t, n]) => ((e[n] = t), e), {}), w(), w(), w(), w(), w());
  var wc, xc;
  (xc = (wc = M).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__) != null ||
    (wc.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__ = new Set());
  function Sc(e, t) {
    return Ec.setupDevToolsPlugin(e, t);
  }
  function Jg(e, t) {
    const [n, r] = e;
    if (n.app !== t) return;
    const s = new Hg({ plugin: { setupFn: r, descriptor: n }, ctx: Un });
    (n.packageName === 'vuex' &&
      s.on.editInspectorState((o) => {
        s.sendInspectorState(o.inspectorId);
      }),
      r(s));
  }
  function Cc(e, t) {
    M.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.has(e) ||
      (Ae.highPerfModeEnabled && !(t != null && t.inspectingComponent)) ||
      (M.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.add(e),
      mi.forEach((n) => {
        Jg(n, e);
      }));
  }
  (w(), w());
  var Or = '__VUE_DEVTOOLS_ROUTER__',
    Mn = '__VUE_DEVTOOLS_ROUTER_INFO__',
    Ac,
    Tc;
  (Tc = (Ac = M)[Mn]) != null || (Ac[Mn] = { currentRoute: null, routes: [] });
  var Oc, kc;
  ((kc = (Oc = M)[Or]) != null || (Oc[Or] = {}),
    new Proxy(M[Mn], {
      get(e, t) {
        return M[Mn][t];
      }
    }),
    new Proxy(M[Or], {
      get(e, t) {
        if (t === 'value') return M[Or];
      }
    }));
  function Yg(e) {
    const t = new Map();
    return ((e == null ? void 0 : e.getRoutes()) || []).filter(
      (n) => !t.has(n.path) && t.set(n.path, 1)
    );
  }
  function yi(e) {
    return e.map((t) => {
      let { path: n, name: r, children: s, meta: o } = t;
      return (s != null && s.length && (s = yi(s)), { path: n, name: r, children: s, meta: o });
    });
  }
  function Qg(e) {
    if (e) {
      const {
        fullPath: t,
        hash: n,
        href: r,
        path: s,
        name: o,
        matched: i,
        params: l,
        query: a
      } = e;
      return {
        fullPath: t,
        hash: n,
        href: r,
        path: s,
        name: o,
        params: l,
        query: a,
        matched: yi(i)
      };
    }
    return e;
  }
  function Zg(e, t) {
    function n() {
      var r;
      const s = (r = e.app) == null ? void 0 : r.config.globalProperties.$router,
        o = Qg(s == null ? void 0 : s.currentRoute.value),
        i = yi(Yg(s)),
        l = console.warn;
      ((console.warn = () => {}),
        (M[Mn] = { currentRoute: o ? Bu(o) : {}, routes: Bu(i) }),
        (M[Or] = s),
        (console.warn = l));
    }
    (n(),
      Ec.on.componentUpdated(
        Ln(() => {
          var r;
          ((r = t.value) == null ? void 0 : r.app) === e.app &&
            (n(),
            !Ae.highPerfModeEnabled && Un.hooks.callHook('routerInfoUpdated', { state: M[Mn] }));
        }, 200)
      ));
  }
  function Xg(e) {
    return {
      async getInspectorTree(t) {
        const n = { ...t, app: Me.value.app, rootNodes: [] };
        return (
          await new Promise((r) => {
            e.callHookWith(async (s) => {
              (await Promise.all(s.map((o) => o(n))), r());
            }, 'getInspectorTree');
          }),
          n.rootNodes
        );
      },
      async getInspectorState(t) {
        const n = { ...t, app: Me.value.app, state: null },
          r = { currentTab: `custom-inspector:${t.inspectorId}` };
        return (
          await new Promise((s) => {
            e.callHookWith(async (o) => {
              (await Promise.all(o.map((i) => i(n, r))), s());
            }, 'getInspectorState');
          }),
          n.state
        );
      },
      editInspectorState(t) {
        const n = new Sg(),
          r = {
            ...t,
            app: Me.value.app,
            set: (s, o = t.path, i = t.state.value, l) => {
              n.set(s, o, i, l || n.createDefaultSetCallback(t.state));
            }
          };
        e.callHookWith((s) => {
          s.forEach((o) => o(r));
        }, 'editInspectorState');
      },
      sendInspectorState(t) {
        const n = Ps(t);
        e.callHook('sendInspectorState', {
          inspectorId: t,
          plugin: { descriptor: n.descriptor, setupFn: () => ({}) }
        });
      },
      inspectComponentInspector() {
        return vg();
      },
      cancelInspectComponentInspector() {
        return yg();
      },
      getComponentRenderCode(t) {
        const n = ii(Me.value, t);
        if (n)
          return typeof (n == null ? void 0 : n.type) != 'function'
            ? n.render.toString()
            : n.type.toString();
      },
      scrollToComponent(t) {
        return qg({ id: t });
      },
      openInEditor: Fg,
      getVueInspector: wg,
      toggleApp(t, n) {
        const r = Bs.value.find((s) => s.id === t);
        r && ($g(t), Bg(r), Zg(r, Me), nc(), Cc(r.app, n));
      },
      inspectDOM(t) {
        const n = ii(Me.value, t);
        if (n) {
          const [r] = li(n);
          r && (M.__VUE_DEVTOOLS_INSPECT_DOM_TARGET__ = r);
        }
      },
      updatePluginSettings(t, n, r) {
        Vg(t, n, r);
      },
      getPluginSettings(t) {
        return { options: Ng(t), values: vc(t) };
      }
    };
  }
  w();
  var Ic, Rc;
  (Rc = (Ic = M).__VUE_DEVTOOLS_ENV__) != null ||
    (Ic.__VUE_DEVTOOLS_ENV__ = { vitePluginDetected: !1 });
  var Dc = Rg(),
    Pc,
    Bc;
  (Bc = (Pc = M).__VUE_DEVTOOLS_KIT_CONTEXT__) != null ||
    (Pc.__VUE_DEVTOOLS_KIT_CONTEXT__ = {
      hooks: Dc,
      get state() {
        return { ...Ae, activeAppRecordId: Me.id, activeAppRecord: Me.value, appRecords: Bs.value };
      },
      api: Xg(Dc)
    });
  var Un = M.__VUE_DEVTOOLS_KIT_CONTEXT__;
  (w(), eg(ng()));
  var $c, Fc;
  ((Fc = ($c = M).__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__) != null ||
    ($c.__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__ = { id: 0, appIds: new Set() }),
    w());
  function e_(e) {
    ((Ae.highPerfModeEnabled = e ?? !Ae.highPerfModeEnabled), !e && Me.value && Cc(Me.value.app));
  }
  (w(), w(), w());
  function t_(e) {
    Ae.devtoolsClientDetected = { ...Ae.devtoolsClientDetected, ...e };
    const t = Object.values(Ae.devtoolsClientDetected).some(Boolean);
    e_(!t);
  }
  var Nc, Lc;
  ((Lc = (Nc = M).__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__) != null ||
    (Nc.__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__ = t_),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w());
  var n_ = class {
      constructor() {
        ((this.keyToValue = new Map()), (this.valueToKey = new Map()));
      }
      set(e, t) {
        (this.keyToValue.set(e, t), this.valueToKey.set(t, e));
      }
      getByKey(e) {
        return this.keyToValue.get(e);
      }
      getByValue(e) {
        return this.valueToKey.get(e);
      }
      clear() {
        (this.keyToValue.clear(), this.valueToKey.clear());
      }
    },
    Vc = class {
      constructor(e) {
        ((this.generateIdentifier = e), (this.kv = new n_()));
      }
      register(e, t) {
        this.kv.getByValue(e) || (t || (t = this.generateIdentifier(e)), this.kv.set(t, e));
      }
      clear() {
        this.kv.clear();
      }
      getIdentifier(e) {
        return this.kv.getByValue(e);
      }
      getValue(e) {
        return this.kv.getByKey(e);
      }
    },
    r_ = class extends Vc {
      constructor() {
        (super((e) => e.name), (this.classToAllowedProps = new Map()));
      }
      register(e, t) {
        typeof t == 'object'
          ? (t.allowProps && this.classToAllowedProps.set(e, t.allowProps),
            super.register(e, t.identifier))
          : super.register(e, t);
      }
      getAllowedProps(e) {
        return this.classToAllowedProps.get(e);
      }
    };
  (w(), w());
  function s_(e) {
    if ('values' in Object) return Object.values(e);
    const t = [];
    for (const n in e) e.hasOwnProperty(n) && t.push(e[n]);
    return t;
  }
  function o_(e, t) {
    const n = s_(e);
    if ('find' in n) return n.find(t);
    const r = n;
    for (let s = 0; s < r.length; s++) {
      const o = r[s];
      if (t(o)) return o;
    }
  }
  function Hn(e, t) {
    Object.entries(e).forEach(([n, r]) => t(r, n));
  }
  function $s(e, t) {
    return e.indexOf(t) !== -1;
  }
  function Mc(e, t) {
    for (let n = 0; n < e.length; n++) {
      const r = e[n];
      if (t(r)) return r;
    }
  }
  var i_ = class {
    constructor() {
      this.transfomers = {};
    }
    register(e) {
      this.transfomers[e.name] = e;
    }
    findApplicable(e) {
      return o_(this.transfomers, (t) => t.isApplicable(e));
    }
    findByName(e) {
      return this.transfomers[e];
    }
  };
  (w(), w());
  var l_ = (e) => Object.prototype.toString.call(e).slice(8, -1),
    Uc = (e) => typeof e > 'u',
    a_ = (e) => e === null,
    kr = (e) =>
      typeof e != 'object' || e === null || e === Object.prototype
        ? !1
        : Object.getPrototypeOf(e) === null
          ? !0
          : Object.getPrototypeOf(e) === Object.prototype,
    vi = (e) => kr(e) && Object.keys(e).length === 0,
    Qt = (e) => Array.isArray(e),
    u_ = (e) => typeof e == 'string',
    c_ = (e) => typeof e == 'number' && !isNaN(e),
    f_ = (e) => typeof e == 'boolean',
    d_ = (e) => e instanceof RegExp,
    Ir = (e) => e instanceof Map,
    Rr = (e) => e instanceof Set,
    Hc = (e) => l_(e) === 'Symbol',
    p_ = (e) => e instanceof Date && !isNaN(e.valueOf()),
    h_ = (e) => e instanceof Error,
    jc = (e) => typeof e == 'number' && isNaN(e),
    m_ = (e) => f_(e) || a_(e) || Uc(e) || c_(e) || u_(e) || Hc(e),
    g_ = (e) => typeof e == 'bigint',
    __ = (e) => e === 1 / 0 || e === -1 / 0,
    y_ = (e) => ArrayBuffer.isView(e) && !(e instanceof DataView),
    v_ = (e) => e instanceof URL;
  w();
  var zc = (e) => e.replace(/\./g, '\\.'),
    qi = (e) => e.map(String).map(zc).join('.'),
    Dr = (e) => {
      const t = [];
      let n = '';
      for (let s = 0; s < e.length; s++) {
        let o = e.charAt(s);
        if (o === '\\' && e.charAt(s + 1) === '.') {
          ((n += '.'), s++);
          continue;
        }
        if (o === '.') {
          (t.push(n), (n = ''));
          continue;
        }
        n += o;
      }
      const r = n;
      return (t.push(r), t);
    };
  w();
  function Et(e, t, n, r) {
    return { isApplicable: e, annotation: t, transform: n, untransform: r };
  }
  var Kc = [
    Et(
      Uc,
      'undefined',
      () => null,
      () => {}
    ),
    Et(
      g_,
      'bigint',
      (e) => e.toString(),
      (e) => (typeof BigInt < 'u' ? BigInt(e) : (console.error('Please add a BigInt polyfill.'), e))
    ),
    Et(
      p_,
      'Date',
      (e) => e.toISOString(),
      (e) => new Date(e)
    ),
    Et(
      h_,
      'Error',
      (e, t) => {
        const n = { name: e.name, message: e.message };
        return (
          t.allowedErrorProps.forEach((r) => {
            n[r] = e[r];
          }),
          n
        );
      },
      (e, t) => {
        const n = new Error(e.message);
        return (
          (n.name = e.name),
          (n.stack = e.stack),
          t.allowedErrorProps.forEach((r) => {
            n[r] = e[r];
          }),
          n
        );
      }
    ),
    Et(
      d_,
      'regexp',
      (e) => '' + e,
      (e) => {
        const t = e.slice(1, e.lastIndexOf('/')),
          n = e.slice(e.lastIndexOf('/') + 1);
        return new RegExp(t, n);
      }
    ),
    Et(
      Rr,
      'set',
      (e) => [...e.values()],
      (e) => new Set(e)
    ),
    Et(
      Ir,
      'map',
      (e) => [...e.entries()],
      (e) => new Map(e)
    ),
    Et(
      (e) => jc(e) || __(e),
      'number',
      (e) => (jc(e) ? 'NaN' : e > 0 ? 'Infinity' : '-Infinity'),
      Number
    ),
    Et(
      (e) => e === 0 && 1 / e === -1 / 0,
      'number',
      () => '-0',
      Number
    ),
    Et(
      v_,
      'URL',
      (e) => e.toString(),
      (e) => new URL(e)
    )
  ];
  function Fs(e, t, n, r) {
    return { isApplicable: e, annotation: t, transform: n, untransform: r };
  }
  var Wc = Fs(
      (e, t) => (Hc(e) ? !!t.symbolRegistry.getIdentifier(e) : !1),
      (e, t) => ['symbol', t.symbolRegistry.getIdentifier(e)],
      (e) => e.description,
      (e, t, n) => {
        const r = n.symbolRegistry.getValue(t[1]);
        if (!r) throw new Error('Trying to deserialize unknown symbol');
        return r;
      }
    ),
    q_ = [
      Int8Array,
      Uint8Array,
      Int16Array,
      Uint16Array,
      Int32Array,
      Uint32Array,
      Float32Array,
      Float64Array,
      Uint8ClampedArray
    ].reduce((e, t) => ((e[t.name] = t), e), {}),
    Gc = Fs(
      y_,
      (e) => ['typed-array', e.constructor.name],
      (e) => [...e],
      (e, t) => {
        const n = q_[t[1]];
        if (!n) throw new Error('Trying to deserialize unknown typed array');
        return new n(e);
      }
    );
  function Jc(e, t) {
    return e != null && e.constructor ? !!t.classRegistry.getIdentifier(e.constructor) : !1;
  }
  var Yc = Fs(
      Jc,
      (e, t) => ['class', t.classRegistry.getIdentifier(e.constructor)],
      (e, t) => {
        const n = t.classRegistry.getAllowedProps(e.constructor);
        if (!n) return { ...e };
        const r = {};
        return (
          n.forEach((s) => {
            r[s] = e[s];
          }),
          r
        );
      },
      (e, t, n) => {
        const r = n.classRegistry.getValue(t[1]);
        if (!r)
          throw new Error(
            `Trying to deserialize unknown class '${t[1]}' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564`
          );
        return Object.assign(Object.create(r.prototype), e);
      }
    ),
    Qc = Fs(
      (e, t) => !!t.customTransformerRegistry.findApplicable(e),
      (e, t) => ['custom', t.customTransformerRegistry.findApplicable(e).name],
      (e, t) => t.customTransformerRegistry.findApplicable(e).serialize(e),
      (e, t, n) => {
        const r = n.customTransformerRegistry.findByName(t[1]);
        if (!r) throw new Error('Trying to deserialize unknown custom value');
        return r.deserialize(e);
      }
    ),
    b_ = [Yc, Wc, Qc, Gc],
    Zc = (e, t) => {
      const n = Mc(b_, (s) => s.isApplicable(e, t));
      if (n) return { value: n.transform(e, t), type: n.annotation(e, t) };
      const r = Mc(Kc, (s) => s.isApplicable(e, t));
      if (r) return { value: r.transform(e, t), type: r.annotation };
    },
    Xc = {};
  Kc.forEach((e) => {
    Xc[e.annotation] = e;
  });
  var E_ = (e, t, n) => {
    if (Qt(t))
      switch (t[0]) {
        case 'symbol':
          return Wc.untransform(e, t, n);
        case 'class':
          return Yc.untransform(e, t, n);
        case 'custom':
          return Qc.untransform(e, t, n);
        case 'typed-array':
          return Gc.untransform(e, t, n);
        default:
          throw new Error('Unknown transformation: ' + t);
      }
    else {
      const r = Xc[t];
      if (!r) throw new Error('Unknown transformation: ' + t);
      return r.untransform(e, n);
    }
  };
  w();
  var jn = (e, t) => {
    if (t > e.size) throw new Error('index out of bounds');
    const n = e.keys();
    for (; t > 0; ) (n.next(), t--);
    return n.next().value;
  };
  function ef(e) {
    if ($s(e, '__proto__')) throw new Error('__proto__ is not allowed as a property');
    if ($s(e, 'prototype')) throw new Error('prototype is not allowed as a property');
    if ($s(e, 'constructor')) throw new Error('constructor is not allowed as a property');
  }
  var w_ = (e, t) => {
      ef(t);
      for (let n = 0; n < t.length; n++) {
        const r = t[n];
        if (Rr(e)) e = jn(e, +r);
        else if (Ir(e)) {
          const s = +r,
            o = +t[++n] == 0 ? 'key' : 'value',
            i = jn(e, s);
          switch (o) {
            case 'key':
              e = i;
              break;
            case 'value':
              e = e.get(i);
              break;
          }
        } else e = e[r];
      }
      return e;
    },
    bi = (e, t, n) => {
      if ((ef(t), t.length === 0)) return n(e);
      let r = e;
      for (let o = 0; o < t.length - 1; o++) {
        const i = t[o];
        if (Qt(r)) {
          const l = +i;
          r = r[l];
        } else if (kr(r)) r = r[i];
        else if (Rr(r)) {
          const l = +i;
          r = jn(r, l);
        } else if (Ir(r)) {
          if (o === t.length - 2) break;
          const a = +i,
            c = +t[++o] == 0 ? 'key' : 'value',
            u = jn(r, a);
          switch (c) {
            case 'key':
              r = u;
              break;
            case 'value':
              r = r.get(u);
              break;
          }
        }
      }
      const s = t[t.length - 1];
      if ((Qt(r) ? (r[+s] = n(r[+s])) : kr(r) && (r[s] = n(r[s])), Rr(r))) {
        const o = jn(r, +s),
          i = n(o);
        o !== i && (r.delete(o), r.add(i));
      }
      if (Ir(r)) {
        const o = +t[t.length - 2],
          i = jn(r, o);
        switch (+s == 0 ? 'key' : 'value') {
          case 'key': {
            const a = n(i);
            (r.set(a, r.get(i)), a !== i && r.delete(i));
            break;
          }
          case 'value': {
            r.set(i, n(r.get(i)));
            break;
          }
        }
      }
      return e;
    };
  function Ei(e, t, n = []) {
    if (!e) return;
    if (!Qt(e)) {
      Hn(e, (o, i) => Ei(o, t, [...n, ...Dr(i)]));
      return;
    }
    const [r, s] = e;
    (s &&
      Hn(s, (o, i) => {
        Ei(o, t, [...n, ...Dr(i)]);
      }),
      t(r, n));
  }
  function x_(e, t, n) {
    return (
      Ei(t, (r, s) => {
        e = bi(e, s, (o) => E_(o, r, n));
      }),
      e
    );
  }
  function S_(e, t) {
    function n(r, s) {
      const o = w_(e, Dr(s));
      r.map(Dr).forEach((i) => {
        e = bi(e, i, () => o);
      });
    }
    if (Qt(t)) {
      const [r, s] = t;
      (r.forEach((o) => {
        e = bi(e, Dr(o), () => e);
      }),
        s && Hn(s, n));
    } else Hn(t, n);
    return e;
  }
  var C_ = (e, t) => kr(e) || Qt(e) || Ir(e) || Rr(e) || Jc(e, t);
  function A_(e, t, n) {
    const r = n.get(e);
    r ? r.push(t) : n.set(e, [t]);
  }
  function T_(e, t) {
    const n = {};
    let r;
    return (
      e.forEach((s) => {
        if (s.length <= 1) return;
        t || (s = s.map((l) => l.map(String)).sort((l, a) => l.length - a.length));
        const [o, ...i] = s;
        o.length === 0 ? (r = i.map(qi)) : (n[qi(o)] = i.map(qi));
      }),
      r ? (vi(n) ? [r] : [r, n]) : vi(n) ? void 0 : n
    );
  }
  var tf = (e, t, n, r, s = [], o = [], i = new Map()) => {
    var l;
    const a = m_(e);
    if (!a) {
      A_(e, s, t);
      const g = i.get(e);
      if (g) return r ? { transformedValue: null } : g;
    }
    if (!C_(e, n)) {
      const g = Zc(e, n),
        v = g ? { transformedValue: g.value, annotations: [g.type] } : { transformedValue: e };
      return (a || i.set(e, v), v);
    }
    if ($s(o, e)) return { transformedValue: null };
    const c = Zc(e, n),
      u = (l = c == null ? void 0 : c.value) != null ? l : e,
      f = Qt(u) ? [] : {},
      d = {};
    Hn(u, (g, v) => {
      if (v === '__proto__' || v === 'constructor' || v === 'prototype')
        throw new Error(
          `Detected property ${v}. This is a prototype pollution risk, please remove it from your object.`
        );
      const y = tf(g, t, n, r, [...s, v], [...o, e], i);
      ((f[v] = y.transformedValue),
        Qt(y.annotations)
          ? (d[v] = y.annotations)
          : kr(y.annotations) &&
            Hn(y.annotations, (E, N) => {
              d[zc(v) + '.' + N] = E;
            }));
    });
    const h = vi(d)
      ? { transformedValue: f, annotations: c ? [c.type] : void 0 }
      : { transformedValue: f, annotations: c ? [c.type, d] : d };
    return (a || i.set(e, h), h);
  };
  (w(), w());
  function nf(e) {
    return Object.prototype.toString.call(e).slice(8, -1);
  }
  function rf(e) {
    return nf(e) === 'Array';
  }
  function O_(e) {
    if (nf(e) !== 'Object') return !1;
    const t = Object.getPrototypeOf(e);
    return !!t && t.constructor === Object && t === Object.prototype;
  }
  function k_(e, t, n, r, s) {
    const o = {}.propertyIsEnumerable.call(r, t) ? 'enumerable' : 'nonenumerable';
    (o === 'enumerable' && (e[t] = n),
      s &&
        o === 'nonenumerable' &&
        Object.defineProperty(e, t, { value: n, enumerable: !1, writable: !0, configurable: !0 }));
  }
  function wi(e, t = {}) {
    if (rf(e)) return e.map((s) => wi(s, t));
    if (!O_(e)) return e;
    const n = Object.getOwnPropertyNames(e),
      r = Object.getOwnPropertySymbols(e);
    return [...n, ...r].reduce((s, o) => {
      if (rf(t.props) && !t.props.includes(o)) return s;
      const i = e[o],
        l = wi(i, t);
      return (k_(s, o, l, e, t.nonenumerable), s);
    }, {});
  }
  var _e = class {
    constructor({ dedupe: e = !1 } = {}) {
      ((this.classRegistry = new r_()),
        (this.symbolRegistry = new Vc((t) => {
          var n;
          return (n = t.description) != null ? n : '';
        })),
        (this.customTransformerRegistry = new i_()),
        (this.allowedErrorProps = []),
        (this.dedupe = e));
    }
    serialize(e) {
      const t = new Map(),
        n = tf(e, t, this, this.dedupe),
        r = { json: n.transformedValue };
      n.annotations && (r.meta = { ...r.meta, values: n.annotations });
      const s = T_(t, this.dedupe);
      return (s && (r.meta = { ...r.meta, referentialEqualities: s }), r);
    }
    deserialize(e) {
      const { json: t, meta: n } = e;
      let r = wi(t);
      return (
        n != null && n.values && (r = x_(r, n.values, this)),
        n != null && n.referentialEqualities && (r = S_(r, n.referentialEqualities)),
        r
      );
    }
    stringify(e) {
      return JSON.stringify(this.serialize(e));
    }
    parse(e) {
      return this.deserialize(JSON.parse(e));
    }
    registerClass(e, t) {
      this.classRegistry.register(e, t);
    }
    registerSymbol(e, t) {
      this.symbolRegistry.register(e, t);
    }
    registerCustom(e, t) {
      this.customTransformerRegistry.register({ name: t, ...e });
    }
    allowErrorProps(...e) {
      this.allowedErrorProps.push(...e);
    }
  };
  ((_e.defaultInstance = new _e()),
    (_e.serialize = _e.defaultInstance.serialize.bind(_e.defaultInstance)),
    (_e.deserialize = _e.defaultInstance.deserialize.bind(_e.defaultInstance)),
    (_e.stringify = _e.defaultInstance.stringify.bind(_e.defaultInstance)),
    (_e.parse = _e.defaultInstance.parse.bind(_e.defaultInstance)),
    (_e.registerClass = _e.defaultInstance.registerClass.bind(_e.defaultInstance)),
    (_e.registerSymbol = _e.defaultInstance.registerSymbol.bind(_e.defaultInstance)),
    (_e.registerCustom = _e.defaultInstance.registerCustom.bind(_e.defaultInstance)),
    (_e.allowErrorProps = _e.defaultInstance.allowErrorProps.bind(_e.defaultInstance)),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w());
  var sf, of;
  (of = (sf = M).__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__) != null ||
    (sf.__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__ = []);
  var lf, af;
  (af = (lf = M).__VUE_DEVTOOLS_KIT_RPC_CLIENT__) != null ||
    (lf.__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = null);
  var uf, cf;
  (cf = (uf = M).__VUE_DEVTOOLS_KIT_RPC_SERVER__) != null ||
    (uf.__VUE_DEVTOOLS_KIT_RPC_SERVER__ = null);
  var ff, df;
  (df = (ff = M).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__) != null ||
    (ff.__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = null);
  var pf, hf;
  (hf = (pf = M).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__) != null ||
    (pf.__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = null);
  var mf, gf;
  ((gf = (mf = M).__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__) != null ||
    (mf.__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__ = null),
    w(),
    w(),
    w(),
    w(),
    w(),
    w(),
    w());
  let xi;
  const Pr = (e) => (xi = e),
    _f = Symbol('pinia');
  function bn(e) {
    return (
      e &&
      typeof e == 'object' &&
      Object.prototype.toString.call(e) === '[object Object]' &&
      typeof e.toJSON != 'function'
    );
  }
  var wt;
  (function (e) {
    ((e.direct = 'direct'), (e.patchObject = 'patch object'), (e.patchFunction = 'patch function'));
  })(wt || (wt = {}));
  const En = typeof window < 'u',
    yf =
      typeof window == 'object' && window.window === window
        ? window
        : typeof self == 'object' && self.self === self
          ? self
          : typeof global == 'object' && global.global === global
            ? global
            : typeof globalThis == 'object'
              ? globalThis
              : { HTMLElement: null };
  function I_(e, { autoBom: t = !1 } = {}) {
    return t &&
      /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type)
      ? new Blob(['\uFEFF', e], { type: e.type })
      : e;
  }
  function Si(e, t, n) {
    const r = new XMLHttpRequest();
    (r.open('GET', e),
      (r.responseType = 'blob'),
      (r.onload = function () {
        bf(r.response, t, n);
      }),
      (r.onerror = function () {
        console.error('could not download file');
      }),
      r.send());
  }
  function vf(e) {
    const t = new XMLHttpRequest();
    t.open('HEAD', e, !1);
    try {
      t.send();
    } catch {}
    return t.status >= 200 && t.status <= 299;
  }
  function Ns(e) {
    try {
      e.dispatchEvent(new MouseEvent('click'));
    } catch {
      const n = new MouseEvent('click', {
        bubbles: !0,
        cancelable: !0,
        view: window,
        detail: 0,
        screenX: 80,
        screenY: 20,
        clientX: 80,
        clientY: 20,
        ctrlKey: !1,
        altKey: !1,
        shiftKey: !1,
        metaKey: !1,
        button: 0,
        relatedTarget: null
      });
      e.dispatchEvent(n);
    }
  }
  const Ls = typeof navigator == 'object' ? navigator : { userAgent: '' },
    qf =
      /Macintosh/.test(Ls.userAgent) &&
      /AppleWebKit/.test(Ls.userAgent) &&
      !/Safari/.test(Ls.userAgent),
    bf = En
      ? typeof HTMLAnchorElement < 'u' && 'download' in HTMLAnchorElement.prototype && !qf
        ? R_
        : 'msSaveOrOpenBlob' in Ls
          ? D_
          : P_
      : () => {};
  function R_(e, t = 'download', n) {
    const r = document.createElement('a');
    ((r.download = t),
      (r.rel = 'noopener'),
      typeof e == 'string'
        ? ((r.href = e),
          r.origin !== location.origin
            ? vf(r.href)
              ? Si(e, t, n)
              : ((r.target = '_blank'), Ns(r))
            : Ns(r))
        : ((r.href = URL.createObjectURL(e)),
          setTimeout(function () {
            URL.revokeObjectURL(r.href);
          }, 4e4),
          setTimeout(function () {
            Ns(r);
          }, 0)));
  }
  function D_(e, t = 'download', n) {
    if (typeof e == 'string')
      if (vf(e)) Si(e, t, n);
      else {
        const r = document.createElement('a');
        ((r.href = e),
          (r.target = '_blank'),
          setTimeout(function () {
            Ns(r);
          }));
      }
    else navigator.msSaveOrOpenBlob(I_(e, n), t);
  }
  function P_(e, t, n, r) {
    if (
      ((r = r || open('', '_blank')),
      r && (r.document.title = r.document.body.innerText = 'downloading...'),
      typeof e == 'string')
    )
      return Si(e, t, n);
    const s = e.type === 'application/octet-stream',
      o = /constructor/i.test(String(yf.HTMLElement)) || 'safari' in yf,
      i = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((i || (s && o) || qf) && typeof FileReader < 'u') {
      const l = new FileReader();
      ((l.onloadend = function () {
        let a = l.result;
        if (typeof a != 'string') throw ((r = null), new Error('Wrong reader.result type'));
        ((a = i ? a : a.replace(/^data:[^;]*;/, 'data:attachment/file;')),
          r ? (r.location.href = a) : location.assign(a),
          (r = null));
      }),
        l.readAsDataURL(e));
    } else {
      const l = URL.createObjectURL(e);
      (r ? r.location.assign(l) : (location.href = l),
        (r = null),
        setTimeout(function () {
          URL.revokeObjectURL(l);
        }, 4e4));
    }
  }
  function Oe(e, t) {
    const n = '🍍 ' + e;
    typeof __VUE_DEVTOOLS_TOAST__ == 'function'
      ? __VUE_DEVTOOLS_TOAST__(n, t)
      : t === 'error'
        ? console.error(n)
        : t === 'warn'
          ? console.warn(n)
          : console.log(n);
  }
  function Ci(e) {
    return '_a' in e && 'install' in e;
  }
  function Ef() {
    if (!('clipboard' in navigator))
      return (Oe("Your browser doesn't support the Clipboard API", 'error'), !0);
  }
  function wf(e) {
    return e instanceof Error && e.message.toLowerCase().includes('document is not focused')
      ? (Oe(
          'You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.',
          'warn'
        ),
        !0)
      : !1;
  }
  async function B_(e) {
    if (!Ef())
      try {
        (await navigator.clipboard.writeText(JSON.stringify(e.state.value)),
          Oe('Global state copied to clipboard.'));
      } catch (t) {
        if (wf(t)) return;
        (Oe('Failed to serialize the state. Check the console for more details.', 'error'),
          console.error(t));
      }
  }
  async function $_(e) {
    if (!Ef())
      try {
        (xf(e, JSON.parse(await navigator.clipboard.readText())),
          Oe('Global state pasted from clipboard.'));
      } catch (t) {
        if (wf(t)) return;
        (Oe(
          'Failed to deserialize the state from clipboard. Check the console for more details.',
          'error'
        ),
          console.error(t));
      }
  }
  async function F_(e) {
    try {
      bf(
        new Blob([JSON.stringify(e.state.value)], { type: 'text/plain;charset=utf-8' }),
        'pinia-state.json'
      );
    } catch (t) {
      (Oe('Failed to export the state as JSON. Check the console for more details.', 'error'),
        console.error(t));
    }
  }
  let Mt;
  function N_() {
    Mt || ((Mt = document.createElement('input')), (Mt.type = 'file'), (Mt.accept = '.json'));
    function e() {
      return new Promise((t, n) => {
        ((Mt.onchange = async () => {
          const r = Mt.files;
          if (!r) return t(null);
          const s = r.item(0);
          return t(s ? { text: await s.text(), file: s } : null);
        }),
          (Mt.oncancel = () => t(null)),
          (Mt.onerror = n),
          Mt.click());
      });
    }
    return e;
  }
  async function L_(e) {
    try {
      const n = await N_()();
      if (!n) return;
      const { text: r, file: s } = n;
      (xf(e, JSON.parse(r)), Oe(`Global state imported from "${s.name}".`));
    } catch (t) {
      (Oe('Failed to import the state from JSON. Check the console for more details.', 'error'),
        console.error(t));
    }
  }
  function xf(e, t) {
    for (const n in t) {
      const r = e.state.value[n];
      r ? Object.assign(r, t[n]) : (e.state.value[n] = t[n]);
    }
  }
  function ft(e) {
    return { _custom: { display: e } };
  }
  const Sf = '🍍 Pinia (root)',
    Vs = '_root';
  function V_(e) {
    return Ci(e) ? { id: Vs, label: Sf } : { id: e.$id, label: e.$id };
  }
  function M_(e) {
    if (Ci(e)) {
      const n = Array.from(e._s.keys()),
        r = e._s;
      return {
        state: n.map((o) => ({ editable: !0, key: o, value: e.state.value[o] })),
        getters: n
          .filter((o) => r.get(o)._getters)
          .map((o) => {
            const i = r.get(o);
            return {
              editable: !1,
              key: o,
              value: i._getters.reduce((l, a) => ((l[a] = i[a]), l), {})
            };
          })
      };
    }
    const t = {
      state: Object.keys(e.$state).map((n) => ({ editable: !0, key: n, value: e.$state[n] }))
    };
    return (
      e._getters &&
        e._getters.length &&
        (t.getters = e._getters.map((n) => ({ editable: !1, key: n, value: e[n] }))),
      e._customProperties.size &&
        (t.customProperties = Array.from(e._customProperties).map((n) => ({
          editable: !0,
          key: n,
          value: e[n]
        }))),
      t
    );
  }
  function U_(e) {
    return e
      ? Array.isArray(e)
        ? e.reduce(
            (t, n) => (
              t.keys.push(n.key),
              t.operations.push(n.type),
              (t.oldValue[n.key] = n.oldValue),
              (t.newValue[n.key] = n.newValue),
              t
            ),
            { oldValue: {}, keys: [], operations: [], newValue: {} }
          )
        : { operation: ft(e.type), key: ft(e.key), oldValue: e.oldValue, newValue: e.newValue }
      : {};
  }
  function H_(e) {
    switch (e) {
      case wt.direct:
        return 'mutation';
      case wt.patchFunction:
        return '$patch';
      case wt.patchObject:
        return '$patch';
      default:
        return 'unknown';
    }
  }
  let zn = !0;
  const Ms = [],
    wn = 'pinia:mutations',
    Be = 'pinia',
    { assign: j_ } = Object,
    Us = (e) => '🍍 ' + e;
  function z_(e, t) {
    Sc(
      {
        id: 'dev.esm.pinia',
        label: 'Pinia 🍍',
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes: Ms,
        app: e
      },
      (n) => {
        (typeof n.now != 'function' &&
          Oe(
            'You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.'
          ),
          n.addTimelineLayer({ id: wn, label: 'Pinia 🍍', color: 15064968 }),
          n.addInspector({
            id: Be,
            label: 'Pinia 🍍',
            icon: 'storage',
            treeFilterPlaceholder: 'Search stores',
            actions: [
              {
                icon: 'content_copy',
                action: () => {
                  B_(t);
                },
                tooltip: 'Serialize and copy the state'
              },
              {
                icon: 'content_paste',
                action: async () => {
                  (await $_(t), n.sendInspectorTree(Be), n.sendInspectorState(Be));
                },
                tooltip: 'Replace the state with the content of your clipboard'
              },
              {
                icon: 'save',
                action: () => {
                  F_(t);
                },
                tooltip: 'Save the state as a JSON file'
              },
              {
                icon: 'folder_open',
                action: async () => {
                  (await L_(t), n.sendInspectorTree(Be), n.sendInspectorState(Be));
                },
                tooltip: 'Import the state from a JSON file'
              }
            ],
            nodeActions: [
              {
                icon: 'restore',
                tooltip: 'Reset the state (with "$reset")',
                action: (r) => {
                  const s = t._s.get(r);
                  s
                    ? typeof s.$reset != 'function'
                      ? Oe(
                          `Cannot reset "${r}" store because it doesn't have a "$reset" method implemented.`,
                          'warn'
                        )
                      : (s.$reset(), Oe(`Store "${r}" reset.`))
                    : Oe(`Cannot reset "${r}" store because it wasn't found.`, 'warn');
                }
              }
            ]
          }),
          n.on.inspectComponent((r) => {
            const s = r.componentInstance && r.componentInstance.proxy;
            if (s && s._pStores) {
              const o = r.componentInstance.proxy._pStores;
              Object.values(o).forEach((i) => {
                (r.instanceData.state.push({
                  type: Us(i.$id),
                  key: 'state',
                  editable: !0,
                  value: i._isOptionsAPI
                    ? {
                        _custom: {
                          value: Q(i.$state),
                          actions: [
                            {
                              icon: 'restore',
                              tooltip: 'Reset the state of this store',
                              action: () => i.$reset()
                            }
                          ]
                        }
                      }
                    : Object.keys(i.$state).reduce((l, a) => ((l[a] = i.$state[a]), l), {})
                }),
                  i._getters &&
                    i._getters.length &&
                    r.instanceData.state.push({
                      type: Us(i.$id),
                      key: 'getters',
                      editable: !1,
                      value: i._getters.reduce((l, a) => {
                        try {
                          l[a] = i[a];
                        } catch (c) {
                          l[a] = c;
                        }
                        return l;
                      }, {})
                    }));
              });
            }
          }),
          n.on.getInspectorTree((r) => {
            if (r.app === e && r.inspectorId === Be) {
              let s = [t];
              ((s = s.concat(Array.from(t._s.values()))),
                (r.rootNodes = (
                  r.filter
                    ? s.filter((o) =>
                        '$id' in o
                          ? o.$id.toLowerCase().includes(r.filter.toLowerCase())
                          : Sf.toLowerCase().includes(r.filter.toLowerCase())
                      )
                    : s
                ).map(V_)));
            }
          }),
          (globalThis.$pinia = t),
          n.on.getInspectorState((r) => {
            if (r.app === e && r.inspectorId === Be) {
              const s = r.nodeId === Vs ? t : t._s.get(r.nodeId);
              if (!s) return;
              s && (r.nodeId !== Vs && (globalThis.$store = Q(s)), (r.state = M_(s)));
            }
          }),
          n.on.editInspectorState((r) => {
            if (r.app === e && r.inspectorId === Be) {
              const s = r.nodeId === Vs ? t : t._s.get(r.nodeId);
              if (!s) return Oe(`store "${r.nodeId}" not found`, 'error');
              const { path: o } = r;
              (Ci(s)
                ? o.unshift('state')
                : (o.length !== 1 || !s._customProperties.has(o[0]) || o[0] in s.$state) &&
                  o.unshift('$state'),
                (zn = !1),
                r.set(s, o, r.state.value),
                (zn = !0));
            }
          }),
          n.on.editComponentState((r) => {
            if (r.type.startsWith('🍍')) {
              const s = r.type.replace(/^🍍\s*/, ''),
                o = t._s.get(s);
              if (!o) return Oe(`store "${s}" not found`, 'error');
              const { path: i } = r;
              if (i[0] !== 'state')
                return Oe(`Invalid path for store "${s}":
${i}
Only state can be modified.`);
              ((i[0] = '$state'), (zn = !1), r.set(o, i, r.state.value), (zn = !0));
            }
          }));
      }
    );
  }
  function K_(e, t) {
    (Ms.includes(Us(t.$id)) || Ms.push(Us(t.$id)),
      Sc(
        {
          id: 'dev.esm.pinia',
          label: 'Pinia 🍍',
          logo: 'https://pinia.vuejs.org/logo.svg',
          packageName: 'pinia',
          homepage: 'https://pinia.vuejs.org',
          componentStateTypes: Ms,
          app: e,
          settings: {
            logStoreChanges: {
              label: 'Notify about new/deleted stores',
              type: 'boolean',
              defaultValue: !0
            }
          }
        },
        (n) => {
          const r = typeof n.now == 'function' ? n.now.bind(n) : Date.now;
          (t.$onAction(({ after: i, onError: l, name: a, args: c }) => {
            const u = Cf++;
            (n.addTimelineEvent({
              layerId: wn,
              event: {
                time: r(),
                title: '🛫 ' + a,
                subtitle: 'start',
                data: { store: ft(t.$id), action: ft(a), args: c },
                groupId: u
              }
            }),
              i((f) => {
                ((Zt = void 0),
                  n.addTimelineEvent({
                    layerId: wn,
                    event: {
                      time: r(),
                      title: '🛬 ' + a,
                      subtitle: 'end',
                      data: { store: ft(t.$id), action: ft(a), args: c, result: f },
                      groupId: u
                    }
                  }));
              }),
              l((f) => {
                ((Zt = void 0),
                  n.addTimelineEvent({
                    layerId: wn,
                    event: {
                      time: r(),
                      logType: 'error',
                      title: '💥 ' + a,
                      subtitle: 'end',
                      data: { store: ft(t.$id), action: ft(a), args: c, error: f },
                      groupId: u
                    }
                  }));
              }));
          }, !0),
            t._customProperties.forEach((i) => {
              at(
                () => jt(t[i]),
                (l, a) => {
                  (n.notifyComponentUpdate(),
                    n.sendInspectorState(Be),
                    zn &&
                      n.addTimelineEvent({
                        layerId: wn,
                        event: {
                          time: r(),
                          title: 'Change',
                          subtitle: i,
                          data: { newValue: l, oldValue: a },
                          groupId: Zt
                        }
                      }));
                },
                { deep: !0 }
              );
            }),
            t.$subscribe(
              ({ events: i, type: l }, a) => {
                if ((n.notifyComponentUpdate(), n.sendInspectorState(Be), !zn)) return;
                const c = {
                  time: r(),
                  title: H_(l),
                  data: j_({ store: ft(t.$id) }, U_(i)),
                  groupId: Zt
                };
                (l === wt.patchFunction
                  ? (c.subtitle = '⤵️')
                  : l === wt.patchObject
                    ? (c.subtitle = '🧩')
                    : i && !Array.isArray(i) && (c.subtitle = i.type),
                  i &&
                    (c.data['rawEvent(s)'] = {
                      _custom: {
                        display: 'DebuggerEvent',
                        type: 'object',
                        tooltip: 'raw DebuggerEvent[]',
                        value: i
                      }
                    }),
                  n.addTimelineEvent({ layerId: wn, event: c }));
              },
              { detached: !0, flush: 'sync' }
            ));
          const s = t._hotUpdate;
          t._hotUpdate = Ht((i) => {
            (s(i),
              n.addTimelineEvent({
                layerId: wn,
                event: {
                  time: r(),
                  title: '🔥 ' + t.$id,
                  subtitle: 'HMR update',
                  data: { store: ft(t.$id), info: ft('HMR update') }
                }
              }),
              n.notifyComponentUpdate(),
              n.sendInspectorTree(Be),
              n.sendInspectorState(Be));
          });
          const { $dispose: o } = t;
          ((t.$dispose = () => {
            (o(),
              n.notifyComponentUpdate(),
              n.sendInspectorTree(Be),
              n.sendInspectorState(Be),
              n.getSettings().logStoreChanges && Oe(`Disposed "${t.$id}" store 🗑`));
          }),
            n.notifyComponentUpdate(),
            n.sendInspectorTree(Be),
            n.sendInspectorState(Be),
            n.getSettings().logStoreChanges && Oe(`"${t.$id}" store installed 🆕`));
        }
      ));
  }
  let Cf = 0,
    Zt;
  function Af(e, t, n) {
    const r = t.reduce((s, o) => ((s[o] = Q(e)[o]), s), {});
    for (const s in r)
      e[s] = function () {
        const o = Cf,
          i = n
            ? new Proxy(e, {
                get(...a) {
                  return ((Zt = o), Reflect.get(...a));
                },
                set(...a) {
                  return ((Zt = o), Reflect.set(...a));
                }
              })
            : e;
        Zt = o;
        const l = r[s].apply(i, arguments);
        return ((Zt = void 0), l);
      };
  }
  function W_({ app: e, store: t, options: n }) {
    if (!t.$id.startsWith('__hot:')) {
      if (((t._isOptionsAPI = !!n.state), !t._p._testing)) {
        Af(t, Object.keys(n.actions), t._isOptionsAPI);
        const r = t._hotUpdate;
        Q(t)._hotUpdate = function (s) {
          (r.apply(this, arguments), Af(t, Object.keys(s._hmrPayload.actions), !!t._isOptionsAPI));
        };
      }
      K_(e, t);
    }
  }
  function G_() {
    const e = ql(!0),
      t = e.run(() => se({}));
    let n = [],
      r = [];
    const s = Ht({
      install(o) {
        (Pr(s),
          (s._a = o),
          o.provide(_f, s),
          (o.config.globalProperties.$pinia = s),
          En && z_(o, s),
          r.forEach((i) => n.push(i)),
          (r = []));
      },
      use(o) {
        return (this._a ? n.push(o) : r.push(o), this);
      },
      _p: n,
      _a: null,
      _e: e,
      _s: new Map(),
      state: t
    });
    return (En && typeof Proxy < 'u' && s.use(W_), s);
  }
  function Tf(e, t) {
    for (const n in t) {
      const r = t[n];
      if (!(n in e)) continue;
      const s = e[n];
      bn(s) && bn(r) && !me(r) && !mt(r) ? (e[n] = Tf(s, r)) : (e[n] = r);
    }
    return e;
  }
  const J_ = () => {};
  function Of(e, t, n, r = J_) {
    e.push(t);
    const s = () => {
      const o = e.indexOf(t);
      o > -1 && (e.splice(o, 1), r());
    };
    return (!n && bl() && Sp(s), s);
  }
  function Kn(e, ...t) {
    e.slice().forEach((n) => {
      n(...t);
    });
  }
  const Y_ = (e) => e(),
    kf = Symbol(),
    Ai = Symbol();
  function Ti(e, t) {
    e instanceof Map && t instanceof Map
      ? t.forEach((n, r) => e.set(r, n))
      : e instanceof Set && t instanceof Set && t.forEach(e.add, e);
    for (const n in t) {
      if (!t.hasOwnProperty(n)) continue;
      const r = t[n],
        s = e[n];
      bn(s) && bn(r) && e.hasOwnProperty(n) && !me(r) && !mt(r) ? (e[n] = Ti(s, r)) : (e[n] = r);
    }
    return e;
  }
  const Q_ = Symbol('pinia:skipHydration');
  function Z_(e) {
    return !bn(e) || !Object.prototype.hasOwnProperty.call(e, Q_);
  }
  const { assign: rt } = Object;
  function If(e) {
    return !!(me(e) && e.effect);
  }
  function Rf(e, t, n, r) {
    const { state: s, actions: o, getters: i } = t,
      l = n.state.value[e];
    let a;
    function c() {
      !l && !r && (n.state.value[e] = s ? s() : {});
      const u = Hl(r ? se(s ? s() : {}).value : n.state.value[e]);
      return rt(
        u,
        o,
        Object.keys(i || {}).reduce(
          (f, d) => (
            d in u &&
              console.warn(
                `[🍍]: A getter cannot have the same name as another state property. Rename one of them. Found with "${d}" in store "${e}".`
              ),
            (f[d] = Ht(
              ee(() => {
                Pr(n);
                const h = n._s.get(e);
                return i[d].call(h, h);
              })
            )),
            f
          ),
          {}
        )
      );
    }
    return ((a = Oi(e, c, t, n, r, !0)), a);
  }
  function Oi(e, t, n = {}, r, s, o) {
    let i;
    const l = rt({ actions: {} }, n);
    if (!r._e.active) throw new Error('Pinia destroyed');
    const a = { deep: !0 };
    a.onTrigger = (I) => {
      c
        ? (h = I)
        : c == !1 &&
          !V._hotUpdating &&
          (Array.isArray(h)
            ? h.push(I)
            : console.error(
                '🍍 debuggerEvents should be an array. This is most likely an internal Pinia bug.'
              ));
    };
    let c,
      u,
      f = [],
      d = [],
      h;
    const g = r.state.value[e];
    !o && !g && !s && (r.state.value[e] = {});
    const v = se({});
    let y;
    function E(I) {
      let O;
      ((c = u = !1),
        (h = []),
        typeof I == 'function'
          ? (I(r.state.value[e]), (O = { type: wt.patchFunction, storeId: e, events: h }))
          : (Ti(r.state.value[e], I),
            (O = { type: wt.patchObject, payload: I, storeId: e, events: h })));
      const T = (y = Symbol());
      (wo().then(() => {
        y === T && (c = !0);
      }),
        (u = !0),
        Kn(f, O, r.state.value[e]));
    }
    const N = o
      ? function () {
          const { state: O } = n,
            T = O ? O() : {};
          this.$patch((ne) => {
            rt(ne, T);
          });
        }
      : () => {
          throw new Error(
            `🍍: Store "${e}" is built using the setup syntax and does not implement $reset().`
          );
        };
    function P() {
      (i.stop(), (f = []), (d = []), r._s.delete(e));
    }
    const te = (I, O = '') => {
        if (kf in I) return ((I[Ai] = O), I);
        const T = function () {
          Pr(r);
          const ne = Array.from(arguments),
            he = [],
            be = [];
          function de(oe) {
            he.push(oe);
          }
          function L(oe) {
            be.push(oe);
          }
          Kn(d, { args: ne, name: T[Ai], store: V, after: de, onError: L });
          let Z;
          try {
            Z = I.apply(this && this.$id === e ? this : V, ne);
          } catch (oe) {
            throw (Kn(be, oe), oe);
          }
          return Z instanceof Promise
            ? Z.then((oe) => (Kn(he, oe), oe)).catch((oe) => (Kn(be, oe), Promise.reject(oe)))
            : (Kn(he, Z), Z);
        };
        return ((T[kf] = !0), (T[Ai] = O), T);
      },
      B = Ht({ actions: {}, getters: {}, state: [], hotState: v }),
      J = {
        _p: r,
        $id: e,
        $onAction: Of.bind(null, d),
        $patch: E,
        $reset: N,
        $subscribe(I, O = {}) {
          const T = Of(f, I, O.detached, () => ne()),
            ne = i.run(() =>
              at(
                () => r.state.value[e],
                (he) => {
                  (O.flush === 'sync' ? u : c) && I({ storeId: e, type: wt.direct, events: h }, he);
                },
                rt({}, a, O)
              )
            );
          return T;
        },
        $dispose: P
      },
      V = os(rt({ _hmrPayload: B, _customProperties: Ht(new Set()) }, J));
    r._s.set(e, V);
    const U = ((r._a && r._a.runWithContext) || Y_)(() =>
      r._e.run(() => (i = ql()).run(() => t({ action: te })))
    );
    for (const I in U) {
      const O = U[I];
      if ((me(O) && !If(O)) || mt(O))
        (s
          ? (v.value[I] = qo(U, I))
          : o ||
            (g && Z_(O) && (me(O) ? (O.value = g[I]) : Ti(O, g[I])), (r.state.value[e][I] = O)),
          B.state.push(I));
      else if (typeof O == 'function') {
        const T = s ? O : te(O, I);
        ((U[I] = T), (B.actions[I] = O), (l.actions[I] = O));
      } else
        If(O) &&
          ((B.getters[I] = o ? n.getters[I] : O),
          En && (U._getters || (U._getters = Ht([]))).push(I));
    }
    if (
      (rt(V, U),
      rt(Q(V), U),
      Object.defineProperty(V, '$state', {
        get: () => (s ? v.value : r.state.value[e]),
        set: (I) => {
          if (s) throw new Error('cannot set hotState');
          E((O) => {
            rt(O, I);
          });
        }
      }),
      (V._hotUpdate = Ht((I) => {
        ((V._hotUpdating = !0),
          I._hmrPayload.state.forEach((O) => {
            if (O in V.$state) {
              const T = I.$state[O],
                ne = V.$state[O];
              typeof T == 'object' && bn(T) && bn(ne) ? Tf(T, ne) : (I.$state[O] = ne);
            }
            V[O] = qo(I.$state, O);
          }),
          Object.keys(V.$state).forEach((O) => {
            O in I.$state || delete V[O];
          }),
          (c = !1),
          (u = !1),
          (r.state.value[e] = qo(I._hmrPayload, 'hotState')),
          (u = !0),
          wo().then(() => {
            c = !0;
          }));
        for (const O in I._hmrPayload.actions) {
          const T = I[O];
          V[O] = te(T, O);
        }
        for (const O in I._hmrPayload.getters) {
          const T = I._hmrPayload.getters[O],
            ne = o ? ee(() => (Pr(r), T.call(V, V))) : T;
          V[O] = ne;
        }
        (Object.keys(V._hmrPayload.getters).forEach((O) => {
          O in I._hmrPayload.getters || delete V[O];
        }),
          Object.keys(V._hmrPayload.actions).forEach((O) => {
            O in I._hmrPayload.actions || delete V[O];
          }),
          (V._hmrPayload = I._hmrPayload),
          (V._getters = I._getters),
          (V._hotUpdating = !1));
      })),
      En)
    ) {
      const I = { writable: !0, configurable: !0, enumerable: !1 };
      ['_p', '_hmrPayload', '_getters', '_customProperties'].forEach((O) => {
        Object.defineProperty(V, O, rt({ value: V[O] }, I));
      });
    }
    return (
      r._p.forEach((I) => {
        if (En) {
          const O = i.run(() => I({ store: V, app: r._a, pinia: r, options: l }));
          (Object.keys(O || {}).forEach((T) => V._customProperties.add(T)), rt(V, O));
        } else
          rt(
            V,
            i.run(() => I({ store: V, app: r._a, pinia: r, options: l }))
          );
      }),
      V.$state &&
        typeof V.$state == 'object' &&
        typeof V.$state.constructor == 'function' &&
        !V.$state.constructor.toString().includes('[native code]') &&
        console.warn(`[🍍]: The "state" must be a plain object. It cannot be
	state: () => new MyClass()
Found in store "${V.$id}".`),
      g && o && n.hydrate && n.hydrate(V.$state, g),
      (c = !0),
      (u = !0),
      V
    );
  }
  /*! #__NO_SIDE_EFFECTS__ */ function X_(e, t, n) {
    let r;
    const s = typeof t == 'function';
    r = s ? n : t;
    function o(i, l) {
      const a = Yh();
      if (((i = i || (a ? yr(_f, null) : null)), i && Pr(i), !xi))
        throw new Error(`[🍍]: "getActivePinia()" was called but there was no active Pinia. Are you trying to use a store before calling "app.use(pinia)"?
See https://pinia.vuejs.org/core-concepts/outside-component-usage.html for help.
This will fail in production.`);
      ((i = xi), i._s.has(e) || (s ? Oi(e, t, r, i) : Rf(e, r, i), (o._pinia = i)));
      const c = i._s.get(e);
      if (l) {
        const u = '__hot:' + e,
          f = s ? Oi(u, t, r, i, !0) : Rf(u, rt({}, r), i, !0);
        (l._hotUpdate(f), delete i.state.value[u], i._s.delete(u));
      }
      if (En) {
        const u = Ss();
        if (u && u.proxy && !l) {
          const f = u.proxy,
            d = '_pStores' in f ? f._pStores : (f._pStores = {});
          d[e] = c;
        }
      }
      return c;
    }
    return ((o.$id = e), o);
  }
  const e1 = (e, t) => {
      const n = e.__vccOpts || e;
      for (const [r, s] of t) n[r] = s;
      return n;
    },
    t1 = {},
    n1 = {
      class:
        'qlfqa:!min-h-screen qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center qlfqa:sm:!pt-0 qlfqa:!bg-[#F6F4F2]'
    },
    r1 = {
      class:
        'qlfqa:!w-full qlfqa:sm:!max-w-md qlfqa:!mt-4 qlfqa:!px-6 qlfqa:!bg-[#F6F4F2] qlfqa:!overflow-hidden'
    };
  function s1(e, t) {
    return (
      H(),
      K('div', n1, [
        _('div', r1, [
          t[0] ||
            (t[0] = _(
              'img',
              {
                src: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/logo.png?v=1753083867',
                alt: 'Logo',
                style: { width: '50px !important', height: '50px !important' }
              },
              null,
              -1
            )),
          Ro(e.$slots, 'default')
        ])
      ])
    );
  }
  const o1 = e1(t1, [['render', s1]]),
    qe = X_('quiz', {
      state: () => ({
        age: null,
        gender: null,
        womenHealth: null,
        height: null,
        weight: null,
        activity: null,
        waterConsumption: null,
        climate: null,
        healthIssues: [],
        handTest: null,
        urineTest: null,
        concentration: null,
        headache: null,
        drySkin: null,
        digestion: [],
        optIn: [],
        coffeeAndEnergy: null,
        performanceLows: null,
        currentScreen: 'AgeScreen',
        screenHistory: [],
        quizCompleted: !1,
        results: null
      }),
      getters: {
        currentQuestion() {
          if (!this.gender) return null;
          const e = this.gender === 'male' ? this.maleQuestions : this.femaleQuestions;
          if (this.currentQuestionIndex < e.length) return e[this.currentQuestionIndex];
          {
            const t = this.currentQuestionIndex - e.length;
            return t < this.commonQuestions.length ? this.commonQuestions[t] : null;
          }
        },
        isFinished() {
          if (!this.gender) return !1;
          const e = this.gender === 'male' ? this.maleQuestions : this.femaleQuestions;
          return this.currentQuestionIndex >= e.length + this.commonQuestions.length;
        }
      },
      actions: {
        goToNextScreen(e = null) {
          (e && (this[this.getDataPropertyForScreen(this.currentScreen)] = e),
            this.screenHistory.push(this.currentScreen),
            (this.currentScreen = this.getNextScreen()));
        },
        goBack() {
          this.screenHistory.length > 0 && (this.currentScreen = this.screenHistory.pop());
        },
        getNextScreen() {
          const t = {
            AgeScreen: 'GenderScreen',
            GenderScreen: () => (this.gender === 'w' ? 'ExtraQuestionWomenScreen' : 'HeightScreen'),
            ExtraQuestionWomenScreen: 'HeightScreen',
            HeightScreen: 'WeightScreen',
            WeightScreen: 'ActivityScreen',
            ActivityScreen: 'HowMuchWaterScreen',
            HowMuchWaterScreen: 'ClimateScreen',
            ClimateScreen: 'HealthScreen',
            HealthScreen: 'HealthPhase2Screen',
            HealthPhase2Screen: 'HandTestScreen',
            HandTestScreen: 'UrineTestScreen',
            UrineTestScreen: 'InfoPersonScreen',
            InfoPersonScreen: 'ConcentrationScreen',
            ConcentrationScreen: 'HeadacheScreen',
            HeadacheScreen: 'DrySkinScreen',
            DrySkinScreen: 'EffectsOnSkinScreen',
            EffectsOnSkinScreen: 'DigestionScreen',
            DigestionScreen: 'DigestionInfoScreen',
            DigestionInfoScreen: 'CoffeeAndEnergyScreen',
            CoffeeAndEnergyScreen: 'PerformanceLowsScreen',
            PerformanceLowsScreen: 'EndLoadingScreen'
          }[this.currentScreen];
          return typeof t == 'function' ? t() : t;
        },
        getDataPropertyForScreen(e) {
          return (
            {
              AgeScreen: 'age',
              GenderScreen: 'gender',
              ExtraQuestionWomenScreen: 'womenHealth',
              HeightScreen: 'height',
              WeightScreen: 'weight',
              ActivityScreen: 'activity',
              HowMuchWaterScreen: 'waterConsumption',
              ClimateScreen: 'climate',
              HealthScreen: 'healthIssues',
              HandTestScreen: 'handTest',
              UrineTestScreen: 'urineTest',
              ConcentrationScreen: 'concentration',
              HeadacheScreen: 'headache',
              DrySkinScreen: 'drySkin',
              DigestionScreen: 'digestion',
              OptInScreen: 'optIn',
              CoffeeAndEnergyScreen: 'coffeeAndEnergy',
              PerformanceLowsScreen: 'performanceLows'
            }[e] || null
          );
        },
        resetQuiz() {
          this.$reset();
        },
        completeQuiz() {
          ((this.quizCompleted = !0), this.calculateResults());
        },
        calculateResults() {
          const e = (i) => Math.round(i * 100) / 100;
          let t = Math.max(2.5, e((this.weight * 35) / 1e3));
          const n = {
              nierenerkrankung: -0.1,
              herzerkrankung: -0.05,
              schwangerschaft: 0.3,
              stillzeit: 0.5
            },
            r = this.healthIssues.find((i) => n[i]) || null,
            s = r ? t * n[r] : 0,
            o = e(t * this.activity + t * (this.age / 100) + t * (this.climate / 100) + s);
          this.results = { hydrationScore: e(o), foodIntake: e(o * 0.2), waterIntake: e(o * 0.8) };
        }
      }
    }),
    i1 = {
      class: 'qlfqa:!w-full qlfqa:!bg-gray-200 qlfqa:!h-[5px] qlfqa:!mb-4 qlfqa:!rounded-full'
    },
    l1 = {
      __name: 'LoadingBar',
      props: { currentScreen: { type: String, required: !0 } },
      setup(e) {
        const t = e,
          n = [
            'AgeScreen',
            'GenderScreen',
            'ExtraQuestionWomenScreen',
            'HeightScreen',
            'WeightScreen',
            'ActivityScreen',
            'HowMuchWaterScreen',
            'ClimateScreen',
            'HealthScreen',
            'HealthPhase2Screen',
            'HandTestScreen',
            'UrineTestScreen',
            'InfoPersonScreen',
            'ConcentrationScreen',
            'HeadacheScreen',
            'DrySkinScreen',
            'EffectsOnSkinScreen',
            'DigestionScreen',
            'DigestionInfoScreen',
            'CoffeeAndEnergyScreen',
            'PerformanceLowsScreen',
            'EndLoadingScreen'
          ],
          r = ee(() => {
            const s = n.indexOf(t.currentScreen);
            if (s === -1) return 0;
            const o = s / (n.length - 1),
              i = Math.pow(o, 0.5);
            return Math.round(i * 100);
          });
        return (s, o) => (
          H(),
          K('div', i1, [
            _(
              'div',
              {
                class:
                  'qlfqa:!bg-yellow-400 qlfqa:!h-full qlfqa:!transition-all qlfqa:!duration-300 qlfqa:!rounded-full',
                style: On({ width: `${r.value}%` })
              },
              null,
              4
            )
          ])
        );
      }
    },
    a1 = ['disabled'],
    Df = {
      __name: 'ImageButton',
      props: {
        text: { type: String, default: 'Weiter' },
        disabled: { type: Boolean, default: !1 },
        variant: { type: String, default: 'primary' },
        customClass: { type: String, default: '' }
      },
      emits: ['click'],
      setup(e, { emit: t }) {
        const n = e,
          r = t,
          s = ee(() => {
            const i = 'qlfqa:!px-2 qlfqa:!py-2',
              l = { primary: 'qlfqa:hover:!cursor-pointer qlfqa:!text-white' };
            return `${i} ${l[n.variant] || l.primary} ${n.customClass}`;
          }),
          o = (i) => {
            r('click', i);
          };
        return (i, l) => (
          H(),
          K(
            'button',
            { onClick: o, disabled: e.disabled, class: Xe(s.value) },
            [Ro(i.$slots, 'default', {}, () => [ut(ot(e.text), 1)])],
            10,
            a1
          )
        );
      }
    },
    u1 = () => {
      const e = (r) => {
        let s = r.replace('https:', ''),
          o = [],
          i = s.lastIndexOf('.'),
          l = s.substring(0, i),
          a = s.substring(i + 1);
        return (
          [250, 375, 420, 600, 782].forEach((u) => {
            o.push(`${l}_${u}x_crop_center.${a}`);
          }),
          o
        );
      };
      return {
        generateSrcSetImages: (r) => {
          const s = e(r),
            o = [250, 375, 420, 600, 782];
          return s.map((i, l) => `${i} ${o[l]}w`).join(', ');
        },
        convertImageUrlTo150: (r) => {
          let s = r.lastIndexOf('.'),
            o = r.substring(0, s),
            i = r.substring(s + 1);
          return `${o}_150x_crop_center.${i}`;
        }
      };
    },
    c1 = ['src', 'data-srcset', 'alt', 'sizes', 'srcset', 'aria-hidden'],
    xt = {
      __name: 'Image',
      props: {
        src: { type: String, required: !0 },
        alt: { type: String, default: '' },
        sizes: { type: String, default: '400px' },
        class: { type: [String, Array, Object], default: 'qlfqa:!w-full qlfqa:!h-auto' }
      },
      setup(e) {
        const { generateSrcSetImages: t } = u1(),
          n = e,
          r = ee(() => n.class);
        return (s, o) =>
          e.src
            ? (H(),
              K(
                'img',
                {
                  key: 0,
                  'data-sizes': 'auto',
                  src: e.src,
                  'data-srcset': jt(t)(e.src),
                  alt: e.alt,
                  sizes: e.sizes,
                  srcset: jt(t)(e.src),
                  class: Xe(r.value),
                  'aria-hidden': e.alt === '',
                  role: 'img'
                },
                null,
                10,
                c1
              ))
            : Pe('', !0);
      }
    },
    f1 = { class: 'qlfqa:!py-2', role: 'form', 'aria-labelledby': 'age-title' },
    d1 = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!flex-wrap',
      role: 'radiogroup',
      'aria-label': 'Wähle deine Altersgruppe'
    },
    p1 = { class: 'qlfqa:!w-full qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center' },
    h1 = nt({
      __name: 'AgeScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = se(null),
          s = [
            {
              id: 1,
              text: '18-29',
              val: '5',
              image:
                'https://cdn.shopify.com/s/files/1/0867/7068/0081/files/app-age30.jpg?v=1748946181',
              altText: ''
            },
            {
              id: 2,
              text: '30-44',
              val: '0',
              image:
                'https://cdn.shopify.com/s/files/1/0867/7068/0081/files/app-age44.jpg?v=1748946181',
              altText: ''
            },
            {
              id: 3,
              text: '45-59',
              val: '0',
              image:
                'https://cdn.shopify.com/s/files/1/0867/7068/0081/files/app-age59.jpg?v=1748946181',
              altText: ''
            },
            {
              id: 4,
              text: '60+',
              val: '10',
              image:
                'https://cdn.shopify.com/s/files/1/0867/7068/0081/files/app-age60.jpg?v=1748946181',
              altText: ''
            }
          ];
        function o(i) {
          ((r.value = i), r.value && n('next', r.value));
        }
        return (i, l) => (
          H(),
          K('div', f1, [
            l[0] ||
              (l[0] = _(
                'h1',
                {
                  id: 'age-title',
                  class: 'qlfqa:!text-2xl qlfqa:!font-medium qlfqa:!mb-4 qlfqa:!text-center'
                },
                'Der Hydration-Test',
                -1
              )),
            l[1] ||
              (l[1] = _(
                'p',
                { class: 'qlfqa:!mb-4 qlfqa:!text-center' },
                [
                  ut('Mach jetzt den Test und finde in '),
                  _('span', { class: 'qlfqa:!font-medium' }, '2 Minuten'),
                  ut(' heraus, ob dein Körper wirklich optimal versorgt ist.')
                ],
                -1
              )),
            _('div', d1, [
              (H(),
              K(
                Se,
                null,
                gr(s, (a) =>
                  j(
                    Df,
                    {
                      class: Xe([
                        'qlfqa:!w-6/12 qlfqa:!flex',
                        { 'qlfqa:!border-2 qlfqa:!border-[#FED43CFF]': r.value === a.val }
                      ]),
                      key: a.id,
                      onClick: (c) => o(a.val),
                      role: 'radio',
                      'aria-checked': r.value === a.val,
                      'aria-label': 'Altersgruppe ' + a.text
                    },
                    {
                      default: dr(() => [
                        _('span', p1, [
                          j(
                            xt,
                            {
                              src: a.image,
                              alt: 'Person in Altersgruppe ' + a.text,
                              sizes: '400px',
                              class: 'qlfqa:!w-full qlfqa:!h-auto'
                            },
                            null,
                            8,
                            ['src', 'alt']
                          )
                        ])
                      ]),
                      _: 2
                    },
                    1032,
                    ['class', 'onClick', 'aria-checked', 'aria-label']
                  )
                ),
                64
              ))
            ])
          ])
        );
      }
    }),
    m1 = { class: 'qlfqa:!py-6', role: 'form', 'aria-labelledby': 'gender-title' },
    g1 = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!flex-wrap',
      role: 'radiogroup',
      'aria-labelledby': 'gender-title'
    },
    _1 = { class: 'qlfqa:!w-full qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center' },
    y1 = nt({
      __name: 'GenderScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se(null),
          o = [
            {
              id: 1,
              text: 'Weiblich',
              val: 'w',
              image:
                'https://cdn.shopify.com/s/files/1/0867/7068/0081/files/Benefit_Funnel_Frau.jpg?v=1748964177'
            },
            {
              id: 2,
              text: 'Männlich',
              val: 'm',
              image:
                'https://cdn.shopify.com/s/files/1/0867/7068/0081/files/Benefit_Funnel_Mann.jpg?v=1748964177'
            }
          ];
        ee(() => r.screenHistory.length > 0);
        function i(l) {
          ((s.value = l), n('next', s.value));
        }
        return (l, a) => (
          H(),
          K('div', m1, [
            a[0] ||
              (a[0] = _(
                'h1',
                {
                  id: 'gender-title',
                  class: 'qlfqa:!text-2xl qlfqa:!font-medium qlfqa:!mb-4 qlfqa:!text-center'
                },
                'Wähle dein Geschlecht',
                -1
              )),
            a[1] ||
              (a[1] = _(
                'p',
                { class: 'qlfqa:!mb-4 qlfqa:!text-center' },
                ' Wir nutzen diese Angaben, um deinen Plan zu personalisieren. ',
                -1
              )),
            _('div', g1, [
              (H(),
              K(
                Se,
                null,
                gr(o, (c) =>
                  j(
                    Df,
                    {
                      class: 'qlfqa:!w-6/12 qlfqa:!flex',
                      key: c.id,
                      onClick: (u) => i(c.val),
                      role: 'radio',
                      'aria-checked': s.value === c.val,
                      'aria-label': c.text
                    },
                    {
                      default: dr(() => [
                        _('span', _1, [
                          c.image
                            ? (H(),
                              hn(
                                xt,
                                {
                                  key: 0,
                                  src: c.image,
                                  alt: c.text,
                                  sizes: '400px',
                                  class: 'qlfqa:!w-full qlfqa:!h-auto'
                                },
                                null,
                                8,
                                ['src', 'alt']
                              ))
                            : Pe('', !0)
                        ])
                      ]),
                      _: 2
                    },
                    1032,
                    ['onClick', 'aria-checked', 'aria-label']
                  )
                ),
                64
              ))
            ])
          ])
        );
      }
    }),
    v1 = {
      class:
        'qlfqa:!mt-2 qlfqa:!grid qlfqa:!grid-cols-1 qlfqa:!gap-y-3 qlfqa:sm:!gap-x-4 qlfqa:!w-full'
    },
    q1 = ['onClick', 'onKeydown', 'aria-checked', 'aria-label', 'aria-description'],
    b1 = ['onMouseenter'],
    E1 = { class: 'qlfqa:!flex qlfqa:!flex-1' },
    w1 = { class: 'qlfqa:!flex qlfqa:!items-center' },
    x1 = { class: 'qlfqa:!block qlfqa:!text-sm qlfqa:!font-medium qlfqa:!text-gray-900' },
    S1 = {
      key: 0,
      class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!justify-center qlfqa:!text-yellow-300'
    },
    St = {
      __name: 'SelectionGroup',
      props: {
        modelValue: { type: [String, Number], default: null },
        options: { type: Array, default: null }
      },
      emits: ['update:modelValue'],
      setup(e, { emit: t }) {
        const n = e,
          r = t,
          s = se(n.modelValue),
          o = se(null);
        (at(
          () => n.modelValue,
          (l) => {
            s.value = l;
          }
        ),
          at(s, (l) => {
            r('update:modelValue', l);
          }));
        function i(l) {
          s.value = l;
        }
        return (l, a) => (
          H(),
          K('div', v1, [
            (H(!0),
            K(
              Se,
              null,
              gr(
                e.options,
                (c) => (
                  H(),
                  K(
                    'div',
                    {
                      key: c.id,
                      class: 'qlfqa:!flex-1',
                      onClick: (u) => i(c.val),
                      onKeydown: ku(
                        Ou((u) => i(c.val), ['prevent']),
                        ['space']
                      ),
                      tabindex: '0',
                      role: 'radio',
                      'aria-checked': s.value === c.val,
                      'aria-label': c.text,
                      'aria-description': `Select ${c.text}`
                    },
                    [
                      _(
                        'div',
                        {
                          class: Xe([
                            s.value === c.val
                              ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                              : 'qlfqa:!border-gray-300',
                            o.value === c.val
                              ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                              : '',
                            'qlfqa:!relative qlfqa:!flex qlfqa:!cursor-pointer qlfqa:!rounded-lg qlfqa:!h-14 qlfqa:!border qlfqa:!bg-white qlfqa:!p-4 qlfqa:!shadow-md qlfqa:focus:!outline-none'
                          ]),
                          onMouseenter: (u) => (o.value = c.val),
                          onMouseleave: a[0] || (a[0] = (u) => (o.value = null))
                        },
                        [
                          _('span', E1, [_('span', w1, [_('span', x1, ot(c.text), 1)])]),
                          s.value === c.val
                            ? (H(),
                              K(
                                'span',
                                S1,
                                a[1] ||
                                  (a[1] = [
                                    _(
                                      'svg',
                                      {
                                        xmlns: 'http://www.w3.org/2000/svg',
                                        viewBox: '0 0 24 24',
                                        fill: 'currentColor',
                                        class: 'qlfqa:!size-5'
                                      },
                                      [
                                        _('path', {
                                          'fill-rule': 'evenodd',
                                          d: 'M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z',
                                          'clip-rule': 'evenodd'
                                        })
                                      ],
                                      -1
                                    )
                                  ])
                              ))
                            : Pe('', !0),
                          _(
                            'span',
                            {
                              class: Xe([
                                o.value === c.val ? 'qlfqa:!border' : 'qlfqa:!border-2',
                                s.value === c.val
                                  ? 'qlfqa:!border-yellow-300'
                                  : 'qlfqa:!border-transparent',
                                'qlfqa:!pointer-events-none qlfqa:!absolute qlfqa:!-inset-px qlfqa:!rounded-lg'
                              ]),
                              'aria-hidden': 'true'
                            },
                            null,
                            2
                          )
                        ],
                        42,
                        b1
                      )
                    ],
                    40,
                    q1
                  )
                )
              ),
              128
            ))
          ])
        );
      }
    },
    C1 = { class: 'qlfqa:!mt-5 qlfqa:!flex qlfqa:!gap-4' },
    A1 = ['disabled'],
    T1 = ['disabled'],
    Ue = nt({
      __name: 'NavigationButtons',
      props: {
        showBackButton: { type: Boolean, default: !0 },
        disableContinue: { type: Boolean, default: !1 },
        backText: { type: String, default: 'Zurück' },
        continueText: { type: String, default: 'Weiter' }
      },
      emits: ['back', 'continue'],
      setup(e, { emit: t }) {
        const n = e,
          r = t,
          s = (o) => {
            o.key === 'Enter' && !n.disableContinue && r('continue');
          };
        return (
          mr(() => {
            window.addEventListener('keydown', s);
          }),
          vs(() => {
            window.removeEventListener('keydown', s);
          }),
          (o, i) => (
            H(),
            K('div', C1, [
              _(
                'button',
                {
                  onClick: i[0] || (i[0] = (l) => o.$emit('back')),
                  disabled: !e.showBackButton,
                  class:
                    'qlfqa:!border qlfqa:!border-solid qlfqa:!border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                },
                ot(e.backText),
                9,
                A1
              ),
              _(
                'button',
                {
                  onClick: i[1] || (i[1] = (l) => o.$emit('continue')),
                  disabled: e.disableContinue,
                  class:
                    'qlfqa:!bg-custom-yellow qlfqa:!text-[#131313] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-1/2 qlfqa:!font-medium'
                },
                ot(e.continueText),
                9,
                T1
              )
            ])
          )
        );
      }
    }),
    O1 = { class: 'qlfqa:!py-2' },
    k1 = { class: 'qlfqa:!flex' },
    I1 = {
      __name: 'ExtraQuestionWomenScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se(null),
          o = [
            { id: 1, text: 'Schwangerschaft', val: 'schwangerschaft' },
            { id: 2, text: 'Stillzeit', val: 'stillzeit' },
            { id: 3, text: 'Nein', val: '0' }
          ],
          i = ee(() => r.screenHistory.length > 0);
        function l() {
          n('next', s.value);
        }
        function a() {
          r.goBack();
        }
        return (c, u) => (
          H(),
          K('div', O1, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Befindest Du dich aktuell in einer Schwangerschaft oder Stillzeit?',
                -1
              )),
            _('div', k1, [
              j(
                St,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: s.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (f) => (s.value = f))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            j(
              Ue,
              { showBackButton: i.value, disableContinue: !s.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    },
    R1 = { class: 'qlfqa:!py-2' },
    D1 = {
      class:
        'qlfqa:!mt-8 qlfqa:!flex qlfqa:!items-center qlfqa:!bg-transparent qlfqa:!border-b qlfqa:!pr-3 qlfqa:!border-yellow-300 qlfqa:focus:!border-yellow-400 qlfqa:focus:!border-b qlfqa:focus:!ring-yellow-300 qlfqa:!rounded-t-md'
    },
    P1 = { key: 0, class: 'qlfqa:!text-red-500 qlfqa:!mt-2 qlfqa:!text-sm' },
    B1 = nt({
      __name: 'HeightScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se(null),
          o = se(''),
          i = ee(() => r.screenHistory.length > 0);
        function l() {
          c({ target: { value: s.value } }) && n('next', s.value);
        }
        function a() {
          r.goBack();
        }
        function c(u) {
          const f = u.target.value;
          if (f === '') {
            o.value = '';
            return;
          }
          const d = Number(f);
          return d < 60
            ? ((o.value = 'Größe muss mindestens 60 cm betragen.'), !1)
            : d > 250
              ? ((o.value = 'Größe darf maximal 250 cm betragen.'), !1)
              : ((o.value = ''), !0);
        }
        return (u, f) => (
          H(),
          K('div', R1, [
            f[2] ||
              (f[2] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie groß bist du?',
                -1
              )),
            _('div', D1, [
              sa(
                _(
                  'input',
                  {
                    type: 'number',
                    'onUpdate:modelValue': f[0] || (f[0] = (d) => (s.value = d)),
                    'aria-label': 'Gebe deine Größe ein',
                    min: '30',
                    max: '250',
                    class:
                      'qlfqa:!border-none qlfqa:!block qlfqa:!min-w-0 qlfqa:!grow qlfqa:!px-4 qlfqa:!py-2 qlfqa:focus:!outline-0 qlfqa:!text-[3em] qlfqa:!font-semibold qlfqa:!text-center qlfqa:!w-full qlfqa:!box-border'
                  },
                  null,
                  512
                ),
                [[Tu, s.value]]
              ),
              f[1] || (f[1] = _('div', null, 'cm', -1))
            ]),
            o.value ? (H(), K('div', P1, ot(o.value), 1)) : Pe('', !0),
            j(
              Ue,
              { showBackButton: i.value, disableContinue: !s.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    $1 = { class: 'qlfqa:!py-2' },
    F1 = {
      class:
        'qlfqa:!mt-8 qlfqa:!flex qlfqa:!items-center qlfqa:!bg-transparent qlfqa:!border-b qlfqa:!pr-3 qlfqa:!border-yellow-300 qlfqa:focus:!border-yellow-400 qlfqa:focus:!border-b qlfqa:focus:!ring-yellow-300 qlfqa:!rounded-t-md'
    },
    N1 = { key: 0, class: 'qlfqa:!text-red-500 qlfqa:!mt-2 qlfqa:!text-sm' },
    L1 = nt({
      __name: 'WeightScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se(null),
          o = se(''),
          i = ee(() => r.screenHistory.length > 0);
        function l() {
          c({ target: { value: s.value } }) && n('next', s.value);
        }
        function a() {
          r.goBack();
        }
        function c(u) {
          const f = u.target.value;
          if (f === '') {
            o.value = '';
            return;
          }
          const d = Number(f);
          return d < 30
            ? ((o.value = 'Gewicht muss mindestens 30 kg betragen.'), !1)
            : d > 250
              ? ((o.value = 'Gewicht darf 250 kg nicht überschreiten.'), !1)
              : ((o.value = ''), !0);
        }
        return (u, f) => (
          H(),
          K('div', $1, [
            f[2] ||
              (f[2] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Was ist dein aktuelles Gewicht?',
                -1
              )),
            _('div', F1, [
              sa(
                _(
                  'input',
                  {
                    type: 'number',
                    'onUpdate:modelValue': f[0] || (f[0] = (d) => (s.value = d)),
                    'aria-label': 'Enter your weight',
                    min: '30',
                    max: '250',
                    class:
                      'qlfqa:!border-none qlfqa:!font-semibold qlfqa:!block qlfqa:!min-w-0 qlfqa:!grow qlfqa:!px-4 qlfqa:!py-3 qlfqa:focus:!outline-0 qlfqa:!text-[3em] qlfqa:!text-center'
                  },
                  null,
                  512
                ),
                [[Tu, s.value]]
              ),
              f[1] || (f[1] = _('div', null, 'kg', -1))
            ]),
            o.value ? (H(), K('div', N1, ot(o.value), 1)) : Pe('', !0),
            j(
              Ue,
              { showBackButton: i.value, disableContinue: !s.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    V1 = { class: 'qlfqa:!py-2' },
    M1 = { class: 'qlfqa:!flex' },
    U1 = {
      __name: 'ActivityScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se(null),
          o = [
            { id: 1, text: 'Wenig Bewegung', val: '1.375' },
            { id: 2, text: 'Moderate Bewegung', val: '1.55' },
            { id: 3, text: 'Viel Bewegung', val: '1.725' },
            { id: 4, text: 'Sehr viel Bewegung', val: '1.9' }
          ],
          i = ee(() => r.screenHistory.length > 0);
        function l() {
          n('next', s.value);
        }
        function a() {
          r.goBack();
        }
        return (c, u) => (
          H(),
          K('div', V1, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie viel Bewegung hast du pro Woche?',
                -1
              )),
            _('div', M1, [
              j(
                St,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: s.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (f) => (s.value = f))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            j(
              Ue,
              { showBackButton: i.value, disableContinue: !s.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    },
    H1 = { class: 'qlfqa:!py-2' },
    j1 = { class: 'qlfqa:!flex' },
    z1 = {
      __name: 'HowMuchWaterScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se(null),
          o = [
            { id: 1, text: 'Weniger als 1 Liter', val: '-1' },
            { id: 2, text: '1 - 1,5 Liter', val: '1 - 1.5' },
            { id: 3, text: '1,5 - 2 Liter', val: '1.5 - 2' },
            { id: 4, text: 'Mehr als 2 Liter', val: '2+' }
          ],
          i = ee(() => r.screenHistory.length > 0);
        function l() {
          n('next', s.value);
        }
        function a() {
          r.goBack();
        }
        return (c, u) => (
          H(),
          K('div', H1, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Wie viel trinkst du an einem durchschnittlichen Tag (inkl. Kaffee, Tee, Wasser, Softdrinks)?',
                -1
              )),
            _('div', j1, [
              j(
                St,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: s.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (f) => (s.value = f))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            j(
              Ue,
              { showBackButton: i.value, disableContinue: !s.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    },
    K1 = { class: 'qlfqa:!py-2' },
    W1 = { class: 'qlfqa:!flex' },
    G1 = {
      __name: 'ClimateScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se(null),
          o = [
            { id: 1, text: 'Normal (20 - 25 °C)', val: '0' },
            { id: 2, text: 'Heiß  (über 25 °C)', val: '30' },
            { id: 3, text: 'Heiß & Feucht', val: '40' },
            { id: 4, text: 'Kälter  (unter 20 °C)', val: '-5' }
          ],
          i = ee(() => r.screenHistory.length > 0);
        function l() {
          n('next', s.value);
        }
        function a() {
          r.goBack();
        }
        return (c, u) => (
          H(),
          K('div', K1, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Was beschreibt das aktuelle Wetter bzw. Klima bei dir am besten?',
                -1
              )),
            _('div', W1, [
              j(
                St,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: s.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (f) => (s.value = f))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            j(
              Ue,
              { showBackButton: i.value, disableContinue: !s.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    },
    J1 = {
      class:
        'qlfqa:!grid qlfqa:!grid-cols-1 qlfqa:!gap-y-3 qlfqa:sm:!gap-x-4 qlfqa:!w-full qlfqa:!flex'
    },
    Y1 = ['onClick'],
    Q1 = { class: 'qlfqa:!flex qlfqa:!flex-1' },
    Z1 = { class: 'qlfqa:!flex qlfqa:!items-center' },
    X1 = { class: 'qlfqa:!block qlfqa:!text-sm qlfqa:!font-medium qlfqa:!text-gray-900' },
    ey = {
      key: 0,
      class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!justify-center qlfqa:!text-yellow-300'
    },
    ty = { class: 'qlfqa:!flex qlfqa:!flex-1' },
    ny = { class: 'qlfqa:!flex qlfqa:!items-center' },
    ry = { class: 'qlfqa:!block qlfqa:!text-sm qlfqa:!font-medium qlfqa:!text-gray-900' },
    sy = {
      key: 0,
      class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!justify-center qlfqa:!text-yellow-300'
    },
    Pf = {
      __name: 'MultiSelectionGroup',
      props: {
        modelValue: { type: Array, default: () => [] },
        checkboxOptions: { type: Array, default: () => [] },
        exclusiveOption: { type: Object, default: null }
      },
      emits: ['update:modelValue'],
      setup(e, { emit: t }) {
        const n = e,
          r = t,
          s = se(!1);
        at(
          () => n.modelValue,
          (l) => {
            n.exclusiveOption && l.includes(n.exclusiveOption.val)
              ? (s.value = !0)
              : (s.value = !1);
          },
          { immediate: !0 }
        );
        function o(l) {
          if (s.value) {
            ((s.value = !1), r('update:modelValue', [l.val]));
            return;
          }
          const a = [...n.modelValue],
            c = a.indexOf(l.val);
          (c === -1 ? a.push(l.val) : a.splice(c, 1), r('update:modelValue', a));
        }
        function i() {
          ((s.value = !s.value),
            s.value ? r('update:modelValue', [n.exclusiveOption.val]) : r('update:modelValue', []));
        }
        return (l, a) => (
          H(),
          K('div', J1, [
            (H(!0),
            K(
              Se,
              null,
              gr(
                e.checkboxOptions,
                (c) => (
                  H(),
                  K(
                    'div',
                    {
                      key: c.id,
                      onClick: (u) => o(c),
                      class: Xe([
                        'qlfqa:!h-14 qlfqa:!flex qlfqa:!cursor-pointer qlfqa:!rounded-lg qlfqa:!border qlfqa:!bg-white qlfqa:!p-4 qlfqa:!shadow-md qlfqa:focus:!outline-none',
                        [
                          e.modelValue.includes(c.val)
                            ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                            : 'qlfqa:!border-gray-300'
                        ]
                      ])
                    },
                    [
                      _('span', Q1, [_('span', Z1, [_('span', X1, ot(c.text), 1)])]),
                      e.modelValue.includes(c.val)
                        ? (H(),
                          K(
                            'span',
                            ey,
                            a[0] ||
                              (a[0] = [
                                _(
                                  'svg',
                                  {
                                    xmlns: 'http://www.w3.org/2000/svg',
                                    viewBox: '0 0 24 24',
                                    fill: 'currentColor',
                                    class: 'qlfqa:!size-6'
                                  },
                                  [
                                    _('path', {
                                      'fill-rule': 'evenodd',
                                      d: 'M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z',
                                      'clip-rule': 'evenodd'
                                    })
                                  ],
                                  -1
                                )
                              ])
                          ))
                        : Pe('', !0)
                    ],
                    10,
                    Y1
                  )
                )
              ),
              128
            )),
            e.exclusiveOption
              ? (H(),
                K(
                  'div',
                  {
                    key: 0,
                    onClick: i,
                    class: Xe([
                      'qlfqa:!h-14 qlfqa:!flex qlfqa:!cursor-pointer qlfqa:!rounded-lg qlfqa:!border qlfqa:!bg-white qlfqa:!p-4 qlfqa:!shadow-md qlfqa:focus:!outline-none',
                      [
                        s.value
                          ? 'qlfqa:!border-yellow-300 qlfqa:!ring-1 qlfqa:!ring-yellow-300'
                          : 'qlfqa:!border-gray-300'
                      ]
                    ])
                  },
                  [
                    _('span', ty, [_('span', ny, [_('span', ry, ot(e.exclusiveOption.text), 1)])]),
                    s.value
                      ? (H(),
                        K(
                          'span',
                          sy,
                          a[1] ||
                            (a[1] = [
                              _(
                                'svg',
                                {
                                  xmlns: 'http://www.w3.org/2000/svg',
                                  viewBox: '0 0 24 24',
                                  fill: 'currentColor',
                                  class: 'qlfqa:!size-6'
                                },
                                [
                                  _('path', {
                                    'fill-rule': 'evenodd',
                                    d: 'M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z',
                                    'clip-rule': 'evenodd'
                                  })
                                ],
                                -1
                              )
                            ])
                        ))
                      : Pe('', !0)
                  ],
                  2
                ))
              : Pe('', !0)
          ])
        );
      }
    },
    oy = { class: 'qlfqa:!py-2' },
    iy = {
      __name: 'HealthScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se([]),
          o = se(!1),
          i = [
            { id: 1, text: 'Nierenerkrankung (ärztliche Absprache)', val: 'nierenerkrankung' },
            { id: 2, text: 'Herzerkrankung (ärztliche Absprache)', val: 'herzerkrankung' }
          ],
          l = { id: 3, text: 'Nein, keine davon', val: '0' },
          a = ee(() => r.screenHistory.length > 0),
          c = ee(() => s.value.length > 0 || o.value);
        function u() {
          let d = [];
          (o.value ? (d = [l.val]) : (d = s.value), n('next', d));
        }
        function f() {
          r.goBack();
        }
        return (d, h) => (
          H(),
          K('div', oy, [
            h[1] ||
              (h[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Trifft eine dieser Diagnosen auf dich zu?',
                -1
              )),
            j(
              Pf,
              {
                modelValue: s.value,
                'onUpdate:modelValue': h[0] || (h[0] = (g) => (s.value = g)),
                class: 'qlfqa:!mt-2',
                checkboxOptions: i,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            j(
              Ue,
              { showBackButton: a.value, disableContinue: !c.value, onBack: f, onContinue: u },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    },
    ly = { class: 'qlfqa:!py-2' },
    ay = nt({
      __name: 'HealthPhase2Screen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se('checked');
        ee(() => r.screenHistory.length > 0);
        function o() {
          n('next', s.value);
        }
        return (i, l) => (
          H(),
          K('div', ly, [
            l[0] ||
              (l[0] = Za(
                '<h2 class="qlfqa:!text-lg qlfqa:!font-medium qlfqa:!mb-2">Phase 2: Symptom-Check</h2><p class="qlfqa:!mb-4"> Danke für deine Angaben - Im 2. Schritt gehen wir nun typische Symptome durch, um dir eine optimale Empfehlung aussprechen zu können. </p><div class="qlfqa:!w-full qlfqa:!border-b qlfqa:!border-gray-700 qlfqa:!mb-4"></div><div class="qlfqa:!mb-4"><div class="qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2"><span class="qlfqa:!h-2 qlfqa:!w-2 qlfqa:!rounded-full qlfqa:!bg-green-500"></span><p class="qlfqa:!mb-0"><span class="qlfqa:!font-medium">Empfehlung:</span> So viel solltest Du trinken</p></div><div class="qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2"><span class="qlfqa:!h-2 qlfqa:!w-2 qlfqa:!rounded-full qlfqa:!bg-green-500"></span><p class="qlfqa:!mb-0"><span class="qlfqa:!font-medium">Besser hydriert:</span> Wissenschaftliche Strategien</p></div></div><div class="qlfqa:!w-full qlfqa:!border-b qlfqa:!border-gray-700 qlfqa:!mb-4"></div><p> Viele denken, sie trinken genug - trotzdem können einige dieser <span class="qlfqa:!font-medium">Folgen der Dehydration</span> auftreten. </p><div class="qlfqa:!mt-2 qlfqa:!px-4 qlfqa:!py-2 qlfqa:!bg-white qlfqa:!shadow-md qlfqa:!rounded-md qlfqa:!text-[0.9rem]"><h3 class="qlfqa:!text-[1.1rem] qlfqa:!font-bold qlfqa:!mb-2">Risiken einer Dehydration</h3><p class="qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2 qlfqa:!mb-3 qlfqa:!font-bold"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="red" class="qlfqa:!size-5"><path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd"></path></svg> Müdigkeit &amp; Energielosigkeit </p><p class="qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2 qlfqa:!mb-3 qlfqa:!font-bold"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="red" class="qlfqa:!size-5"><path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd"></path></svg> Konzentrationsprobleme &amp; Brain Fog </p><p class="qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2 qlfqa:!mb-3 qlfqa:!font-bold"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="red" class="qlfqa:!size-5"><path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd"></path></svg> Kopfschmerzen &amp; Migräneanfälle </p><p class="qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2 qlfqa:!mb-3 qlfqa:!font-bold"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="red" class="qlfqa:!size-5"><path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd"></path></svg> Verdauungsprobleme &amp; träger Stoffwechsel </p><p class="qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2 qlfqa:!mb-3 qlfqa:!font-bold"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="red" class="qlfqa:!size-5"><path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd"></path></svg> Trockene Haut &amp; schlechte Regeneration </p></div>',
                7
              )),
            _('div', { class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!justify-center' }, [
              _(
                'button',
                {
                  onClick: o,
                  class:
                    'qlfqa:!text-white qlfqa:!font-medium qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:!cursor-pointer qlfqa:!w-full qlfqa:!bg-[#323232]'
                },
                ' Weiter '
              )
            ])
          ])
        );
      }
    }),
    uy = { class: 'qlfqa:!py-2', role: 'form', 'aria-labelledby': 'hand-test-title' },
    cy = {
      class:
        'qlfqa:!grid qlfqa:!grid-cols-3 qlfqa:!gap-2 qlfqa:!hyphens-auto qlfqa:!text-[0.8rem] qlfqa:!mb-4',
      role: 'group',
      'aria-label': 'Anleitung zum Handrücken-Test'
    },
    fy = {
      class: 'qlfqa:!col-span-1 qlfqa:!items-center qlfqa:!justify-center qlfqa:!mr-1',
      role: 'figure',
      'aria-labelledby': 'step1-desc'
    },
    dy = {
      class: 'qlfqa:!col-span-1 qlfqa:!items-center qlfqa:!justify-center qlfqa:!mr-1',
      role: 'figure',
      'aria-labelledby': 'step2-desc'
    },
    py = {
      class: 'qlfqa:!col-span-1 qlfqa:!items-center qlfqa:!justify-center',
      role: 'figure',
      'aria-labelledby': 'step3-desc'
    },
    hy = { class: 'qlfqa:!flex', role: 'radiogroup', 'aria-labelledby': 'hand-test-title' },
    my = nt({
      __name: 'HandTestScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se(null),
          o = [
            { id: 1, text: 'Sofort', val: 'schwangerschaft' },
            { id: 2, text: 'Leicht verzögert', val: 'stillzeit' }
          ],
          i = ee(() => r.screenHistory.length > 0);
        function l() {
          n('next', s.value);
        }
        function a() {
          r.goBack();
        }
        return (c, u) => (
          H(),
          K('div', uy, [
            u[4] ||
              (u[4] = _(
                'h2',
                { id: 'hand-test-title', class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Handrücken-Check: Wie schnell oder langsam geht deine Haut zurück?',
                -1
              )),
            _('div', cy, [
              _('div', fy, [
                j(xt, {
                  src: 'https://cdn.shopify.com/s/files/1/0867/7068/0081/files/handruecken_01.jpg?v=1750319603',
                  alt: 'Handtest Schritt 1',
                  sizes: '100px',
                  class: 'qlfqa:!w-auto qlfqa:!h-26 qlfqa:!rounded-md'
                }),
                u[1] ||
                  (u[1] = _(
                    'p',
                    { id: 'step1-desc', class: 'qlfqa:!mt-2' },
                    'Leicht etwas Haut am Handrücken zusammenkneifen',
                    -1
                  ))
              ]),
              _('div', dy, [
                j(xt, {
                  src: 'https://cdn.shopify.com/s/files/1/0867/7068/0081/files/handruecken_02.jpg?v=1750319603',
                  alt: 'Handtest Schritt 2',
                  sizes: '100px',
                  class: 'qlfqa:!w-auto qlfqa:!h-26 qlfqa:!rounded-md'
                }),
                u[2] ||
                  (u[2] = _(
                    'p',
                    { id: 'step2-desc', class: 'qlfqa:!mt-2' },
                    '1 cm hochziehen und für 2s halten, dann loslassen',
                    -1
                  ))
              ]),
              _('div', py, [
                j(xt, {
                  src: 'https://cdn.shopify.com/s/files/1/0867/7068/0081/files/handruecken_03.jpg?v=1750319603',
                  alt: 'Handtest Schritt 3',
                  sizes: '100px',
                  class: 'qlfqa:!w-auto qlfqa:!h-26 qlfqa:!rounded-md'
                }),
                u[3] ||
                  (u[3] = _(
                    'p',
                    { id: 'step3-desc', class: 'qlfqa:!mt-2' },
                    'Wie schnell zieht sich deine Haut wieder zurück?',
                    -1
                  ))
              ])
            ]),
            _('div', hy, [
              j(
                St,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: s.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (f) => (s.value = f))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            j(
              Ue,
              { showBackButton: i.value, disableContinue: !s.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    gy = {
      class:
        'qlfqa:!flex qlfqa:!gap-4 qlfqa:sm:!gap-4 qlfqa:!justify-center qlfqa:!w-full qlfqa:!flex-wrap'
    },
    _y = ['onClick', 'onKeydown', 'aria-checked', 'aria-label', 'onMouseenter'],
    yy = { key: 0, class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!justify-center qlfqa:!h-full' },
    vy = {
      __name: 'ColorSelectionGroup',
      props: {
        modelValue: { type: [String, Number], default: null },
        colors: { type: Array, default: null }
      },
      emits: ['update:modelValue'],
      setup(e, { emit: t }) {
        const n = e,
          r = t,
          s = se(n.modelValue),
          o = se(null);
        (at(
          () => n.modelValue,
          (l) => {
            s.value = l;
          }
        ),
          at(s, (l) => {
            r('update:modelValue', l);
          }));
        function i(l) {
          s.value = l;
        }
        return (l, a) => (
          H(),
          K('div', gy, [
            (H(!0),
            K(
              Se,
              null,
              gr(
                e.colors,
                (c) => (
                  H(),
                  K(
                    'div',
                    {
                      key: c.id,
                      onClick: (u) => i(c.val),
                      onKeydown: ku(
                        Ou((u) => i(c.val), ['prevent']),
                        ['space']
                      ),
                      tabindex: '0',
                      role: 'radio',
                      'aria-checked': s.value === c.val,
                      'aria-label': c.name,
                      class: Xe([
                        'qlfqa:!cursor-pointer qlfqa:!flex-grow qlfqa:!min-w-10 qlfqa:!min-h-10 qlfqa:!max-w-20 qlfqa:!max-h-20 qlfqa:!aspect-square qlfqa:!rounded-md qlfqa:!shadow-md qlfqa:!transition-all qlfqa:!duration-200',
                        [
                          s.value === c.val
                            ? 'qlfqa:!ring-4 qlfqa:!ring-yellow-300 qlfqa:!scale-110'
                            : 'qlfqa:!ring-1 qlfqa:!ring-gray-300',
                          o.value === c.val ? 'qlfqa:!ring-2 qlfqa:!ring-yellow-200' : ''
                        ]
                      ]),
                      style: On({ backgroundColor: c.hex }),
                      onMouseenter: (u) => (o.value = c.val),
                      onMouseleave: a[0] || (a[0] = (u) => (o.value = null))
                    },
                    [
                      s.value === c.val
                        ? (H(),
                          K(
                            'div',
                            yy,
                            a[1] ||
                              (a[1] = [
                                _(
                                  'svg',
                                  {
                                    xmlns: 'http://www.w3.org/2000/svg',
                                    viewBox: '0 0 24 24',
                                    fill: 'white',
                                    class: 'qlfqa:!size-6 qlfqa:sm:!size-8'
                                  },
                                  [
                                    _('path', {
                                      'fill-rule': 'evenodd',
                                      d: 'M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z',
                                      'clip-rule': 'evenodd'
                                    })
                                  ],
                                  -1
                                )
                              ])
                          ))
                        : Pe('', !0)
                    ],
                    46,
                    _y
                  )
                )
              ),
              128
            ))
          ])
        );
      }
    },
    qy = { class: 'qlfqa:!py-2' },
    by = { class: 'qlfqa:!flex qlfqa:!mt-4' },
    Ey = {
      __name: 'UrineTestScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se(null),
          o = [
            { id: 1, name: 'Yellow', val: 'yellow', hex: '#F2F7CE' },
            { id: 2, name: 'Orange', val: 'orange', hex: '#F7F4B0' },
            { id: 3, name: 'Red', val: 'red', hex: '#F5EA58' },
            { id: 4, name: 'Blue', val: 'blue', hex: '#EED24D' },
            { id: 5, name: 'Green', val: 'green', hex: '#E1A744' }
          ],
          i = ee(() => r.screenHistory.length > 0);
        function l() {
          n('next', s.value);
        }
        function a() {
          r.goBack();
        }
        return (c, u) => (
          H(),
          K('div', qy, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Welche Farbe hat dein Urin die meiste Zeit?',
                -1
              )),
            u[2] ||
              (u[2] = _(
                'p',
                { class: 'qlfqa:mb-4 qlfqa:italic' },
                'Tippe auf die Farbe, welche am meisten zutrifft.',
                -1
              )),
            _('div', by, [
              j(
                vy,
                {
                  class: 'qlfqa:!flex',
                  colors: o,
                  modelValue: s.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (f) => (s.value = f))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            j(
              Ue,
              { showBackButton: i.value, disableContinue: !s.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    },
    wy = { class: 'qlfqa:!py-4', role: 'article', 'aria-labelledby': 'info-title' },
    xy = { class: 'qlfqa:!w-full' },
    Sy = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!justify-center qlfqa:!gap-4',
      role: 'group',
      'aria-label': 'Navigation'
    },
    Cy = ['disabled', 'aria-disabled'],
    Ay = nt({
      __name: 'InfoPersonScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se('checked'),
          o = ee(() => r.screenHistory.length > 0);
        function i() {
          n('next', s.value);
        }
        function l() {
          r.goBack();
        }
        return (a, c) => (
          H(),
          K('div', wy, [
            c[0] ||
              (c[0] = _(
                'h2',
                { id: 'info-title', class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                ' Wusstest Du, dass mehr als jede 2. Person zu wenig trinkt und durchgängig dehydriert ist? ',
                -1
              )),
            c[1] ||
              (c[1] = _(
                'p',
                { class: 'qlfqa:!text-gray-400 qlfqa:italic qlfqa:!text-sm' },
                ' Weltweit erreichen weniger als 50% der Frauen und etwa 60% der Männer den von der EFSA festgelegten Wert für Wasser aus Flüssigkeiten nicht. ',
                -1
              )),
            _('div', xy, [
              j(xt, {
                src: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Person-Wasser1.jpg?v=1754590492',
                alt: 'Person mit Wasser',
                sizes: '400px',
                class: 'qlfqa:!w-full qlfqa:!h-auto'
              })
            ]),
            _('div', Sy, [
              _(
                'button',
                {
                  onClick: l,
                  disabled: !o.value,
                  'aria-disabled': !o.value,
                  'aria-label': 'Zurück zum vorherigen Schritt',
                  class:
                    'qlfqa:!border qlfqa:!border-solid qlfqa:!border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                },
                ' Zurück ',
                8,
                Cy
              ),
              _(
                'button',
                {
                  onClick: i,
                  'aria-label': 'Weiter zum nächsten Schritt',
                  class:
                    'qlfqa:!bg-yellow-500 qlfqa:!text-black qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                },
                ' Weiter '
              )
            ]),
            c[2] ||
              (c[2] = _(
                'div',
                {
                  class: 'qlfqa:!mt-8 qlfqa:!text-[0.7rem] qlfqa:!text-gray-500',
                  role: 'doc-footnote',
                  'aria-label': 'Wissenschaftliche Referenzen'
                },
                [
                  _('span', { class: 'qlfqa:!text-[0.65rem]', 'aria-hidden': 'true' }, '🔬'),
                  _('span', null, [
                    _(
                      'span',
                      { class: 'qlfqa:!italic qlfqa:!px-1 qlfqa:!text-gray-700' },
                      'Wissenschaftliche Referenzen:'
                    ),
                    _('br'),
                    _('br'),
                    ut(
                      ' C. Ferreira-Pêgo et al. "Total fluid intake and its determinants: cross-sectional surveys among adults in 13 countries worldwide." European Journal of Nutrition, 54 (2015): 35 - 43. https://doi.org/10.1007/s00394-015-0943-9. '
                    )
                  ])
                ],
                -1
              ))
          ])
        );
      }
    }),
    Ty = { class: 'qlfqa:!py-2' },
    Oy = { class: 'qlfqa:!flex' },
    ky = {
      __name: 'ConcentrationScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se(null),
          o = [
            { id: 1, text: 'Ja, relativ häufig', val: 'schwangerschaft' },
            { id: 2, text: 'Manchmal', val: 'stillzeit' },
            { id: 3, text: 'Nein, ich bin fokussiert', val: 'nein' }
          ],
          i = ee(() => r.screenHistory.length > 0);
        function l() {
          n('next', s.value);
        }
        function a() {
          r.goBack();
        }
        return (c, u) => (
          H(),
          K('div', Ty, [
            u[1] ||
              (u[1] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Fällt es dir schwer, dich über längere Zeit zu konzentrieren?',
                -1
              )),
            _('div', Oy, [
              j(
                St,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: s.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (f) => (s.value = f))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            j(
              Ue,
              { showBackButton: i.value, disableContinue: !s.value, onBack: a, onContinue: l },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    },
    Iy = { class: 'qlfqa:!py-2' },
    Ry = { class: 'qlfqa:!flex' },
    Dy = {
      key: 0,
      class: 'qlfqa:!mt-4 qlfqa:!p-4 qlfqa:!border qlfqa:!border-black qlfqa:!rounded-md'
    },
    Py = {
      key: 1,
      class: 'qlfqa:!mt-8 qlfqa:!text-[0.7rem] qlfqa:!text-gray-500',
      role: 'doc-footnote',
      'aria-label': 'Wissenschaftliche Referenzen'
    },
    By = {
      __name: 'HeadacheScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se(null),
          o = [
            { id: 1, text: 'Ja, regelmäßig', val: 'schwangerschaft' },
            { id: 2, text: 'Manchmal', val: 'stillzeit' },
            { id: 3, text: 'Nein', val: 'nein' }
          ],
          i = ee(() => (s.value ? o.find((f) => f.val === s.value) : null)),
          l = ee(() => r.screenHistory.length > 0),
          a = ee(() => i.value && (i.value.id === 1 || i.value.id === 2));
        function c() {
          n('next', s.value);
        }
        function u() {
          r.goBack();
        }
        return (f, d) => (
          H(),
          K('div', Iy, [
            d[3] ||
              (d[3] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Hast du häufig Kopfschmerzen, besonders nach einem Arbeitstag?',
                -1
              )),
            _('div', Ry, [
              j(
                St,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: s.value,
                  'onUpdate:modelValue': d[0] || (d[0] = (h) => (s.value = h))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            a.value
              ? (H(),
                K(
                  'div',
                  Dy,
                  d[1] ||
                    (d[1] = [
                      _(
                        'div',
                        {
                          class: 'qlfqa:!font-medium qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2'
                        },
                        [
                          _(
                            'span',
                            { style: { 'font-size': '30px' }, class: 'qlfqa:!mr-3' },
                            '🤕️'
                          ),
                          _(
                            'span',
                            { class: 'qlfqa:!text-sm' },
                            'Fokus ist einer der wichtigsten Fähigkeiten der Moderne - Migräne ist hier der schlimmste Feind.'
                          )
                        ],
                        -1
                      ),
                      _(
                        'p',
                        { class: 'qlfqa:!text-xs qlfqa:!text-gray-700 qlfqa:!mt-2' },
                        ' Kopfschmerzen und Migräne entstehen weniger durch Stress, sondern häufig durch Dehydrierung und dem stetigen Flüssigkeitsmangel - Einer der Hauptgründe für Migräne. ',
                        -1
                      )
                    ])
                ))
              : Pe('', !0),
            j(
              Ue,
              { showBackButton: l.value, disableContinue: !s.value, onBack: u, onContinue: c },
              null,
              8,
              ['showBackButton', 'disableContinue']
            ),
            a.value
              ? (H(),
                K(
                  'div',
                  Py,
                  d[2] ||
                    (d[2] = [
                      _(
                        'span',
                        { class: 'qlfqa:!text-[0.65rem]', 'aria-hidden': 'true' },
                        '🔬',
                        -1
                      ),
                      _(
                        'span',
                        null,
                        [
                          _(
                            'span',
                            { class: 'qlfqa:!italic qlfqa:!px-1 qlfqa:!text-gray-700' },
                            'Wissenschaftliche Referenzen:'
                          ),
                          _('br'),
                          _('br'),
                          ut(
                            ' Martins, I., & Gouveia, R. (2007). More on Water and Migraine. Cephalalgia, 27, 372 - 374. https://doi.org/10.1111/j1468-2982.2007.01297.x. '
                          )
                        ],
                        -1
                      )
                    ])
                ))
              : Pe('', !0)
          ])
        );
      }
    },
    $y = { class: 'qlfqa:!py-2', role: 'form', 'aria-labelledby': 'dry-skin-title' },
    Fy = { class: 'qlfqa:!flex', role: 'radiogroup', 'aria-labelledby': 'dry-skin-title' },
    Ny = nt({
      __name: 'DrySkinScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se(null),
          o = [
            { id: 1, text: 'Ja', val: 'ja' },
            { id: 2, text: 'Ab und zu', val: 'manchmal' },
            { id: 3, text: 'Nein', val: 'nein' }
          ],
          i = ee(() => r.screenHistory.length > 0);
        function l() {
          n('next', s.value);
        }
        function a() {
          r.goBack();
        }
        return (c, u) => (
          H(),
          K('div', $y, [
            u[1] ||
              (u[1] = _(
                'h2',
                { id: 'dry-skin-title', class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Hast du häufiger trockene Lippen, trockene Haut oder trockene Augen?',
                -1
              )),
            _('div', null, [
              j(xt, {
                src: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Trockene-Haut1.jpg?v=1754590710',
                alt: 'Trockene Haut',
                sizes: '400px'
              })
            ]),
            _('div', Fy, [
              j(
                St,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: s.value,
                  'onUpdate:modelValue': u[0] || (u[0] = (f) => (s.value = f))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            j(
              Ue,
              {
                showBackButton: i.value,
                disableContinue: !s.value,
                onBack: a,
                onContinue: l,
                'aria-label': 'Navigation'
              },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    }),
    Ly = { class: 'qlfqa:py-2', role: 'article', 'aria-labelledby': 'skin-effects-title' },
    Vy = { class: 'qlfqa:!mb-4' },
    My = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!justify-center qlfqa:!gap-4',
      role: 'group',
      'aria-label': 'Navigation'
    },
    Uy = ['disabled', 'aria-disabled'],
    Hy = nt({
      __name: 'EffectsOnSkinScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se('checked'),
          o = ee(() => r.screenHistory.length > 0);
        function i() {
          n('next', s.value);
        }
        function l() {
          r.goBack();
        }
        return (a, c) => (
          H(),
          K('div', Ly, [
            c[0] ||
              (c[0] = _(
                'h2',
                { id: 'skin-effects-title', class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                ' Wusstest Du, dass eine Dehydrierung zu früherer Hautalterung und einer vermehrten Faltenbildung sowie Haarbruch führt? ',
                -1
              )),
            c[1] ||
              (c[1] = _(
                'p',
                { class: 'qlfqa:!text-sm qlfqa:italic qlfqa:text-gray-700' },
                'Auswirkungen von Dehydrierung auf die Hautgesundheit',
                -1
              )),
            _('div', Vy, [
              j(xt, {
                src: 'https://cdn.shopify.com/s/files/1/0867/7068/0081/files/Folgen-trockene-Haut.jpg?v=1749145488',
                alt: 'Auswirkungen von Dehydrierung auf die Haut',
                sizes: '400px'
              })
            ]),
            c[2] ||
              (c[2] = _(
                'div',
                { class: 'qlfqa:!mb-4' },
                [
                  _('p', { class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2' }, [
                    _(
                      'svg',
                      {
                        xmlns: 'http://www.w3.org/2000/svg',
                        viewBox: '0 0 24 24',
                        fill: 'red',
                        class: 'qlfqa:!size-5 qlfqa:!flex-shrink-0',
                        role: 'img',
                        'aria-hidden': 'true'
                      },
                      [
                        _('title', null, 'Wichtiger Hinweis'),
                        _('path', {
                          'fill-rule': 'evenodd',
                          d: 'M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z',
                          'clip-rule': 'evenodd'
                        })
                      ]
                    ),
                    _('span', null, [
                      _('span', { class: 'qlfqa:!font-bold' }, 'Hautelastizität:'),
                      ut(
                        ' Dehydrierung mindert die Gescheidigkeit und fördert diverse Alterserscheinungen der Haut. '
                      )
                    ])
                  ])
                ],
                -1
              )),
            c[3] ||
              (c[3] = _(
                'div',
                { class: 'qlfqa:!mb-4' },
                [
                  _('p', { class: 'qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2' }, [
                    _(
                      'svg',
                      {
                        xmlns: 'http://www.w3.org/2000/svg',
                        viewBox: '0 0 24 24',
                        fill: 'red',
                        class: 'qlfqa:!size-5 qlfqa:!flex-shrink-0',
                        role: 'img',
                        'aria-hidden': 'true'
                      },
                      [
                        _('title', null, 'Wichtiger Hinweis'),
                        _('path', {
                          'fill-rule': 'evenodd',
                          d: 'M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z',
                          'clip-rule': 'evenodd'
                        })
                      ]
                    ),
                    _('span', null, [
                      _('span', { class: 'qlfqa:!font-bold' }, 'Feuchtigkeitsgehalt:'),
                      ut(
                        ' Eine ausreichende Hydration beugt Trockenheit und Falten vor - Zeichen einer jungen & frischen Haut. '
                      )
                    ])
                  ])
                ],
                -1
              )),
            _('div', My, [
              _(
                'button',
                {
                  onClick: l,
                  disabled: !o.value,
                  'aria-disabled': !o.value,
                  'aria-label': 'Zurück zum vorherigen Schritt',
                  class:
                    'qlfqa:!border qlfqa:!border-solid qlfqa:border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                },
                ' Zurück ',
                8,
                Uy
              ),
              _(
                'button',
                {
                  onClick: i,
                  'aria-label': 'Alles klar und weiter',
                  class:
                    'qlfqa:!bg-yellow-500 qlfqa:!text-black qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                },
                ' Alles klar! '
              )
            ]),
            c[4] ||
              (c[4] = _(
                'div',
                {
                  class: 'qlfqa:!mt-8 qlfqa:!text-[0.7rem] qlfqa:!text-gray-500',
                  role: 'doc-footnote',
                  'aria-label': 'Wissenschaftliche Referenzen'
                },
                [
                  _('span', { class: 'qlfqa:!text-[0.65rem]', 'aria-hidden': 'true' }, '🔬'),
                  _('span', null, [
                    _(
                      'span',
                      { class: 'qlfqa:!italic qlfqa:!px-1 qlfqa:!text-gray-700' },
                      'Wissenschaftliche Referenzen:'
                    ),
                    _('br'),
                    _('br'),
                    ut(
                      ' Eda, N., Nakamura, N., Inai, Y., Sun, Z., Sone, R., Watanabe, K., & Akama, T. (2022). Changes in the skin characteristics associated with dehydration and rehydration. European Journal of Sport Science, 23, 552 - 560. https://doi.org/10.1080/17461391.2022.2044914. '
                    )
                  ])
                ],
                -1
              ))
          ])
        );
      }
    }),
    jy = { class: 'qlfqa:!py-2' },
    zy = {
      __name: 'DigestionScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se([]),
          o = se(!1),
          i = [
            { id: 1, text: 'Blähungen', val: 'schwangerschaft' },
            { id: 2, text: 'Verdauungsstörungen', val: 'stillzeit' },
            { id: 3, text: 'Verstopfungen', val: 'stillzeit2' },
            { id: 4, text: 'Unregelmäßiger Stuhlgang', val: 'stillzeit3' }
          ],
          l = { id: 3, text: 'Keine davon', val: 'nein' },
          a = ee(() => r.screenHistory.length > 0),
          c = ee(() => s.value.length > 0 || o.value);
        function u() {
          let d = [];
          (o.value ? (d = [l.val]) : (d = s.value), n('next', d));
        }
        function f() {
          r.goBack();
        }
        return (d, h) => (
          H(),
          K('div', jy, [
            h[1] ||
              (h[1] = _(
                'h2',
                { class: 'qlfqa:!text-lg qlfqa:!font-medium qlfqa:!mb-4' },
                'Hast du gelegentlich eine dieser Beschwerden oder Verdauungsprobleme?',
                -1
              )),
            j(
              Pf,
              {
                modelValue: s.value,
                'onUpdate:modelValue': h[0] || (h[0] = (g) => (s.value = g)),
                class: 'qlfqa:!mt-4',
                checkboxOptions: i,
                exclusiveOption: l
              },
              null,
              8,
              ['modelValue']
            ),
            j(
              Ue,
              { showBackButton: a.value, disableContinue: !c.value, onBack: f, onContinue: u },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    },
    Ky = { class: 'qlfqa:!py-4', role: 'article', 'aria-labelledby': 'digestion-title' },
    Wy = { class: 'qlfqa:!w-full' },
    Gy = {
      class: 'qlfqa:!mt-8 qlfqa:!flex qlfqa:!justify-center qlfqa:!gap-4',
      role: 'group',
      'aria-label': 'Navigation'
    },
    Jy = ['disabled', 'aria-disabled'],
    Yy = 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/Info-Verdauung1.jpg?v=1754591010',
    Qy = 'Verdauungsinformation',
    Zy = nt({
      __name: 'DigestionInfoScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se('checked'),
          o = ee(() => r.screenHistory.length > 0);
        function i() {
          n('next', s.value);
        }
        function l() {
          r.goBack();
        }
        return (a, c) => (
          H(),
          K('div', Ky, [
            c[0] ||
              (c[0] = _(
                'h2',
                { id: 'digestion-title', class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                ' Studien zeigen, dass eine reduzierte Flüssigkeitszufuhr einer der Hauptgründe für Verstopfungen & Verdauungsbeschwerden ist. ',
                -1
              )),
            c[1] ||
              (c[1] = _(
                'p',
                { class: 'qlfqa:!mb-2 qlfqa:!text-gray-700 qlfqa:italic qlfqa:!text-sm' },
                ' Info: Dehydrierung führt dazu dass der Körper mehr Flüssigkeit und Elektrolyte verliert, als er erhält. Wer zu wenig trinkt, dessen Darm entzieht dem Stuhl Wasser, wodurch sich der Stuhl eindickt & Probleme entstehen. ',
                -1
              )),
            _('div', Wy, [j(xt, { src: Yy, alt: Qy, sizes: '400px' })]),
            _('div', Gy, [
              _(
                'button',
                {
                  onClick: l,
                  disabled: !o.value,
                  'aria-disabled': !o.value,
                  'aria-label': 'Zurück zum vorherigen Schritt',
                  class:
                    'qlfqa:!border qlfqa:!border-solid qlfqa:!border-[#CECDCA] qlfqa:!text-[#808080] qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!opacity-80 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                },
                ' Zurück ',
                8,
                Jy
              ),
              _(
                'button',
                {
                  onClick: i,
                  'aria-label': 'Verstanden und weiter',
                  class:
                    'qlfqa:!bg-yellow-500 qlfqa:!text-black qlfqa:!px-6 qlfqa:!py-3 qlfqa:!rounded-md qlfqa:disabled:!opacity-50 qlfqa:hover:!bg-yellow-400 qlfqa:!cursor-pointer qlfqa:!w-1/2'
                },
                ' Verstanden '
              )
            ]),
            c[2] ||
              (c[2] = _(
                'div',
                {
                  class: 'qlfqa:!mt-8 qlfqa:!text-[0.7rem] qlfqa:!text-gray-500',
                  role: 'doc-footnote',
                  'aria-label': 'Wissenschaftliche Referenzen'
                },
                [
                  _('span', { class: 'qlfqa:!text-[0.65rem]', 'aria-hidden': 'true' }, '🔬'),
                  _('span', null, [
                    _(
                      'span',
                      { class: 'qlfqa:!italic qlfqa:!px-1 qlfqa:!text-gray-700' },
                      'Wissenschaftliche Referenzen:'
                    ),
                    _('br'),
                    _('br'),
                    ut(
                      ' Jangid, Varsha, et al. "Water intake, dietary fibre, defecatory habits and its association with chronic functional constipation." Current Research in Nutrition and Food Science Journal 4.2 (2016): 90-95. '
                    )
                  ])
                ],
                -1
              ))
          ])
        );
      }
    }),
    Xy = { class: 'qlfqa:!py-2' },
    ev = { class: 'qlfqa:!flex' },
    tv = {
      key: 0,
      class: 'qlfqa:!mt-4 qlfqa:!p-4 qlfqa:!border qlfqa:!border-black qlfqa:!rounded-md'
    },
    nv = {
      __name: 'CoffeeAndEnergyScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se(null),
          o = [
            { id: 1, text: 'Ja, mehrmals täglich', val: 'schwangerschaft' },
            { id: 2, text: 'Ja, aber nur gelegentlich', val: 'stillzeit' },
            { id: 3, text: 'Nein', val: 'nein' }
          ],
          i = ee(() => (s.value ? o.find((f) => f.val === s.value) : null)),
          l = ee(() => r.screenHistory.length > 0),
          a = ee(() => i.value && (i.value.id === 1 || i.value.id === 2));
        function c() {
          n('next', s.value);
        }
        function u() {
          r.goBack();
        }
        return (f, d) => (
          H(),
          K('div', Xy, [
            d[2] ||
              (d[2] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                'Trinkst du Kaffee oder Energy-Drinks, um wacher zu werden?',
                -1
              )),
            _('div', ev, [
              j(
                St,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: s.value,
                  'onUpdate:modelValue': d[0] || (d[0] = (h) => (s.value = h))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            a.value
              ? (H(),
                K(
                  'div',
                  tv,
                  d[1] ||
                    (d[1] = [
                      _(
                        'div',
                        {
                          class: 'qlfqa:!font-medium qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2'
                        },
                        [
                          _(
                            'span',
                            { style: { 'font-size': '30px!important' }, class: 'qlfqa:!mr-3' },
                            '☕️'
                          ),
                          _(
                            'span',
                            { class: 'qlfqa:!text-sm' },
                            'Studien zeigen, dass Koffein tolle Vorteile hat - nur Übertreiben sollte man es eben nicht.'
                          )
                        ],
                        -1
                      ),
                      _(
                        'p',
                        { class: 'qlfqa:!text-xs qlfqa:!text-gray-700 qlfqa:!mt-2' },
                        ' Nicht mehr Müde sein ist halt nicht das gleiche, wie spürbar wach zu sein. Für wirklich mentale und körperliche Frische ist es deshalb essentiell ausreichend hydriert zu sein. ',
                        -1
                      )
                    ])
                ))
              : Pe('', !0),
            j(
              Ue,
              { showBackButton: l.value, disableContinue: !s.value, onBack: u, onContinue: c },
              null,
              8,
              ['showBackButton', 'disableContinue']
            )
          ])
        );
      }
    },
    rv = { class: 'qlfqa:!py-2' },
    sv = { class: 'qlfqa:!flex' },
    ov = {
      key: 0,
      class: 'qlfqa:!mt-4 qlfqa:!p-4 qlfqa:!border qlfqa:!border-black qlfqa:!rounded-md'
    },
    iv = {
      key: 1,
      class: 'qlfqa:!mt-8 qlfqa:!text-[0.7rem] qlfqa:!text-gray-500',
      role: 'doc-footnote',
      'aria-label': 'Wissenschaftliche Referenzen'
    },
    lv = {
      __name: 'PerformanceLowsScreen',
      emits: ['next'],
      setup(e, { emit: t }) {
        const n = t,
          r = qe(),
          s = se(null),
          o = [
            { id: 1, text: 'Ja, viel zu oft', val: 'schwangerschaft' },
            { id: 2, text: 'Manchmal', val: 'stillzeit' },
            { id: 3, text: 'Nein', val: 'nein' }
          ],
          i = ee(() => (s.value ? o.find((f) => f.val === s.value) : null)),
          l = ee(() => r.screenHistory.length > 0),
          a = ee(() => i.value && (i.value.id === 1 || i.value.id === 2));
        function c() {
          n('next', s.value);
        }
        function u() {
          r.goBack();
        }
        return (f, d) => (
          H(),
          K('div', rv, [
            d[3] ||
              (d[3] = _(
                'h2',
                { class: 'qlfqa:!text-l qlfqa:!font-medium qlfqa:!mb-4' },
                ' Hast du nachmittags oft ein Leistungstief oder erlebst einen plötzlichen Energieeinbruch? ',
                -1
              )),
            _('div', sv, [
              j(
                St,
                {
                  class: 'qlfqa:!flex',
                  options: o,
                  modelValue: s.value,
                  'onUpdate:modelValue': d[0] || (d[0] = (h) => (s.value = h))
                },
                null,
                8,
                ['modelValue']
              )
            ]),
            a.value
              ? (H(),
                K(
                  'div',
                  ov,
                  d[1] ||
                    (d[1] = [
                      _(
                        'div',
                        {
                          class: 'qlfqa:!font-medium qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2'
                        },
                        [
                          _(
                            'span',
                            { style: { 'font-size': '30px' }, class: 'qlfqa:!mr-3' },
                            '🥱️'
                          ),
                          _(
                            'span',
                            { class: 'qlfqa:!text-sm' },
                            'Starke Müdigkeit und plötzliches Leistungstief gehen Hand in Hand mit der Dehydration.'
                          )
                        ],
                        -1
                      ),
                      _(
                        'p',
                        { class: 'qlfqa:!text-xs qlfqa:!text-gray-700 qlfqa:!mt-2' },
                        ' Die Erhaltung einer optimalen Flüssigkeitszufuhr verringert Müdigkeit und Stimmungsschwankungen, die mit einem wacheren und aufmerksameren Gefühl einhergehen. ',
                        -1
                      )
                    ])
                ))
              : Pe('', !0),
            j(
              Ue,
              { showBackButton: l.value, disableContinue: !s.value, onBack: u, onContinue: c },
              null,
              8,
              ['showBackButton', 'disableContinue']
            ),
            a.value
              ? (H(),
                K(
                  'div',
                  iv,
                  d[2] ||
                    (d[2] = [
                      _('span', null, '🔬', -1),
                      _(
                        'span',
                        null,
                        [
                          _(
                            'span',
                            { class: 'qlfqa:!font-medium qlfqa:!px-2' },
                            'Wissenschaftliche Referenzen:'
                          ),
                          _('br'),
                          _('br'),
                          ut(
                            ' Jangid, Varsha, et al. "Water intake, dietary fibre, defecatory habits and its association with chronic functional constipation." Current Research in Nutrition and Food Science Journal 4.2 (2016): 90-95. '
                          )
                        ],
                        -1
                      )
                    ])
                ))
              : Pe('', !0)
          ])
        );
      }
    };
  (function () {
    try {
      if (typeof document < 'u') {
        var e = document.createElement('style');
        (e.appendChild(
          document.createTextNode(
            '@keyframes filling{0%{stroke-dashoffset:var(--0f014bb6)}to{stroke-dashoffset:var(--2f449254)}}.circle-progress__circle{fill:transparent;stroke-width:var(--686651bf)}.circle-progress__line--back{stroke:var(--1665467b);stroke-dashoffset:0}.circle-progress__line--top{animation-name:filling;animation-duration:var(--e222206e);animation-timing-function:ease-in;transition:.5s all}.circle-progress__line--top--rounded{stroke-linecap:round}.circle-progress{display:flex;position:relative;justify-content:center;align-items:center}.circle-progress__line--filled{stroke:var(--1975d9f6)}.circle-progress__line--unfilled{stroke:var(--b0980662)}.circle-progress__content{position:absolute;left:0;right:0;top:0;bottom:0;display:flex;justify-content:center;align-items:center;flex-direction:column}'
          )
        ),
          document.head.appendChild(e));
      }
    } catch (t) {
      console.error('vite-plugin-css-injected-by-js', t);
    }
  })();
  const av = { class: 'circle-progress' },
    uv = ['width', 'height'],
    cv = ['r'],
    fv = ['transform', 'r'],
    dv = { class: 'circle-progress__content' },
    pv = { key: 0, class: 'circle-progress__percentage' },
    hv = {
      __name: 'CircleProgressBar',
      props: {
        max: { type: Number, required: !0 },
        value: { type: Number, required: !0 },
        colorFilled: { type: String, required: !1, default: '#FF5533' },
        colorUnfilled: { type: String, required: !1, default: '#3BB44A' },
        colorBack: { type: String, required: !1, default: '#ECEEF1' },
        percentage: { type: Boolean, required: !1, default: !1 },
        rounded: { type: Boolean, required: !1, default: !1 },
        animationDuration: { type: String, required: !1, default: '0.5s' },
        strokeWidth: { type: String, required: !1, default: '5px' },
        reversedFilling: { type: Boolean, required: !1, default: !1 },
        size: { type: [String, Number], required: !1, default: '124' },
        startAngle: { type: Number, required: !1, default: 180 }
      },
      setup(e) {
        t0((h) => ({
          '0f014bb6': u.value,
          '2f449254': f.value,
          '686651bf': t.strokeWidth,
          '1665467b': t.colorBack,
          e222206e: t.animationDuration,
          '1975d9f6': t.colorFilled,
          b0980662: t.colorUnfilled
        }));
        const t = e,
          n = ee(() => t.max <= t.value),
          r = ee(() => ({
            'circle-progress__line--top--rounded': t.rounded,
            'circle-progress__line--filled': n.value,
            'circle-progress__line--unfilled': !n.value
          })),
          s = ee(() => ({ strokeDashoffset: f.value, strokeDasharray: u.value })),
          o = 48 - (parseInt(t.strokeWidth) - 5) / 2,
          i = ee(() => (n.value ? t.max : t.value)),
          l = ee(() => t.startAngle - 90),
          a = se(null),
          c = se(o),
          u = ee(() => c.value * Math.PI * 2),
          f = ee(() =>
            t.reversedFilling
              ? u.value - (u.value * (t.max - i.value)) / t.max
              : u.value - (u.value * i.value) / t.max
          ),
          d = ee(() => Math.floor((t.value / t.max) * 100) + '%');
        return (h, g) => (
          H(),
          K('div', av, [
            (H(),
            K(
              'svg',
              {
                class: 'circle-progress__svg',
                viewBox: '-2 -2 106 106',
                width: e.size,
                height: e.size
              },
              [
                _(
                  'circle',
                  {
                    class: 'circle-progress__circle circle-progress__line--back',
                    r: c.value,
                    cx: '52',
                    cy: '52'
                  },
                  null,
                  8,
                  cv
                ),
                _(
                  'circle',
                  {
                    class: Xe(['circle-progress__circle circle-progress__line--top', r.value]),
                    style: On(s.value),
                    transform: `rotate(${l.value} 52 52)`,
                    ref_key: 'fillingCircle',
                    ref: a,
                    r: c.value,
                    cx: '52',
                    cy: '52'
                  },
                  null,
                  14,
                  fv
                )
              ],
              8,
              uv
            )),
            _('div', dv, [
              e.percentage ? (H(), K('span', pv, ot(d.value), 1)) : Pe('', !0),
              Ro(h.$slots, 'default')
            ])
          ])
        );
      }
    },
    mv = { class: 'qlfqa:!py-2' },
    gv = { class: 'qlfqa:!flex qlfqa:!flex-col qlfqa:!items-center' },
    _v = { class: 'qlfqa:!relative qlfqa:!mb-4 qlfqa:!text-black' },
    yv = {
      class:
        'qlfqa:!text-center qlfqa:!text-m qlfqa:!font-medium qlfqa:!min-h-[5rem] qlfqa:!text-gray-600'
    },
    vv = {
      class:
        'qlfqa:!text-center qlfqa:!text-sm qlfqa:!mb-4 qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2 qlfqa:!font-bold qlfqa:!text-black'
    },
    qv = '#FDD539',
    bv = '#CADaba',
    Ev = '#e6e6e6',
    wv = {
      __name: 'EndLoadingScreen',
      setup(e) {
        const t = qe(),
          n = [
            'Alter, Gewicht & Aktivität werden analysiert ...',
            'Abgleich mit Studien zur Hydrierung ...',
            'Dein individuelles Ergebnis wird berechnet ...',
            'Symptome werden mit Dehydrierungsmustern verglichen ...'
          ],
          r = se(0),
          s = se(n[0]);
        let o = 0,
          i = null,
          l = null,
          a = !1;
        function c() {
          if (!a) {
            a = !0;
            try {
              const d = new URLSearchParams();
              t.results
                ? (d.append('hydrationScore', t.results.hydrationScore),
                  d.append('foodIntake', t.results.foodIntake),
                  d.append('waterIntake', t.results.waterIntake))
                : (d.append('hydrationScore', '0'),
                  d.append('foodIntake', '0'),
                  d.append('waterIntake', '0'));
              const g = `https://qlf.de/pages/ergebnis?${d.toString()}`;
              try {
                window.location.href = g;
              } catch {
                window.location.replace(g);
              }
            } catch {
              window.location.href = 'https://qlf.de/pages/ergebnis';
            }
          }
        }
        function u() {
          ((r.value = 0),
            (o = 0),
            (s.value = n[0]),
            (a = !1),
            i && clearInterval(i),
            l && clearInterval(l));
          const d = Date.now(),
            h = 9e3;
          i = setInterval(() => {
            const v = Date.now() - d,
              y = Math.min(Math.round((v / h) * 100), 100);
            ((r.value = y),
              y >= 100 &&
                (clearInterval(i),
                clearInterval(l),
                setTimeout(() => {
                  c();
                }, 200)));
          }, 50);
          const g = h / n.length;
          l = setInterval(() => {
            ((o = (o + 1) % n.length),
              (s.value = n[o]),
              console.log(`Text changed to: ${s.value}`));
          }, g);
        }
        function f() {
          (i && clearInterval(i), l && clearInterval(l));
        }
        return (
          mr(() => {
            (t.completeQuiz(),
              setTimeout(() => {
                u();
              }, 100));
          }),
          Io(() => {
            f();
          }),
          (d, h) => (
            H(),
            K('div', mv, [
              h[2] ||
                (h[2] = _(
                  'h2',
                  { class: 'qlfqa:!text-xl qlfqa:!font-medium qlfqa:!mb-4 qlfqa:!text-center' },
                  'Daten werden analysiert ...',
                  -1
                )),
              _('div', gv, [
                _('div', _v, [
                  j(
                    jt(hv),
                    {
                      value: r.value,
                      max: 100,
                      size: '200',
                      'animation-duration': '9000',
                      'color-back': Ev,
                      'color-unfilled': qv,
                      'color-filled': bv,
                      'start-angle': 0,
                      percentage: !0
                    },
                    null,
                    8,
                    ['value']
                  )
                ]),
                _('p', yv, ot(s.value), 1),
                _('p', vv, [
                  j(xt, {
                    src: 'https://cdn.shopify.com/s/files/1/0794/9097/4033/files/testis.jpg?v=1754585128',
                    alt: 'Testimonials',
                    class: 'qlfqa:!w-auto qlfqa:!h-7',
                    sizes: '100px'
                  }),
                  h[0] ||
                    (h[0] = _(
                      'svg',
                      {
                        width: '25px',
                        height: '25px',
                        viewBox: '0 0 24 24',
                        fill: 'none',
                        xmlns: 'http://www.w3.org/2000/svg'
                      },
                      [
                        _('rect', { width: '24', height: '24' }),
                        _('path', {
                          'fill-rule': 'evenodd',
                          'clip-rule': 'evenodd',
                          d: 'M9.55879 3.6972C10.7552 2.02216 13.2447 2.02216 14.4412 3.6972L14.6317 3.96387C14.8422 4.25867 15.1958 4.41652 15.5558 4.37652L16.4048 4.28218C18.3156 4.06988 19.9301 5.68439 19.7178 7.59513L19.6235 8.44415C19.5835 8.8042 19.7413 9.15774 20.0361 9.36831L20.3028 9.55879C21.9778 10.7552 21.9778 13.2447 20.3028 14.4412L20.0361 14.6317C19.7413 14.8422 19.5835 15.1958 19.6235 15.5558L19.7178 16.4048C19.9301 18.3156 18.3156 19.9301 16.4048 19.7178L15.5558 19.6235C15.1958 19.5835 14.8422 19.7413 14.6317 20.0361L14.4412 20.3028C13.2447 21.9778 10.7553 21.9778 9.55879 20.3028L9.36831 20.0361C9.15774 19.7413 8.8042 19.5835 8.44414 19.6235L7.59513 19.7178C5.68439 19.9301 4.06988 18.3156 4.28218 16.4048L4.37652 15.5558C4.41652 15.1958 4.25867 14.8422 3.96387 14.6317L3.6972 14.4412C2.02216 13.2447 2.02216 10.7553 3.6972 9.55879L3.96387 9.36831C4.25867 9.15774 4.41652 8.8042 4.37652 8.44414L4.28218 7.59513C4.06988 5.68439 5.68439 4.06988 7.59513 4.28218L8.44415 4.37652C8.8042 4.41652 9.15774 4.25867 9.36831 3.96387L9.55879 3.6972ZM15.7071 9.29289C16.0976 9.68342 16.0976 10.3166 15.7071 10.7071L11.8882 14.526C11.3977 15.0166 10.6023 15.0166 10.1118 14.526L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929C8.68342 10.9024 9.31658 10.9024 9.70711 11.2929L11 12.5858L14.2929 9.29289C14.6834 8.90237 15.3166 8.90237 15.7071 9.29289Z',
                          fill: '#3D7FDE'
                        })
                      ],
                      -1
                    )),
                  h[1] ||
                    (h[1] = _(
                      'span',
                      { class: 'qlfqa:text-[0.7rem]' },
                      'über 500.000 Kunden vertrauen QLF',
                      -1
                    ))
                ])
              ]),
              h[3] ||
                (h[3] = Za(
                  '<div class="qlfqa:!mt-2 qlfqa:!p-4 qlfqa:!bg-white qlfqa:!shadow-md qlfqa:!rounded-md qlfqa:!text-[0.9rem]"><h2 class="qlfqa:!text-[1.1rem] qlfqa:mb-2 qlfqa:!font-bold">Benefits der richtigen Hydrierung</h2><p class="qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2 qlfqa:!mb-3 qlfqa:!font-bold"><span>✅</span> Mehr Energie &amp; spürbar weniger Müdigkeit </p><p class="qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2 qlfqa:!mb-3 qlfqa:!font-bold"><span>✅</span> Bessere Konzentration &amp; klares Denken </p><p class="qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2 qlfqa:!mb-3 qlfqa:!font-bold"><span>✅</span> Weniger Kopfschmerzen &amp; Heißhunger </p><p class="qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2 qlfqa:!mb-3 qlfqa:!font-bold"><span>✅</span> Gesunde Verdauung &amp; leichtes Körpergefühl </p><p class="qlfqa:!flex qlfqa:!items-center qlfqa:!gap-2 qlfqa:!mb-3 qlfqa:!font-bold"><span>✅</span> Frischere Haut &amp; bessere Regeneration </p></div>',
                  1
                ))
            ])
          )
        );
      }
    },
    xv = { class: 'quiz-container' },
    Sv = nt({
      __name: 'Quiz',
      setup(e) {
        const t = qe(),
          n = {
            AgeScreen: h1,
            GenderScreen: y1,
            ExtraQuestionWomenScreen: I1,
            HeightScreen: B1,
            WeightScreen: L1,
            ActivityScreen: U1,
            HowMuchWaterScreen: z1,
            ClimateScreen: G1,
            HealthScreen: iy,
            HealthPhase2Screen: ay,
            HandTestScreen: my,
            UrineTestScreen: Ey,
            InfoPersonScreen: Ay,
            ConcentrationScreen: ky,
            HeadacheScreen: By,
            DrySkinScreen: Ny,
            EffectsOnSkinScreen: Hy,
            DigestionScreen: zy,
            DigestionInfoScreen: Zy,
            CoffeeAndEnergyScreen: nv,
            PerformanceLowsScreen: lv,
            EndLoadingScreen: wv
          },
          r = ee(() => n[t.currentScreen]);
        function s(o) {
          t.goToNextScreen(o);
        }
        return (o, i) => (
          H(),
          K('div', xv, [
            jt(t).currentScreen !== 'HealthPhase2Screen'
              ? (H(),
                hn(l1, { key: 0, 'current-screen': jt(t).currentScreen }, null, 8, [
                  'current-screen'
                ]))
              : Pe('', !0),
            j(
              Gm,
              {
                name: jt(t).currentScreen === 'EndLoadingScreen' ? 'zoom' : 'fade',
                mode: 'out-in'
              },
              { default: dr(() => [(H(), hn($h(r.value), { onNext: s }, null, 32))]), _: 1 },
              8,
              ['name']
            )
          ])
        );
      }
    }),
    Cv = {
      __name: 'Index',
      setup(e) {
        return (t, n) => (H(), hn(o1, null, { default: dr(() => [j(Sv)]), _: 1 }));
      }
    };
  window.__QLFQuizDrinkAppMounted = window.__QLFQuizDrinkAppMounted || {};
  function Av(e = {}) {
    const { elementId: t = 'qlfquizapp' } = e;
    if (!document.getElementById(t))
      return (console.warn(`Element with id "${t}" not found`), null);
    if (window.__QLFQuizDrinkAppMounted[t])
      return (
        console.info(`App already mounted on #${t}, reusing existing instance`),
        window.__QLFQuizDrinkAppMounted[t]
      );
    const r = G_(),
      s = b0(Cv);
    return (s.use(r), s.mount(`#${t}`), (window.__QLFQuizDrinkAppMounted[t] = s), s);
  }
  return (
    typeof window < 'u' &&
      document.getElementById('qlfquizapp') &&
      setTimeout(() => {
        document.getElementById('qlfquizapp') &&
          !window.__QLFQuizDrinkAppMounted.qlfquizapp &&
          window.QLFQuizDrinkApp();
      }, 0),
    Av
  );
});
